webpackJsonp([43],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1249),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1009)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(993)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1144),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(996)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdAlert__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EdAlert__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__EdAlert___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdButton__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EdButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdForm__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EdForm__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__EdForm___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdModal__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EdModal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__EdModal___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdInputText__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdInputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EdInputText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__EdInputText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdInputTextArea__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdInputTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EdInputTextArea__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__EdInputTextArea___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EdInputSelect__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EdInputSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EdInputSelect__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__EdInputSelect___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EdInputSwitch__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EdInputSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EdInputSwitch__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__EdInputSwitch___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EdInputEditor__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EdInputEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__EdInputEditor__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_9__EdInputEditor___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EdInputDate__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EdInputDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__EdInputDate__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__EdInputDate___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EdInputUpload__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EdInputUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__EdInputUpload__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__EdInputUpload___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EdInputTime__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EdInputTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__EdInputTime__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__EdInputTime___default.a; });















/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1220),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1011)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1006)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1246),
  /* scopeId */
  "data-v-76b7d6d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1185),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1014)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1289),
  /* scopeId */
  "data-v-e0139152",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(998)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1002)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1199),
  /* scopeId */
  "data-v-43108a21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1186),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.495817c.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1226),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1005)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1243),
  /* scopeId */
  "data-v-7331f698",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1225),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Pessoais'
}, {
    id: 2,
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'nome',
    maxlength: 200,
    label: 'Nome',
    rules: ['required']
}, {
    id: 1,
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    field: 'rg',
    label: 'RG',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'date',
    field: 'dt_nas',
    label: 'Data de Nascimento',
    mask: 'date',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-tipo',
    tipo: 59,
    valor: 'valor',
    field: 'sexo',
    label: 'Sexo',
    rules: ['required']
}, {
    id: 3,
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'email',
    field: 'email',
    maxlength: 100,
    label: 'Email',
    rules: ['email']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    maxlength: 100,
    field: 'tel_res',
    label: 'Telefone',
    mask: 'telefone',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    maxlength: 100,
    field: 'tel_cel',
    label: 'Celular',
    mask: 'celular',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Trabalhistas'
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-custom',
    field: 'id_fdt',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    label: 'Frente de Trabalho',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-custom',
    field: 'id_funcao',
    label: 'Função',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-ghe',
    field: 'id_ghe',
    label: 'GHE (Setor)',
    info: 'Somente se tiver PCMSO cadastrado',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
    type: 'text',
    maxlength: 100,
    field: 'pis',
    label: 'PIS',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
    type: 'text',
    maxlength: 100,
    field: 'mat',
    label: 'Matrícula',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 100,
    field: 'ct_num',
    label: 'Carteira de Trabalho (Número):',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 100,
    field: 'ct_serie',
    label: 'Carteira de Trabalho (Série):',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 100,
    field: 'ct_uf',
    label: 'Carteira de Trabalho (UF):',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Endereço Residencial'
}, {
    id: 5,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'cep',
    maxlength: 10,
    field: 'cep',
    label: 'CEP',
    mask: 'cep',
    rules: ['']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    maxlength: 500,
    field: 'end',
    label: 'Endereço',
    rules: ['']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 50,
    field: 'num',
    label: 'Número',
    rules: ['']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    maxlength: 100,
    field: 'bairro',
    label: 'Bairro',
    rules: ['']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 50,
    field: 'comp',
    label: 'Complemento',
    rules: ['']
}, {
    id: 8,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    rules: ['']
}, {
    id: 9,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    rules: ['']
}, {
    id: 14,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    rules: ['']
}]);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'laboratorio',
    label: 'Laboratório',
    option: {
        key: 'id',
        label: 'nome',
        value: 'object'
    },
    info: 'Para cadastrar um novo laboratório por favor acesso o menú: LTCAT > Laboratórios',
    rules: ['required']
}]);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Gerais'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 100,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'nome_comercial',
    label: 'Nome Comercial',
    maxlength: 255,
    info: 'Campo utilizado para fins de orçamentos',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-tipo',
    tipo: 269,
    field: 'cat_esocial',
    valor: 'descricao',
    multiple: false,
    label: 'Categoria - Tabela 23 do eSocial',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_metodologia',
    label: 'Código Metodologia',
    maxlength: 45,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_cas',
    label: 'Código CAS',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-tipo',
    tipo: 290,
    field: 'id_tipo_unidade_medida',
    multiple: false,
    label: 'Unidade de Medida - eSocial',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_esocial',
    label: 'Código eSocial (Tabela 24)',
    maxlength: 45,
    mask: 'esocial',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'esocial_atividade_per',
    label: 'Atividades Periculosas, Instalubres ou Especiais - Tabela 28 do eSocial',
    option: {
        key: 'id',
        label: 'esocial',
        title: 'nome',
        value: 'id'
    },
    info: 'Campo obrigatório para gerar o E-Social',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'vazao',
    label: 'Vazão',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'volume',
    label: 'Volume',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_amostrador',
    label: 'Código Tipo Amostrador',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_tab',
    label: 'Tabela Dinâmica',
    option: {
        key: 'id',
        label: 'tabela_dinamica',
        value: 'id'
    },
    info: 'Selecione o modelo de tabela que esse fator de risco pertence',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'desc_metodologia',
    label: 'Descrição Metodologia',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'amostra',
    label: 'Cuidados Amostra',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'desc_amostrador',
    label: 'Descrição Tipo Amostrador',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Ativo?',
    info: 'Esse campo serve para inativar o fator de risco em outras partes no sistema.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Laboratórios'
}]);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-cnae',
    field: 'cnae',
    label: 'CNAE',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'ie',
    label: 'Inscrição Estadual',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'cep',
    field: 'cep',
    label: 'CEP',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'end',
    label: 'Endereço',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'num',
    label: 'Número',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'comp',
    label: 'Complemento',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'text',
    field: 'bairro',
    label: 'Bairro',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'tel_com',
    label: 'Telefone',
    mask: 'telefone',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'tel_cel',
    label: 'Celular',
    mask: 'celular',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-8',
    type: 'email',
    field: 'email',
    label: 'Email',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-6',
    type: 'text',
    field: 'site',
    label: 'Site',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'resp',
    label: 'Responsável',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'r_obs',
    label: 'Observações',
    info: '',
    rules: ['']
}]);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'color',
    field: 'cor',
    label: 'Cor das Colunas',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Tabela Ativo?',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'copiar',
    label: 'Copiar Versão',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Caso desejar copiar um modelo de tabela já cadastrado, selecione aqui a tabela para ser copiada.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    info: '',
    rules: ['']
}]);

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1015)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1291),
  /* scopeId */
  "data-v-ec5ba4d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1262),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1004)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(995)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1224),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1007)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1240),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1216),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(997)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1010)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1268),
  /* scopeId */
  "data-v-abd7595c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mask__ = __webpack_require__(844);


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__empresa__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__credenciada__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parceiro__ = __webpack_require__(848);







var hostname = window.location.hostname,
    urlParams = null,
    ambiente = null,
    routes = [];

console.log('**hostname ' + hostname + '**');

if (false) {
  urlParams = new URLSearchParams(window.location.search);
  ambiente = urlParams.get('t');

  if (ambiente == 'emp') {
    routes = empresa;
  } else if (ambiente == 'cre') {
    routes = credenciada;
  } else {
    routes = web;
  }
} else {
  if (hostname == "web1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_2__web__["a" /* default */];
  } else if (hostname == "empresa1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_3__empresa__["a" /* default */];
  } else if (hostname == "credenciada1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_4__credenciada__["a" /* default */];
  } else if (hostname == "parceiro1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_5__parceiro__["a" /* default */];
  } else {
    routes = __WEBPACK_IMPORTED_MODULE_2__web__["a" /* default */];
  }
}

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  history: true,
  mode: 'history',
  routes: routes
}));

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilidade__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie__ = __webpack_require__(850);



/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cliente__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__credenciada__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__empresa__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ltcat__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__usuario__ = __webpack_require__(879);










__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var Store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
      common: __WEBPACK_IMPORTED_MODULE_2__common__["a" /* default */],
      cliente: __WEBPACK_IMPORTED_MODULE_3__cliente__["a" /* default */],
      credenciada: __WEBPACK_IMPORTED_MODULE_4__credenciada__["a" /* default */],
      empresa: __WEBPACK_IMPORTED_MODULE_5__empresa__["a" /* default */],
      ltcat: __WEBPACK_IMPORTED_MODULE_6__ltcat__["a" /* default */],
      usuario: __WEBPACK_IMPORTED_MODULE_7__usuario__["a" /* default */]
    }
  });

  return Store;
});

/***/ }),
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */,
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_par',
    label: 'Copiar Tabela de Preço',
    placeholder: 'Selecione o parceiro...',
    clearable: true,
    info: 'Você pode copiar uma tabela de preço de outro parceiro. Escolha aqui o parceiro que deseja utilizar como modelo que o sistema vai duplicar a base de exames.',
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_exa',
    label: 'Exame',
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'parceiro_padrao',
    label: 'Parceiro Padrão',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'valor_custo',
    label: 'Valor de Custo',
    mask: 'money',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'valor_venda',
    label: 'Valor de Venda',
    mask: 'money',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'boolean',
    field: 'padrao',
    label: 'Definir esse Parceiro como Padrão',
    info: 'Aqui você pode habilitar esse parceiro como padrão para esse exame.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'boolean',
    field: 'atualizar_tb_empresa',
    label: 'Atualizar Tabela de Preço das Empresas',
    info: 'Se habilitar essa opção o sistema vai inserir na tabela de preço das empresas, caso não existir, esse parceiro como padrão para esse exame. Se existir esse parceiro cadastrado o sistema vai apenas definir o exame como esse parceiro padrão.',
    rules: ['']
}]);

/***/ }),
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EffectScope", function() { return EffectScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createApp", function() { return createApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return createRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customRef", function() { return customRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Plugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineAsyncComponent", function() { return defineAsyncComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineComponent", function() { return defineComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "del", function() { return del; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effectScope", function() { return effectScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentInstance", function() { return getCurrentInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentScope", function() { return getCurrentScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRaw", function() { return isRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReactive", function() { return isReactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadonly", function() { return isReadonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRef", function() { return isRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "markRaw", function() { return markRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextTick", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onActivated", function() { return onActivated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeMount", function() { return onBeforeMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUnmount", function() { return onBeforeUnmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUpdate", function() { return onBeforeUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onDeactivated", function() { return onDeactivated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorCaptured", function() { return onErrorCaptured; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onMounted", function() { return onMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onScopeDispose", function() { return onScopeDispose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onServerPrefetch", function() { return onServerPrefetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onUnmounted", function() { return onUnmounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onUpdated", function() { return onUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "provide", function() { return provide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "proxyRefs", function() { return proxyRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reactive", function() { return reactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readonly", function() { return readonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ref", function() { return ref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowReactive", function() { return shallowReactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowReadonly", function() { return shallowReadonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowRef", function() { return shallowRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRaw", function() { return toRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRef", function() { return toRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRefs", function() { return toRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerRef", function() { return triggerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unref", function() { return unref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useAttrs", function() { return useAttrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCSSModule", function() { return useCSSModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCssModule", function() { return useCssModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSlots", function() { return useSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watch", function() { return watch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchEffect", function() { return watchEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchPostEffect", function() { return watchPostEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchSyncEffect", function() { return watchSyncEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] " + msg);
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn$1(msg, vm) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn$1("Error in " + info + ": \"" + err.toString() + "\"", vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn(message) {
    var _a;
    warn$1(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destory on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(21);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn$1('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$" + prop];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn$1(hook + " is called when there is no active component instance to be " +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn$1("slots." + slotName + "() got called outside of the \"render()\" scope", vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn$1("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    value.value = value.value;
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn$1('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    setupAccessControl(observed);
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                var value = getter ? getter.call(obj) : val;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return value;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn$1('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob.__raw__ = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a, _b;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_b = (_a = observed) === null || _a === void 0 ? void 0 : _a.__ob__) === null || _b === void 0 ? void 0 : _b.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn$1("value cannot be made reactive: " + String(target));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn$1("value cannot be made reactive: " + String(obj));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn$1("Set operation on key \"" + key + "\" failed: target is readonly.");
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on" + (name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got " + mode);
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn$1("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn$1("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args)));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn$1("Invalid watch source: " + JSON.stringify(s) + ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.", vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn$1("Invalid watch source: " + JSON.stringify(source) + ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.", vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return Object.is(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn$1("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn$1('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn$1('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn$1("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn$1("injection \"" + String(key) + "\" not found.", vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    if (defaultValue === undefined && ("production" !== 'production')) {
        warn$1("Injection \"" + String(key) + "\" not found", vm);
    }
    return treatDefaultAsFactory && isFunction(defaultValue)
        ? defaultValue()
        : defaultValue;
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn$1("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn$1("Current instance does not have CSS module named \"" + name + "\".");
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign({ propsData: rootProps }, rootComponent));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn$1("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn$1("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!instance) {
        ("production" !== 'production') &&
            warn$1('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn$1("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn$1("The setup binding property \"" + propName + "\" is already declared as a prop.", vm);
        }
        else {
            warn$1("The setup binding property \"" + propName + "\" is already declared.", vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn$1("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            updateTemplateRef(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            var _a;
            updateTemplateRef(this);
            if ((_a = this.$vnode) === null || _a === void 0 ? void 0 : _a.context) {
                updateTemplateRef(this.$vnode.context);
            }
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn$1('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"" + Object.prototype.toString
                .call(binding)
                .slice(8, -1) + "\"");
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$" + key;
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn$1("Cannot assign to '" + key + "' because it is a read-only property", vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$" + key;
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn$1('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn$1("[vue-composition-api] only works with Vue 2, v" + Vue.version + " found.");
            }
        }
        else {
            warn$1('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$1("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn$1("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: " + comp);
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.4.4";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App'
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-alert",
  components: {},
  mixins: [],
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    },
    description: {
      type: String,
      default: ''
    }

  },
  watch: {
    title: function title() {},
    type: function type() {},
    description: function description() {}
  },

  data: function data() {
    return {
      showModal: false
    };
  },
  mounted: function mounted() {},


  methods: {}
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_laravel_echo__ = __webpack_require__(409);





/* harmony default export */ __webpack_exports__["default"] = ({
      name: "broadcast",
      components: {},
      mixins: [__WEBPACK_IMPORTED_MODULE_0_common_session___default.a],

      data: function data() {
            return {
                  pusher: null
            };
      },
      created: function created() {},
      beforeDestroy: function beforeDestroy() {
            window.Echo = null;
      },
      mounted: function mounted() {
            this.inicialize();
      },


      watch: {},

      methods: {
            inicialize: function inicialize() {

                  if (false) {
                        window.io = require('socket.io-client');
                        window.Echo = new Echo({
                              broadcaster: 'socket.io',
                              key: process.env.PUSHER_KEY,
                              host: process.env.URL_API.web + ':6001'
                        });
                  }
            },
            onBroadcast: function onBroadcast(_channel, _event, _onEvent, _notClear) {
                  var self = this;

                  _channel = (this.cliente.logged ? this.cliente.logged.id : '0') + (_channel ? '.' + _channel : '');
                  _event = (this.cliente.logged ? this.cliente.logged.id : '0') + (_event ? '.' + _event : '');;
            },


            unSubscribe: function unSubscribe(_channel) {
                  this.pusher.unsubscribe(_channel);
            },

            sendBroadcastEvent: function sendBroadcastEvent(_channel, _event, _data) {}

      }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-button",
  components: {},
  mixins: [],
  props: {
    icon: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    type: {
      type: String,
      default: function _default() {
        return 'primary';
      }
    },
    size: {
      type: String,
      default: function _default() {
        return 'medium';
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    loading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    click: {
      type: Function,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    icon: function icon() {},
    type: function type() {},
    size: function size() {},
    title: function title() {},
    value: function value() {},
    disabled: function disabled() {},
    loading: function loading() {},
    click: function click() {}
  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);



var _methods;



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ckeditor",
    components: {},
    mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],

    props: {
        model: {
            type: String,
            default: function _default() {
                return null;
            }
        },
        conteudo: {
            type: String,
            default: function _default() {
                return null;
            }
        },

        reload: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },

    data: function data() {
        return {
            loadingContent: true,
            urlRemove: [],
            initControls: null,
            deleteAll: null,
            mensagem: null,
            froalaConfig: {
                language: 'pt_br',
                placeholderText: "Escreva seu texto aqui",
                disableRightClick: true,
                key: "mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==",

                imageUploadParam: 'froala_image',
                imageUploadURL: '',
                imageUploadParams: { id: 'my_editor' },
                imageUploadMethod: 'POST',
                imageMaxSize: 5 * 1024 * 1024,
                imageAllowedTypes: ['jpeg', 'jpg', 'png'],
                requestHeaders: {},
                imageStyles: {
                    imageAddBorda: 'Adicionar Borda'
                },

                imageManagerPageSize: 20,
                imageManagerScrollOffset: 10,
                imageManagerLoadURL: "",
                imageManagerLoadMethod: "GET",
                imageManagerLoadParams: { user_id: 4219762 },
                imageManagerDeleteURL: "",
                imageManagerDeleteMethod: "POST",
                imageManagerDeleteParams: { param: 'value' },
                toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'embedly', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo'],
                imageEditButtons: ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],

                events: {}
            }
        };
    },
    mounted: function mounted() {
        this.init();
    },


    watch: {
        'conteudo': function conteudo() {
            this.init();
        },
        'mensagem': function mensagem() {
            this.setConteudo();
        },
        'model': function model() {},
        reload: function reload() {
            this.init();
        }
    },

    methods: (_methods = {
        setConteudo: function setConteudo() {
            this.$events.fire('ckeditor-' + this.model, this.mensagem);
        },


        init: function init() {

            var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.froalaConfig);

            this.froalaConfig = config;
            this.mensagem = this.conteudo;
            this.loadingContent = false;
        },

        initialize: function initialize(initControls) {
            var _this = this;

            this.initControls = initControls;
            this.deleteAll = function () {
                _this.initControls.getEditor()('html.set', '');
                _this.initControls.getEditor()('undo.reset');
                _this.initControls.getEditor()('undo.saveStep');
            };

            this.initControls.initialize();
        },

        initialized: function initialized() {},

        imageBeforeUpload: function imageBeforeUpload(e, editor, files) {},

        imageUploaded: function imageUploaded(e, editor, response) {},

        imageInserted: function imageInserted(e, editor, $img, response) {},

        imageReplaced: function imageReplaced(e, editor, $img, response) {},

        imagesLoaded: function imagesLoaded(e, editor, data) {},

        imageLoaded: function imageLoaded(e, editor, $img) {},

        beforeDeleteImage: function beforeDeleteImage(e, editor, $img) {},

        imageDeleted: function imageDeleted(e, editor, data) {}

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imageDeleted', function imageDeleted(e, editor, $img) {

        var src = $img[0] && $img[0]['currentSrc'] ? $img[0]['currentSrc'] : null;

        if (src) {
            this.post('froala/delete', { src: src }).then(function (result) {

                result = result[0];
                console.log(result);
            });
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imageError', function imageError(e, editor, error, response) {}), _methods)
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "upload",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],

  props: {
    arquivo: {
      type: [Object, String],
      default: function _default() {
        return null;
      }
    },
    fullWidth: {
      type: [Boolean],
      default: function _default() {
        return false;
      }
    }
  },

  data: function data() {
    return {
      id: 0,
      loadingDelete: false
    };
  },
  mounted: function mounted() {
    this.inicialize();
  },


  watch: {
    arquivo: function arquivo() {
      this.inicialize();
    }
  },

  methods: {

    inicialize: function inicialize() {
      this.id = new Date().getTime().toString();
    },

    downloadFile: function downloadFile(arquivo) {

      var id = arquivo && arquivo.id ? arquivo.id : this.arquivo && this.arquivo.id ? this.arquivo.id : null;

      if (!id) alert('Arquivo inválido');

      this.open('arquivo/' + this.toMd5(id) + '/download');
    },

    displayFile: function displayFile(arquivo) {
      return this.getUrl('arquivo/' + this.toMd5(arquivo.id) + '/display');
    },
    deleteFile: function deleteFile(arquivo) {
      return this.post('arquivo/' + this.toMd5(arquivo.id) + '/deletar');
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-error",
  components: {},
  mixins: [],

  props: {

    response: {
      type: Object,
      default: function _default() {
        return null;
      }
    }

  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  watch: {
    response: function response() {}
  },

  methods: {}
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_64__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);



var FileSaver = __webpack_require__(1016);






__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale("pt-br");

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "fct",
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {
    getLocation: function getLocation(type) {
      var hostname = window.location;

      type = type ? type : 'hostname';

      return hostname[type];

      return '';
    },
    random: function random(min, max) {
      return Math.random() * (max - min) + min;
    },
    arrFindByField: function arrFindByField(arr, field, value) {
      if (!field || !arr || !arr.length > 0) return null;

      var arr = arr.filter(function (x) {
        return x[field] == value;
      });

      if (arr.length == 1) return arr[0];

      return null;
    },
    onlyNumber: function onlyNumber(value) {
      if (!value) return "";

      return value.replace(/[\. ,:-]+/g, "-").replace(/[^0-9\.]+/g, "");
    },
    onlyText: function onlyText(value) {
      if (!value) return "";

      value = this.toString(value);
      return value.replace(/(<([^>]+)>)/gi, "");
    },
    tempoSessao: function tempoSessao() {
      var jwt = null,
          iat = 0,
          exp = 0;

      try {
        jwt = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(this.jwt);
      } catch (error) {
        jwt = null;
      }

      if (jwt) {
        exp = this.toDate(jwt.exp * 1000, false, "YYYY-MM-DD HH:mm:ss");

        var diffSecs = Math.abs(this.diffDays(null, exp, "s")).toFixed(0);

        var hours = Math.floor(diffSecs / 3600);
        var minutes = Math.floor((diffSecs - hours * 3600) / 60);

        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;

        return hours + "h " + minutes + "m";
      }

      return "00h 00m";
    },
    stringToArray: function stringToArray(string) {
      if (!string) return [];

      return JSON.parse(string);
    },
    toFormUpload: function toFormUpload(form) {
      var data = new FormData();

      for (var key in form) {
        data.append(key, form[key] != null ? form[key] : '');
      }

      return data;
    },
    toJoin: function toJoin(data) {

      var retorno = '';

      if ((typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) == 'object') {
        for (var key in data) {
          retorno += key + ": " + data[key] + "\n";
        }
      } else if (typeof data == 'array') {
        retorno = data.join('\n');
      } else {
        retorno = data;
      }

      return retorno;
    },
    textSpace: function textSpace(text) {
      try {
        text = this.toString(text).split(' ');
        return text[0];
      } catch (error) {
        return text;
      }
    },
    booleanToInteger: function booleanToInteger(form) {
      for (var key in form) {
        if (form[key] === true) form[key] = 1;

        if (form[key] === false) form[key] = 0;
      }

      return form;
    },
    base64Decode: function base64Decode(value) {
      try {
        return __WEBPACK_IMPORTED_MODULE_2_base_64___default.a.decode(value);
      } catch (err) {
        return null;
      }
    },
    base64Encode: function base64Encode(value) {
      try {
        return __WEBPACK_IMPORTED_MODULE_2_base_64___default.a.encode(value);
      } catch (err) {
        return null;
      }
    },
    utf8Decode: function utf8Decode(t) {
      if (!t) return t;

      try {
        return decodeURIComponent(escape(t));
      } catch (err) {
        return t;
      }
    },
    intervaloMes: function intervaloMes(mes, ano) {
      if (!mes || !ano) {
        mes = new Date().getMonth() + 1;
        ano = new Date().getFullYear();
      }

      var data = new Date(ano + "-" + mes + "-01");
      return data;
    },
    now: function now() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd");
    },
    toDate: function toDate(date, disableHours, format) {
      if (!date) {
        date = new Date();
      }

      if (!format) {
        format = "DD/MM/YYYY HH:mm:ss";

        if (disableHours) {
          format = "DD/MM/YYYY";
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(format);
    },
    convertDate: function convertDate(date, format) {
      if (!date) {
        return new Date();
      }

      format = format ? format : 'DD/MM/YYYY';

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(format);
    },
    moneyToFloat: function moneyToFloat(value) {
      if (!value || value == "") {
        return 0;
      }

      value = this.toString(value);

      return parseFloat(value.replace(".", "").replace(",", "."));
    },
    floatToMoney: function floatToMoney(value) {
      if (!value) {
        return "0,00";
      }

      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      });

      value = formatter.format(value).replace("R$", "").trim();

      return value;
    },
    formataCampo: function formataCampo(text, left, format) {

      format = !format ? '0' : format;
      left = !left ? 0 : left;

      if (!text) return text;

      return text.toString().padStart(left, format);
    },
    formataRevisao: function formataRevisao(data) {

      var retorno = [],
          tmpEmp = [];

      for (var i = 0; i < data.length; i++) {
        var element = data[i];

        if (element.empresa && element.fdt) {
          var key = element.empresa.id + '_' + element.fdt.id;

          if (tmpEmp.indexOf(key) == -1) {
            tmpEmp.push(key);
            retorno.push({
              id: key,
              label: element.empresa.nome + ' :: ' + element.fdt.pcmso + ' (' + element.fdt.descricao + ')',
              options: []
            });
          }

          retorno[tmpEmp.indexOf(key)]['options'].push(element);
        }
      }
      return retorno;
    },
    addDate: function addDate(value, date, type, utc) {

      if (!date) {
        date = new Date();
      } else {
        date = new Date(date);
      }

      switch (type) {
        case "y":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'years').toDate();
          break;
        case "M":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'months').toDate();
          break;
        case "D":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'days').toDate();
          break;
        case "h":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'hours').toDate();
          break;
        case "m":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'minutes').toDate();
          break;
        case "s":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'secounds').toDate();
          break;
        default:
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'days').toDate();
      }

      if (utc) {
        return date.toUTCString();
      }
      return date;
    },
    diffDays: function diffDays(date1, date2, type) {
      type = !type ? "d" : type;
      date1 = !date1 ? __WEBPACK_IMPORTED_MODULE_1_moment___default()() : __WEBPACK_IMPORTED_MODULE_1_moment___default()(date1);
      date2 = !date2 ? __WEBPACK_IMPORTED_MODULE_1_moment___default()() : __WEBPACK_IMPORTED_MODULE_1_moment___default()(date2);

      switch (type) {
        case "y":
          return date1.diff(date2, "years", true);
          break;
        case "d":
          return date1.diff(date2, "days", true);
          break;
        case "h":
          return date1.diff(date2, "hours", true);
          break;
        case "m":
          return date1.diff(date2, "minutes", true);
          break;
        case "s":
          return date1.diff(date2, "seconds", true);
          break;
        default:
          return date1.diff(date2, "days", true);
          break;
      }
    },
    b64toBlob: function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });

      return blob;
    },
    download: function download(blobData, filename) {
      FileSaver.saveAs(blobData, filename);
    },
    utf8_encode: function utf8_encode(s) {
      return unescape(encodeURIComponent(s));
    },
    utf8_decode: function utf8_decode(s) {
      return decodeURIComponent(escape(s));
    },


    toMb: function toMb(bytes) {

      if (!bytes) return '0 MB';

      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    },

    toString: function toString(value) {
      if (value == null || value == undefined) return '';

      return value.toString();
    },
    toMd5: function toMd5(text) {

      try {
        text = this.toString(text);
        text = __WEBPACK_IMPORTED_MODULE_3_js_md5___default()(text);
        return text;
      } catch (e) {
        return text;
      }
    },
    edAlert: function edAlert(_msg, _type, _items) {

      _type = _type ? _type : 'success';

      this.$alert(_msg, 'Atenção', {
        type: _type,
        confirmButtonText: 'OK'
      });
    },
    edMsg: function edMsg(_msg, _type) {

      _type = _type ? _type : 'success';

      this.$message({
        showClose: true,
        type: _type,
        message: _msg
      });
    },
    edNotification: function edNotification(_msg, _type) {

      _type = _type ? _type : 'success';

      this.$notify({
        showClose: true,
        type: _type,
        message: _msg
      });
    },
    validateEmail: function validateEmail(email) {

      email = email ? email.trim() : null;

      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    getPreco: function getPreco(value, type) {
      if (!value) return null;

      var arr = value.split(',');

      if (arr.length != 2) return null;

      if (type == 'unit') return arr[0];else return arr[1];
    },
    textLimit: function textLimit(value, limit) {

      limit = limit ? limit : 100;

      if (value && value.length > limit) {
        return value.substring(0, limit) + "...";
      }

      return value;
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_error__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_ckeditor__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_ckeditor__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-form",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, EdError: __WEBPACK_IMPORTED_MODULE_4_common_error___default.a, EdUpload: __WEBPACK_IMPORTED_MODULE_2_common_upload___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_5_common_alert___default.a, EdEditor: __WEBPACK_IMPORTED_MODULE_6_common_ckeditor___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    response: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    save: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    itens: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    data: function data() {
      this.inicialize();
    },
    response: function response() {
      this.inicialize();
    },
    save: function save() {},
    config: function config() {
      this.inicialize();
    },
    "config.click": function configClick() {
      this.inicialize();
    },
    "config.list": function configList() {
      this.inicialize();
    },
    "config.tipo_exclude": function configTipo_exclude() {
      this.inicialize();
    },
    "config.obs": function configObs() {},
    itens: function itens() {}
  },

  data: function data() {
    return {
      id: this.toString(new Date().getTime()),
      rules: {
        required: { required: true, message: "Campo Obrigatório", trigger: "blur" },
        email: { type: "email", message: "Informe um email válido", trigger: ["blur", "change"] }
      },
      mask: {
        money: "money",
        number: "999999999999999999",
        cep: "99.999-999",
        cbo: "9999-99",
        time: "99:99:99",
        cpf: "999.999.999-99",
        cnpj: "99.999.999/9999-99",
        documento: "99.999.999/9999-99",
        celular: "(99) 99999-9999",
        telefone: "(99) 9999-9999",
        date: "99/99/9999",
        esocial: "99.99.999"
      },
      predefineColors: ["#ff4500", "#d72d12", "#ff8c00", "#ffd700", "#90ee90", "#18BE31", "#00ced1", "#1e90ff", "#c71585", "#9C5317"],
      error: {},
      tipos: {},
      cidades: [],
      estados: [],
      funcoes: [],
      events: [],
      cnaes: [],
      revisoesEmp: [],
      status: 200,
      loadingEstado: false,
      loadingCidade: false,
      loadingCnae: false,
      handleCidadeDebounce: null,
      handleCnaeDebounce: null,
      maxDaysTomorrow: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.handlerClear();
  },
  mounted: function mounted() {
    this.inicialize();
    this.handleCidadeDebounce = _.debounce(this.handleCidade, 1000);
    this.handleCnaeDebounce = _.debounce(this.handleCnae, 1000);
  },


  methods: {
    inicialize: function inicialize() {
      this.error = {};

      if (this.response.options && this.response.options.data) {
        this.error = this.response.options.data;
      }
      this.status = this.response.status ? this.response.status : 200;

      if (this.config.estado) {
        this.handleEstado();
      }

      if (this.config.cnae) {
        this.handleCnae(this.data.cnae && this.data.cnae.cnae ? this.data.cnae.cnae : this.data.cnae);
      }

      if (this.config.tipo && this.config.tipo.length > 0) {
        this.handleParametros();
      }
    },
    handlerClear: function handlerClear() {
      this.id = null;
      this.error = {};
      this.tipos = {};
      this.cidades = [], this.estados = [];
      this.funcoes = [];
      this.events = [];
      this.cnaes = [];
    },
    handlerUpload: function handlerUpload() {
      var _this = this;

      var _loop = function _loop() {
        var event = "upload-" + field;

        if (field.search("arquivo") != -1 && _this.events.indexOf(event) == -1) {
          _this.$events.on(event, function (eventData) {
            if (_this.events.indexOf(event) != -1) {}
          });

          _this.events.push(event);
        }
      };

      for (var field in this.data) {
        _loop();
      }
    },
    handleValidation: function handleValidation() {
      var retorno = true;

      for (var i = 0; i < this.itens.length; i++) {
        var item = this.itens[i];

        if (item && item.rules) {
          var field = item.field,
              input = this.data[field];

          for (var j = 0; j < item.rules.length; j++) {
            var element = item.rules[j];

            switch (element) {
              case "required":
                if (input == null || input == "") {
                  this.error[field] = ["Campo obrigatório"];
                  retorno = false;
                }
                break;
            }
          }
        }
      }

      return retorno;
    },
    handlerSave: function handlerSave() {
      this.config.click.save();
    },
    handleValueSelect: function handleValueSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.value) {
        switch (item.option.value) {
          case "object":
            return val;
            break;

          case "id":
            return parseInt(val[item.option.value]);
            break;

          default:
            return val[item.option.value];
            break;
        }
      }

      return val.id;
    },
    handleLabelSelect: function handleLabelSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.label) {
        switch (item.option.label) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            var parent = "";

            if (val.parent) {
              parent = val.parent.rev + " (" + val.parent.descricao + ") / ";
            }

            return (val.empresa ? val.empresa.nome + " :: " : "") + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ") :: " : "") + parent + val.rev + " (" + val.descricao + ")";

            break;

          case "funcionario":
            return val.nome + " (" + val.cpf + ")";
            break;

          case "empresa":
            return val.nome + " (" + val.cnpj + ")";
            break;

          case "financeiro.conta":
            return "AG: " + val.agencia + " CC: " + val.conta;
            break;

          case "equipamento_medicao":
            return val.nome + " / " + val.marca + " / " + val.modelo + " / " + val.serie;
            break;

          case "tabela.preco":
            return (val.empresa ? val.empresa.nome : "") + " / " + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")" : "");
            break;

          case "esocial":
            return val.codigo;
            break;

          case "fator_risco":
          case "tabela_dinamica":
            return val.nome;
            break;

          default:
            return val[item.option.label];
            break;
        }
      }

      return val.nome;
    },
    handleTitleSelect: function handleTitleSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.title) {
        switch (item.option.title) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            return (val.empresa ? val.empresa.nome + " :: " : "") + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ") :: " : "") + val.rev + " (" + val.descricao + ")";
            break;

          case "funcionario":
            return val.nome + " (" + val.cpf + ")";
            break;

          case "ltcat_orcamento":
            return val.codigo;
            break;

          case "empresa":
            return val.nome + " (" + val.cnpj + ")";
            break;

          case "equipamento_medicao":
            return val.nome + " / " + val.marca + " / " + val.modelo + " / " + val.serie;
            break;

          case "financeiro.conta":
            return "AG: " + val.agencia + " CC: " + val.conta;
            break;

          case "tabela.preco":
            return (val.empresa ? val.empresa.nome : "") + " / " + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")" : "");
            break;

          default:
            return val[item.option.title];
            break;
        }
      }

      return val.nome;
    },
    handleLabelSelectHtml: function handleLabelSelectHtml(item, val) {
      var width = this.window.width,
          limit = width * 0.98 / 10;

      limit = 80;

      if (!val) return val;

      if (item.option && item.option.label) {
        switch (item.option.label) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            return '<span style="' + (val.style ? val.style : "") + '">' + (!val.parent ? "<b>" + val.rev + " (" + val.descricao + (val.data ? " em " + this.toDate(val.data, true) : "") + ")" + "</b>" : val.rev + " (" + val.descricao + (val.data ? " em " + this.toDate(val.data, true) : "") + ")") + "</span>";
            break;

          case "funcionario":
            return "<b>" + val.nome + "</b>" + (val.empresa ? ' (<span style="font-size:9pt">' + val.empresa.nome + "</span>)" : "") + (val.cpf ? '<br><span style="font-size:9pt">' + val.cpf + "</span>" : "");
            break;

          case "ltcat_orcamento":
            return "<b>" + val.codigo + " (" + this.toDate(val.updated_at) + ")" + "</b>" + (val.descricao ? '<br><span style="font-size:9pt">' + val.descricao + "</span>" : "");
            break;

          case "financeiro.conta":
            return "<br>AG:</b> " + val.agencia + " <b>CC:</b> " + val.conta;
            break;

          case "tabela.preco":
            return "<b>" + (val.empresa ? val.empresa.nome + "</b>" : "") + '<br><span style="font-size:9pt">' + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")</span>" : "");
            break;

          case "consulta":
            return "<b>CÓD: " + val.id_con + " (" + this.toDate(val.dt_cad, true) + ")</b>" + (val.empresa ? '<br><span style="font-size:9pt">' + val.empresa.nome + "</span>" : "") + (val.funcionario ? '<br><span style="font-size:9pt">' + val.funcionario.nome + "</span>" : "");
            break;

          case "empresa":
            return "<b>" + val.nome + "</b>" + (val.cnpj ? '<br><span style="font-size:9pt">' + val.cnpj + "</span>" : "");
            break;

          case "esocial":
            return "<b>" + this.textLimit(val.nome, limit) + "</b>" + (val.codigo ? '<br><span style="font-size:9pt">' + val.codigo + "</span>" : "");
            break;

          case "fator_risco":
            return "<b>" + this.textLimit(val.nome, limit) + "</b>" + (val.cod_esocial ? '<br><span style="font-size:9pt">' + val.cod_esocial + "</span>" : "") + (val.cod_metodologia && val.cod_metodologia != "***" ? (!val.cod_esocial ? "<br>" : "") + '<span style="font-size:9pt"> (' + val.cod_metodologia + ")</span>" : "");
            break;

          case "tabela_dinamica":
            return '<span style="width:40px;margin-bottom:1px;margin-rigth:5px;float:left;background:' + val.cor + '">&nbsp;</span>' + val.nome;
            break;

          case "equipamento_medicao":
            return "<b>" + val.nome + "</b>" + (val.marca ? '<br><span style="font-size:9pt">' + val.marca + " / " + val.modelo + " / " + val.serie + "</span>" : "");
            break;

          default:
            return val[item.option.label];
            break;
        }
      }

      return val.nome;
    },
    handlerDisableYesterdayDate: function handlerDisableYesterdayDate(date) {
      var hoje = this.toDate(null, true, "YYYY-MM-DD");
      date = this.toDate(date, true, "YYYY-MM-DD");

      if (this.maxDaysTomorrow) {
        var diff = this.diffDays(date);
        if (diff > this.maxDaysTomorrow) {
          return true;
        }
      }

      return date < hoje;
    },
    handlerDisableTomorrowDate: function handlerDisableTomorrowDate(date) {
      var hoje = this.toDate(null, true, "YYYY-MM-DD");
      date = this.toDate(date, true, "YYYY-MM-DD");

      if (this.maxDaysTomorrow) {
        var diff = this.addDate(this.maxDaysTomorrow, date, "d");
        if (diff > this.maxDaysTomorrow) {
          return false;
        }
      }

      return date > hoje;
    },
    handleTimeOptions: function handleTimeOptions() {
      return {
        start: "00:00",
        step: "00:15",
        end: "24:00"
      };
    },
    handleDateOptions: function handleDateOptions(item) {
      var options = null;

      this.maxDaysTomorrow = item.maxDaysTomorrow;

      if (item.yesterdayDisabledDate) {
        options = {
          disabledDate: this.handlerDisableYesterdayDate
        };
      } else if (this.config.options && this.config.options[item.field] && this.config.options[item.field].disabledDate) {
        options = {
          disabledDate: this.config.options[item.field].disabledDate
        };
      }

      if (item.tomorrowDisabledDate) {
        options = {
          disabledDate: this.handlerDisableTomorrowDate
        };
      }

      return options;
    },
    handleRules: function handleRules(rules) {
      if (!rules || rules.length == 0) return [];

      var arr = [];

      for (var i = 0; i < rules.length; i++) {
        if (this.rules[rules[i]]) arr.push(this.rules[rules[i]]);
      }

      return arr;
    },
    handlePrefixIcon: function handlePrefixIcon(item) {
      switch (item.mask) {
        case "money":
          return "fas fa-dollar-sign";
          break;

        case "cpf":
        case "cnpj":
        case "documento":
          return "fas fa-credit-card";
          break;

        case "telefone":
          return "fas fa-phone";
          break;

        case "celular":
          return "fas fa-mobile-alt";
          break;
      }
    },
    handleParametros: function handleParametros() {
      var _this2 = this;

      var exclude = this.config.tipo_exclude ? this.config.tipo_exclude : [];

      this.post("tipo/parent", { codigo: this.config.tipo, exclude: exclude }).then(function (result) {
        result = result[0];

        _this2.tipos = {};

        if (result.status == 200) {
          for (var i = 0; i < _this2.config.tipo.length; i++) {
            _this2.tipos[_this2.config.tipo[i]] = result.data[_this2.config.tipo[i]];
          }
        }
      });
    },


    handleCnae: function handleCnae(search) {
      var _this3 = this;

      this.loadingCnae = true;
      this.cnaes = [];

      if ((typeof search === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(search)) == "object" && search) {
        search = search["cnae"];
      }

      this.get("common/cnae", { search: search }).then(function (result) {
        result = result[0];

        _this3.loadingCnae = false;

        if (result.status == 200) {
          _this3.cnaes = result.data.data;
        }
      });
    },

    handleEstado: function handleEstado() {
      var _this4 = this;

      this.loadingEstado = true;

      this.get("common/estado", null, true).then(function (result) {
        result = result[0];

        _this4.loadingEstado = false;
        _this4.estados = [];

        if (result.status == 200) {
          _this4.estados = result.data;

          if (_this4.data.id_estado) _this4.handleCidade(_this4.data.id_cidade ? _this4.data.id_cidade : "");
        }
      });
    },
    handleCidade: function handleCidade(search) {
      var _this5 = this;

      if (!this.data || !this.data.id_estado) return;

      this.cidades = [];
      this.loadingCidade = true;

      this.get("common/cidade/" + this.data.id_estado, { search: search, take: 100 }, true).then(function (result) {
        result = result[0];

        _this5.loadingCidade = false;

        if (result.status == 200) {
          _this5.cidades = result.data;
        }
      });
    },
    handleEndereco: function handleEndereco() {
      var _this6 = this;

      var cep = this.onlyNumber(this.data.cep);

      if (!cep) return;

      this.get("common/cep/" + cep, null, true).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this6.data.end = result.data.endereco.logradouro ? result.data.endereco.logradouro : _this6.data.end;

          _this6.data.bairro = result.data.endereco.bairro ? result.data.endereco.bairro : _this6.data.endereco_bairro;

          _this6.data.comp = result.data.endereco.complemento ? result.data.endereco.complemento : _this6.data.endereco_complemento;

          if (result.data.cidade) {
            _this6.data.id_cidade = result.data.cidade.id_cidade;
            _this6.cidades = [result.data.cidade];
          }

          if (result.data.estado) {
            _this6.data.id_estado = result.data.estado.uf;
          }
        }
      });
    }
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "logout",
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: false
    };
  },
  mounted: function mounted() {
    this.inicialize();
  },


  methods: {
    inicialize: function inicialize() {
      var _this = this;

      if (!this.logged()) {
        this.toRoute({ name: this.sub_domain + '.login' });
        return;
      }

      var self = this;

      this.$confirm('Tem certeza que deseja encerrar sua sessão no sistema?', 'Atenção', {
        type: 'warning'

      }).then(function () {

        self.loadingContent = true;

        _this.post("usuario/logout").then(function (result) {
          result = result[0];
          self.loadingContent = false;
          _this.logout();
        });
      }).catch(function () {
        _this.toRoute({ name: _this.sub_domain + '.home' });
      });
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_session__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_session__);





/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a, __WEBPACK_IMPORTED_MODULE_1_common_session___default.a],
	data: function data() {
		return {};
	}
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_broadcast__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_broadcast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_broadcast__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a, __WEBPACK_IMPORTED_MODULE_2_common_broadcast___default.a],
  components: {},
  created: function created() {},


  mounted: function mounted() {},

  data: function data() {
    return {
      sessao: "08h 00m",
      loadingContent: true,
      items: [{
        text: 'Admin',
        href: '#'
      }, {
        text: 'Manage',
        href: '#'
      }, {
        text: 'Library',
        active: true
      }]
    };
  },

  methods: {

    getMensagem: function getMensagem(result) {
      if (result && result.data) {
        var mensagem = result.data;

        this.$notify({
          title: mensagem.title ? mensagem.title : "Atenção",
          message: mensagem.message,
          type: mensagem.type ? mensagem.type : "success",
          offset: 100,
          duration: 10000
        });
      }
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-modal",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_1_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_session___default.a],
  props: {
    title: {
      type: String,
      default: 'Modal'
    },
    modal: {
      type: Boolean,
      default: false
    },
    onClear: {
      type: Function,
      default: null
    },
    loadingSave: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '95%'
    },
    saveIcon: {
      type: String,
      default: 'fa fa-save'
    },
    closeESC: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: true
    },
    closeCLICK: {
      type: Boolean,
      default: false
    },
    lodingSave: {
      type: Boolean,
      default: false
    },
    disabledSave: {
      type: Boolean,
      default: false
    },
    saveName: {
      type: String,
      default: 'Salvar'
    },
    onSave: {
      type: Function,
      default: null
    },
    onClose: {
      type: Function,
      default: null
    }

  },
  watch: {
    title: function title() {},
    disabledSave: function disabledSave() {},
    modal: function modal() {
      this.showModal = !this.showModal;
    },
    loading: function loading() {},
    loadingSave: function loadingSave() {},
    width: function width() {},
    saveIcon: function saveIcon() {},
    closeESC: function closeESC() {},
    isModal: function isModal() {},
    closeCLICK: function closeCLICK() {},
    lodingSave: function lodingSave() {},
    saveName: function saveName() {},
    onSave: function onSave() {}
  },

  data: function data() {
    return {
      showModal: false
    };
  },
  mounted: function mounted() {},


  methods: {
    handlerClose: function handlerClose() {
      if (this.onClose) {
        this.onClose();
      } else {
        this.showModal = false;
      }
    }
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-paginate",
  components: {},
  mixins: [],

  props: {
    pagination: {
      type: Object,
      default: null
    },
    navigation: {
      type: Function,
      default: function _default() {
        return;
      }
    }
  },

  watch: {
    pagination: function pagination() {},
    navigation: function navigation() {}
  },

  data: function data() {
    return {
      page: 1
    };
  },
  mounted: function mounted() {},


  methods: {
    onHandlerPage: function onHandlerPage() {
      this.navigation(this.page);
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_session__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_stringify_safe__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_json_stringify_safe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_broadcast__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_broadcast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_broadcast__);










/* harmony default export */ __webpack_exports__["default"] = ({

	name: "rest",
	components: {},
	mixins: [__WEBPACK_IMPORTED_MODULE_4_common_session___default.a, __WEBPACK_IMPORTED_MODULE_6_common_broadcast___default.a],

	data: function data() {
		return {
			requestParam: {
				force_web: false,
				url: "web1.softwareatento.com.br",
				xToken: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).X_TOKEN,
				appVersion: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).APP_VERSION,
				service: null,
				method: null,
				encryptData: null,
				jwt: null,
				headers: null,
				loginRedirect: true,
				uploadProgress: null
			}
		};
	},
	mounted: function mounted() {},


	methods: {

		getUrl: function getUrl(method) {
			this.setUrl();
			return this.requestParam.url + method + '?token=' + this.logged();
		},

		get: function get(_service, _params, _force_web) {

			_params = !_params ? '' : '?' + $.param(_params);

			this.requestParam.service = _service + _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'GET';

			return this.request();
		},
		post: function post(_service, _params, _filters, _force_web) {

			_filters = !_filters ? '' : '?' + $.param(_filters);

			this.requestParam.service = _service + _filters;
			this.requestParam.param = _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'POST';

			return this.request();
		},

		put: function put(_service, _params, _filters, _force_web) {

			_filters = !_filters ? '' : '?' + $.param(_filters);

			this.requestParam.service = _service + _filters;
			this.requestParam.param = _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'PUT';

			return this.request();
		},

		delete: function _delete(_service, _params, _filters, _force_web) {

			_filters = !_filters ? '' : '?' + $.param(_filters);

			this.requestParam.service = _service + _filters;
			this.requestParam.param = _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'DELETE';

			return this.request();
		},

		open: function open(_service, _params) {
			this.setUrl();

			_params = !_params ? '' : '&' + $.param(_params);

			var token = this.logged();

			if (token) _service += '?token=' + token + _params;

			window.open(this.requestParam.url + _service, '_blank');
		},

		removeStyle: function removeStyle() {
			$('body').removeAttr('style');
			$('body').removeClass('el-loading-parent--relative el-loading-parent--hidden');
		},

		getReq: function getReq() {
			var req = {
				date: null,
				hash: null
			};

			req.date = this.addDate(1, null, 'm');
			req.date = this.toDate(req.date, false, 'YYYY-MM-DD HH:mm:ss');

			req.hash = this.toMd5(req.date + "6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E");

			return this.base64Encode(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(req));
		},


		getHeaders: function getHeaders(onlyeJWT) {

			var jwt = this.logged(),
			    version = this.getCookie('version'),
			    req = {
				date: null,
				hash: null
			};

			if (onlyeJWT) {
				return {
					'authorization': jwt ? 'Bearer ' + jwt : null
				};
			}

			var headers = {
				'Authorization': jwt ? 'Bearer ' + jwt : null,
				'Version': version ? version : 'null',
				'Accept': 'application/json',
				'Content-Type': 'application/json;charset=UTF8',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
				'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type'
			};

			headers["xToken"] = this.getReq();

			return headers;
		},

		setHeaders: function setHeaders() {

			this.requestParam.headers = this.getHeaders();

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common = this.requestParam.headers;
		},

		setUrl: function setUrl() {

			var sub_domain = this.requestParam.force_web == true ? 'web' : this.sub_domain,
			    url = "https://" + __webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"})[sub_domain];

			if (true) {
				url += '/commtrol';
			}

			url += '/api/';

			if (sub_domain != 'web') url += this.tenant + '/';

			this.requestParam.url = url;

			return url;
		},

		request: function request() {
			var _this = this;

			this.setUrl();
			this.setHeaders();

			var response = {};

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

				response = { msg: 'OK', status: 200, data: null };
				var promisses = [],
				    self = _this;

				__WEBPACK_IMPORTED_MODULE_3_axios___default()({
					method: _this.requestParam.method,
					url: _this.requestParam.service,
					data: _this.requestParam.param,
					baseURL: _this.requestParam.url,

					onUploadProgress: function onUploadProgress(progressEvent) {
						var uploadProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);

						if (uploadProgress == 100) {
							uploadProgress = 99;
						}

						self.requestParam.uploadProgress = uploadProgress;
					},

					onDownloadProgress: function onDownloadProgress(progressEvent) {}
				}).then(function (result) {

					response = result.data;
					promisses.push(response);

					_this.removeStyle();
					_this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

					if (_this.env.log && _this.env.log.request) {
						console.log('[request ' + _this.requestParam.method + ' TO => ' + _this.requestParam.service + ' ' + result.status + ']');
					}

					return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
						resolve(success);
					}, function (err) {});
				}).catch(function (err) {

					var error = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, err).response;
					_this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

					if (!error) {

						error = {
							status: 500,
							msg: 'Não foi possível completar a requisição. Precione as teclas CTRL+F5 para recarregar a página e tente novamente.',
							data: null
						};

						error.data = error;
					}

					if (error) {

						response = error.data;

						switch (response.status) {

							case 400:

								if (response.options && response.options.data) {

									var h = _this.$createElement;
									var items = [],
									    validation_messages = response.options.data;
									_this.edAlert(response.msg, 'error');
								}

								break;

							case 401:
								_this.logout();
								break;

							case 413:
								response.msg = 'A requisição excedeu o tamanho limite.';
								response.data = 'A requisição excedeu o tamanho limite.';
								break;

							case 426:
								window.location.reload(true);
								break;

							case 429:
								_this.edAlert('Servico indisponível. Aguarde 5 minutos e tente novamente.', 'error');
								break;
						}
					}

					promisses.push(response);

					if (_this.env.log && _this.env.log.request) {
						console.log('[request ' + _this.requestParam.method + ' TO => ' + _this.requestParam.service + ' ' + response.status + ']');
						console.log(error);
					}

					if (_this.requestParam.method != 'GET' && response.status != 200 && response.status != 400 && response.status != 426 && response.status != 403 && response.status != 401 && response.status != 404) {
						_this.edAlert(response.msg, 'error');
					}

					_this.removeStyle();

					return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
						resolve(success);
					}, function (err) {});
				});
			});
		}

	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "session",
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
  computed: {
    cliente: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setCliente", value);
      }
    },
    production: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    usuario: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    jwt: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario.jwt;
      },
      set: function set(jwt) {
        this.$store.dispatch("usuario/setJwt", jwt);
      }
    },
    sub_domain: {
      cache: false,
      get: function get() {
        return this.$store.state.common.sub_domain;
      },
      set: function set(value) {
        this.$store.dispatch("common/setSubDomain", value);
      }
    },
    tenant: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente.tenant;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setTenant", value);
      }
    },
    env: {
      cache: false,
      get: function get() {
        return this.$store.state.common.env;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEnv", value);
      }
    },
    navigation: {
      cache: false,
      get: function get() {
        return this.$store.state.common.navigation;
      },
      set: function set(value) {
        this.$store.dispatch("common/setNavigation", value);
      }
    },
    window: {
      cache: false,
      get: function get() {
        return this.$store.state.common.window;
      },
      set: function set(value) {
        this.$store.dispatch("common/setWindow", value);
      }
    },
    device: {
      cache: false,
      get: function get() {
        return this.$store.state.common.device;
      }
    }
  },
  watch: {
    sub_domain: function sub_domain() {},
    navigation: function navigation() {},
    window: function window() {},
    "cliente.logged": function clienteLogged() {
      this.setTitle();
    },
    "usuario.logged": function usuarioLogged() {}
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    logout: function logout(reload) {
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
      this.clearSession(true);

      this.toRoute({ name: this.sub_domain + ".login" });
    },
    clearSession: function clearSession() {
      this.deleteCookie(this.getJwt());
    },
    validarAcesso: function validarAcesso(modulo) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_modulo.indexOf(modulo) != -1;
    },
    validarPermissao: function validarPermissao(permissao) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_permissao.indexOf(permissao) != -1;
    },
    validarPacote: function validarPacote(pacote) {
      return (this.cliente.logged && this.cliente.logged.pacotes.indexOf(pacote)) != -1;
    },
    toRoute: function toRoute(route, type) {
      type = type ? type : "name";

      var query = this.$route.query;

      switch (type) {
        case "location":
          window.open(route, "_top");
          break;

        default:
          if ((typeof route === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(route)) == "object") {
            route.query = query;
          }

          this.$router.push(route);
          break;
      }
    },
    logged: function logged() {
      var jwt = this.getJwt(),
          cookie = null;

      if (!jwt) return null;

      cookie = __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(jwt);

      return cookie;
    },
    getJwt: function getJwt(parse) {
      var jwt = null;

      try {
        jwt = this.env["jwt_" + this.sub_domain];

        if (!jwt) return null;

        if (parse) return __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default()(jwt);

        return jwt;
      } catch (error) {
        this.edAlert(error, "error");
      }
    },
    setTitle: function setTitle(title) {
      if (!title) {
        var to = this.$route;
        if (to.meta && to.meta.title && to.meta.navigation) {
          title = to.meta.title;
        }
      }

      switch (this.sub_domain) {
        case "web":
          document.title = title + " :: " + (this.cliente.logged ? this.cliente.logged.nome : "");
          break;

        case "empresa":
          document.title = "Area da Empresa" + (title ? " :: " + title : "");
          break;

        case "credenciada":
          document.title = "Area da Credenciada" + (title ? " :: " + title : "");
          break;

        case "parceiro":
          document.title = "Area do Parceiro" + (title ? " :: " + title : "");
          break;
      }
    },
    setCookie: function setCookie(key, value, _expires, toJSONString) {
      if (this.getCookie(key)) return;

      _expires = _expires ? _expires : 8;

      if (toJSONString) {
        value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
      }

      if (_expires == -1) {
        _expires = 720;
      }

      var date = this.addDate(_expires, null, "h");

      var test = __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set(key, value, {
        expires: date,

        secure: false,
        path: "/"
      });
    },
    getCookie: function getCookie(key, toJSON) {
      if (toJSON) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(key));
      }
      return __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(key);
    },
    deleteCookie: function deleteCookie(key) {
      if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(key)) {
        __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.delete(key);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_error__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_paginate__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_paginate__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "table",
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_5_common_alert___default.a, EdError: __WEBPACK_IMPORTED_MODULE_6_common_error___default.a, EdPaginate: __WEBPACK_IMPORTED_MODULE_7_common_paginate___default.a, Download: __WEBPACK_IMPORTED_MODULE_2_common_download___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    onEdit: {
      type: Function,
      default: null
    },

    onEditAll: {
      type: Function,
      default: null
    },
    onClear: {
      type: Function,
      default: null
    },

    onDelete: {
      type: Function,
      default: null
    },

    onRegister: {
      type: Function,
      default: null
    },

    onSearch: {
      type: Function,
      default: null
    },

    onFilter: {
      type: Function,
      default: null
    },

    inputSearch: {
      type: String,
      default: null
    },

    inputFilter: {
      type: Object,
      default: null
    },

    onDeleteName: {
      type: String,
      default: "Deletrar Registro"
    },

    registerName: {
      type: String,
      default: "Novo Registro"
    },

    registerIcon: {
      type: String,
      default: "fa fa-plus-circle"
    },

    editAllIcon: {
      type: String,
      default: "fa fa-pencil-square-o"
    },

    editAllName: {
      type: String,
      default: "Editar Registro(s)"
    },

    editAllTitle: {
      type: String,
      default: "Editar Registro(s)"
    },

    emptyTable: {
      type: String,
      default: "Nenhum resultado encontrado"
    },

    tableHead: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tableFooter: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    disableInputSearch: {
      type: Boolean,
      default: false
    },

    disableInputButtons: {
      type: Boolean,
      default: true
    },

    disableCheckAll: {
      type: Boolean,
      default: false
    },

    disableTableContent: {
      type: Boolean,
      default: false
    },

    editableRows: {
      type: Boolean,
      default: false
    },

    disabledConfigCell: {
      type: Boolean,
      default: false
    },

    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    response: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    loadingTable: {
      type: Boolean,
      default: false
    },

    loadingRegister: {
      type: Boolean,
      default: false
    },

    loadingEditAll: {
      type: Boolean,
      default: false
    },

    filterBadge: {
      type: [Number, String],
      default: 0
    }
  },

  data: function data() {
    return {
      formData: {
        search: null,
        sortBy: null,
        sortDesc: false,
        page: 1,
        ppage: 50,
        filter: null
      },
      items: [],
      fields: [],
      checkAll: [],
      checkItem: [],
      showPopoverCheckAll: false,
      showFilter: false,
      lstPages: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 600, 700, 800, 900]
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.handlerClear();
  },
  mounted: function mounted() {
    this.inicialize();
  },


  watch: {
    tableHead: function tableHead() {
      this.handleFields();
    },
    tableData: function tableData() {
      this.handleItens();
    },
    tableFooter: function tableFooter() {},
    onEdit: function onEdit() {},
    onEditAll: function onEditAll() {},
    onSearch: function onSearch() {},
    onRegister: function onRegister() {},
    filterBadge: function filterBadge() {},
    loadingTable: function loadingTable() {},
    loadingEditAll: function loadingEditAll() {},
    loadingRegister: function loadingRegister() {},
    disabledConfigCell: function disabledConfigCell() {
      this.handleFields();
    },
    "response.status": function responseStatus() {},
    config: function config() {},
    device: function device() {
      this.handleFields();
    },
    inputSearch: function inputSearch() {
      this.formData.search = this.inputSearch;
    },
    inputFilter: function inputFilter() {
      this.formData.filter = this.inputFilter;
    },
    pagination: function pagination() {
      if (this.pagination && this.pagination.per_page) {
        this.formData.ppage = parseInt(this.pagination.per_page);
      } else {
        this.formData.ppage = 50;
      }
    }
  },

  methods: {
    getUrlFuncionario: function getUrlFuncionario(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/funcionarios/editar/" + (_data.funcionario ? _data.funcionario.id : _data.id);
      } else {
        url = this.env.url_cs + "/app/funcionarios_info.php?abre=" + (_data.funcionario ? _data.funcionario.id : _data.id);
      }
      return url;
    },
    getUrlEmpresa: function getUrlEmpresa(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/meu-cadastro?";
      } else {
        url = this.env.url_cs + "/app/empresas_info.php?abre=" + (_data.empresa ? _data.empresa.id : _data.empresa_id);
      }
      return url;
    },
    getUrlConsulta: function getUrlConsulta(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "#";
      } else {
        url = this.env.url_cs + "/app/consulta.php?con=" + _data.id_con;
      }
      return url;
    },
    getUrlLote: function getUrlLote(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/esocial/gerar-lote" + (_data.lote ? "/" + _data.lote : "");
      } else {
        url = "https://" + "web1.softwareatento.com.br" + "/esocial/lotes" + (_data.lote ? "/" + _data.lote : "");
      }

      return url;
    },
    inicialize: function inicialize() {
      this.formData.search = this.inputSearch;
      this.formData.filter = this.inputFilter;
      this.handleItens();
      this.handleFields();
    },
    handleItens: function handleItens() {
      this.items = this.tableData;
      this.checkItem = [];
      this.checkAll = [];
      this.showPopoverCheckAll = false;
    },
    handlerClear: function handlerClear() {
      this.error = {};
      this.items = [], this.fields = [];
      this.checkAll = [];
      this.checkItem = [];
      this.formData = {
        search: null,
        sortBy: null,
        sortDesc: false,
        page: 1,
        ppage: 50,
        filter: null
      };
    },
    handleClear: function handleClear() {
      if (this.onClear) {
        this.onClear();
        this.showFilter = !this.showFilter;
      }
    },
    handleFields: function handleFields() {
      var fields = [];

      if (this.device != "xs" && !this.disableCheckAll) {
        fields.push({
          key: "selected",
          sortable: true,
          width: "50px",
          label: ""
        });
      }

      for (var i = 0; i < this.tableHead.length; i++) {
        fields.push(this.tableHead[i]);
      }

      if (!this.disabledConfigCell) {
        fields.push({
          key: "buttons",
          class: "table-v2-buttons",
          label: ""
        });
      }

      this.fields = fields;
    },
    handleSearch: function handleSearch() {
      this.showPopoverCheckAll = false;
      this.checkAll = [];
      this.checkItem = [];

      if (this.onSearch) this.onSearch(this.formData.search, 1, this.formData.ppage, this.formData.filter);
    },
    handleEdit: function handleEdit(data) {
      if (this.onEdit) this.onEdit(data);
    },
    handleEditAll: function handleEditAll() {
      var data = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var element = this.tableData[i];

        if (element._data && element._data.id && this.checkItem.indexOf(element._data.id) != -1) {
          data.push(element._data);
        }
      }

      if (this.onEditAll) this.onEditAll(data);
    },
    handleDelete: function handleDelete(data) {
      var ids = [];

      if (data && data.id) ids = [data.id];else ids = this.checkItem;

      if (ids.length > 0 && this.onDelete) this.onDelete(ids);
    },


    handleFilter: function handleFilter() {
      this.showFilter = !this.showFilter;
      if (this.onFilter) {
        this.onFilter(this.formData.search, 1, this.formData.ppage, this.formData.filter);
      }
    },

    handleSelectAll: function handleSelectAll(check) {
      this.checkItem = [];
      this.showPopoverCheckAll = false;

      if (!check) return;

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];

        if (item && item._data) {
          this.checkItem.push(item._data.id);
        }
      }

      this.showPopoverCheckAll = true;
    },

    handleSelectItem: function handleSelectItem() {
      this.showPopoverCheckAll = this.checkItem.length > 0;
    },
    handleNavigate: function handleNavigate(page) {
      this.formData.page = page;

      if (this.onSearch) this.onSearch(this.formData.search, this.formData.page, this.formData.ppage);
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_download__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_download__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-upload",
  components: { Download: __WEBPACK_IMPORTED_MODULE_0_common_download___default.a },
  mixins: [],

  props: {
    onChangeFile: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    currentFile: {
      type: [Object, Array, File],
      default: function _default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    multiple: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    accept: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    input: {
      type: String,
      default: function _default() {
        return new Date().getTime().toString();
      }
    }
  },
  watch: {
    onChangeFile: function onChangeFile() {},
    currentFile: function currentFile() {
      if (this.currentFile && this.currentFile.id) {
        this.file = new File(['foo'], this.currentFile.name, this.currentFile);
      } else {
        this.file = this.currentFile;
      }
    },
    accept: function accept() {},
    multiple: function multiple() {},
    disabled: function disabled() {},
    input: function input() {}
  },

  data: function data() {
    return {
      file: null,
      loadingDelete: false
    };
  },
  mounted: function mounted() {
    this.clearFiles();
  },


  methods: {
    clearFiles: function clearFiles() {
      this.$refs['file-input-' + this.input].reset();
    },
    handleChange: function handleChange(e) {
      if (this.onChangeFile) this.onChangeFile(e);

      e.preventDefault();

      this.$events.fire('upload-' + this.input, e.target.files[0]);
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    funcionario: {
      type: Object,
      default: null
    },
    id_funcao: {
      type: Number,
      default: null
    }
  },
  watch: {
    funcionario: function funcionario() {
      this.getHistorico();
    },
    id_funcao: function id_funcao() {
      this.getHistorico();
    }
  },

  data: function data() {
    return {
      formData: {
        historico: null,
        consulta: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'consulta',
        sortable: true,
        label: 'Consulta',
        width: '50px'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }, {
        key: 'tipo_aso',
        sortable: true,
        label: 'Tipo',
        width: '150px'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getHistorico();
  },


  methods: {
    onShowExame: function onShowExame(data) {
      this.showModal = !this.showModal;
      this.formData.consulta = data;
    },
    getHistorico: function getHistorico(_search) {
      var _this = this;

      if (!this.funcionario || !this.funcionario.id) return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var ontem = this.convertDate(this.addDate(-5, null, 'y')),
          amanha = this.convertDate(this.addDate(30, null)),
          filter = {
        id_funcionario: this.funcionario.id,
        created_at: [ontem, amanha]
      };

      this.get('consulta', { filter: filter }).then(function (result) {
        result = result[0];

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_aso: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              data: _this.toDate(data[i].dt_cad, true),
              _data: data[i],
              buttons: [{
                color: 'primary',
                icon: 'fa fa-search',
                title: 'Ver Exames',
                click: _this.onShowExame

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_table__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_2_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    id_ghe: {
      type: Number,
      default: null
    }
  },
  watch: {
    id_ghe: function id_ghe() {
      this.getPCMSO();
    }
  },

  data: function data() {
    return {
      formData: {
        pcmso: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: 'adm',
        sortable: true,
        show_html: true,
        label: 'Admissional'
      }, {
        key: 'apos_adm',
        sortable: true,
        show_html: true,
        label: 'Após Admissional'
      }, {
        key: 'dem',
        sortable: true,
        show_html: true,
        label: 'Demissional'
      }, {
        key: 'ret_tra',
        sortable: true,
        show_html: true,
        label: 'Retorno ao Trabalho'
      }, {
        key: 'mud_fun',
        sortable: true,
        show_html: true,
        label: 'Mudança de Função'
      }, {
        key: 'periodicidade',
        sortable: true,
        show_html: true,
        label: 'Periódico'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getPCMSO();
  },


  methods: {
    getPCMSO: function getPCMSO() {
      var _this = this;

      if (!this.id_ghe) return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};

      this.get('pcmso/ghe/exame/' + this.id_ghe).then(function (result) {
        result = result[0];

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var periodicidade = data[i].periodicidade != '0' ? '<span style="color:green">' + data[i].periodicidade + ' meses</span>' : '<span style="color:red">Não</span>';

            if (data[i].per_id1 != '0') {
              periodicidade += "<span style='color:#000'>\nA partir dos " + data[i].per_id1 + " anos</span>";
            }

            if (data[i].per_id2 != '0') {
              periodicidade += "<span style='color:#000'>\nAté os  " + data[i].per_id2 + " anos</span>";
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              adm: data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              apos_adm: data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              dem: data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              ret_tra: data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              mud_fun: data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              periodicidade: periodicidade,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {}
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      formData: null,
      formOption: {
        empty: 0
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
  },


  methods: {
    imprimirASO: function imprimirASO() {
      var _this = this;

      this.loadingSave = true;
      this.tabSelected = 'tab-aso';

      this.post('consulta/externa/editar', this.formData).then(function (result) {

        result = result[0];
        _this.loadingSave = false;

        if (result.status == 200) {

          _this.formOption.empty = _this.formOption.empty ? 1 : 0;

          _this.open('consulta/aso/' + _this.toMd5(_this.formData.id_con), _this.formOption);
        }
      });
    },
    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.consulta || !this.consulta.id) return;

      this.loadingContent = true;
      this.tabSelected = 'tab-aso';

      this.get("consulta/externa/" + this.consulta.id).then(function (result) {

        result = result[0];
        _this2.loadingContent = false;

        if (result.status == 200) {
          _this2.formData = result.data;
        }
      });
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_consulta_config_cancelar__ = __webpack_require__(799);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: {
    'consulta.id': function consultaId() {},
    'consulta.tipo_status.id': function consultaTipo_statusId() {},
    'formData.senha': function formDataSenha() {
      this.config.disabled.obs = this.formData.senha ? false : true;
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [],
        tipo_exclude: [],
        list: {},
        loading: {
          save: false
        },
        disabled: {
          obs: true
        }
      },
      response: {},
      formData: {
        obs: null,
        senha: null
      },
      formItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_consulta_config_cancelar__["a" /* default */];
  },


  methods: {

    salvar: function salvar() {
      var _this = this;

      this.$confirm('Ao efetuar o CANCELAMENTO da consulta, não será possível desfazer a ação. Deseja prosseguir?', 'Atenção', {
        type: 'warning'
      }).then(function () {

        _this.config.loading.save = true;
        _this.response = {};

        _this.post('consulta/liberacao/' + _this.consulta.id_con + '/cancelar', _this.formData).then(function (result) {

          result = result[0];
          _this.response = result;

          _this.config.loading.save = false;

          if (result.status == 200) {
            _this.edMsg('Liberação cadastrado com sucesso!');
            _this.$events.fire('consulta-liberado');
          }
        });
      });
    }

  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_femo__ = __webpack_require__(800);


var _watch;







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: (_watch = {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {},
    'formData.q14': function formDataQ14() {
      this.config.disabled.qd14 = this.formData.q14 != '133' ? false : true;
    },
    'formData.q116': function formDataQ116() {
      this.config.disabled.qd116 = this.formData.q116 != '133' ? false : true;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q14', function formDataQ14() {
    this.config.disabled.qd14 = this.formData.q14 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q11024', function formDataQ11024() {
    this.config.disabled.qd11024 = this.formData.q11024 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q14096', function formDataQ14096() {
    this.config.disabled.qd14096 = this.formData.q14096 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q116384', function formDataQ116384() {
    this.config.disabled.qd116384 = this.formData.q116384 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q132768', function formDataQ132768() {
    this.config.disabled.qd132768 = this.formData.q132768 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q165536', function formDataQ165536() {
    this.config.disabled.qd165536 = this.formData.q165536 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q12048', function formDataQ12048() {
    this.config.disabled.qd12048 = this.formData.q12048 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q18192', function formDataQ18192() {
    this.config.disabled.qd18192 = this.formData.q18192 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q22', function formDataQ22() {
    this.config.disabled.qd22 = this.formData.q22 != '133' ? false : true;
  }), _watch),
  data: function data() {
    return {
      config: {
        tipo: [122, 131, 134, 139, 144, 152, 158, 164, 167, 171, 180],
        loading: {
          content: false,
          save: false
        },
        disabled: {
          qd14: true,
          qd116: true,
          qd11024: true,
          qd14096: true,
          qd116384: true,
          qd132768: true,
          qd165536: true,
          qd12048: true,
          qd18192: true,
          qd22: true
        }
      },
      response: {},
      formData: {
        id: 0,
        empty: 0,
        grau_estudo: null,
        peso: null,
        altura: null,
        pa1: null,
        pa2: null,
        q14: '133',
        qd14: null,
        q18: '0',
        q116: '133',
        qd116: null,
        q132: '132',
        q164: '133',
        q1128: '133',
        q1256: '133',
        q1512: '133',
        q11024: '133',
        qd11024: null,
        q12048: '133',
        qd12048: null,
        q14096: '133',
        qd14096: null,
        q18192: '133',
        q116384: '133',
        qd116384: null,
        q132768: '133',
        qd132768: null,
        q165536: '133',
        qd165536: null,
        q22: '133',
        qd22: null,

        q34: [],
        q44: [],
        q54: [],
        q64: [],
        q74: [],
        q84: [],
        q94: [],
        conclusao: null,
        observacoes: null
      },
      formItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_femo__["a" /* default */];
    this.getConsulta();
  },


  methods: {
    imprimir: function imprimir() {
      var _this = this;

      this.config.loading.save = true;

      this.post('consulta/femo/' + this.consulta.id_con + '/editar', this.formData).then(function (result) {

        result = result[0];

        _this.config.loading.save = false;

        if (result.status == 200) {
          _this.open('consulta/femo/' + _this.toMd5(_this.consulta.id_con) + '/gerar', { empty: _this.formData.empty ? 1 : 0 });
        }
      });
    },
    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.consulta || !this.consulta.id) return;

      this.config.loading.content = true;
      this.tabSelected = 'tab-aso';
      this.response = {};

      this.get("consulta/femo/" + this.consulta.id_con).then(function (result) {

        result = result[0];

        _this2.response = result;

        _this2.config.loading.content = false;

        if (result.status == 200) {

          var data = result.data,
              resposta = null;

          if (data) {
            resposta = data.resposta;

            _this2.formData.id = data.id;
            _this2.formData.pa1 = data.pa1;
            _this2.formData.pa2 = data.pa2;
            _this2.formData.peso = data.peso;
            _this2.formData.altura = data.altura;
            _this2.formData.observacoes = data.observacoes;
            _this2.formData.grau_estudo = data.tipo_grau_estudo ? data.tipo_grau_estudo.valor.toString() : null;
            _this2.formData.conclusao = data.conclusao;

            for (var q1 in resposta) {

              if (resposta[q1]) {
                for (var q2 in resposta[q1]) {

                  var form_value = 'q' + q1 + q2,
                      form_desc = 'qd' + q1 + q2,
                      valor = resposta[q1][q2] && resposta[q1][q2].valor ? resposta[q1][q2].valor : 0,
                      descricao = resposta[q1][q2] && resposta[q1][q2].valor ? resposta[q1][q2].descricao : null;
                  switch (q1) {
                    case '1':

                      _this2.formData[form_value] = q2 == 8 ? '0' : '133';
                      _this2.formData[form_desc] = null;

                      if (valor == 1) {
                        if (q2 == 8) {
                          _this2.formData[form_value] = (parseInt(descricao) + 8).toString();
                        } else {
                          _this2.formData[form_value] = '132';
                          _this2.formData[form_desc] = descricao;
                        }
                      }
                      break;

                    default:
                      if (valor == 1) {
                        _this2.formData['q' + q1 + '4'].push(q2);
                      }
                      break;
                  }
                }
              }
            }
          }
        }
      });
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aso__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__femo__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__femo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__femo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__liberar__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__liberar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__liberar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancelar__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancelar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cancelar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { Aso: __WEBPACK_IMPORTED_MODULE_0__aso___default.a, Femo: __WEBPACK_IMPORTED_MODULE_1__femo___default.a, Liberar: __WEBPACK_IMPORTED_MODULE_2__liberar___default.a, Cancelar: __WEBPACK_IMPORTED_MODULE_3__cancelar___default.a },
  mixins: [],
  props: {
    consulta: {
      type: Object,
      default: null
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.tabSelected = "tab-aso";
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {
      this.tabSelected = "tab-aso";
    }
  },
  data: function data() {
    return {
      tabSelected: 'tab-aso'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$events.on('consulta-liberado', function (eventData) {
      _this.tabSelected = "tab-aso";
    });
  },


  methods: {}
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_liberacao__ = __webpack_require__(801);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {},
    'formData.aptidao': function formDataAptidao() {
      this.handleAptidao();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [53, 185, 189],
        tipo_exclude: [54, 55, 68, 56, 57, 58, 69],
        click: {
          exames: this.getExame
        },
        list: {
          exames: []
        },
        loading: {
          save: false,
          table: false,
          content: false,
          exames: false
        },
        disabled: {
          id_tipo_status: false,
          te_alt: false,
          te_esp: false,
          exames: false,
          obs: false
        }
      },
      response: {},
      formData: {
        id: 0,
        id_tipo_status: '69',
        tipo_status: null,
        aptidao: null,
        te_alt: null,
        te_esp: null,
        te_ele: null,
        obs: null,
        senha: null,
        arquivo_aso: null,
        arquivo_femo: null,
        arquivo_exame: null,
        updated_at: null,
        exames: []
      },
      formItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_liberacao__["a" /* default */];
    this.getConsulta();

    this.$events.on('upload-arquivo_aso', function (eventData) {
      _this.formData.arquivo_aso = eventData;
    });

    this.$events.on('upload-arquivo_femo', function (eventData) {
      _this.formData.arquivo_femo = eventData;
    });

    this.$events.on('upload-arquivo_exame', function (eventData) {
      _this.formData.arquivo_exame = eventData;
    });
  },


  methods: {
    handleAptidao: function handleAptidao() {

      this.config.disabled.id_tipo_status = this.formData.aptidao == '2' || this.formData.aptidao == '5';
      this.config.disabled.te_alt = this.formData.aptidao == '5';
      this.config.disabled.te_esp = this.formData.aptidao == '5';

      if (this.formData.aptidao == '2') {
        this.formData.id_tipo_status = '67';
      } else if (this.formData.aptidao == '5') {
        this.formData.id_tipo_status = '70';
      } else if (this.formData.aptidao == '1') {
        this.formData.id_tipo_status = '66';
      }
    },
    getExame: function getExame(search) {},
    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.consulta || !this.consulta.id) return;

      this.config.loading.content = true;
      this.tabSelected = 'tab-aso';
      this.response = {};

      this.get("consulta/" + this.consulta.id_con).then(function (result) {

        result = result[0];

        _this2.response = result;

        _this2.config.loading.content = false;
        _this2.config.list.exames = [];

        if (result.status == 200) {
          var _this2$formData;

          _this2.formData = (_this2$formData = {
            id_tipo_status: '66',
            tipo_status: result.data.tipo_status,
            aptidao: _this2.toString(result.data.aptidao) == '0' ? null : _this2.toString(result.data.aptidao),
            te_alt: _this2.toString(result.data.te_alt) == '0' ? null : _this2.toString(result.data.te_alt)
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_alt', _this2.toString(result.data.te_alt) == '0' ? null : _this2.toString(result.data.te_alt)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_esp', _this2.toString(result.data.te_esp) == '0' ? null : _this2.toString(result.data.te_esp)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'updated_at', result.data.updated_at ? _this2.toDate(result.data.updated_at) : null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'obs', result.data.obs), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'exames', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'senha', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'arquivo_aso', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'arquivo_femo', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'arquivo_exame', null), _this2$formData);

          for (var i = 0; i < result.data.exames.length; i++) {
            var element = result.data.exames[i];

            if (element.dem == 0) {
              _this2.config.list.exames.push(element.exame);
            }
          }
        }
      });
    },


    salvar: function salvar() {
      var _this3 = this;

      this.$confirm('Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?', 'Atenção', {
        type: 'warning'
      }).then(function () {

        _this3.config.loading.save = true;
        _this3.response = {};

        _this3.post('consulta/liberacao/' + _this3.consulta.id_con + '/cadastrar', _this3.toFormUpload(_this3.formData)).then(function (result) {

          result = result[0];
          _this3.response = result;

          _this3.config.loading.save = false;

          if (result.status == 200) {
            _this3.edMsg('Liberação cadastrado com sucesso!');
            _this3.getConsulta();
            _this3.$events.fire('consulta-liberado');
          }
        });
      });
    }

  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_consulta_editar__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuracao_index__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__configuracao_index__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, Historico: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso___default.a, Config: __WEBPACK_IMPORTED_MODULE_6__configuracao_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        tipo: [],
        readonly: {
          id_fdt: true,
          id_ghe: true,
          id_funcao: true,
          id_tipo_aso: true,
          data_age: true,
          funcionario: true,
          obs: true
        }
      },
      pcmso: null,
      consulta_historico: null,
      formData: {
        id: 0,
        data_age: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        exames: [],
        obs: null,
        result: null
      },
      showAso: false,
      showFemo: false,
      tabSelected: 'tab-acompanhamento'

    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_consulta_editar__["a" /* default */];
    this.getConsulta();

    this.$events.on('consulta-liberado', function (eventData) {
      _this.getConsulta();
    });
  },


  methods: {
    onASO: function onASO() {
      this.showAso = !this.showAso;
    },
    onFemo: function onFemo() {
      this.showFemo = !this.showFemo;
    },
    getConsulta: function getConsulta() {
      var _this2 = this;

      this.loadingContent = true;
      this.response = {};

      this.get('consulta/externa/' + this.$route.params.consulta).then(function (result) {
        result = result[0];

        _this2.loadingContent = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.formData = {
            id: result.data.id,
            data_age: _this2.convertDate(result.data.data_age),
            funcionario: result.data.funcionario.nome,
            id_tipo_aso: result.data.tipo_aso.descricao,
            id_funcao: result.data.funcao.nome,
            id_fdt: result.data.fdt.pcmso + ' (' + result.data.fdt.descricao + ')',
            id_ghe: result.data.ghe.ghe + ' (' + result.data.ghe.descricao + ')',
            obs: result.data.obs,
            result: result.data
          };
        } else {
          if (result.status == 404) _this2.toRoute({ name: 'credenciada.consulta' });
        }
      });
    }
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuracao_index__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__configuracao_index__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, Config: __WEBPACK_IMPORTED_MODULE_5__configuracao_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formFilter.id_empresa': function formFilterId_empresa() {
      this.getFuncionario();

      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.formFilter.id_funcionario = null;
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        tipo_exclude: [68],
        click: {
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario
        },
        list: {
          id_empresa: [],
          id_funcionario: []
        },
        loading: {
          id_empresa: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: true,
          id_fdt: true
        }
      },
      formFilter: {
        id_empresa: null,
        id_funcionario: null,
        id_tipo_status: ['54', '55', '69', '68', '70'],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      },
      filterBadge: 0,
      showConfig: false,
      consulta: null,
      pagination: {},
      response: {},
      filterItems: [],
      tableData: [],
      tableHead: [{
        key: 'id_con',
        sortable: true,
        label: 'Consulta'

      }, {
        key: 'empresa',
        sortable: true,
        label: 'Empresa'

      }, {
        key: 'funcionario',
        sortable: true,
        label: 'Funcionário'
      }, {
        key: 'funcao',
        sortable: true,
        show_tipo_aso: true,
        label: 'Função'
      }, {
        key: 'data_age',
        sortable: true,
        label: 'Agendamento'
      }, {
        key: 'tipo_status',
        sortable: true,
        label: 'Status'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.filterItems = __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__["a" /* default */];
    this.getConsulta();
    this.getEmpresa();

    this.$events.on('consulta-liberado', function (eventData) {
      _this.getConsulta();
    });
  },


  methods: {
    onEdit: function onEdit(data) {
      this.toRoute({ name: 'credenciada.consulta.edt', params: { consulta: data.id } });
    },
    onConfig: function onConfig(data) {
      this.consulta = data;
      this.showConfig = !this.showConfig;
    },
    onGerarConsulta: function onGerarConsulta(data) {

      var label = data.funcionario.nome,
          self = this;

      this.$confirm('O sistema vai gerar uma consulta definitiva para o funcionário ' + label + '. Deseja continuar?', 'Atenção', {
        type: 'warning'
      }).then(function () {
        self.config.loading.table = true;

        self.get('consulta/externa/' + data.id + '/gerar').then(function (result) {
          result = result[0];

          self.config.loading.table = false;

          if (result.status == 200) {
            self.onEdit(data);
          } else {
            self.edAlert(result.msg, 'error');
          }
        });
      });
    },


    getEmpresa: function getEmpresa(_search) {
      var _this2 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get('/empresa', { search: _search }).then(function (result) {

        result = result[0];

        _this2.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this2.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('/empresa/funcionario/' + this.formFilter.id_empresa, { search: _search }).then(function (result) {

        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(search, page, pagination) {
      var _this4 = this;

      this.config.loading.table = true;

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-60, null, 'D'), true),
            amanha = this.toDate(this.addDate(0, null, 'D'), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + (this.formFilter.agendamento_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("consulta/externa", { search: search, page: page, pagination: pagination, filter: this.formFilter }).then(function (result) {
        result = result[0];

        _this4.config.loading.table = false;
        _this4.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              id_con: data[i].id_con ? data[i].id_con : '---',
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              tipo_status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              data_age: _this4.toDate(data[i].data_age, true),
              _data: data[i],
              options: {
                disable_edit: data[i].deleted_at ? true : false,
                disable_delete: data[i].id_con || data[i].deleted_at ? true : false
              },
              buttons: []
            };

            if (!data[i].deleted_at && data[i].tipo_status.id == 54) {
              item.buttons.push({
                color: 'success',
                icon: 'fa fa-paper-plane',
                title: 'Iniciar Atendimento',
                click: _this4.onGerarConsulta

              });
            } else if (!data[i].deleted_at) {
              item.buttons.push({
                color: 'primary',
                icon: 'fa fa-pencil-square-o',
                title: 'Editar Consulta',
                click: _this4.onEdit

              });

              if (data[i].id_con && data[i].tipo_status.id != 57 && data[i].tipo_status.id != 58) {
                item.buttons.push({
                  color: 'success',
                  icon: 'fa fa-cogs',
                  title: 'Ver Opções desta Consulta',
                  click: _this4.onConfig

                });
              }
            }
            tableData.push(item);
          }

          pagination = result.data;
        }

        _this4.tableData = tableData;
        _this4.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_login__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_reset__ = __webpack_require__(805);









/* harmony default export */ __webpack_exports__["default"] = ({
		components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
		mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
		data: function data() {
				return {
						error: {},
						response: {},
						formData: {
								cpf: null,
								cnpj: null,
								senha: null,
								point_type: 'credenciada'
						},
						loginItens: [],
						resetitens: [],
						loadingSave: false,
						loadingRecuperarSenha: false,
						showModal: false,
						loadingContent: true
				};
		},
		created: function created() {

				if (this.logged()) this.toRoute({ name: 'credenciada.consulta' });else this.loadingContent = false;
		},
		mounted: function mounted() {
				this.loginItens = __WEBPACK_IMPORTED_MODULE_4__form_login__["a" /* default */];
				this.resetitens = __WEBPACK_IMPORTED_MODULE_5__form_reset__["a" /* default */];
		},


		methods: {
				login: function login() {
						var _this = this;

						this.loadingSave = true;
						this.error = {};
						this.response = {};

						this.post("login", this.formData).then(function (result) {
								result = result[0];

								_this.loadingSave = false;
								_this.response = result;

								if (result.status == 200) {

										var usuario = result.data.usuario,
										    cliente = result.data.cliente,
										    empresa = result.data.empresa;

										_this.setCookie(_this.env.jwt_credenciada, result.data.jwt, usuario.sessao);

										_this.usuario = usuario;
										_this.cliente = cliente;
										_this.empresa = empresa;

										_this.toRoute({ name: 'credenciada.consulta' });
								}
						});
				},
				recuperarSenha: function recuperarSenha() {
						var _this2 = this;

						this.loadingRecuperarSenha = true;
						this.response = {};

						this.post("recuperar-senha", this.formData).then(function (result) {
								result = result[0];
								_this2.response = result;
								_this2.loadingRecuperarSenha = false;

								if (result.status == 200) {
										_this2.showModal = false;
										_this2.edAlert("Sua nova senha foi enviada para o email: " + result.data + ". Aguarde alguns minutos e verifique sua caixa de entrada.");
								}
						});
				}
		}
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__ = __webpack_require__(806);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formData.id_fdt': function formDataId_fdt() {
      this.getFuncao();
    },
    'formData.id_funcao': function formDataId_funcao() {
      this.getGHE();
    }
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        tipo: [],
        readonly: {
          nome: true,
          cnpj: true,
          u_cpf: true,
          u_nome: true
        }
      },
      formData: {
        id: null,
        id_estado: null,
        id_cidade: null,
        nome: null,
        cnpj: null,
        email: null,
        tel_com: null,
        r_nome: null,
        r_email: null,
        r_tel_com: null,
        u_nome: null,
        u_cpf: null,
        u_email: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        log: [],
        obs: null,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmpresa();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__["a" /* default */];
  },


  methods: {
    getEmpresa: function getEmpresa() {
      var _this = this;

      this.loadingContent = true;
      this.response = {};

      this.get("meu-cadastro").then(function (result) {

        result = result[0];

        console.log(result);

        _this.loadingContent = false;
        _this.response = result;

        if (result.status == 200) {
          var data = result.data;

          _this.formData = {
            id: data.id,
            id_estado: data.id_estado,
            id_cidade: data.id_cidade,
            nome: data.nome,
            cnpj: data.cnpj,
            email: data.email,
            tel_com: data.tel_com,
            r_nome: data.r_nome,
            r_email: data.r_email,
            r_tel_com: data.r_tel_com,
            cep: data.cep,
            end: data.end,
            num: data.num,
            bairro: data.bairro,
            comp: data.comp,
            obs: data.obs,
            created_at: data.created_at,
            updated_at: data.updated_at,

            senha_atual: null,
            senha_nova: null,
            senha_confirma: null,

            u_nome: _this.usuario.logged.nome,
            u_cpf: _this.usuario.logged.usuario,
            u_email: _this.usuario.logged.email
          };
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.loadingSave = true;
      this.response = {};

      this.post('meu-cadastro', this.formData).then(function (result) {
        result = result[0];

        _this2.loadingSave = false;

        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Dados atualizados com sucesso');
          _this2.getEmpresa();
        }
      });
    }
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    },
    showGuia: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    showGuia: function showGuia() {
      this.showModal = !this.showModal;
    }
  },
  data: function data() {
    return {
      showModal: false,
      loadingContent: false,
      formData: null,
      tabSelected: 'tab-guia',
      parceiros: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
  },


  methods: {
    onAso: function onAso() {
      this.open('consulta/aso/' + this.toMd5(this.formData.id_con));
    },
    onGuia: function onGuia(parceiro) {
      this.open('consulta/externa/guia/' + this.toMd5(this.formData.id));
    },
    getConsulta: function getConsulta() {
      var _this = this;

      if (!this.consulta || !this.consulta.id) return;

      this.loadingContent = true;

      this.get("consulta/externa/" + this.consulta.id).then(function (result) {

        result = result[0];
        _this.loadingContent = false;

        if (result.status == 200) {
          _this.formData = result.data;
          _this.formataParceiro();

          if (_this.formData && _this.formData.tipo_status.id == 54) {
            _this.tabSelected = 'tab-guia';
          } else {
            _this.tabSelected = 'tab-aso';
          }
        }
      });
    },
    formataParceiro: function formataParceiro() {
      var consulta = this.formData,
          parceiros = {};

      try {
        consulta.exames = consulta.exames.sort(function (a, b) {
          return a.parceiro.nome > b.parceiro.nome ? 1 : b.parceiro.nome > a.parceiro.nome ? -1 : 0;
        });
      } catch (error) {}

      for (var i = 0; i < consulta.exames.length; i++) {
        var consulta_exame = consulta.exames[i],
            index = null;

        if (consulta_exame.parceiro && consulta_exame.id_con_rea == 0 && consulta_exame.id_con_dem == 0) {

          index = this.toMd5(consulta_exame.parceiro.id);

          if (!parceiros[index]) {
            parceiros[index] = {
              parceiro: consulta_exame.parceiro,
              exames: []
            };
          }
          parceiros[index]['exames'].push(consulta_exame.exame);
        }
      }
      this.parceiros = parceiros;
    }
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    funcionario: {
      type: Object,
      default: null
    },
    id_funcao: {
      type: Number,
      default: null
    }
  },
  watch: {
    funcionario: function funcionario() {
      this.getHistorico();
    },
    id_funcao: function id_funcao() {
      this.getHistorico();
    }
  },

  data: function data() {
    return {
      formData: {
        historico: null,
        consulta: null,
        exames: []
      },
      pagination: {},
      paginationExame: {},
      response: {},
      tableData: [],
      tableDataExame: [],
      tableHeadExame: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,
        show_alt: true,
        label: 'Exame'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }],
      tableHead: [{
        key: 'consulta',
        sortable: true,
        label: 'Consulta',
        width: '90px'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }, {
        key: 'tipo_aso',
        sortable: true,
        label: 'Tipo',
        width: '200px'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }],
      showModal: false,
      loadingTable: false,
      loadingTableExame: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getHistorico();
  },


  methods: {
    onShowExame: function onShowExame(consulta) {
      this.showModal = !this.showModal;
      this.formData.consulta = consulta;
      this.getExame();
    },
    ordenar: function ordenar(array) {
      array = array.sort(function (a, b) {
        return a.id_con_rea > b.id_con_rea ? 1 : b.id_con_rea > a.id_con_rea ? -1 : 0;
      });
      return array;
    },
    getExame: function getExame(_search, _page, _pagination) {
      var _this = this;

      this.loadingTableExame = true;
      this.formData.exames = [];

      this.get('consulta/exame/' + this.formData.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];

        _this.loadingTableExame = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = _this.ordenar(result.data.data);

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              data: data[i].dt_cad ? _this.toDate(data[i].dt_cad, true) : null,
              valor: data[i].valor,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableDataExame = tableData;
        _this.paginationExame = pagination;
      });
    },
    getHistorico: function getHistorico(_search) {
      var _this2 = this;

      if (!this.funcionario || !this.funcionario.id) return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var ontem = this.convertDate(this.addDate(-10, null, 'y')),
          amanha = this.convertDate(this.addDate(30, null)),
          filter = {
        id_empresa: this.usuario.logged.point.id,
        id_funcionario: this.funcionario.id,
        created_at: [ontem, amanha]
      };

      this.get('consulta', { filter: filter }).then(function (result) {
        result = result[0];

        _this2.response = result;
        _this2.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_aso: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              data: _this2.toDate(data[i].dt_cad, true),
              _data: data[i],
              buttons: [{
                color: 'primary',
                icon: 'fa fa-search',
                title: 'Ver Exames',
                click: _this2.onShowExame

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this2.tableData = tableData;
        _this2.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(27);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EmpresaCadastro",
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdForm */],
    EdModal: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdModal */],
    EdAlert: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdAlert */],
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["c" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_2_template__["i" /* EdInputSelectTipo */]
  },
  mixins: [],
  props: {
    showLote: {
      type: Boolean,
      default: false
    },
    parent: {
      type: Object,
      default: null
    },
    funcionario: {
      type: Array,
      default: null
    },
    tipoAso: {
      type: [String, Number],
      default: 52
    },
    callback: {
      type: Function,
      default: null
    }
  },
  watch: {
    parent: function parent() {},
    funcionario: function funcionario() {},
    tipoAso: function tipoAso() {},
    showLote: function showLote() {
      this.showModal = !this.showModal;
      this.inicialize();
    },
    "$root.$session.event": function $root$sessionEvent() {
      this.$forceUpdate();
    },

    formData: {
      handler: function handler(newVal) {},
      deep: true
    }
  },
  computed: {
    listaPeriodicidade: function listaPeriodicidade() {
      return function (funcionario) {
        if (funcionario.id_tipo_aso == 48) {
          funcionario.periodicidade = 6;
          return [{ id: 6, nome: "6 meses" }];
        }

        funcionario.periodicidade = 12;

        return [{ id: 6, nome: "6 meses" }, { id: 12, nome: "12 meses" }];
      };
    },
    disabilitarConsulta: function disabilitarConsulta() {
      var _this = this;

      return function (item, funcionario) {
        switch (item.id) {
          case 47:
            return _this.formData.funcionario && _this.formData.funcionario.adm == 1;
            break;

          case 48:
            return _this.formData.funcionario && _this.formData.funcionario.apos_adm == 1;
            break;

          case 51:
            return _this.formData.funcionario && _this.formData.funcionario.dem == 1;
            break;

          default:
            return false;
            break;
        }
      };
    }
  },
  data: function data() {
    return {
      showModal: false,
      tabSelected: "tab-guia",
      response: {},
      formDataItems: [],
      list: {
        fdt: [],
        ghe: [],
        mf_ghe: [],
        mf_funcao: [],
        funcao: [],
        funcionario: []
      },
      formData: {
        funcionario: null
      },
      loadingFuncionario: false,
      loadingFdt: false,
      loadingGhe: false,
      loadingFuncao: false
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
    this.getFDT();
  },


  methods: {
    getError: function getError(funcionario) {
      if (this.$root.$request.dados && this.$root.$request.dados.options && this.$root.$request.dados.options.data && this.$root.$request.dados.options.data[funcionario.id]) {
        return this.$root.$request.dados.options.data[funcionario.id].join('<br>');
      }

      return null;
    },
    formatarFuncionario: function formatarFuncionario(_funcionario, _id_tipo_aso) {
      if (_funcionario && !this.$utilidade.arrFindByField(this.formData.funcionarios, "id", _funcionario.id)) {
        var funcionario = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_funcionario, {});

        if (!funcionario.id_tipo_aso) {
          funcionario.id_tipo_aso = _id_tipo_aso ? _id_tipo_aso : 52;
          funcionario.id_mf_fdt = null;
          funcionario.id_mf_ghe = null;
          funcionario.id_mf_funcao = null;
        }
        this.formData.funcionarios.push(funcionario);
      }
      this.formData.funcionario = null;
    },
    formatarTipoConsulta: function formatarTipoConsulta(funcionario) {
      var aso = "SELECIONE";

      switch (funcionario.id_tipo_aso) {
        case 47:
          aso = "ADMISSIONAL";
          break;

        case 48:
          aso = "APÓS ADMISSIONAL";
          break;

        case 49:
          aso = "RETORNO AO TRABALHO";
          break;

        case 50:
          aso = "MUDANÇA DE FUNÇÃO";
          break;

        case 51:
          aso = "DEMISSIONAL";
          break;

        case 52:
          aso = "PERIÓDICO" + (funcionario.periodicidade ? " " + funcionario.periodicidade + " MESES" : "");
          break;
      }

      return aso + (funcionario.periodicidade ? " " + funcionario.periodicidade + " MESES" : "");
    },
    inicialize: function inicialize() {
      this.formData = {
        id: 0,
        data_age: this.$utilidade.toDate(null, true),
        funcionarios: [],
        tabela_preco: null,
        obs: null
      };
      this.list.funcionario = [];

      if (this.funcionario && this.funcionario.length > 0) {
        var self = this;
        this.funcionario.forEach(function (funcionario) {
          self.formatarFuncionario(funcionario, self.tipoAso);
        });
      }
    },
    onDelete: function onDelete(funcionario) {
      var element = this.$utilidade.arrFindByField(this.formData.funcionarios, "id", funcionario.id);

      for (var i = 0; i < this.formData.funcionarios.length; i++) {
        var _element = this.formData.funcionarios[i];

        if (_element.id == funcionario.id) {
          this.formData.funcionarios.splice(i, 1);
        }
      }
    },
    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      this.loadingFuncionario = true;
      this.list.funcionario = [];

      this.$root.$request.get("funcionario/0", { search: _search, pagination: 100 }).then(function (result) {
        _this2.loadingFuncionario = false;

        if (result.status == 200) {
          _this2.list.funcionario = result.data.data;
        }
      });
    },
    getFDT: function getFDT() {
      var _this3 = this;

      this.loadingFdt = true;
      this.list.fdt = [];

      this.$root.$request.get("pcmso/fdt").then(function (result) {
        _this3.loadingFdt = false;

        if (result.status == 200) {
          _this3.list.fdt = result.data.data;
        }
      });
    },
    getGhe: function getGhe(funcionario) {
      var _this4 = this;

      this.loadingGhe = true;
      this.ghe = [];

      this.formData.id_mf_ghe = null;

      var filter = {
        id_fdt: funcionario.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        _this4.loadingGhe = false;

        if (result.status == 200) {
          _this4.list.ghe = result.data;
        }
      });
    },
    getFuncao: function getFuncao(funcionario) {
      var _this5 = this;

      this.loadingFuncao = true;
      this.list.funcao = [];

      funcionario.id_mf_funcao = null;

      var filter = {
        id_fdt: funcionario.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe/funcao/" + funcionario.id_mf_ghe, {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        _this5.loadingFuncao = false;

        if (result.status == 200) {
          _this5.list.funcao = result.data.data;
        }
      });
    },
    fechar: function fechar() {
      this.formDataItems = [];
      if (this.callback) this.callback();
    },
    salvar: function salvar() {
      var _this6 = this;

      this.$root.$loading.set(true);

      this.$root.$request.post("consulta/externa/lote", this.formData).then(function (result) {
        _this6.$root.$loading.set(false);

        console.log(result);
        if (result.status == 200) {
          _this6.showModal = !_this6.showModal;

          if (_this6.parent) {
            _this6.parent.getConsulta();
          }

          _this6.$root.$dialog.alert("Consulta registrada com sucesso. Agora você deve aguardar enquanto o sistema processa a solicitação em segundo plano. Espere alguns minutos e atualize essa página para verificar o andamento da solicitação.");
        }
      });
    }
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a },
  mixins: [],
  props: {
    id_ghe: {
      type: Number,
      default: null
    }
  },
  watch: {
    id_ghe: function id_ghe() {
      this.getPCMSO();
    }
  },

  data: function data() {
    return {
      formData: {
        pcmso: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: 'adm',
        sortable: true,
        show_html: true,
        label: 'Admissional'
      }, {
        key: 'apos_adm',
        sortable: true,
        show_html: true,
        label: 'Após Admissional'
      }, {
        key: 'dem',
        sortable: true,
        show_html: true,
        label: 'Demissional'
      }, {
        key: 'ret_tra',
        sortable: true,
        show_html: true,
        label: 'Retorno ao Trabalho'
      }, {
        key: 'mud_fun',
        sortable: true,
        show_html: true,
        label: 'Mudança de Função'
      }, {
        key: 'periodicidade',
        sortable: true,
        show_html: true,
        label: 'Periódico'
      }, {
        key: 'validade',
        sortable: true,
        show_html: true,
        label: 'Validade do Exame'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getPCMSO();
  },


  methods: {
    getPCMSO: function getPCMSO() {
      var _this = this;

      if (!this.id_ghe) return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};
      this.$root.$session.pcmso = null;

      this.$root.$request.get('pcmso/ghe/exame/' + this.id_ghe).then(function (result) {

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          _this.$root.$session.pcmso = data;

          for (var i = 0; i < data.length; i++) {

            var periodicidade = '';

            if (data[i].periodicidade_a != '0' && data[i].per_id1 != '0') {
              periodicidade += "<span style='color:green'>" + data[i].periodicidade_a + " meses até " + data[i].per_id1 + " anos, </span>";
            }

            periodicidade += data[i].periodicidade != '0' ? '<span style="color:green">' + data[i].periodicidade + ' meses</span>' : '<span style="color:red">Não</span>';

            if (data[i].per_id1 != '0') {
              periodicidade += "<span style='color:green'>\nA partir dos " + data[i].per_id1 + " anos</span>";
            }

            if (data[i].per_id2 != '0') {
              periodicidade += "<span style='color:green'>\nAté os  " + data[i].per_id2 + " anos</span>";
            }

            if (data[i].periodicidade_d != '0' && data[i].per_id2 != '0') {
              periodicidade += "<span style='color:green'>, " + data[i].periodicidade_d + " meses depois dos " + data[i].per_id2 + " anos </span>";
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              adm: data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              apos_adm: data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              dem: data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              ret_tra: data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              mud_fun: data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              validade: data[i].validade != 0 ? '<span style="color:green">' + data[i].validade + ' dias</span>' : '<span style="color:red">---</span>',
              periodicidade: periodicidade,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_table__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa.consulta.exame',
  components: { TableView: __WEBPACK_IMPORTED_MODULE_2_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      tableHead: [{
        key: 'created_at',
        sortable: true,
        width: '150px',
        label: 'Data'
      }, {
        key: 'usuario',
        sortable: true,
        show_point: true,
        label: 'Usuario'
      }, {
        key: 'tipo_status',
        sortable: true,
        width: '250px',
        label: 'Status'
      }, {
        key: 'obs',
        sortable: true,
        label: 'Observações'
      }],
      tableData: [],
      loadingTable: false,
      pagination: {},
      response: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsultaAcompanhamento();
  },


  computed: {},

  methods: {
    onEdit: function onEdit(data) {},
    getConsultaAcompanhamento: function getConsultaAcompanhamento(search, page, pagination) {
      var _this = this;

      this.loadingTable = true;
      this.response = {};

      this.get('consulta/externa/acompanhamento/' + this.$route.params.consulta, { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this.loadingTable = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              created_at: _this.toDate(data[i].created_at),
              usuario: data[i].log_acesso && data[i].log_acesso.usuario ? data[i].log_acesso.usuario.usuario : null,
              tipo_status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              obs: data[i].obs,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__credenciada_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdCredenciada: __WEBPACK_IMPORTED_MODULE_1__credenciada_index___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["c" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_2_template__["i" /* EdInputSelectTipo */]
  },
  watch: {},
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      formData: {
        id: 0,
        data_age: this.$utilidade.toDate(null, true),
        periodicidade: 12,
        id_tabela_preco: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        id_mf_fdt: null,
        id_mf_ghe: null,
        id_mf_funcao: null,
        exames: [],
        obs: null,
        pcd: 0
      },
      formFilter: {
        order: "ate_cli_cre.nome",
        id_estado: null,
        id_cidade: null,
        id_tipo_tabela_preco: null,
        preco: null
      },
      list: {
        fdt: [],
        ghe: [],
        mf_ghe: [],
        mf_funcao: [],
        funcao: [],
        funcionario: []
      },
      tabHistorico: "tab-credenciada",
      loadingPCMSO: false,
      loadingFdt: false,
      loadingGhe: false,
      loadingFuncao: false,
      loadingTabelaPreco: false,
      loadingFuncionario: false,
      loadingConsultaHistorico: false,
      pcmso: null,
      consulta_historico: null,
      tabela_preco: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
  },


  computed: {
    listaPeriodicidade: function listaPeriodicidade() {
      var _this = this;

      var arrayPeriodicidade = [];

      this.formData.periodicidade = 12;

      if (this.formData.id_tipo_aso == 48) {
        this.formData.periodicidade = 6;
      }

      if (this.$root.$session.pcmso) {
        this.$root.$session.pcmso.forEach(function (pcmso, index) {
          var periodicidade = pcmso.periodicidade;

          if (_this.formData.id_tipo_aso == 48) {
            periodicidade = pcmso.apos_adm == 0 ? 6 : pcmso.apos_adm;
          }

          if (periodicidade > 0 && !_this.$utilidade.arrFindByField(arrayPeriodicidade, "id", periodicidade)) {
            arrayPeriodicidade.push({
              id: periodicidade,
              nome: periodicidade + " meses"
            });
          }
        });
      }

      return arrayPeriodicidade.sort(function (a, b) {
        return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
      });;
    },
    disabilitarConsulta: function disabilitarConsulta() {
      var _this2 = this;

      return function (item) {
        switch (item.id) {
          case 47:
            return _this2.formData.funcionario && _this2.formData.funcionario.adm == 1;
            break;

          case 48:
            return _this2.formData.funcionario && _this2.formData.funcionario.apos_adm == 1;
            break;

          case 51:
            return _this2.formData.funcionario && _this2.formData.funcionario.dem == 1;
            break;

          default:
            return false;
            break;
        }
      };
    }
  },

  methods: {
    formatarFuncionario: function formatarFuncionario() {
      if (this.formData.funcionario) {
        this.formData.id_funcionario = this.formData.funcionario.id;
        this.formData.id_fdt = this.formData.funcionario.id_pcmso;
        this.formData.id_funcao = this.formData.funcionario.id_funcao;
        this.formData.id_ghe = this.formData.funcionario.id_ghe;
        this.getFuncao();
      }
    },
    getFDT: function getFDT() {
      var _this3 = this;

      this.loadingFdt = true;
      this.list.fdt = [];

      var filter = {
        ativo: 1
      };

      this.$root.$request.get("pcmso/fdt", {
        filter: filter
      }).then(function (result) {
        _this3.loadingFdt = false;

        if (result.status == 200) {
          _this3.list.fdt = result.data.data;

          if (_this3.formData.id_fdt) {
            if (!_this3.$utilidade.arrFindByField(_this3.list.fdt, "id", _this3.formData.id_fdt)) {
              _this3.formData.id_fdt = null;
              _this3.formData.id_funcao = null;
              _this3.formData.id_ghe = null;
            }
          }
        }
      });
    },
    getFuncao: function getFuncao(_search) {
      var _this4 = this;

      this.list.funcao = [];

      if (!this.formData.id_fdt) return;

      this.loadingFuncao = true;

      var filter = {
        id_fdt: this.formData.id_fdt
      };

      this.$root.$request.get("pcmso/ghe/funcao", {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        _this4.loadingFuncao = false;

        if (result.status == 200) {
          _this4.list.funcao = result.data.data;

          if (_this4.formData.id_funcao) {
            if (!_this4.$utilidade.arrFindByField(_this4.list.funcao, "id", _this4.formData.id_funcao)) {
              _this4.formData.id_funcao = null;
              _this4.formData.id_ghe = null;
            }
          }

          _this4.getGHE();
        }
      });
    },
    getGHE: function getGHE() {
      var _this5 = this;

      this.list.ghe = [];

      if (!this.formData.id_fdt || !this.formData.id_funcao) return;

      this.loadingGhe = true;
      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.$root.$request.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        _this5.loadingGhe = false;

        if (result.status == 200) {
          _this5.list.ghe = result.data;

          var encontrado = false;
          _this5.list.ghe.forEach(function (revisao, index) {
            if (_this5.$utilidade.arrFindByField(revisao.options, "id", _this5.formData.id_ghe)) {
              encontrado = true;
            }
          });

          if (_this5.formData.id_ghe && !encontrado) {
            _this5.formData.id_ghe = null;
          }
        }
      });
    },
    getGheMudancaFuncao: function getGheMudancaFuncao() {
      var _this6 = this;

      this.loadingGhe = true;
      this.mf_ghe = [];

      this.formData.id_mf_ghe = null;

      var filter = {
        id_fdt: this.formData.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        _this6.loadingGhe = false;

        if (result.status == 200) {
          _this6.list.mf_ghe = result.data;
        }
      });
    },
    getFuncaoMudancaFuncao: function getFuncaoMudancaFuncao(_search) {
      var _this7 = this;

      this.loadingFuncao = true;
      this.list.mf_funcao = [];

      this.formData.id_mf_funcao = null;

      var filter = {
        id_fdt: this.formData.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe/funcao/" + this.formData.id_mf_ghe, {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        _this7.loadingFuncao = false;

        if (result.status == 200) {
          _this7.list.mf_funcao = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this8 = this;

      this.loadingFuncionario = true;
      this.list.funcionario = [];

      if (this.$route.params.funcionario && !_search) {
        _search = this.$route.params.funcionario;
      }

      this.$root.$request.get("funcionario/0", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this8.loadingFuncionario = false;

        if (result.status == 200) {
          _this8.list.funcionario = result.data.data;

          var funcionario = null;
          if (funcionario = _this8.$utilidade.arrFindByField(_this8.list.funcionario, "id", _this8.$route.params.funcionario)) {
            _this8.formData.funcionario = funcionario;
            _this8.formatarFuncionario();
          }
        } else {
          _this8.$utilidade.$notify.error(result.data);
        }

        _this8.getFDT();
      });
    },
    ordenar: function ordenar(tabela_preco) {
      for (var index = 0; index < tabela_preco.length; index++) {
        tabela_preco[index].exames.consulta = tabela_preco[index].exames.consulta.sort(function (a, b) {
          return a.id_con_rea > b.id_con_rea ? 1 : b.id_con_rea > a.id_con_rea ? -1 : 0;
        });

        tabela_preco[index].exames.consulta = tabela_preco[index].exames.consulta.sort(function (a, b) {
          return a.id_con_dem > b.id_con_dem ? 1 : b.id_con_dem > a.id_con_dem ? -1 : 0;
        });

        tabela_preco[index].exames.demonstrativo = tabela_preco[index].exames.demonstrativo.sort(function (a, b) {
          return a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0;
        });
      }
      return tabela_preco;
    },
    getCredenciada: function getCredenciada(page, search) {
      var _this9 = this;

      this.tabHistorico = "tab-credenciada";

      if (this.formData.id_tipo_aso == 50 && (!this.formData.id_mf_fdt || !this.formData.id_mf_ghe) || !this.formData.id_tipo_aso || !this.formData.id_ghe || !this.formData.id_funcionario || !this.formData.data_age) {
        return;
      }

      this.$root.$loading.set(true, "Carregando exames");

      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        id_fdt: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_fdt : this.formData.id_fdt,
        id_funcao: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_funcao : this.formData.id_funcao,
        id_ghe: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_ghe : this.formData.id_ghe,
        periodicidade: this.formData.id_tipo_aso == 52 || this.formData.id_tipo_aso == 48 ? this.formData.periodicidade : -1,
        id_funcionario: this.formData.id_funcionario,
        id_tipo_tabela_preco: this.formFilter.id_tipo_tabela_preco,
        hoje: this.formData.data_age,
        id_tipo_aso: [this.formData.id_tipo_aso],
        pcd: this.formData.pcd
      }, this.formFilter);

      this.$root.$request.get("tabela-preco", {
        search: search,
        page: page,
        filter: filter
      }).then(function (result) {
        _this9.$root.$loading.set(false);

        console.log(result);
        if (result.status == 200) {
          _this9.tabela_preco = _this9.ordenar(result.data);

          for (var index = 0; index < _this9.tabela_preco.length; index++) {
            var tabela_preco = _this9.tabela_preco[index],
                valor = 0,
                valor_servico = 0,
                valor_total = 0;

            if (tabela_preco.credenciada && tabela_preco.credenciada.padrao == "1" || index == 0) {
              _this9.formData.id_tabela_preco = tabela_preco.id;
            }

            for (var j = 0; j < tabela_preco.exames.consulta.length; j++) {
              valor += _this9.$utilidade.moneyToFloat(tabela_preco.exames.consulta[j].valor_venda);
              valor_servico += _this9.$utilidade.moneyToFloat(tabela_preco.exames.consulta[j].valor_servico);
              valor_total += _this9.$utilidade.moneyToFloat(tabela_preco.exames.consulta[j].valor_total);
            }

            _this9.tabela_preco[index].total_exames = tabela_preco.exames.consulta.length;

            _this9.tabela_preco[index].total_exames_realizar = tabela_preco.exames.consulta.filter(function (exame) {
              return !exame.id_con_dem && !exame.id_con_rea;
            }).length;

            _this9.tabela_preco[index].valor = _this9.$utilidade.floatToMoney(valor);
            _this9.tabela_preco[index].valor_servico = _this9.$utilidade.floatToMoney(valor_servico);
            _this9.tabela_preco[index].valor_total = _this9.$utilidade.floatToMoney(valor_total);
          }
        } else {
          _this9.tabela_preco = result.data;
        }
      });
    },
    salvar: function salvar() {
      var _this10 = this;

      this.$root.$loading.set(true, "Gerando consulta");
      this.response = {};

      var formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.formData, {});

      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        id_fdt: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_fdt : this.formData.id_fdt,
        id_funcao: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_funcao : this.formData.id_funcao,
        id_ghe: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_ghe : this.formData.id_ghe,
        periodicidade: this.formData.id_tipo_aso == 52 || this.formData.id_tipo_aso == 48 ? this.formData.periodicidade : -1,
        id_funcionario: this.formData.id_funcionario,
        id_tipo_tabela_preco: this.formFilter.id_tipo_tabela_preco,
        hoje: this.formData.data_age,
        id_tipo_aso: [this.formData.id_tipo_aso],
        pcd: this.formData.pcd
      }, this.formFilter);

      formData.periodicidade = filter.periodicidade;

      this.$root.$request.put("consulta/externa/cadastrar", formData, {
        filter: filter
      }).then(function (result) {
        _this10.$root.$loading.set(false);
        _this10.response = result;

        if (result.status == 200) {
          _this10.$root.$notify.success("Dados atualizados com sucesso");

          if (_this10.$route.name == "empresa.consulta.cad") {
            _this10.$router.push({
              name: "empresa.consulta.edt",
              params: {
                consulta: result.data.id
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_table__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_4_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: {}
    },
    tabela_preco: {
      type: Object,
      default: {}
    },
    showExame: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showExame: function showExame() {
      this.showModal = !this.showModal;
    },
    showModal: function showModal() {},
    tabela_preco: function tabela_preco() {},
    'tabela_preco.id': function tabela_precoId() {
      this.getData();
    },
    'parent.showExame': function parentShowExame() {
      this.getData();
    },
    'parent.loadingExame': function parentLoadingExame() {}
  },

  data: function data() {
    return {
      showModal: false,
      loadingTable: false,
      tableHead: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,
        show_alt: true,
        label: 'Exame'
      }, {
        key: 'data_ultuma_consulta',
        label: 'Data Ultima Consulta'
      }, {
        key: 'valor_total',
        sortable: true,
        show_html: true,
        width: '170px',
        label: 'Valor Total (R$)',
        value: 0
      }],
      tableFooter: [],
      tableData: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    getData: function getData() {

      if (!this.tabela_preco || !this.tabela_preco.id || !this.tabela_preco.exames || !this.tabela_preco.exames.consulta) return;

      var tableData = [],
          tableFooter = [],
          total_valor_venda = 0,
          total_valor_servico = 0;
      this.loadingTable = true;

      for (var i = 0; i < this.tabela_preco.exames.consulta.length; i++) {

        var element = this.tabela_preco.exames.consulta[i];

        var valor_venda = null,
            valor_servico = null,
            valor_total = null;

        if (!element.id_con_rea && element.valor_venda) {
          valor_venda = element.valor_venda;
        }

        if (!element.id_con_rea && element.valor_total) {
          valor_total = element.valor_total;
        }

        if (!element.id_con_rea && element.valor_servico) {
          valor_servico = element.valor_servico;
        }

        var item = {
          id: element.id,
          exame: element.exame ? element.exame.nome : null,
          data_ultuma_consulta: (element.dt_exame ? this.$utilidade.toDate(element.dt_exame, true) : '---') + (element.validade_exame > 0 ? '<br><span style="color:red">Exame válido por ' + element.validade_exame + ' dias</span>' : '') + (element.validade_pcmso ? '<br><span style="color:' + element.validade_pcmso_cor + '">Exame válido até ' + this.$utilidade.toDate(element.validade_pcmso, true) + '</span>' : ''),
          valor: element.va == '1' ? '<img src="' + this.env.url_cs + 'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : valor_venda ? valor_venda : '---',
          valor_servico: element.va == '1' ? '<img src="' + this.env.url_cs + 'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : valor_servico ? valor_servico + ' (' + element.taxa_servico + ')%' : '---',
          valor_total: element.va == '1' ? '<img src="' + this.env.url_cs + 'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : valor_total ? valor_total : '---',
          _data: element,
          buttons: []
        };

        this.tableHead[1].value += this.moneyToFloat(valor_venda);
        this.tableHead[2].value += this.moneyToFloat(valor_servico);


        tableData.push(item);
      }

      for (var _i = 0; _i < this.tabela_preco.exames.demonstrativo.length; _i++) {

        var _element = this.tabela_preco.exames.demonstrativo[_i];

        var item = {
          id: _element.id,
          exame: _element.nome,
          data_ultuma_consulta: _element.dt_exame ? this.$utilidade.toDate(_element.dt_exame, true) : '---',
          valor: '---',
          valor_servico: '---',
          valor_total: '---',
          _data: _element,
          buttons: []
        };

        tableData.push(item);
      }

      this.loadingTable = false;
      this.tableData = tableData;
      this.tableFooter = tableFooter;
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_paginate__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exame__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__exame__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EmpresaCadastro",
  components: { EdPaginate: __WEBPACK_IMPORTED_MODULE_1_common_paginate___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso___default.a, Historico: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico___default.a, Exame: __WEBPACK_IMPORTED_MODULE_6__exame___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: {}
    }
  },
  watch: {
    parent: function parent() {},
    "parent.formData.tabHistorico": function parentFormDataTabHistorico() {},
    "parent.formData.id_tabela_preco": function parentFormDataId_tabela_preco() {},
    "parent.formData.id_funcao": function parentFormDataId_funcao() {},
    "parent.formData.id_ghe": function parentFormDataId_ghe() {},
    "parent.formData.id_mf_ghe": function parentFormDataId_mf_ghe() {},
    "parent.formData.funcionario": function parentFormDataFuncionario() {},
    "parent.loadingTabelaPreco": function parentLoadingTabelaPreco() {},

    "parent.tabela_preco": {
      deep: true,
      handler: function handler() {
        this.inicialize();
      }
    }
  },

  data: function data() {
    return {
      showExame: false,
      loadingExame: false,
      tabela_preco: null,
      lstOrganizar: [{ value: "ate_cli_cre.nome", label: "Nome" }, { value: "ate_cli_cre.rate", label: "Mais Relevantes" }],
      filtros: [],
      estados: [],
      cidades: [],
      tipo_tabela_preco: []
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    inicialize: function inicialize() {
      if (this.parent.tabela_preco && this.parent.tabela_preco.length) {
        this.getEstado();
      }
    },
    onChangeParceiro: function onChangeParceiro(tabela_preco, item) {
      var valor = 0,
          valor_total = 0,
          valor_servico = 0,
          exames = [];

      for (var i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
        var _tabela_preco = this.tabela_preco.exames.consulta[i];

        for (var j = 0; j < _tabela_preco.parceiros.length; j++) {
          if (_tabela_preco.id_par == _tabela_preco.parceiros[j].parceiro.id) {
            var parceiro = _tabela_preco.parceiros[j];

            valor += this.moneyToFloat(parceiro.valor);
            valor_servico += this.moneyToFloat(parceiro.valor_servico);
            valor_total += this.moneyToFloat(parceiro.valor_total);

            this.tabela_preco.exames.consulta[i].valor_venda = parceiro.valor;
            this.tabela_preco.exames.consulta[i].valor_servico = parceiro.valor_servico;
            this.tabela_preco.exames.consulta[i].valor_total = parceiro.valor_total;

            exames.push({
              id_exa: _tabela_preco.exame.id,
              id_par: _tabela_preco.id_par
            });
          }
        }
      }

      this.tabela_preco.valor = this.floatToMoney(valor);
      this.tabela_preco.valor_total = this.floatToMoney(valor_total);
      this.tabela_preco.valor_servico = this.floatToMoney(valor_servico);

      this.parent.formData.exames = exames;

      for (var _i = 0; _i < this.parent.tabela_preco.length; _i++) {
        if (this.parent.tabela_preco[_i].id == this.tabela_preco.id) {
          this.parent.tabela_preco[_i].valor = this.tabela_preco.valor;
          this.parent.tabela_preco[_i].valor_total = this.tabela_preco.valor_total;
          this.parent.tabela_preco[_i].valor_servico = this.tabela_preco.valor_servico;
        }
      }
    },
    onShowExame: function onShowExame(tabela_preco) {
      var _this = this;

      this.tabela_preco = tabela_preco;
      this.showExame = !this.showExame;
      this.loadingExame = true;

      var filter = {
        id_exa: []
      };

      for (var i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
        filter.id_exa.push(this.tabela_preco.exames.consulta[i].exame.id);
      }

      this.get("tabela-preco/exame/" + this.tabela_preco.id, {
        filter: filter
      }).then(function (result) {
        result = result[0];

        _this.loadingExame = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (var _i2 = 0; _i2 < _this.tabela_preco.exames.consulta.length; _i2++) {
            var elementi = _this.tabela_preco.exames.consulta[_i2];

            _this.tabela_preco.exames.consulta[_i2].parceiros = [];

            for (var j = 0; j < data.length; j++) {
              var elementj = data[j];

              if (elementi.exame.id == elementj.exame.id) {
                _this.tabela_preco.exames.consulta[_i2].parceiros = elementj.exames_parceiro;
              }
            }
          }
        }
      });
    },
    getEstado: function getEstado() {
      var tabela_preco = this.parent.tabela_preco;
      this.estados = [];

      var estados = [{
        value: null,
        label: "Todos"
      }];

      for (var i = 0; i < tabela_preco.length; i++) {
        var element = tabela_preco[i];

        if (!element.credenciada_uf) continue;

        if (!this.arrFindByField(this.estados, "value", element.credenciada_uf)) {
          this.estados.push({
            value: element.credenciada_uf,
            label: element.credenciada_estado
          });
        }
      }

      this.estados = this.estados.sort(function (a, b) {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });
      this.estados = estados.concat(this.estados);

      this.getCidade();
    },
    getCidade: function getCidade() {
      var tabela_preco = this.parent.tabela_preco;

      this.cidades = [];
      var cidades = [{
        value: null,
        label: "Todos"
      }];

      if (!this.parent.formFilter.id_estado) {
        cidades = [{
          value: null,
          label: "Selecione o Estado"
        }];
        this.parent.formFilter.id_cidade = null;
        return;
      }

      for (var i = 0; i < tabela_preco.length; i++) {
        var element = tabela_preco[i];

        if (!element.credenciada_cidade) continue;

        if (!this.arrFindByField(this.cidades, "value", element.credenciada_cidade)) {
          this.cidades.push({
            value: element.credenciada_cidade_id,
            label: element.credenciada_cidade,
            disable: !this.parent.formFilter.id_estado ? true : false
          });
        }
      }

      this.cidades = this.cidades.sort(function (a, b) {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });
      this.cidades = cidades.concat(this.cidades);
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__credenciada_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_editar__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riscos_index__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riscos_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riscos_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exames_index__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exames_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__exames_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acompanhamento_index__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acompanhamento_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__acompanhamento_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, Riscos: __WEBPACK_IMPORTED_MODULE_6__riscos_index___default.a, Exames: __WEBPACK_IMPORTED_MODULE_7__exames_index___default.a, Acompanhamento: __WEBPACK_IMPORTED_MODULE_8__acompanhamento_index___default.a, Guia: __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso___default.a, Historico: __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        tipo: [],
        readonly: {
          id_fdt: true,
          id_ghe: true,
          id_funcao: true,
          id_tipo_aso: true,
          data_age: false,
          funcionario: true,
          obs: true
        }
      },
      formData: {
        id: 0,
        data_age: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_tipo_status: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        exames: [],
        obs: null,
        result: null
      },
      pcmso: null,
      consulta_historico: null,
      showGuia: false,
      tabSelected: 'tab-exames'

    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_editar__["a" /* default */];
    this.getConsulta();
  },


  methods: {
    onGuia: function onGuia() {
      this.showGuia = !this.showGuia;
    },
    getConsulta: function getConsulta() {
      var _this = this;

      this.loadingContent = true;
      this.response = {};

      this.get('consulta/externa/' + this.$route.params.consulta).then(function (result) {
        result = result[0];

        _this.loadingContent = false;
        _this.response = result;

        if (result.status == 200) {
          _this.formData = {
            id: result.data.id,
            data_age: _this.convertDate(result.data.data_age),
            funcionario: result.data.funcionario.nome,
            id_tipo_aso: result.data.tipo_aso.descricao + (result.data.periodicidade ? ' ' + result.data.periodicidade + ' MESES' : ''),
            id_tipo_status: result.data.tipo_status.id,
            id_funcao: result.data.funcao.nome,
            id_fdt: result.data.fdt.pcmso + ' (' + result.data.fdt.descricao + ')',
            id_ghe: result.data.ghe.ghe + ' (' + result.data.ghe.descricao + ')',
            obs: result.data.obs,
            result: result.data
          };

          if (result.data.tipo_status.id == '194' || result.data.tipo_status.id == '195') {
            _this.tabSelected = 'tab-acompanhamento';
          }
        } else {
          if (result.status == 404) _this.toRoute({ name: 'empresa.consulta' });
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.loadingSave = true;
      this.response = {};

      this.post('consulta/externa/editar', this.formData).then(function (result) {

        result = result[0];

        _this2.loadingSave = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Dados atualizados com sucesso');
        }
      });
    }
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa.consulta.exame',
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      tableHead: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,

        label: 'Exame'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data'
      }, {
        key: 'valor',
        sortable: true,
        show_html: true,
        label: 'Valor (R$)'
      }, {
        key: 'valor_servico',
        sortable: true,
        show_html: true,
        label: 'Taxa de Serviço (R$)'
      }, {
        key: 'valor_total',
        sortable: true,
        show_html: true,
        label: 'Valor Total (R$)'
      }],
      tableData: [],
      loadingTable: false,
      pagination: {},
      response: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsultaExame();
  },


  computed: {},

  methods: {
    onEdit: function onEdit(data) {},
    getConsultaExame: function getConsultaExame(search, page, pagination) {
      var _this = this;

      this.loadingTable = true;
      this.response = {};

      this.get('consulta/externa/exame/' + this.$route.params.consulta, { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this.loadingTable = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var exa_pcmso = '';

            if (!data[i].pcmso_exame) {
              exa_pcmso = '<br><span style="color:red">Exame não encontrado no PCMSO</span>';
            }
            var item = {
              id: data[i].id,
              exame: data[i].exame ? data[i].exame.nome + exa_pcmso : null,
              data: _this.toDate(data[i].data, true),
              valor: data[i].va == '1' ? '<img src="' + _this.env.url_cs + 'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor,
              valor_servico: data[i].va == '1' ? '<img src="' + _this.env.url_cs + 'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor_servico,
              valor_total: data[i].va == '1' ? '<img src="' + _this.env.url_cs + 'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor_total,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_consulta_filtro__ = __webpack_require__(808);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a, Guia: __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia___default.a, Lote: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        tipo_exclude: [68, 70],
        click: {
          id_cre: this.getCredenciada,
          id_funcionario: this.getFuncionario
        },
        list: {
          id_cre: [],
          id_funcionario: []
        },
        loading: {
          id_cre: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: false,
          id_fdt: true
        }
      },
      formFilter: {
        id_cre: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      },
      filterBadge: 0,
      loadingTable: false,
      showGuia: false,
      showLote: false,
      consulta: null,
      pagination: {},
      response: {},
      tableData: [],
      filterItems: [],
      tableHead: [{
        key: 'id_con',
        sortable: true,
        label: 'Consulta'

      }, {
        key: 'credenciada',
        sortable: true,
        label: 'Credenciada'

      }, {
        key: 'funcionario',
        sortable: true,
        label: 'Funcionário'
      }, {
        key: 'funcao',
        sortable: true,
        show_tipo_aso: true,
        label: 'Função'
      }, {
        key: 'data_age',
        sortable: true,
        label: 'Agendamento'
      }, {
        key: 'status',
        show_status: true,
        sortable: true,
        label: 'Status'
      }]
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
    this.getCredenciada();
    this.getFuncionario();

    this.filterItems = __WEBPACK_IMPORTED_MODULE_6__form_consulta_filtro__["a" /* default */];
  },


  methods: {
    onRegister: function onRegister() {
      this.toRoute({ name: 'empresa.consulta.cad' });
    },
    onEdit: function onEdit(data) {
      this.toRoute({ name: 'empresa.consulta.edt', params: { consulta: data.id } });
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        type: 'warning'

      }).then(function () {

        self.response = {};
        self.loadingTable = true;

        self.delete('consulta/externa/deletar', { itens: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;
          self.response = result;
          self.getConsulta();

          if (result.status == 200) {
            _this.edMsg('Registro(s) excluído(s) com sucesso');
            self.getFuncionario();
          }
        });
      });
    },
    onGuia: function onGuia(data) {
      this.consulta = data;
      this.showGuia = !this.showGuia;
    },
    onLote: function onLote() {
      this.showLote = !this.showLote;
    },


    getCredenciada: function getCredenciada(_search) {
      var _this2 = this;

      this.config.loading.id_cre = true;
      this.config.list.id_cre = [];

      this.get('/credenciada', { search: _search }).then(function (result) {

        result = result[0];

        _this2.config.loading.id_cre = false;

        if (result.status == 200) {
          _this2.config.list.id_cre = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('/funcionario/0', { search: _search }).then(function (result) {

        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(search, page, pagination) {
      var _this4 = this;

      this.config.loading.table = true;

      if (!this.formFilter.agendamento_at) {
        this.formFilter.agendamento_at = [];
      }

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-60, null, 'D'), true),
            amanha = this.toDate(this.addDate(0, null, 'D'), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_cre ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + (this.formFilter.agendamento_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("consulta/externa", { search: search, page: page, pagination: pagination, filter: this.formFilter }).then(function (result) {
        result = result[0];

        _this4.config.loading.table = false;
        _this4.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              id_con: data[i].id_con ? data[i].id_con : '---',
              credenciada: data[i].credenciada ? data[i].credenciada.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].info,
              data_age: _this4.toDate(data[i].data_age, true),
              _data: data[i],
              options: {
                disable_edit: data[i].deleted_at ? true : false,
                disable_delete: data[i].id_con || data[i].deleted_at ? true : false
              },
              buttons: []
            };

            if (!data[i].deleted_at && data[i].tipo_status.id != 57 && data[i].tipo_status.id != 58) {
              item.buttons.push({
                color: 'info',
                icon: 'fa fa-file-pdf-o',
                title: 'Abrir Guia de Encaminhamento',
                click: _this4.onGuia
              });
            }
            tableData.push(item);
          }

          pagination = result.data;
        }

        _this4.tableData = tableData;
        _this4.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa.consulta.exame',
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      tableHead: [{
        key: 'categoria',
        sortable: true,
        label: 'Categoria'
      }, {
        key: 'risco',
        sortable: true,
        label: 'Risco'
      }],
      tableData: [],
      loadingTable: false,
      pagination: {},
      response: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsultaRisco();
  },


  computed: {},

  methods: {
    onEdit: function onEdit(data) {},
    getConsultaRisco: function getConsultaRisco(search, page, pagination) {
      var _this = this;

      this.loadingTable = true;
      this.response = {};

      this.get('consulta/externa/risco/' + this.$route.params.consulta, { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this.loadingTable = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              risco: data[i].risco ? data[i].risco.nome : data[i].nome,
              categoria: data[i].risco && data[i].risco.categoria ? data[i].risco.categoria.categoria : data[i].categoria ? data[i].categoria.categoria : null,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_funcionario_editar__ = __webpack_require__(229);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formData.id_fdt': function formDataId_fdt() {},
    'formData.id_funcao': function formDataId_funcao() {
      this.formData.id_ghe = null;
      this.getGHE();
    }
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_fdt: this.getFDT,
          id_ghe: this.getGHE,
          id_funcao: this.getFuncao
        },
        list: {
          id_fdt: [],
          id_ghe: [],
          id_funcao: []
        },
        loading: {
          id_fdt: false,
          id_ghe: false,
          id_funcao: false,
          save: false
        },
        tipo: [59]
      },
      formData: {
        id: 0,
        id_estado: null,
        id_cidade: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        nome: null,
        cpf: null,
        rg: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        ct_num: null,
        ct_serie: null,
        ct_uf: null,
        tel_res: null,
        tel_cel: null,
        dt_nas: null,
        sexo: null,
        email: null,
        mat: null,
        pis: null,
        status: null,
        pcd: 0,
        obs: null,
        created_user: 0,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_funcionario_editar__["a" /* default */];
    this.getFDT();
  },


  methods: {
    getFuncao: function getFuncao(_search) {
      var _this = this;

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      var filter = {
        'id_fdt': this.formData.id_fdt
      };

      this.get('funcao', {
        search: _search,
        filter: filter,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this.config.loading.id_funcao = false;

        if (result.status == 200) {
          _this.config.list.id_funcao = result.data.data;
        }
      });
    },
    getFDT: function getFDT() {
      var _this2 = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      var filter = {
        ativo: 1
      };

      this.get('pcmso/fdt', {
        filter: filter
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },
    getGHE: function getGHE() {
      var _this3 = this;

      this.config.loading.id_ghe = true;
      this.config.list.id_ghe = [];
      this.formData.id_ghe = null;

      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.get('pcmso/ghe', {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_ghe = false;

        if (result.status == 200) {
          _this3.config.list.id_ghe = result.data;
        }
      });
    },
    salvar: function salvar() {
      var _this4 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post('funcionario/0/editar', this.formData).then(function (result) {
        result = result[0];
        console.log(result);

        _this4.config.loading.save = false;
        _this4.response = result;

        if (result.status == 200) {
          if (typeof result.data.cadastrado !== 'undefined' && result.data.cadastrado !== null) {
            _this4.$confirm('CPF já cadastrado, deseja transferir o Funcionário de empresa?', 'Atenção', { type: 'warning' }).then(function () {
              _this4.formData.created_user = 1;
              console.log(_this4.formData);

              _this4.salvar();
            }).catch(function () {
              _this4.toRoute({
                name: 'empresa.funcionario'
              });
            });
          } else {
            _this4.edMsg('Dados atualizados com sucesso');
            _this4.toRoute({
              name: 'empresa.funcionario.edt',
              params: {
                id: result.data.id
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_funcionario_editar__ = __webpack_require__(229);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  watch: {
    "formData.id_fdt": function formDataId_fdt() {
      if (!this.config.loading.save) {}
    },
    "formData.id_funcao": function formDataId_funcao() {
      if (!this.config.loading.save) {}
      this.getGHE();
    }
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_fdt: this.getFDT,
          id_ghe: this.getGHE,
          id_funcao: this.getFuncao
        },
        list: {
          id_fdt: [],
          id_ghe: [],
          id_funcao: []
        },
        loading: {
          id_fdt: false,
          id_ghe: false,
          id_funcao: false,
          save: false
        },
        tipo: [59]
      },
      formData: {
        id: 0,
        id_estado: null,
        id_cidade: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        nome: null,
        cpf: null,
        rg: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        ct_num: null,
        ct_serie: null,
        ct_uf: null,
        tel_res: null,
        tel_cel: null,
        dt_nas: null,
        sexo: null,
        email: null,
        mat: null,
        pis: null,
        status: null,
        pcd: 0,

        obs: null,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_4__form_funcionario_editar__["a" /* default */];
  },


  methods: {
    getFuncao: function getFuncao(_search) {
      var _this = this;

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      var filter = {
        id_fdt: this.formData.id_fdt
      };

      this.get("funcao", {
        search: _search,
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        result = result[0];

        _this.config.loading.id_funcao = false;

        if (result.status == 200) {
          _this.config.list.id_funcao = result.data.data;

          if (_this.formData.id_funcao) {
            if (!_this.arrFindByField(_this.config.list.id_funcao, "id", _this.formData.id_funcao)) {
              _this.formData.id_funcao = null;
              _this.formData.id_ghe = null;
              _this.config.list.id_ghe = [];
            }
          }
        }

        _this.config.loading.save = false;
      });
    },
    getFDT: function getFDT() {
      var _this2 = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];
      var filter = {
        ativo: 1
      };
      this.get("pcmso/fdt", {
        filter: filter
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {

          _this2.config.list.id_fdt = result.data.data;
          _this2.getFuncao();
        }
      });
    },
    getGHE: function getGHE() {
      var _this3 = this;

      if (!this.formData.id_funcao) return;

      this.config.loading.id_ghe = true;
      this.config.list.id_ghe = [];

      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_ghe = false;

        if (result.status == 200) {
          _this3.config.list.id_ghe = result.data;

          var encontrado = false;
          result.data.forEach(function (revisao, index) {
            if (_this3.$utilidade.arrFindByField(revisao.options, "id", _this3.formData.id_ghe)) {
              encontrado = true;
            }
          });

          if (_this3.formData.id_ghe && !encontrado) {
            _this3.formData.id_ghe = null;
          }
        }
      });
    },
    getFuncionario: function getFuncionario() {
      var _this4 = this;

      this.config.loading.save = true;

      this.get("funcionario/0/" + this.$route.params.id).then(function (result) {
        result = result[0];

        _this4.response = result;

        if (result.status == 200) {
          var _this4$formData;

          var data = result.data;

          if (data.funcao) {}

          _this4.formData = (_this4$formData = {
            id: data.id,
            id_estado: data.id_estado == "0" ? null : data.id_estado,
            id_cidade: data.id_cidade == "0" ? null : data.id_cidade,
            id_funcao: data.id_funcao,
            id_fdt: data.id_pcmso ? data.id_pcmso : null,
            id_ghe: data.id_ghe ? data.id_ghe : null,
            _id_ghe: data._id_ghe ? data._id_ghe : null,
            nome: data.nome,
            cpf: data.cpf,
            rg: data.rg,
            dt_nas: data.dt_nas ? _this4.toDate(data.dt_nas, true) : null
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "dt_nas", data.dt_nas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "email", data.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "tel_res", data.tel_res), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "tel_cel", data.tel_cel), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "cep", data.cep), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "end", data.end), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "num", data.num), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "bairro", data.bairro), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "comp", data.comp), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "obs", data.obs), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "ct_num", data.ct_num), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "ct_serie", data.ct_serie), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "pcd", data.pcd), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "ct_uf", data.ct_uf), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "sexo", data.sexo), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "mat", data.mat), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "pis", data.pis), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "user_edit", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "created_at", data.created_at), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "updated_at", data.updated_at), _this4$formData);
        } else {
          if (result.status == 404) _this4.toRoute({
            name: "empresa.funcionario"
          });
        }

        _this4.config.loading.save = false;
        _this4.getFDT();
      });
    },
    salvar: function salvar() {
      var _this5 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("funcionario/0/editar", this.formData).then(function (result) {
        result = result[0];

        _this5.config.loading.save = false;
        _this5.response = result;

        if (result.status == 200) {
          console.log(result);
          _this5.edMsg("Dados atualizados com sucesso");
          _this5.getFuncionario();
        }
      });
    }
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingTable: false,
      pagination: {},
      response: {},
      tableData: [],
      tableHedad: [{
        key: 'id',
        sortable: true,
        label: 'Cód'

      }, {
        key: 'nome',
        sortable: true,
        label: 'Nome'

      }, {
        key: 'cpf',
        sortable: true,
        label: 'CPF'

      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }, {
        key: 'status',
        sortable: true,
        label: 'Status'
      }]
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
  },


  methods: {
    onRegister: function onRegister() {
      this.toRoute({ name: 'empresa.funcionario.cad' });
    },
    onEdit: function onEdit(data) {
      this.toRoute({ name: 'empresa.funcionario.edt', params: { id: data.id } });
    },
    onConsulta: function onConsulta(data) {
      this.toRoute({ name: 'empresa.consulta.cad', params: { funcionario: data.id } }, 'object');
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        type: 'warning'

      }).then(function () {

        self.response = {};
        self.loadingTable = true;

        self.post('funcionario/0/deletar', { itens: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          self.response = result;

          if (result.status == 200) {
            _this.edMsg('REgistro(s) excluído(s) com sucesso');
            self.getFuncionario();
          }
        });
      });
    },
    getFuncionario: function getFuncionario(search, page, pagination) {
      var _this2 = this;

      this.loadingTable = true;

      this.get("funcionario/0", { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this2.loadingTable = false;
        _this2.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              status: data[i].dem == 1 ? 'DEMITIDO' : 'ATIVO',
              _data: data[i],
              options: {
                style: "color:" + (data[i].dem == 1 ? 'red' : '')
              },
              buttons: [{
                color: 'warning',
                icon: 'fa fa-address-card',
                title: 'Inserir Nova Consulta',
                click: _this2.onConsulta

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this2.tableData = tableData;
        _this2.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__ = __webpack_require__(809);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      config: {
        tipo: [46],
        click: {},
        list: {
          id_cre: [],
          id_funcionario: []
        },
        loading: {
          id_cre: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: false,
          id_fdt: true
        }
      },
      formFilter: {
        id_tipo_status: [66],
        id_tipo_aso: [],
        created_at: [],
        deleted: 0
      },
      filterBadge: 0,
      loadingTable: false,
      consulta: null,
      pagination: {},
      response: {},
      tableData: [],
      filterItems: [],
      tableHead: [{
        key: 'id_con',
        sortable: true,
        label: 'Consulta'

      }, {
        key: 'dt_cad',
        sortable: true,
        label: 'Data'

      }, {
        key: 'credenciada',
        sortable: true,
        label: 'Credenciada'

      }, {
        key: 'funcionario',
        sortable: true,
        label: 'Funcionário'
      }, {
        key: 'funcao',
        sortable: true,
        show_tipo_aso: true,
        label: 'Função'
      }, {
        key: 'status',
        show_status: true,
        sortable: true,
        label: 'Status'
      }]
    };
  },
  mounted: function mounted() {
    this.getConsulta();
    this.filterItems = __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__["a" /* default */];
  },

  methods: {
    onSearchASO: function onSearchASO(data) {
      this.open('consulta/aso/' + this.toMd5(data.id_con));
    },
    getConsulta: function getConsulta(search, page, pagination) {
      var _this = this;

      this.config.loading.table = true;

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      this.filterBadge = (this.formFilter.created_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length;

      this.get("consulta/liberacao", {
        search: search,
        page: page,
        pagination: pagination,
        filter: this.formFilter
      }).then(function (result) {

        result = result[0];
        _this.config.loading.table = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {
          data = result.data.data;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              id_con: data[i].id_con ? data[i].id_con : '---',
              credenciada: data[i].credenciada ? data[i].credenciada.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].info,
              dt_cad: _this.toDate(data[i].dt_cad, true),
              _data: data[i],
              options: {
                disable_edit: true,
                disable_delete: true
              },
              buttons: []
            };

            if (!data[i].deleted_at) {
              item.buttons.push({
                color: 'info',
                icon: 'fa fa-file-pdf-o',
                title: 'Imprimir ASO',
                click: _this.onSearchASO
              });
            }
            tableData.push(item);
          }

          pagination = result.data;
        }
        _this.config.loading.table = false;
        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_login__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_reset__ = __webpack_require__(811);









/* harmony default export */ __webpack_exports__["default"] = ({
		components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
		mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
		data: function data() {
				return {
						error: {},
						response: {},
						formData: {
								cpf: null,
								cnpj: null,
								senha: null,
								point_type: 'empresa'
						},
						loginItens: [],
						resetitens: [],
						loadingSave: false,
						loadingRecuperarSenha: false,
						showModal: false,
						loadingContent: true
				};
		},
		created: function created() {

				if (this.logged()) this.toRoute({ name: 'empresa.consulta' });else this.loadingContent = false;
		},
		mounted: function mounted() {
				this.loginItens = __WEBPACK_IMPORTED_MODULE_4__form_login__["a" /* default */];
				this.resetitens = __WEBPACK_IMPORTED_MODULE_5__form_reset__["a" /* default */];
		},


		methods: {
				login: function login() {
						var _this = this;

						this.loadingSave = true;
						this.error = {};
						this.response = {};

						this.post("login", this.formData).then(function (result) {
								result = result[0];

								_this.loadingSave = false;
								_this.response = result;

								if (result.status == 200) {

										var usuario = result.data.usuario,
										    cliente = result.data.cliente;

										_this.setCookie(_this.env.jwt_empresa, result.data.jwt, usuario.sessao);

										_this.usuario = usuario;
										_this.cliente = cliente;

										_this.toRoute({ name: 'empresa.consulta' });
								}
						});
				},
				recuperarSenha: function recuperarSenha() {
						var _this2 = this;

						this.loadingRecuperarSenha = true;
						this.response = {};

						this.post("recuperar-senha", this.formData).then(function (result) {
								result = result[0];
								_this2.response = result;
								_this2.loadingRecuperarSenha = false;

								if (result.status == 200) {
										_this2.showModal = false;
										_this2.edAlert("Sua nova senha foi enviada para o email: " + result.data + ". Aguarde alguns minutos e verifique sua caixa de entrada.");
								}
						});
				}
		}
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_meu_cadastro_email__ = __webpack_require__(812);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "email",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_4_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    empresa: {
      type: Object,
      default: null
    }
  },
  watch: {
    empresa: function empresa() {
      this.getEmail();
      this.getFdt();
    }
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        id_emp: null,
        id_usu: null,
        tipo: [],
        fdt: [],
        email: null,
        obs: null,
        ativo: 1
      },
      pagination: {},
      response: {},
      config: {
        tipo: [32],
        click: {
          fdt: this.getFdt
        },
        loading: {
          save: false,
          fdt: false
        },
        list: {
          fdt: []
        }
      },
      emailItems: [],
      tableHead: [{
        key: 'email',
        sortable: true,
        label: 'Email'
      }, {
        key: 'setor',
        sortable: true,
        label: 'Setor'
      }, {
        key: 'fdt',
        sortable: true,
        label: 'Frente de Trabalho'
      }, {
        key: 'obs',
        sortable: true,
        label: 'Obs'
      }],
      tableData: [],
      loadingTable: false,
      loadingSave: false,
      showFormEdit: false
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.emailItems = __WEBPACK_IMPORTED_MODULE_5__form_meu_cadastro_email__["a" /* default */];
    this.getEmail();
    this.getFdt();
  },

  methods: {
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_emp: this.empresa.id,
        id_usu: null,
        tipo: [],
        fdt: [],
        email: null,
        obs: null,
        ativo: 1
      };
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function onEdit(data) {

      var fdt = [],
          tipo = [];

      for (var j = 0; j < data.fdt.length; j++) {
        var element = data.fdt[j];
        fdt.push(data.fdt[j].id);
      }

      for (var _j = 0; _j < data.tipo.length; _j++) {
        var _element = data.fdt[_j];
        tipo.push(data.tipo[_j].id);
      }

      this.formData = {
        id: data.id,
        id_usu: data.usuario.id_usu,
        id_emp: this.empresa.id,
        obs: data.obs,
        tipo: tipo,
        fdt: fdt,
        email: data.email,
        usuario: data.usuario,
        updated_at: data.updated_at,
        ativo: data.ativo
      };
      this.showFormEdit = !this.showFormEdit;
    },

    getFdt: function getFdt() {
      var _this = this;

      if (!this.empresa || !this.empresa.id) return;

      this.config.loading.fdt = true;
      this.config.list.fdt = [];

      this.get('pcmso/fdt', { pagination: 100 }).then(function (result) {

        result = result[0];

        _this.config.loading.fdt = false;

        if (result.status == 200) {
          _this.config.list.fdt = result.data.data;
        }
      });
    },


    getEmail: function getEmail(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;

      this.get("/email/0", { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {

            var fdt = [],
                tipo = [];

            for (var j = 0; j < data[i].fdt.length; j++) {
              var element = data[i].fdt[j];
              fdt.push(element.pcmso + ' (' + element.descricao + ')');
            }

            for (var _j2 = 0; _j2 < data[i].tipo.length; _j2++) {
              var _element2 = data[i].tipo[_j2];
              tipo.push(_element2.descricao);
            }

            var item = {
              nome: data[i].nome,
              email: data[i].email.replace(';', '<br>'),
              obs: data[i].obs ? data[i].obs : '---',
              fdt: fdt.length > 0 ? fdt.join('<br>') : '---',
              setor: tipo.length > 0 ? tipo.join('<br>') : '---',
              ativo: data[i].ativo == 1 ? 'Sim' : 'Não',
              _data: data[i],
              options: {
                style: 'color:' + (data[i].ativo == 1 ? 'green' : 'red'),
                title: data[i].ativo == 1 ? '' : 'Email inativo. Clique para atualizar.'
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    },

    salvar: function salvar() {
      var _this3 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("/email/0/editar", this.formData).then(function (result) {
        result = result[0];

        _this3.config.loading.save = false;
        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg('Email salvo com sucesso!');
          _this3.showFormEdit = !_this3.showFormEdit;
          _this3.getEmail();
        }
      });
    }
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__email_index__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__email_index__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, Emails: __WEBPACK_IMPORTED_MODULE_4__email_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formData.id_fdt': function formDataId_fdt() {
      this.getFuncao();
    },
    'formData.id_funcao': function formDataId_funcao() {
      this.getGHE();
    }
  },
  data: function data() {
    return {
      tagConfig: 'tab-cadastro',
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        tipo: [],
        readonly: {
          nome: true,
          cnpj: true,
          u_cpf: true,
          u_nome: true
        }
      },
      formData: {
        id: null,
        id_estado: null,
        id_cidade: null,
        nome: null,
        cnpj: null,
        email: null,
        tel_com: null,
        r_nome: null,
        r_email: null,
        r_tel_com: null,
        u_nome: null,
        u_cpf: null,
        u_email: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        log: [],
        obs: null,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmpresa();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__["a" /* default */];
  },


  methods: {
    getEmpresa: function getEmpresa() {
      var _this = this;

      this.loadingContent = true;
      this.response = {};

      this.get("meu-cadastro").then(function (result) {

        result = result[0];

        _this.loadingContent = false;
        _this.response = result;

        if (result.status == 200) {
          var data = result.data;

          _this.formData = {
            id: data.id,
            id_estado: data.id_estado,
            id_cidade: data.id_cidade,
            nome: data.nome,
            cnpj: data.cnpj,
            email: data.email,
            tel_com: data.tel_com,
            r_nome: data.r_nome,
            r_email: data.r_email,
            r_tel_com: data.r_tel_com,
            cep: data.cep,
            end: data.end,
            num: data.num,
            bairro: data.bairro,
            comp: data.comp,
            obs: data.obs,
            created_at: data.created_at,
            updated_at: data.updated_at,

            senha_atual: null,
            senha_nova: null,
            senha_confirma: null,

            u_nome: _this.usuario.logged.nome,
            u_cpf: _this.usuario.logged.usuario,
            u_email: _this.usuario.logged.email
          };
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.loadingSave = true;
      this.response = {};

      this.post('meu-cadastro', this.formData).then(function (result) {
        result = result[0];

        _this2.loadingSave = false;

        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Dados atualizados com sucesso');
          _this2.getEmpresa();
        }
      });
    }
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_5_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, ConsultaLote: __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote___default.a, ConsultaHistorico: __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingTable: false,
      componentKey: 0,
      pagination: {},
      response: null,
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_funcionario: this.getFuncionario,
          id_fdt: this.getFdt
        },
        list: {
          id_funcionario: [],
          id_fdt: []
        },
        loading: {
          id_funcionario: false,
          id_fdt: false
        },
        tipo: []
      },
      formData: {
        id_funcionario: [],
        id_fdt: [],
        periodo: [this.toDate(this.addDate(-30, null, 'D'), true), this.toDate(this.addDate(30, null, 'D'), true)]
      },
      formDataConsulta: {
        funcionario: []
      },
      tabPeriodico: 'tab-ok',
      tabExame: 'tab-exames',
      tableData: [],
      tableDataForaPeriodo: [],
      tableDataError: [],
      tableDataExame: [],
      tableDataTabelaPreco: [],
      tableHeadTabelaPreco: [{
        key: "exame",
        sortable: true,
        label: "Exame"
      }, {
        key: "quantidade",
        sortable: true,
        label: "Quantidade"
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Unitário (R$)"
      }, {
        key: "valor_total",
        sortable: true,
        label: "Valor Total (R$)"
      }],
      tableHeadExame: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Aproximado (R$)"
      }, {
        key: 'consulta',
        sortable: true,
        width: '215px',
        label: 'Última Consulta Realizada'

      }, {
        key: 'tipo',
        sortable: true,
        label: 'Tipo'

      }, {
        key: 'data',
        sortable: true,
        width: '215px',
        label: 'Data Ideal Para Refazê-lo'
      }, {
        key: 'obs',
        sortable: true,
        label: 'Observações'
      }],
      tableHead: [{
        key: 'nome',
        sortable: true,
        show_cpf: true,
        label: 'Nome'

      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }, {
        key: 'fdt',
        sortable: true,
        label: 'Frente de Trabalho'
      }, {
        key: 'ghe',
        sortable: true,
        label: 'GHE (Setor)'
      }, {
        key: 'obs',
        sortable: true,
        show_html: true,
        label: 'Observações'
      }],
      funcionario: null,
      showModal: false,
      showConsultaLote: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
    this.getFdt();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__["a" /* default */];
  },


  methods: {
    onConsultaLote: function onConsultaLote(data) {

      if (data.id) {
        data = [data];
      }

      this.componentKey += 1;
      this.formDataConsulta.funcionario = data;
      this.showConsultaLote = !this.showConsultaLote;
    },
    onExcel: function onExcel() {
      this.open('periodico/excel', { filter: this.formData });
    },
    onExames: function onExames(data) {

      var tableDataExame = [];

      for (var i = 0; i < data.exames.length; i++) {

        var item = {
          id: data.exames[i].id,
          exame: data.exames[i].nome,
          consulta: data.exames[i].id_con ? 'Consulta ' + data.exames[i].id_con + ' (' + this.toDate(data.exames[i].dt_cad, true) + ')' + (data.exames[i].validade > 0 ? '<br><span>Exame válido por ' + data.exames[i].validade + ' dias</span>' : '') : '---',
          tipo: data.exames[i].dt_rea ? data.exames[i].tipo : '---',
          data: data.exames[i].dt_rea ? this.toDate(data.exames[i].dt_rea, true) : '---',
          obs: data.exames[i].obs ? data.exames[i].obs : '---',
          valor_venda: data.exames[i].tabela_preco ? this.floatToMoney(data.exames[i].tabela_preco.valor_venda) : "---",
          _data: data.exames[i],
          options: {
            style: 'color:' + data.exames[i].cor
          },
          buttons: [{
            color: 'success',
            icon: 'fa fa-user-md',
            title: 'Visualizar Exames',
            click: this.onExames

          }]
        };
        tableDataExame.push(item);
      }

      this.tabExame = 'tab-exames';
      this.showModal = !this.showModal;
      this.tableDataExame = tableDataExame;
      this.funcionario = data;
    },
    getFdt: function getFdt() {
      var _this = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get('pcmso/fdt').then(function (result) {
        result = result[0];

        _this.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this.config.list.id_fdt = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('funcionario/0', { search: _search, pagination: 100 }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this2.config.list.id_funcionario = result.data.data;
        }
      });
    },
    getPeriodico: function getPeriodico(search, page, pagination) {
      var _this3 = this;

      this.loadingTable = true;
      this.tabPeriodico = 'tab-ok';

      if (this.formData.periodo.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-30, null, 'D'), true),
            amanha = this.toDate(this.addDate(30, null, 'D'), true);

        this.formData.periodo = [ontem, amanha];
      }

      this.get("periodico", { search: search, page: page, pagination: pagination, filter: this.formData }).then(function (result) {
        result = result[0];

        _this3.loadingTable = false;
        _this3.response = result;

        var data = [],
            tableData = [],
            tableDataForaPeriodo = [],
            tableDataError = [],
            tableDataTabelaPreco = [],
            pagination = {};

        if (result.status == 200) {
          result.data.per_tabela_preco.forEach(function (tabela_preco, index) {
            var item = {
              id: index,
              exame: tabela_preco.fdt.nome,
              valor_venda: '---',
              valor_total: '---',
              quantidade: tabela_preco.fdt.quantidade,
              _data: tabela_preco,
              options: {
                style: "color:red;font-weight:bold"
              },
              buttons: []
            };
            tableDataTabelaPreco.push(item);

            tabela_preco.exames.forEach(function (tabela_preco_exame, indexExame) {
              var item = {
                id: index + indexExame,
                exame: tabela_preco_exame.nome,
                valor_venda: tabela_preco_exame.quantidade == 0 ? '---' : _this3.floatToMoney(tabela_preco_exame.valor_venda),
                valor_total: _this3.floatToMoney(Number(tabela_preco_exame.valor_venda) * Number(tabela_preco_exame.quantidade)),
                quantidade: tabela_preco_exame.quantidade,
                _data: tabela_preco_exame,
                buttons: []
              };
              tableDataTabelaPreco.push(item);
            });
          });

          data = result.data.per_dentro_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : '---',
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '---',
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : '---',
              _data: data[i],
              buttons: [{
                color: 'warning',
                icon: 'fa fa-address-card',
                title: 'Gerar Consulta para esse Trabalhador',
                click: _this3.onConsultaLote

              }, {
                color: 'success',
                icon: 'fa fa-user-md',
                title: 'Visualizar Exames (' + data[i].length + ' no total)',
                click: _this3.onExames

              }]
            };
            tableData.push(item);
          }

          data = result.data.per_fora_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : '---',
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '---',
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : '---',
              _data: data[i],
              buttons: [{
                color: 'success',
                icon: 'fa fa-user-md',
                title: 'Visualizar Exames (' + data[i].length + ' no total)',
                click: _this3.onExames

              }]
            };
            tableDataForaPeriodo.push(item);
          }

          data = result.data.per_erro;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : '---',
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '---',
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : '---',
              _data: data[i],
              buttons: []
            };
            tableDataError.push(item);
          }
        }

        _this3.tableData = tableData;
        _this3.tableDataForaPeriodo = tableDataForaPeriodo;
        _this3.tableDataError = tableDataError;
        _this3.tableDataTabelaPreco = tableDataTabelaPreco;
      });
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {}
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  data: function data() {
    return {
      url: null
    };
  },
  created: function created() {
    $('body').addClass('bg-login');
    this.url = this.getLocation('origin');
  },
  mounted: function mounted() {
    $(".carregando").hide();
  },


  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  props: {
    erro: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    $('body').addClass('bg-login');
  },
  mounted: function mounted() {
    $(".carregando").hide();
  },


  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  data: function data() {
    return {
      url: null
    };
  },
  created: function created() {
    $('body').addClass('bg-login');
    this.url = this.getLocation('origin');
  },
  mounted: function mounted() {
    $(".carregando").hide();
  },


  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_template__ = __webpack_require__(27);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: { EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_template__["b" /* EdForm */], EdInputSelect: __WEBPACK_IMPORTED_MODULE_3_template__["c" /* EdInputSelect */] },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
	props: {
		consulta: {
			type: Object,
			default: function _default() {
				return null;
			}
		},
		consultaNova: {
			type: Object,
			default: function _default() {
				return null;
			}
		},
		ultimaRevisao: {
			type: Object,
			default: function _default() {
				return null;
			}
		}
	},
	watch: {
		consulta: function consulta() {
			this.getFdt();
		},
		'consultaNova.id_fdt': function consultaNovaId_fdt() {
			this.consultaNova.id_ghe = null;
		},
		'consultaNova.id_ghe': function consultaNovaId_ghe() {
			this.consultaNova.id_funcao = null;
		},
		'consultaNova.id_funcao': function consultaNovaId_funcao() {
			this.getCredenciada();
		}
	},
	data: function data() {
		return {
			list: {
				fdt: [],
				ghe: [],
				revisao: [],
				funcao: []
			},
			tabela_preco: null,
			loadingFdt: false,
			loadingGhe: false,
			loadingFuncao: false,
			loadingRevisao: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.getFdt();
	},

	methods: {
		getFdt: function getFdt() {
			var _this = this;

			if (!this.consulta) return;

			this.loadingFdt = true;

			this.$root.$request.get("pcmso/fdt/" + this.consulta.empresa.id, {}).then(function (result) {

				console.log('fdt', result);
				if (result.status == 200) {
					_this.list.fdt = result.data.data;

					if (_this.consultaNova.id_fdt) {
						_this.getGhe();
					}
				}

				_this.loadingFdt = false;
			});
		},
		getGhe: function getGhe() {
			var _this2 = this;

			this.loadingGhe = true;
			this.list.ghe = [];

			this.$root.$request.get("pcmso/ghe/" + this.consulta.empresa.id, {
				filter: {
					id_fdt: this.consultaNova.id_fdt
				}
			}).then(function (result) {

				console.log('ghe', result);

				if (result.status == 200) {
					_this2.list.ghe = result.data;
				}

				_this2.loadingGhe = false;
			});
		},
		getFuncao: function getFuncao() {
			var _this3 = this;

			this.loadingFuncao = true;
			this.list.funcao = [];

			this.$root.$request.get("pcmso/ghe/funcao/" + this.consultaNova.id_ghe + "/" + this.consulta.empresa.id, {
				filter: {}
			}).then(function (result) {

				console.log('funcao', result.data.data);

				if (result.status == 200) {
					_this3.list.funcao = result.data.data;

					var self = _this3;
					var funcao = _this3.list.funcao.find(function (c) {
						return c.id == self.consulta.funcao.id;
					});
					console.log('asdsdf', [funcao, _this3.list.funcao, self.consulta.funcao]);

					_this3.consultaNova.id_funcao = null;

					if (funcao) {
						_this3.consultaNova.id_funcao = funcao.id;
					}
				}

				_this3.loadingFuncao = false;
			});
		},
		getCredenciada: function getCredenciada(page, search) {
			var _this4 = this;

			if (!this.consultaNova.id_fdt || !this.consultaNova.id_ghe || !this.consultaNova.id_funcao) {
				return;
			}

			this.$root.$loading.set(true, "Carregando exames");

			var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
				id_fdt: this.consultaNova.id_fdt,
				id_funcao: this.consultaNova.id_funcao,
				id_ghe: this.consultaNova.id_ghe,
				periodicidade: this.consulta.periodicidade,
				id_funcionario: this.consulta.funcionario.id,
				hoje: this.$utilidade.toDate(null, true),
				id_tipo_aso: [this.consulta.tipo_aso.id],
				pcd: 0,
				show_tabela_preco: 1
			}, this.formFilter);

			this.$root.$request.get("tabela-preco/" + this.consulta.empresa.id + "/" + this.consultaNova.id_fdt, {
				search: search,
				page: page,
				filter: filter
			}).then(function (result) {
				_this4.$root.$loading.set(false);

				console.log('tabela preco', result);

				_this4.consultaNova.id_tabela_preco = null;

				if (result.status == 200) {
					_this4.tabela_preco = null;

					for (var index = 0; index < result.data.length; index++) {
						var tabela_preco = result.data[index];

						if (tabela_preco.credenciada && tabela_preco.credenciada.padrao == "1" || index == 0) {
							_this4.consultaNova.id_tabela_preco = tabela_preco.id;
						}
					}

					if (!_this4.consultaNova.id_tabela_preco) {
						_this4.tabela_preco = 'Tabela de preço não encontrado para os dados informados.';
					}
				} else {
					_this4.tabela_preco = result.msg;
				}
			});
		}
	}
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {},
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
	props: {
		consulta: {
			type: Object,
			default: function _default() {
				return null;
			}
		}
	},
	watch: {
		consulta: function consulta() {}
	},
	data: function data() {
		return {
			tabConfig: 'tab-consulta'
		};
	},
	created: function created() {},


	mounted: function mounted() {},

	methods: {}
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_externa_filtro__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a,
    ConsultaDetalhe: __WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe___default.a,
    ConsultaAlterarRevisao: __WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_4_common_alert___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  watch: {
    "formFilter.id_empresa": function formFilterId_empresa() {
      this.getFuncionario();
      this.getFDT();

      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.config.disabled.id_fdt = this.formFilter.id_empresa ? false : true;

      this.formFilter.id_funcionario = null;
      this.formFilter.id_fdt = null;
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        click: {
          id_cre: this.getCredenciada,
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario,
          id_funcao: this.getFuncao,
          id_fdt: this.getFDT
        },
        list: {
          id_cre: [],
          id_empresa: [],
          id_funcionario: [],
          id_funcao: [],
          id_fdt: []
        },
        loading: {
          id_cre: false,
          id_empresa: false,
          id_funcionario: false,
          id_funcao: false,
          id_fdt: false
        },
        disabled: {
          id_funcionario: true,
          id_fdt: true
        }
      },
      formData: {
        consulta: null,
        consultaNova: null,
        ultima_revisao: null
      },
      formFilter: {
        id_cre: 1,
        id_funcao: null,
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      },
      pagination: {},
      response: {},
      filterItems: [],
      tableHead: [{
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "credenciada",
        sortable: true,
        label: "Credenciada"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }, {
        key: "data_agendamento",
        sortable: true,
        label: "Agendamento"
      }, {
        key: "data_cadastro",
        sortable: true,
        label: "Cadastro"
      }],
      tableData: [],
      loadingTable: true,
      loadingEditAll: false,
      loadingConsultaDetail: false,
      showFormFilter: false,
      showConsultaDetail: false,
      showAlterarRevisao: false,
      filterBadge: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
    this.getEmpresa();
    this.getCredenciada();
    this.getFuncao();

    this.filterItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_externa_filtro__["a" /* default */];
  },


  computed: {
    checkAlterarPcmso: function checkAlterarPcmso() {
      return this.formData.consultaNova && this.formData.consultaNova.id_fdt && this.formData.consultaNova.id_ghe && this.formData.consultaNova.id_tabela_preco && this.formData.consultaNova.id_funcao ? false : true;
    }
  },
  methods: {
    onClear: function onClear() {
      this.formFilter = {
        id_cre: 1,
        id_funcao: null,
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      };
    },
    onEdit: function onEdit(data) {
      var _this = this;

      this.loadingTable = true;

      this.get("empresa/consulta/externa/" + data.id + "/gerar").then(function (result) {
        result = result[0];

        if (result.status == 200) {
          window.open("https://www1.softwareatento.com.br" + "/app/consulta.php?con=" + result.data.id_con + "&force=1", "_top");
        } else {
          _this.getConsulta();

          _this.$alert(result.msg, "Atenção", {
            confirmButtonText: "OK"
          });
        }
      });
    },
    onShowConsulta: function onShowConsulta(data) {
      var _this2 = this;

      this.showConsultaDetail = !this.showConsultaDetail;
      this.loadingConsultaDetail = true;
      this.formData.consulta = null;

      this.get("empresa/consulta/externa/" + data.id).then(function (result) {
        result = result[0];

        _this2.loadingConsultaDetail = false;

        if (result.status == 200) {
          _this2.formData.consulta = result.data;
        }
      });
    },
    onGerarConsulta: function onGerarConsulta(data) {
      var _this3 = this;

      var label = data.funcionario.nome,
          self = this;

      this.$confirm("O sistema vai gerar uma consulta definitiva para o funcionário " + label + ". Deseja continuar?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.get("pcmso/revisao/" + data.empresa.id + "/" + data.fdt.id + "/ultima-revisao").then(function (result) {
          result = result[0];

          self.formData.ultima_revisao = result.data;
          self.formData.consulta = data;
          self.formData.consultaNova = {
            id: 0,
            id_fdt: data.fdt.id,
            id_emp: data.empresa.id,
            id_ghe: null,
            id_funcao: null,
            id_tabela_preco: null,
            id_mf_fdt: null,
            id_mf_ghe: null,
            id_mf_funcao: null,
            data_age: _this3.toDate(null, true),
            id_tipo_aso: data.tipo_aso.id,
            periodicidade: data.periodicidade,
            id_funcionario: data.funcionario.id,
            id_con_ext_original: data.id
          };

          var diff = _this3.$utilidade.diffDays(data.data_age, _this3.$utilidade.toDate(null, true, "YYYY-MM-DD"), "d");

          console.log("validar revisao", [data, result.data]);

          if (diff <= 0 && (!result.data || !data.revisao || data.revisao.id != result.data.id)) {
            self.showAlterarRevisao = !self.showAlterarRevisao;
          } else {
            self.loadingTable = true;

            self.get("empresa/consulta/externa/" + data.id + "/gerar").then(function (result) {
              result = result[0];

              if (result.status == 200) {
                window.open(_this3.env.url_cs + "/app/consulta.php?con=" + result.data.id_con, "_top");
              } else {
                self.getConsulta();

                _this3.$alert(result.msg, "Atenção", {
                  confirmButtonText: "OK"
                });
              }
            });
          }
        });
      });
    },
    onAlterarPcmso: function onAlterarPcmso() {
      var _this4 = this;

      self = this;

      this.$confirm("O sistema vai alterar o PCMSO e exames vinculados nessa consulta e o processo não poderá ser revertido. Deseja continuar?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.$root.$loading.set(true);

        if (_this4.formData.consulta.tipo_aso.id == 50) {
          _this4.formData.consultaNova.id_mf_fdt = _this4.formData.consultaNova.id_fdt;
          _this4.formData.consultaNova.id_mf_ghe = _this4.formData.consultaNova.id_ghe;
          _this4.formData.consultaNova.id_mf_funcao = _this4.formData.consultaNova.id_funcao;
        }

        var filter = {
          id_fdt: _this4.formData.consultaNova.id_fdt,
          id_funcao: _this4.formData.consultaNova.id_funcao,
          id_ghe: _this4.formData.consultaNova.id_ghe,
          periodicidade: _this4.formData.consulta.periodicidade,
          id_funcionario: _this4.formData.consulta.funcionario.id,
          hoje: _this4.$utilidade.toDate(null, true),
          id_tipo_aso: [_this4.formData.consulta.tipo_aso.id],
          pcd: 0,
          show_tabela_preco: 1
        };

        self.post("empresa/consulta/externa/" + _this4.formData.consulta.id + "/alterar", _this4.formData.consultaNova, filter).then(function (result) {
          result = result[0];

          console.log("altear consulta result", result);
          self.$root.$loading.set(false);

          if (result.status == 200) {
            window.open(_this4.env.url_cs + "/app/consulta.php?con=" + result.data.id_con, "_top");
          }
        });
      });
    },
    getFuncao: function getFuncao(_search) {
      var _this5 = this;

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      this.get("/funcao", { search: _search }).then(function (result) {
        result = result[0];

        _this5.config.loading.id_funcao = false;

        if (result.status == 200) {
          _this5.config.list.id_funcao = result.data.data;
        }
      });
    },
    getCredenciada: function getCredenciada(_search) {
      var _this6 = this;

      this.config.loading.id_cre = true;
      this.config.list.id_cre = [];

      this.get("/credenciada", { search: _search }).then(function (result) {
        result = result[0];

        _this6.config.loading.id_cre = false;

        if (result.status == 200) {
          _this6.config.list.id_cre = result.data.data;
        }
      });
    },
    getEmpresa: function getEmpresa(_search) {
      var _this7 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this7.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this7.config.list.id_empresa = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this8 = this;

      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this8.config.loading.id_funcionario = true;

        if (result.status == 200) {
          _this8.config.list.id_funcionario = result.data.data;
        }
      });
    },
    getFDT: function getFDT() {
      var _this9 = this;

      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formFilter.id_empresa, {
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this9.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this9.config.list.id_fdt = result.data.data;
        }
      });
    },
    getConsulta: function getConsulta(_search, _page, _pagination, _loading) {
      var _this10 = this;

      this.loadingTable = true;
      this.response = {};

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-10, null, "D"), true),
            amanha = this.toDate(this.addDate(30, null, "D"), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcao ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_cre ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + (this.formFilter.agendamento_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("empresa/consulta/externa", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this10.response = result;
        _this10.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this10,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var style = "",
                color = "#6fc956",
                title = "Agendamento",
                hoje = _this10.toDate(null, true),
                data_age = _this10.toDate(data[i].data_age, true),
                diff = _this10.diffDays(data_age, hoje);

            if (data[i].id_con) {
              color = "#6fc956";
            } else if (diff > 0) {
              color = "#e07d59";
            } else if (diff == 0) {
              color = "#6fc956";
            } else {
              color = "#7797ef";
            }

            var item = {
              consulta: data[i].id_con ? data[i].id_con : "---",
              credenciada: data[i].credenciada ? data[i].credenciada.nome : null,
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              data_cadastro: _this10.toDate(data[i].created_at, false),
              data_agendamento: data[i].data_age ? _this10.toDate(data[i].data_age, true) : null,
              style: data[i].deleted_at ? 'color:red;"' : "color:" + color,
              _data: data[i],
              options: {
                disable_delete: !_this10.validarPermissao(560),
                disable_edit: !_this10.validarPermissao(559)
              },
              buttons: []
            };

            if (_this10.validarPermissao(559) && data[i].credenciada.padrao == 1 && data[i].tipo_status.id != 194 && data[i].tipo_status.id != 195) {
              if (!data[i].id_con) {
                item.buttons.push({
                  icon: "fa fa-paper-plane",
                  color: "success",
                  title: "Gerar Consulta (Ação necessária para prosseguir com o atendimento)",
                  click: _this10.onGerarConsulta
                });
              } else {
                item.buttons.push({
                  icon: "fa fa-pencil-square-o",
                  color: "primary",
                  title: "Consulta já foi gerada. Clique aqui para abrir a consulta",
                  click: _this10.onEdit
                });
              }
            }

            item.buttons.push({
              icon: "fa fa-info-circle",
              color: "warning",
              title: "Detalhes da consulta",
              click: _this10.onShowConsulta
            });

            tableData.push(item);
          }

          _this10.pagination = pagination;
          _this10.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    funcionario: {
      type: Object,
      default: null
    },
    empresa: {
      type: Object,
      default: null
    },
    id_funcao: {
      type: Number,
      default: null
    }
  },
  watch: {
    funcionario: function funcionario() {
      this.getHistorico();
    },
    empresa: function empresa() {
      this.getHistorico();
    },
    id_funcao: function id_funcao() {
      this.getHistorico();
    }
  },

  data: function data() {
    return {
      formData: {
        historico: null,
        consulta: null,
        exames: []
      },
      pagination: {},
      paginationExame: {},
      response: {},
      tableData: [],
      tableDataExame: [],
      tableHeadExame: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,
        show_alt: true,
        label: 'Exame'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }],
      tableHead: [{
        key: 'consulta',
        sortable: true,
        label: 'Consulta',
        width: '90px'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }, {
        key: 'tipo_aso',
        sortable: true,
        label: 'Tipo',
        width: '200px'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }],
      showModal: false,
      loadingTable: false,
      loadingTableExame: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getHistorico();
  },


  methods: {
    onShowExame: function onShowExame(consulta) {
      this.showModal = !this.showModal;
      this.formData.consulta = consulta;
      this.getExame();
    },
    getExame: function getExame(_search, _page, _pagination) {
      var _this = this;

      this.loadingTableExame = true;
      this.formData.exames = [];

      this.get('empresa/consulta/exame/' + this.formData.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];

        _this.loadingTableExame = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              data: data[i].dt_cad ? _this.toDate(data[i].dt_cad, true) : null,
              valor: data[i].valor,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableDataExame = tableData;
        _this.paginationExame = pagination;
      });
    },
    getHistorico: function getHistorico(_search) {
      var _this2 = this;

      if (!this.funcionario || !this.empresa || !this.funcionario.id) return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var ontem = this.convertDate(this.addDate(-10, null, 'y')),
          amanha = this.convertDate(this.addDate(30, null)),
          filter = {
        id_empresa: this.empresa.id,
        id_funcionario: this.funcionario.id,
        show_con_exa: 1,
        created_at: [ontem, amanha]
      };

      this.get('empresa/consulta', { filter: filter }).then(function (result) {
        result = result[0];

        _this2.response = result;
        _this2.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_aso: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              data: _this2.toDate(data[i].dt_cad, true),
              exames: '',
              _data: data[i],
              buttons: [{
                color: 'primary',
                icon: 'fa fa-search',
                title: 'Ver Exames',
                click: _this2.onShowExame

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this2.tableData = tableData;
        _this2.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    id_ghe: {
      type: Number,
      default: null
    }
  },
  watch: {
    id_ghe: function id_ghe() {
      this.getPCMSO();
    }
  },

  data: function data() {
    return {
      formData: {
        pcmso: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: 'adm',
        sortable: true,
        show_html: true,
        label: 'Admissional'
      }, {
        key: 'apos_adm',
        sortable: true,
        show_html: true,
        label: 'Após Admissional'
      }, {
        key: 'dem',
        sortable: true,
        show_html: true,
        label: 'Demissional'
      }, {
        key: 'ret_tra',
        sortable: true,
        show_html: true,
        label: 'Retorno ao Trabalho'
      }, {
        key: 'mud_fun',
        sortable: true,
        show_html: true,
        label: 'Mudança de Função'
      }, {
        key: 'periodicidade',
        sortable: true,
        show_html: true,
        label: 'Periódico'
      }, {
        key: 'validade',
        sortable: true,
        show_html: true,
        label: 'Validade'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getPCMSO();
  },


  methods: {
    getPCMSO: function getPCMSO() {
      var _this = this;

      if (!this.id_ghe) return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};

      this.get('pcmso/ghe/exame/' + this.id_ghe).then(function (result) {
        result = result[0];

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var periodicidade = data[i].periodicidade != '0' ? '<span style="color:green">' + data[i].periodicidade + ' meses</span>' : '<span style="color:red">Não</span>';

            if (data[i].per_id1 != '0') {
              periodicidade += "<span style='color:green'>\nA partir dos " + data[i].per_id1 + " anos</span>";
            }

            if (data[i].per_id2 != '0') {
              periodicidade += "<span style='color:green'>\nAté os  " + data[i].per_id2 + " anos</span>";
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              validade: data[i].validade > 0 ? data[i].validade + ' dias' : '---',
              adm: data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              apos_adm: data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              dem: data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              ret_tra: data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              mud_fun: data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              periodicidade: periodicidade,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.showDownloadASO': function parentShowDownloadASO() {
			this.getConsultaEmail();
		},
		'parent.consulta.id': function parentConsultaId() {
			this.getConsultaEmail();
		}
	},
	data: function data() {
		return {
			pagination: {},
			error: {},
			tableHead: [{
				key: 'data',
				sortable: true,
				width: '120px',
				label: 'Data'
			}, {
				key: 'usuario',
				sortable: true,
				label: 'Usuário'
			}, {
				key: 'lote',
				sortable: true,
				width: '55px',
				label: 'Lote'
			}, {
				key: 'consulta',
				sortable: true,
				show_tipo_aso: true,
				show_consulta_link: true,
				label: 'Consulta'
			}, {
				key: 'remetente',
				sortable: true,
				label: 'Remetente'
			}, {
				key: 'destinatario',
				sortable: true,
				show_html: true,
				label: 'Destinatário'
			}, {
				key: 'obs',
				sortable: true,
				limit: 20,
				label: 'Obs'
			}, {
				key: 'documento',
				sortable: true,
				show_html: true,
				label: 'Documento'
			}, {
				key: 'status',
				sortable: true,
				show_status: true,
				label: 'Status'
			}],
			tableData: [],
			loadingTable: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		var _this = this;

		this.getConsultaEmail();

		this.$events.on('onClienteEvent', function (eventData) {
			_this.getConsultaEmail();
		});
	},

	methods: {

		getConsultaEmail: function getConsultaEmail(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;

			this.get('empresa/consulta/email/' + (this.parent.consulta ? this.parent.consulta.id_con : 0), { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this2.formataData(result);
				}
			});
		},

		formataData: function formataData(result) {

			var data = result.data.data,
			    tableData = [],
			    self = this,
			    pagination = result.data;

			for (var i = 0; i < data.length; i++) {

				var fdt = data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '',
				    select_pages = '';

				var arr = data[i].destinatario.split(';'),
				    destinatario = '',
				    msg = '';

				for (var j = 0; j < arr.length; j++) {
					var title = '';

					if (data[i].abertura && data[i].abertura[arr[j]]) {
						var abertura = data[i].abertura[arr[j]],
						    aux = 'Email visualizado em ' + this.toDate(abertura.data) + '\n' + 'Endereço IP ' + abertura.ip;

						title = '<i class="fa fa-eye" title="' + aux + '"></i> ';
					}
					destinatario += '<span>' + title + arr[j] + '</span><br>';
				}

				if (data[i].abertura && data[i].abertura.data) {
					abertura = '<span style="color:red;font-size:7pt"><br><br>Email Visualizado em: ' + this.toDate(data[i].abertura.data, false);
					abertura += '<br>Endereço IP: ' + data[i].abertura.ip + '</span>';
				}

				if (data[i].msg) {
					msg = '<span style="color:red;font-size:7pt" title="' + data[i].msg + '"><i class="fa fa-exclamation-triangle"></i></span> ';
				}

				if (data[i].select_pages) {
					select_pages = '<br><span style="color:red;font-size:7.5pt">Páginas selecionadas: ' + data[i].select_pages.join(',') + '</span>';
				}

				var item = {
					'data': this.toDate(data[i].created_at, false),
					'usuario': data[i].usuario ? data[i].usuario.usuario : null,
					'lote': data[i].lote,
					'obs': data[i].obs,
					'remetente': data[i].remetente,
					'destinatario': destinatario,
					'documento': data[i].tipo_documento ? data[i].tipo_documento.descricao + select_pages : null,
					'status': data[i].msg,
					'consulta': data[i].id_con,
					_data: data[i],
					options: {},
					buttons: []
				};

				tableData.push(item);
			}

			this.pagination = pagination;
			this.tableData = tableData;
			this.loadingTable = false;
		}
	}
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_download__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__download_aso_email__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__download_aso_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__download_aso_email__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a,
    Download: __WEBPACK_IMPORTED_MODULE_3_common_download___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a,
    DownloadAsoEmail: __WEBPACK_IMPORTED_MODULE_5__download_aso_email___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_2_common_fct___default.a, __WEBPACK_IMPORTED_MODULE_3_common_download___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showDownloadASO": function parentShowDownloadASO() {
      this.formData.obs = null;
      this.tagConfig = "tab-cadastro";
    },
    "parent.consulta.id": function parentConsultaId() {

      if (this.parent.consulta) {
        this.formData = {
          destinatario: this.parent.consulta.empresa.email,
          consultas: [this.parent.consulta],
          id_emp: this.parent.consulta.empresa.id,
          id_fun: null,
          obs: null,
          todos: false,
          tipo_documento: [82]
        };
        this.lstConsulta = [this.parent.consulta];
        this.lstEmpresa = [this.parent.consulta.empresa];
        this.empresa = this.parent.consulta.empresa;
      } else {
        this.inicialize();
      }
    }
  },
  data: function data() {
    return {
      formData: {
        destinatario: null,
        todos: false,
        id_emp: null,
        id_fun: null,
        obs: null,
        consultas: [],
        tipo_documento: [82]
      },
      empresa: null,
      pagination: {},
      error: {},
      tableHead: [{
        key: "data",
        sortable: true,
        width: "120px",
        label: "Data"
      }, {
        key: "usuario",
        sortable: true,
        label: "Usuário"
      }, {
        key: "lote",
        sortable: true,
        width: "55px",
        label: "Lote"
      }, {
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "destinatario",
        sortable: true,
        show_html: true,
        label: "Destinatário"
      }, {
        key: "obs",
        sortable: true,
        limit: 20,
        label: "Obs"
      }, {
        key: "documento",
        sortable: true,
        show_html: true,
        label: "Documento"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstConsulta: [],
      lstTipoDocumento: [],
      loadingFuncionario: false,
      loadingConsulta: false,
      loadingEmpresa: false,
      loadingEditAll: false,
      loadingTable: false,
      loadingSave: false,
      novaLiberacao: false,
      tagConfig: "tab-cadastro"
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.getEmpresa();
    this.getTipo();
    this.inicialize();
  },

  methods: {
    inicialize: function inicialize() {
      this.formData = {
        destinatario: null,
        id_emp: null,
        id_fun: null,
        consultas: [],
        todos: false,
        obs: null,
        tipo_documento: [82]
      };
      this.lstConsulta = [];
      this.empresa = null;
    },

    handleClick: function handleClick(tab, event) {
      this.novaLiberacao = false;
    },


    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.loadingEmpresa = true;

      var filter = {
        id_tipo_email: [197],
        show_emp_email: 1
      };

      this.get("/empresa", {
        search: _search,
        filter: filter
      }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this.lstEmpresa = result.data.data;
        } else {
          _this.lstEmpresa = [];
        }

        _this.loadingEmpresa = false;
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      if (!this.formData.id_emp) return;

      this.loadingFuncionario = true;
      this.lstFuncionario = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this2.loadingFuncionario = false;

        if (result.status == 200) {
          _this2.lstFuncionario = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(_search) {
      var _this3 = this;

      if (!this.empresa) return;

      this.formData.id_emp = this.empresa.id;
      this.formData.destinatario = this.empresa.email;

      if (!this.formData.id_emp) return;

      this.loadingConsulta = true;
      this.lstConsulta = [];

      var hoje = this.toDate(null, true),
          ontem = this.toDate(this.addDate(-365 * 2, null, "D"), true),
          amanha = this.toDate(this.addDate(1, null, "D"), true);

      var filter = {
        id_empresa: this.formData.id_emp,
        with_arquivo: 1,

        created_at: [ontem, amanha]
      };

      this.get("/empresa/consulta", {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        result = result[0];

        _this3.loadingConsulta = false;

        if (result.status == 200) {
          _this3.lstConsulta = result.data.data;
        }
      });
    },

    getTipo: function getTipo() {
      var _this4 = this;

      this.post("tipo/parent", {
        codigo: [81],
        exclude: [84, 88]
      }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this4.lstTipoDocumento = result.data["81"];
        }
      });
    },

    salvar: function salvar() {
      var _this5 = this;

      this.loadingSave = true;

      this.post("empresa/consulta/email/" + (this.parent.consulta ? this.parent.consulta.id_con : 0) + "/cadastrar", this.formData).then(function (result) {
        result = result[0];

        _this5.loadingSave = false;

        if (result.status == 200) {
          _this5.$message({
            message: "Email cadastrado com sucesso! O envio pode levar alguns minutos para ser realizado. Por favor aguarde!",
            type: "success"
          });

          _this5.error = {};
          _this5.novaLiberacao = true;
          _this5.tagConfig = "tab-historico";

          _this5.formataData(result);
          _this5.parent.getConsulta();
        }
      });
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_liberacao_aso__ = __webpack_require__(816);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_5_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_3_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.consulta.id": function parentConsultaId() {
      this.getConsulta();
      this.getConsultaLiberacao();
    },
    "parent.showLiberacao": function parentShowLiberacao() {
      this.getConsulta();
      his.getConsultaLiberacao();
    },
    "formData.aptidao": function formDataAptidao() {
      this.handleAptidao();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [53, 185, 189],
        click: {
          exames: _.debounce(this.getExame, 1000)
        },
        list: {
          exames: []
        },
        loading: {
          save: false,
          table: false,
          content: false,
          exames: false
        },
        disabled: {
          id_tipo_status: false,
          te_alt: false,
          te_esp: false,
          obs: false
        }
      },
      formData: {
        id: 0,
        id_tipo_status: 69,
        aptidao: null,
        te_alt: null,
        te_esp: null,
        te_ele: null,
        obs: null,
        senha: null,
        arquivo: null,
        exames: []
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "data",
        sortable: true,
        width: "120px",
        label: "Data"
      }, {
        key: "usuario",
        sortable: true,
        label: "Usuário"
      }, {
        key: "status",
        sortable: true,
        label: "Status"
      }, {
        key: "aptidao",
        sortable: true,
        show_html: true,
        label: "Aptidão"
      }, {
        key: "tra_altura",
        sortable: true,
        show_html: true,
        label: "Tra. Altura"
      }, {
        key: "tra_ec",
        sortable: true,
        show_html: true,
        label: "Tra. Espaço Confinado"
      }, {
        key: "exames",
        sortable: true,
        label: "Exames Alterados"
      }, {
        key: "obs",
        sortable: true,
        label: "Obs"
      }],
      tableData: [],
      formItems: [],
      novaLiberacao: false,
      tagConfig: "tab-cadastro",
      title: ""
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_6__form_liberacao_aso__["a" /* default */];
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      this.novaLiberacao = false;
    },
    handleAptidao: function handleAptidao() {
      this.config.disabled.id_tipo_status = this.formData.aptidao == "2" || this.formData.aptidao == "5";
      this.config.disabled.te_alt = this.formData.aptidao == "5";
      this.config.disabled.te_esp = this.formData.aptidao == "5";

      if (this.formData.aptidao == "1") {
        this.formData.id_tipo_status = 66;
      } else if (this.formData.aptidao == "2") {
        this.formData.id_tipo_status = 67;
      } else if (this.formData.aptidao == "5") {
        this.formData.id_tipo_status = 70;
      }
    },
    getExame: function getExame() {},


    getConsulta: function getConsulta() {
      var _this = this;

      if (!this.parent.consulta) return;

      this.config.loading.content = true;
      this.config.list.exames = [];

      this.get("empresa/consulta/" + this.parent.consulta.id_con).then(function (result) {
        result = result[0];
        _this.config.loading.content = false;

        if (result.status == 200) {
          var _this$formData;

          _this.formData = (_this$formData = {
            id_tipo_status: result.data.tipo_status ? result.data.tipo_status.id : null,
            aptidao: _this.toString(result.data.aptidao) == "0" ? null : _this.toString(result.data.aptidao),
            te_alt: _this.toString(result.data.te_alt) == "0" ? null : _this.toString(result.data.te_alt)
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, "te_alt", _this.toString(result.data.te_alt) == "0" ? null : _this.toString(result.data.te_alt)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, "te_esp", _this.toString(result.data.te_esp) == "0" ? null : _this.toString(result.data.te_esp)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, "obs", result.data.obs), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, "exames", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, "senha", null), _this$formData);

          for (var i = 0; i < result.data.exames.length; i++) {
            var element = result.data.exames[i];

            if (element.dem == 0) {
              _this.config.list.exames.push(element.exame);
            }
          }
        }
      });
    },

    getConsultaLiberacao: function getConsultaLiberacao(_search, _page, _pagination) {
      var _this2 = this;

      if (!this.parent.consulta) return;

      this.config.loading.table = true;
      this.tagConfig = "tab-cadastro";
      this.title = " Nº " + this.parent.consulta.id_con + " - " + this.parent.consulta.empresa.nome + " - " + this.parent.consulta.funcionario.nome;

      this.get("empresa/consulta/liberacao/" + this.parent.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this2.formataData(result);
        }
      });
    },

    formataData: function formataData(result) {
      var data = result.data.data,
          tableData = [],
          self = this,
          pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var aptidao = "",
            altura = "",
            espaco = "";

        if (data[i].aptidao == "1") aptidao = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO PARA A FUNÇÃO"/>';else if (data[i].aptidao == "2") aptidao = '<i class="fa fa-exclamation-triangle fa-2x" style="color:orange" title="APTO COM RESTRIÇÕES"/>';else if (data[i].aptidao == "5" || data[i].aptidao == "6") aptidao = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO PARA A FUNÇÃO"/>';

        if (data[i].te_alt == "1") altura = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';else if (data[i].te_alt == "2") altura = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';else if (data[i].te_alt == "3") altura = '<i title="N/A">-</i>';

        if (data[i].te_esp == "1") espaco = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';else if (data[i].te_esp == "2") espaco = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';else if (data[i].te_esp == "3") espaco = '<i title="N/A">-</i>';

        var item = {
          data: this.toDate(data[i].created, false),
          usuario: data[i].usuario ? data[i].usuario.usuario : null,
          status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
          aptidao: aptidao,
          tra_altura: altura,
          tra_ec: espaco,
          exames: data[i].exame_alt ? data[i].exame_alt.join(", ") : "",
          obs: data[i].obs,
          _data: data[i],
          options: {},
          buttons: []
        };

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.config.loading.table = false;
    },

    salvar: function salvar() {
      var _this3 = this;

      this.$confirm("Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this3.config.loading.save = true;
        _this3.response = {};

        _this3.post("empresa/consulta/liberacao/" + _this3.parent.consulta.id_con + "/cadastrar", _this3.formData).then(function (result) {
          result = result[0];
          _this3.response = result;

          _this3.config.loading.save = false;

          if (result.status == 200) {
            _this3.edMsg("Liberação cadastrado com sucesso!");

            _this3.novaLiberacao = true;
            _this3.tagConfig = "tab-historico";

            _this3.formataData(result);
            _this3.getConsulta();
            _this3.parent.getConsulta();
          }
        });
      });
    }
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_upload__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Upload: __WEBPACK_IMPORTED_MODULE_4_common_upload___default.a, UploadPagina: __WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_4_common_upload___default.a, __WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.showUploadASO': function parentShowUploadASO() {
			this.getConsultaUpload();
			this.tagConfig = 'tab-cadastro';

			this.formData = {
				tipo: 86,
				documento: 82,
				juntar: 1,
				id_emp: null,
				id_fun: null,
				id_con: null,
				arquivo: null
			};
		}
	},
	data: function data() {
		return {
			formData: {
				tipo: 86,
				documento: 82,
				juntar: 1,
				id_emp: null,
				id_fun: null,
				id_con: null,
				arquivo: null
			},
			pagination: {},
			error: {},
			upload_pagina: null,
			tableHead: [{
				key: 'data',
				sortable: true,
				width: '120px',
				label: 'Data'
			}, {
				key: 'usuario',
				sortable: true,
				label: 'Usuário'
			}, {
				key: 'lote',
				sortable: true,
				width: '55px',
				label: 'Lote'
			}, {
				key: 'arquivo',
				sortable: true,
				show_arquivo: true,
				label: 'Arquivo'
			}, {
				key: 'tipo',
				sortable: true,
				label: 'Tipo'
			}, {
				key: 'status',
				sortable: true,
				show_status: true,
				label: 'Status'
			}],
			tableData: [],
			lstTipoStatus: [],
			lstTipoDocumento: [],
			lstTipoUpload: [],
			lstEmpresa: [],
			lstFuncionario: [],
			lstConsulta: [],
			loadingFuncionario: false,
			loadingConsulta: false,
			loadingEmpresa: false,
			loadingEditAll: false,
			loadingTable: false,
			loadingSave: false,
			showUploadPagina: false,
			novaLiberacao: false,
			tagConfig: 'tab-cadastro',
			title: ''

		};
	},
	created: function created() {},


	mounted: function mounted() {
		var _this = this;

		this.getEmpresa();
		this.getTipo();
		this.getConsultaUpload();

		this.$events.on('onClienteEvent', function (eventData) {
			_this.getConsultaUpload();
		});
	},

	methods: {
		handleClick: function handleClick(tab, event) {
			this.novaLiberacao = false;
		},
		handleAptidao: function handleAptidao() {
			if (this.formData.aptidao == 2) {
				this.formData.id_tipo_status = 67;
			}

			if (this.formData.aptidao == 5) {
				this.formData.te_alt = 0;
				this.formData.te_esp = 0;
				this.formData.te_ele = 0;
				this.formData.id_tipo_status = 70;
			}
		},
		handleArquivo: function handleArquivo(e) {
			e.preventDefault();
			this.formData.arquivo = e.target.files[0];
		},


		onUploadPagina: function onUploadPagina(data) {
			this.upload_pagina = data;
			this.showUploadPagina = !this.showUploadPagina;
		},

		onUploadEditar: function onUploadEditar(data) {

			var self = this;

			this.$confirm('Tem certeza que deseja processar o lote ' + data.lote + ' novamente?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				self.get('/empresa/consulta/upload/editar/' + data.id).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getConsultaUpload();
						self.edMsg('Arquivo processado com sucesso. Verifique o status do processamento abaixo.');
					} else {
						self.edAlert(result.msg, 'error');
					}
				});
			});
		},

		onDelete: function onDelete(data) {
			var _this2 = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;
				self.loadingTable = true;

				_this2.post('/empresa/consulta/upload/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;
					self.loadingTable = false;

					if (result.status == 200) {

						_this2.formataData(result);

						_this2.$message({
							message: 'Registo excluido com sucesso',
							type: 'success'
						});
					} else {
						if (result.status == 403) {
							_this2.$alert('Você não possui permissão para deletar esse registro', 'Atenção', {
								confirmButtonText: 'OK'
							});
						} else {
							_this2.$message({
								message: result.msg,
								type: 'error'
							});
						}
					}
				});
			});
		},

		getTipo: function getTipo() {
			var _this3 = this;

			this.post('tipo/parent', { codigo: [81, 85], exclude: [84, 88] }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this3.lstTipoDocumento = result.data['81'];
					_this3.lstTipoUpload = result.data['85'];
				}
			});
		},

		getEmpresa: function getEmpresa(_search) {
			var _this4 = this;

			this.loadingEmpresa = true;

			this.get('/empresa', { search: _search }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this4.lstEmpresa = result.data.data;
				} else {
					_this4.lstEmpresa = [];
				}

				_this4.loadingEmpresa = false;
			});
		},

		getFuncionario: function getFuncionario(_search) {
			var _this5 = this;

			if (!this.formData.id_emp) return;

			this.loadingFuncionario = true;
			this.lstFuncionario = [];

			this.get('/empresa/funcionario/' + this.formData.id_emp, { search: _search }).then(function (result) {

				result = result[0];

				_this5.loadingFuncionario = false;

				if (result.status == 200) {
					_this5.lstFuncionario = result.data.data;
				}
			});
		},

		getConsulta: function getConsulta(_search) {
			var _this6 = this;

			if (!this.formData.id_fun || !this.formData.id_emp) return;

			this.loadingConsulta = true;
			this.lstConsulta = [];

			var hoje = this.toDate(null, true),
			    ontem = this.toDate(this.addDate(-365 * 2, null, 'D'), true),
			    amanha = this.toDate(this.addDate(1, null, 'D'), true);

			var filter = {
				id_funcionario: this.formData.id_fun,
				id_empresa: this.formData.id_emp,
				created_at: [ontem, amanha]
			};

			this.get('/empresa/consulta', { filter: filter }).then(function (result) {

				result = result[0];

				_this6.loadingConsulta = false;

				if (result.status == 200) {
					_this6.lstConsulta = result.data.data;
				}
			});
		},

		getConsultaUpload: function getConsultaUpload(_search, _page, _pagination) {
			var _this7 = this;

			this.loadingTable = true;

			this.get('empresa/consulta/upload', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this7.formataData(result);
				} else {
					_this7.$alert(result.msg, 'Atenção', {
						type: 'error',
						confirmButtonText: 'OK'
					});
				}
			});
		},

		formataData: function formataData(result) {

			var data = result.data.data,
			    tableData = [],
			    self = this,
			    pagination = result.data;

			for (var i = 0; i < data.length; i++) {

				var item = {
					'data': this.toDate(data[i].created_at, false),
					'usuario': data[i].usuario ? data[i].usuario.usuario : null,
					'tipo': data[i].tipo_upload ? data[i].tipo_upload.descricao.toUpperCase() : null,
					'lote': data[i].lote,
					'arquivo': data[i].arquivo,
					'status': data[i].obs,
					_data: data[i],
					options: {},
					buttons: []
				};

				item.buttons.push({
					icon: 'fa fa-files-o',
					color: 'success',
					title: 'Visualizar detalhes das páginas do arquivo',
					click: this.onUploadPagina
				});

				if (data[i].tipo_status && data[i].tipo_status.id == '80') {
					item.buttons.push({
						icon: 'fa fa-cloud-upload',
						color: 'warning',
						title: 'Processar Arquivo Novamente',
						click: this.onUploadEditar
					});
				}

				tableData.push(item);
			}

			this.pagination = pagination;
			this.tableData = tableData;
			this.loadingTable = false;
		},

		salvar: function salvar() {
			var _this8 = this;

			this.loadingSave = true;
			this.error = {};

			this.post('empresa/consulta/upload/cadastrar', this.toFormUpload(this.formData)).then(function (result) {

				result = result[0];

				_this8.loadingSave = false;

				if (result.status == 200) {

					_this8.edMsg('Documento cadastrado com sucesso!');

					_this8.error = {};
					_this8.novaLiberacao = true;
					_this8.tagConfig = 'tab-historico';

					_this8.formataData(result);
					_this8.parent.getConsulta();
				}
			});
		}

	}
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_upload_pagina_editar__ = __webpack_require__(818);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_7_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_5_common_button___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_6_common_alert___default.a, Download: __WEBPACK_IMPORTED_MODULE_2_common_download___default.a, DownloadAsoEmail: __WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showUploadPagina": function parentShowUploadPagina() {
      this.getConsultaUploadPagina();
    },
    "parent.upload_pagina.id": function parentUpload_paginaId() {
      this.getConsultaUploadPagina();
    },
    "formDataEdit.id_emp": function formDataEditId_emp() {
      this.getFuncionario();
      this.config.disabled.id_fun = this.formDataEdit.id_emp ? false : true;
    },
    "formDataEdit.id_fun": function formDataEditId_fun() {
      this.getConsulta();
      this.config.disabled.id_con = this.formDataEdit.id_fun ? false : true;
    }
  },
  data: function data() {
    return {
      pagination: {},
      response: {},
      formData: {},
      formDataEdit: {
        id: 0,
        id_emp: null,
        id_fun: null,
        id_con: null,
        usuario: null,
        updated_at: null
      },
      config: {
        click: {
          id_emp: _.debounce(this.getEmpresa, 1000),
          id_fun: _.debounce(this.getFuncionario, 1000),
          id_con: _.debounce(this.getConsulta, 1000)
        },
        loading: {
          id_emp: false,
          id_fun: false,
          id_con: false,
          save: false
        },
        list: {
          id_emp: [],
          id_fun: [],
          id_con: []
        },
        disabled: {
          id_fun: true,
          id_con: true,
          page: true
        }
      },
      consulta: null,
      tagConfig: "tab-detalhe",
      tableHead: [{
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_link_consulta: true,
        label: "Consulta"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_link_empresa: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcionario_link: true,
        show_funcao: true,
        label: "Funcionário"
      }, {
        key: "pagina",
        sortable: true,
        width: "90px",
        label: "Página"
      }, {
        key: "arquivo",
        sortable: true,
        show_arquivo: true,
        label: "Arquivo"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }],
      tableData: [],
      tableDataEmail: [],
      formItemsEdit: [],
      loadingTable: false,
      showEnviarEmail: false,
      showFormEdit: false,
      showDownloadASO: false,
      loadingEmailSave: false
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItemsEdit = __WEBPACK_IMPORTED_MODULE_9__form_upload_pagina_editar__["a" /* default */];
    this.getEmpresa();
  },

  methods: {
    onArquivoEmail: function onArquivoEmail(item) {
      var data = [],
          tableDataEmail = {},
          formData = {};

      if (item && item.id) {
        data.push(item);
      } else {
        data = item;

        try {
          data = data.sort(function (a, b) {
            return a.empresa.nome > b.empresa.nome ? 1 : b.empresa.nome > a.empresa.nome ? -1 : 0;
          });
        } catch (error) {
          data = item;
        }
      }

      this.showEnviarEmail = !this.showEnviarEmail;

      for (var i = 0; i < data.length; i++) {
        var element = data[i];

        if (!element.id_con) continue;

        if (!tableDataEmail[element.empresa.nome]) {
          tableDataEmail[element.empresa.nome] = [];
          formData[element.empresa.id] = {
            destinatario: element.empresa.email,
            consultas: [],
            obs: null,
            error: null
          };
        }

        if (element.tipo_documento && element.tipo_documento.id == "82") {
          formData[element.empresa.id].consultas.push(element.id_con);
        }

        tableDataEmail[element.empresa.nome].push(element);
      }

      this.tableDataEmail = tableDataEmail;
      this.formData = formData;
    },
    onEdit: function onEdit(data) {
      this.formDataEdit = {
        id: data.id,
        page: data.page,
        id_emp: data.empresa ? data.empresa.id : null,
        id_fun: data.funcionario ? data.funcionario.id : null,
        id_con: data.id_con,
        usuario: data.usuario,
        updated_at: this.toDate(data.updated_at)
      };

      if (data.empresa) {
        this.config.list.id_emp = [data.empresa];
      }

      if (data.funcionario) {
        this.getFuncionario(data.funcionario.nome);
      }

      if (data.id_con) {
        this.getConsulta();
      }

      this.showFormEdit = !this.showFormEdit;
    },
    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this.config.loading.id_emp = false;

        if (result.status == 200) {
          _this.config.list.id_emp = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      if (!this.formDataEdit.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formDataEdit.id_emp, { search: _search, pagination: 500 }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fun = false;

        if (result.status == 200) {
          _this2.config.list.id_fun = result.data.data;
        }
      });
    },
    getConsulta: function getConsulta(_search) {
      var _this3 = this;

      if (!this.formDataEdit.id_emp || !this.formDataEdit.id_fun) return;

      this.config.loading.id_con = true;
      this.config.list.id_con = [];

      var filter = {
        id_empresa: this.formDataEdit.id_emp,
        id_funcionario: this.formDataEdit.id_fun
      };

      this.get("empresa/consulta", { search: _search, filter: filter, pagination: 500 }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_con = false;

        if (result.status == 200) {
          _this3.config.list.id_con = result.data.data;
        }
      });
    },
    getConsultaUploadPagina: function getConsultaUploadPagina(_search, _page, _pagination) {
      var _this4 = this;

      if (!this.parent.upload_pagina) return;

      this.loadingTable = true;

      var filter = {
        id_tipo_email: [197],
        show_emp_email: 1
      };

      this.get("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id, { search: _search, page: _page, pagination: _pagination, filter: filter }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this4.formataData(result);
        } else {
          _this4.$alert(result.msg, "Atenção", {
            type: "error",
            confirmButtonText: "OK"
          });
        }
      });
    },


    formataData: function formataData(result) {
      var data = result.data.data,
          tableData = [],
          self = this,
          pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var send_email = "";

        if (data[i].send_email_at) {
          send_email = ' <i class="fa fa-envelope" title="Último envio de email desse ASO foi em: ' + this.toDate(data[i].send_email_at) + '"/>';
        }

        var item = {
          consulta: (data[i].id_con ? data[i].id_con : "---") + (send_email ? send_email : ""),
          empresa: data[i].empresa ? data[i].empresa.nome : "---",
          funcionario: data[i].funcionario ? data[i].funcionario.nome : "---",
          arquivo: data[i].arquivo ? data[i].arquivo : "---",
          pagina: data[i].page + " de " + data[i].pages,
          status: data[i].obs ? data[i].obs : "",
          _data: data[i],
          options: {},
          buttons: []
        };

        if (data[i].arquivo && data[i].tipo_status && (data[i].tipo_status.id == "79" || data[i].tipo_status.id == "193") && data[i].tipo_documento && data[i].tipo_documento.id == "82") {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Enviar Arquivo por email",
            click: this.onArquivoEmail
          });
        }

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.loadingTable = false;
    },

    salvar: function salvar() {
      var _this5 = this;

      this.config.loading.save = true;

      this.post("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id + "/editar", this.formDataEdit).then(function (result) {
        result = result[0];

        _this5.config.loading.save = false;

        if (result.status == 200) {
          _this5.getConsultaUploadPagina();
          _this5.parent.getConsultaUpload();
          _this5.showFormEdit = !_this5.showFormEdit;
          _this5.edMsg("Dados atualizados com sucesso");
        }
      });
    },
    enviar: function enviar() {
      var _this6 = this;

      var error = false;

      for (var item in this.formData) {
        var element = this.formData[item];

        if (!element.destinatario && element.consultas.length > 0) {
          element.error = "Campo Destinatário é Obrigatório";
          error = true;
        } else if (element.consultas.length > 0) {
          var emails = element.destinatario.split(";");

          for (var j = 0; j < emails.length; j++) {
            if (!this.validateEmail(emails[j])) {
              element.error = "Email `" + emails[j] + "` não é válido";
              error = true;
            }
          }
        }
      }

      if (error) {
        this.edAlert("Não foi possível completar o envio. Você deve corrigir os erros apontados acima.", "error");
      } else {
        this.loadingEmailSave = true;

        this.post("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id + "/enviar", { empresa: this.formData }).then(function (result) {
          result = result[0];

          _this6.loadingEmailSave = false;

          if (result.status == 200) {
            _this6.edMsg("Emails enviado com sucesso. Você pode acompanhar o status do email atravês do `Histórico de Emails` na página anterior.");
            _this6.formataData(result);

            _this6.showEnviarEmail = !_this6.showEnviarEmail;
            _this6.formData = {};
            _this6.tableDataEmail = [];
          }
        });
      }
    }
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_liberar_aso__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_liberar_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_liberar_aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_upload_aso__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_upload_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__includes_upload_aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_download_aso__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_download_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__includes_download_aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_liberacao_filtro__ = __webpack_require__(817);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, LiberarASO: __WEBPACK_IMPORTED_MODULE_4__includes_liberar_aso___default.a, UploadASO: __WEBPACK_IMPORTED_MODULE_5__includes_upload_aso___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a, DownloadASO: __WEBPACK_IMPORTED_MODULE_6__includes_download_aso___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  watch: {
    "formFilter.id_empresa": function formFilterId_empresa() {
      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.getFuncionario();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        click: {
          id_empresa: _.debounce(this.getEmpresa, 1000),
          id_fdt: _.debounce(this.getFDT, 1000),
          id_funcionario: _.debounce(this.getFuncionario, 1000)
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: true
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: []
        }
      },
      formData: {
        id: 0,
        nome: null,
        cbo: null,
        descricao: null
      },
      formFilter: {
        id_funcao: null,
        id_empresa: null,
        id_arquivo_aso: 0,
        inativo: 0,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_aso: [],
        id_tipo_status: [68, 69],
        created_at: []
      },
      pagination: {},
      response: {},
      consulta: null,
      tableHead: [{
        key: "data",
        sortable: true,
        label: "Data Consulta"
      }, {
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "credenciada",
        sortable: true,
        label: "Credenciada"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "status",
        sortable: true,
        label: "Status"
      }],
      tableData: [],
      formItems: [],
      showFormFilter: false,
      showLiberacao: false,
      showUploadASO: false,
      showDownloadASO: false,
      loadingDownloadASO: false,
      filterBadge: "0"
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_7__form_liberacao_filtro__["a" /* default */];

    this.getConsulta();
    this.getEmpresa();
  },

  methods: {
    onLiberarASO: function onLiberarASO(data) {
      this.consulta = data;
      this.showLiberacao = !this.showLiberacao;
    },

    onDownloadASO: function onDownloadASO(data) {
      var _this = this;

      this.showDownloadASO = !this.showDownloadASO;
      this.loadingDownloadASO = true;

      if (!data) {
        this.loadingDownloadASO = false;
        this.consulta = data;
        return;
      }

      var filter = {
        id_tipo_email: [197]
      };

      this.get("/empresa/email/" + data.empresa.id, { filter: filter }).then(function (result) {
        result = result[0];

        _this.loadingDownloadASO = false;

        if (result.status == 200) {
          var emails = [];

          for (var i = 0; i < result.data.data.length; i++) {
            emails.push(result.data.data[i].email);
          }
          data.empresa.email = emails.join(";");
        }

        _this.consulta = data;
      });
    },

    onRegister: function onRegister() {
      this.showUploadASO = !this.showUploadASO;
    },

    getEmpresa: function getEmpresa(_search) {
      var _this2 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this2.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, { search: _search }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getFDT: function getFDT() {
      var _this4 = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formFilter.id_empresa, { pagination: 100 }).then(function (result) {
        result = result[0];

        _this4.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this4.config.loading.id_fdt = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(_search, _page, _pagination, _loading) {
      var _this5 = this;

      this.config.loading.table = true;
      this.response = {};

      if (this.formFilter.created_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-60, null, "D"), true),
            amanha = this.toDate(this.addDate(1, null, "D"), true);

        this.formFilter.created_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcao ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("empresa/consulta", { search: _search, page: _page, pagination: _pagination, filter: this.formFilter }).then(function (result) {
        result = result[0];
        _this5.response = result;
        _this5.config.loading.table = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this5,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var send_email = "";

            if (data[i].send_email_at) {
              send_email = ' <i class="fa fa-envelope" title="Último envio de email desse ASO foi em: ' + _this5.toDate(data[i].send_email_at) + '"/>';
            }
            var item = {
              data: _this5.toDate(data[i].dt_cad, true),
              consulta: data[i].id_con + (data[i].rapido == "1" ? ' <img src="' + _this5.env.url_cs + "app/1.img/img_sof/ar.png" + '" title="Consulta gerada pelo ASO Rápido"/>' : "") + send_email,
              credenciada: data[i].credenciada ? data[i].credenciada.nome : "---",
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              TIPO: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              _data: data[i],
              options: {
                disable_edit: !_this5.validarPermissao(553),
                style: 'color:' + (data[i].status == 0 ? 'red !important' : '')
              },
              buttons: []
            };

            if (!data[i].id_cre && data[i].tipo_status && data[i].tipo_status.id == 66) {
              item.buttons.push({
                icon: "fa fa-unlock",
                color: "warning",
                title: "ASO Liberado. Clique para ver mais detalhes",
                click: _this5.onLiberarASO
              });
            } else {
              if (!data[i].id_cre) {
                item.buttons.push({
                  icon: "fa fa-lock",
                  color: "warning",
                  title: "Liberar esse ASO",
                  click: _this5.onLiberarASO
                });
              }
            }

            if (_this5.validarPermissao(561)) {
              item.buttons.push({
                icon: "fa fa-paper-plane",
                color: "success",
                title: "Enviar ASO por email",
                click: _this5.onDownloadASO
              });
            }

            tableData.push(item);
          }

          _this5.pagination = pagination;
          _this5.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_email_cadastrar__ = __webpack_require__(819);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'parent.formData.id': function parentFormDataId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [240, 32],
				tipo_exclude: [33, 34, 35, 36, 37, 196],
				hidden: {
					padrao: true
				},
				click: {},
				loading: {
					save: false,
					content: false
				},
				list: {}
			},
			formData: {
				id: 0,
				nome: null,
				usuario: null,
				email: null,
				servidor_smtp: null,
				autenticacao: 1,
				conexao_seg: 'tls',
				senha: null,
				porta: 0,
				tempo_espera: 0,
				n_msg_pct: 50,
				t_esp_pct: 600,
				updated_at: null,
				tipo: []
			},
			response: {},
			exameItems: [],
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_email_cadastrar__["a" /* default */];
	},


	methods: {
		init: function init() {

			this.response = {};

			var tipo = [];

			for (var i = 0; i < this.parent.formData.tipo.length; i++) {
				var element = this.parent.formData.tipo[i];
				tipo.push(element.id);
			}
			this.formData = {
				id: this.parent.formData.id,
				nome: this.parent.formData.nome,
				usuario: this.parent.formData.usuario,
				email: this.parent.formData.email,
				servidor_smtp: this.parent.formData.servidor_smtp,
				autenticacao: this.parent.formData.autenticacao,
				conexao_seg: this.parent.formData.conexao_seg,
				porta: this.parent.formData.porta,
				senha: null,
				tempo_espera: this.parent.formData.tempo_espera,
				n_msg_pct: this.parent.formData.n_msg_pct,
				t_esp_pct: this.parent.formData.t_esp_pct,
				updated_at: this.parent.formData.updated_at,
				tipo: tipo
			};
		},
		salvar: function salvar() {
			var _this = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('conta-email/editar', this.formData).then(function (result) {

				result = result[0];

				_this.config.loading.save = false;
				_this.response = result;

				if (result.status == 200) {
					_this.edMsg('Registro salvo com sucesso!');
					_this.showFormEdit = !_this.showFormEdit;

					if (_this.parent && _this.parent.getContaEmail) _this.parent.getContaEmail();
				}
			});
		}
	}
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teste__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__teste__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EmailEditar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a, EmailTeste: __WEBPACK_IMPORTED_MODULE_3__teste___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: "tls",
        senha: null,
        tempo_espera: 0,
        porta: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "nome",
        sortable: true,
        label: "Nome"
      }, {
        key: "email",
        sortable: true,
        label: "Email"
      }, {
        key: "usuario",
        sortable: true,
        label: "Usuário"
      }, {
        key: "tipo",
        sortable: true,
        label: "Serviços Vinculados"
      }],
      tableData: [],
      loadingTable: false,
      loadingTest: false,
      showFormEdit: false,
      showFormTeste: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.getContaEmail();
  },

  methods: {
    onRegister: function onRegister() {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: "tls",
        senha: null,
        porta: 0,
        tempo_espera: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null,
        tipo: []
      };
    },

    onEdit: function onEdit(data) {
      this.showFormEdit = !this.showFormEdit;

      this.formData = {
        id: data.id,
        nome: data.nome,
        usuario: data.usuario,
        email: data.email,
        servidor_smtp: data.servidor_smtp,
        autenticacao: data.autenticacao,
        conexao_seg: data.conexao_seg,
        porta: data.porta,
        senha: null,
        tempo_espera: data.tempo_espera,
        n_msg_pct: data.n_msg_pct,
        t_esp_pct: data.t_esp_pct,
        updated_at: data.updated_at,
        tipo: data.tipo
      };
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingTable = true;

        _this.post("/conta-email/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getContaEmail();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    onTest: function onTest(data) {
      this.showFormTeste = !this.showFormTeste;
      this.formData = {
        id: data.id,
        email: data.email
      };
    },


    getContaEmail: function getContaEmail(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("conta-email", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this2.response = result;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var tipo = [];

            for (var j = 0; j < data[i].tipo.length; j++) {
              var element = data[i].tipo[j];
              tipo.push(element.descricao);
            }

            var item = {
              id: data[i].id,
              nome: data[i].nome,
              email: data[i].email,
              usuario: data[i].usuario,
              servidor_smtp: data[i].servidor_smtp,
              tipo: tipo.length > 0 ? tipo.join("<br>") : "---",
              _data: data[i],
              options: {
                disable_delete: !_this2.validarPermissao(3),
                disable_edit: !_this2.validarPermissao(3)
              },
              buttons: [{
                icon: "fa fa-check",
                color: "success",
                title: "Enviar Email Teste",
                click: _this2.onTest
              }]
            };

            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    }
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_email_teste__ = __webpack_require__(820);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'parent.formData.id': function parentFormDataId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
		}
	},
	data: function data() {
		return {
			config: {
				hidden: {},
				click: {},
				loading: {
					save: false,
					content: false
				},
				list: {}
			},
			formData: {
				id: 0,
				email: null
			},
			response: {},
			exameItems: [],
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_email_teste__["a" /* default */];
	},


	methods: {
		init: function init() {},
		salvar: function salvar() {
			var _this = this;

			this.response = {};
			this.config.loading.save = true;

			this.formData.id = this.parent.formData.id;

			this.post('/conta-email/testar', this.formData).then(function (result) {
				result = result[0];

				_this.config.loading.save = false;

				if (result.status == 200) {
					_this.showFormEdit = !_this.showFormEdit;
					_this.edAlert('Email enviado com sucesso');
				}
			});
		}
	}
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vincular__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vincular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vincular__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-certificado",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, Upload: __WEBPACK_IMPORTED_MODULE_2_common_upload___default.a, Vincular: __WEBPACK_IMPORTED_MODULE_4__vincular___default.a },
  data: function data() {
    return {
      formData: {
        id: 0,
        tipo_certificado_id: null,
        empresa: null,
        arquivo: null,
        representante: null,
        senha: null,
        confirmar_senha: null,
        validade: null,
        vincular: 0,
        inserir_vinculo: 1
      },
      loadingTable: false,
      loadingSave: false,
      showFormEdit: false,
      showFormVincular: false,
      loadingEmpresa: false,
      pagination: {},
      error: {},
      response: {},
      arquivo: null,
      tableHead: [{
        key: 'tipo',
        sortable: true,
        label: 'Tipo'
      }, {
        key: 'nome',
        sortable: true,
        label: 'Nome'
      }, {
        key: 'validade',
        sortable: true,
        label: 'Validade'
      }, {
        key: 'vincular',
        sortable: true,
        label: 'Vincular Automaticamente'
      }, {
        key: 'data_cadastro',
        sortable: true,
        label: 'Data Cadastro'
      }],
      tableData: [],
      lstTipoCertificado: [],
      lstEmpresa: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getParametros();
    this.getEsocialCertificado();
  },


  methods: {

    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        tipo_certificado_id: null,
        arquivo: null,
        representante: null,
        senha: null,
        confirmar_senha: null,
        validade: null,
        vincular: 0,
        deletar_vinculo: 0,
        inserir_vinculo: 0
      };
      this.arquivo = null;
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function onEdit(data) {

      this.formData = {
        id: data.id,
        tipo_certificado_id: data.tipo_certificado_id,
        empresa: data.empresa_id,
        arquivo_name: data.arquivo_name,
        arquivo_size: data.arquivo_size,
        arquivo: null,
        representante: data.representante,
        senha: null,
        confirmar_senha: null,
        validade: null,
        vincular: parseInt(data.vincular),
        deletar_vinculo: 0,
        inserir_vinculo: 0
      };

      this.arquivo = null;

      if (this.formData.arquivo_id) {
        this.arquivo = { name: this.formData.arquivo_name, size: this.formData.arquivo_size };
      }

      this.lstEmpresa = [{
        id: data.empresa_id,
        cnpj: data.empresa_cnpj,
        nome: data.empresa_nome_fantasia
      }];

      this.showFormEdit = !this.showFormEdit;
    },
    onVincularCertificado: function onVincularCertificado(data) {

      this.formData = data;
      this.showFormVincular = !this.showFormVincular;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning'

      }).then(function () {

        self.loadingTable = true;

        _this.post('esocial/certificados/deletar', { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {

            _this.$message({
              message: 'Registo excluido com sucesso',
              type: 'success'
            });

            _this.formataLista(result);
          }
        });
      });
    },
    onChangeArquivo: function onChangeArquivo(e) {
      e.preventDefault();
      this.formData.arquivo = e.target.files[0];
      this.arquivo = { name: this.formData.arquivo.name, size: this.formData.arquivo.size };
    },
    getEmpresa: function getEmpresa(_search) {
      var _this2 = this;

      this.loadingEmpresa = true;
      this.lstEmpresa = [];

      this.get('/empresa', { search: _search }).then(function (result) {

        result = result[0];

        _this2.loadingEmpresa = false;

        if (result.status == 200) {
          _this2.lstEmpresa = result.data.data;
        }
      });
    },
    getParametros: function getParametros() {
      var _this3 = this;

      this.post('/tipo/parent', { codigo: [200] }).then(function (result) {

        result = result[0];
        var data = result.data;

        if (result.status == 200) {
          _this3.lstTipoCertificado = data[200];
        }
      });
    },
    getEsocialCertificado: function getEsocialCertificado(_search, _page) {
      var _this4 = this;

      this.loadingTable = true;
      this.lstTabelaConteudo = [];
      this.hideAdvancedFilter = !this.hideAdvancedFilter;
      this.response = {};

      this.get('esocial/certificados', { page: _page, search: _search }).then(function (result) {

        result = result[0];

        _this4.loadingTable = false;
        _this4.response = result;

        if (result.status == 200) {
          _this4.formataLista(result);
        }
      });
    },
    formataLista: function formataLista(result) {

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {

        var styleDefault = '',
            styleCertificado = ' Vence em ' + arrData[i].validade_diff + ' dia(s)',
            titleRiscoDinamico = '',
            tipo_certificado = arrData[i].tipo_certificado_nome,
            representante = arrData[i].empresa_nome_fantasia,
            validade = arrData[i].validade,
            vincular = arrData[i].vincular,
            created_at = arrData[i].created_at;

        if (arrData[i].parent_id) {
          tipo_certificado = arrData[i].parent_tipo_certificado_nome;
          representante = arrData[i].empresa_nome_fantasia + '<br><b style="font-size:9pt">Usando certificado de ' + arrData[i].parent_empresa_nome_fantasia + '</b>';
          validade = arrData[i].parent_validade;
          vincular = arrData[i].parent_vincular;
          created_at = arrData[i].parent_created_at;
        }

        if (arrData[i].validade_diff && arrData[i].validade_diff > 0 && arrData[i].validade_diff < 10) {
          styleDefault = 'color:#dbb734';
          titleRiscoDinamico = 'O certificado vence em  ' + arrData[i].validade_diff + ' dia(s)';
        } else if (arrData[i].validade_diff && arrData[i].validade_diff == 0) {
          styleDefault = 'color:#dbb734';
          titleRiscoDinamico = 'O certificado vence hoje';
          styleCertificado = ' Vence em hoje';
        } else if (arrData[i].validade_diff && arrData[i].validade_diff < 0) {
          styleDefault = 'color:red';
          titleRiscoDinamico = 'O certificado venceu a ' + arrData[i].validade_diff + ' dia(s)';
          styleCertificado = ' Venceu a ' + arrData[i].validade_diff + ' dia(s)';
        } else if (arrData[i].parent_id) {
          styleDefault = 'color:#3287bc';
          titleRiscoDinamico = 'Esse certificado foi compartilhado por ' + representante;
        } else {}

        var item = {
          'tipo': tipo_certificado,
          'nome': arrData[i].id + ' - ' + representante,
          'validade': this.toDate(validade, true),
          'vincular': vincular == '1' ? 'Sim' : 'Não',
          'data_cadastro': this.toDate(created_at, false),
          _data: arrData[i],
          buttons: [],
          options: {}
        };

        if (this.cliente.logged.cnpj == arrData[i].empresa_cnpj) {
          item.buttons.push({
            icon: 'fa fa-users',
            color: 'success',
            title: 'Vincular clientes',
            click: this.onVincularCertificado
          });
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },


    salvar: function salvar(formName) {
      var _this5 = this;

      this.loadingSave = true;
      this.error = {};
      this.response = {};

      var data = new FormData();

      data.append('id', this.formData.id);
      data.append('tipo_certificado_id', this.formData.tipo_certificado_id);
      data.append('empresa', this.formData.empresa);
      data.append('representante', this.formData.representante);
      data.append('senha', this.formData.senha);
      data.append('confirmar_senha', this.formData.confirmar_senha);
      data.append('vincular', this.formData.vincular);
      data.append('deletar_vinculo', this.formData.deletar_vinculo);
      data.append('inserir_vinculo', this.formData.inserir_vinculo);

      if (this.formData.arquivo) {
        data.append('arquivo', this.formData.arquivo);
      }

      this.post('esocial/certificados/salvar', data, false).then(function (result) {

        result = result[0];

        _this5.loadingSave = false;

        if (result.status == 200) {

          _this5.edMsg('Dados atualizados com sucesso');

          _this5.showFormEdit = !_this5.showFormEdit;
          _this5.formataLista(result);
        }
      });
    }

  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-certificado",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a },

  props: {

    certificado: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }

  },

  watch: {
    certificado: function certificado() {},
    showForm: function showForm() {
      this.showFormEdit = !this.showFormEdit;
      this.getEsocialCertificado();
    }
  },

  data: function data() {
    return {
      formData: {
        id_esocial_certificado: null,
        empresa: null
      },
      loadingTable: false,
      loadingSave: false,
      loadingEmpresa: false,
      showFormEdit: false,
      pagination: {},
      error: {},
      response: {},
      arquivo: null,
      tableHead: [{
        key: 'empresa',
        sortable: true,
        label: 'Empresa'
      }],
      tableData: [],
      lstEmpresa: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEsocialCertificado();
  },


  methods: {

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning'

      }).then(function () {

        self.loadingTable = true;

        _this.post('/esocial/certificados/' + _this.certificado.id + '/deletar/vinculo', { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {

            _this.$message({
              message: 'Registo excluido com sucesso',
              type: 'success'
            });

            _this.formataLista(result);
          } else {
            if (result.status == 403) {
              _this.$alert('Você não possui permissão para deletar esse registro', 'Atenção', {
                confirmButtonText: 'OK'
              });
            } else {
              _this.$message({
                message: result.msg,
                type: 'error'
              });
            }
          }
        });
      });
    },

    getEmpresa: function getEmpresa(_search, _id) {
      var _this2 = this;

      this.loadingEmpresa = true;

      var url = '';

      this.get('/empresa', { search: _search }).then(function (result) {

        result = result[0];

        if (result.status == 200) {
          _this2.lstEmpresa = result.data.data;
        }

        _this2.loadingEmpresa = false;
      });
    },

    getEsocialCertificado: function getEsocialCertificado(_search, _page) {
      var _this3 = this;

      this.loadingTable = true;
      this.lstTabelaConteudo = [];
      this.hideAdvancedFilter = !this.hideAdvancedFilter;
      this.formData.certificado = this.certificado;
      this.response = {};
      this.pagination = {};

      this.get('/esocial/certificados/' + this.certificado.id, { page: _page, search: _search, pagination: 20 }).then(function (result) {

        result = result[0];

        _this3.loadingTable = false;
        _this3.response = result;
        _this3.pagination = result;

        if (result.status == 200) {
          _this3.formataLista(result);
        }
      });
    },


    formataLista: function formataLista(result) {

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {

        var item = {
          'empresa': arrData[i].empresa_cnpj + ' - ' + arrData[i].empresa_nome_fantasia,
          _data: arrData[i],
          buttons: [],
          options: {}
        };

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },

    salvar: function salvar(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {

        if (valid) {

          _this4.loadingTable = true;
          _this4.error = {};

          _this4.post('/esocial/certificados/' + _this4.certificado.id + '/vincular', _this4.formData).then(function (result) {

            _this4.loadingTable = false;

            result = result[0];

            if (result.status == 200) {

              _this4.$message({
                message: 'Dados atualizados com sucesso',
                type: 'success'
              });

              _this4.lstEmpresa = [];
              _this4.formData.empresa = null;

              _this4.formataLista(result);
            }
          });
        } else {
          _this4.$alert('Antes de processeguir, por favor preencher todos os campos obrigatórios', 'Atenção', {
            confirmButtonText: 'OK'
          });
        }
      });
    }

  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_configuracao__ = __webpack_require__(823);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-configuracao",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
  watch: {
    'formData.ativo': function formDataAtivo() {
      this.config.disabled.empresas = this.formData.ativo == 0;
      this.config.disabled.data_inicio = this.formData.ativo == 0;
      this.config.disabled.empresas_processar = this.formData.ativo == 0;
    }
  },
  data: function data() {
    return {
      response: {},
      config: {
        click: {
          empresas: this.getEmpresa,
          empresas_processar: this.getEmpresa,
          save: this.salvar
        },
        list: {
          empresas: [],
          empresas_processar: []
        },
        loading: {
          empresas: false,
          empresas_processar: false,
          save: false
        },
        disabled: {
          empresas: true,
          empresas_processar: true,
          data_inicio: true
        }
      },
      formData: {
        id: 0,
        ativo: 0,
        empresas: [],
        data_inicio: this.toDate(),
        usuario: null,
        updated_at: null
      },
      formItems: [],
      loadingContent: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEsocialConfiguracao();


    this.formItems = __WEBPACK_IMPORTED_MODULE_2__form_configuracao__["a" /* default */];
  },


  methods: {

    getEmpresa: function getEmpresa(_search, _empresas) {
      var _this = this;

      this.config.loading.empresas = true;
      this.config.loading.empresas_processar = true;
      this.config.list.empresas = [];
      this.config.list.empresas_processar = [];

      this.get('/empresa', { search: _search, pagination: 10, filter: { empresas: _empresas } }).then(function (result) {

        result = result[0];
        _this.config.loading.empresas = false;
        _this.config.loading.empresas_processar = false;

        if (result.status == 200) {
          _this.config.list.empresas = result.data.data;
          _this.config.list.empresas_processar = result.data.data;
        }
      });
    },

    getEsocialConfiguracao: function getEsocialConfiguracao() {
      var _this2 = this;

      this.get('/esocial/configuracao').then(function (result) {

        result = result[0];

        _this2.loadingContent = false;
        _this2.config.list.empresas = [];
        _this2.config.list.empresas_processar = [];

        if (result.status == 200 && result.data) {
          _this2.formData = {
            id: result.data.id,
            ativo: result.data.ativo,
            empresas: [],
            empresas_processar: [],
            data_inicio: result.data.data_inicio ? _this2.toDate(result.data.data_inicio, true) : null,
            usuario: result.data.usuario,
            updated_at: _this2.toDate(result.updated_at)
          };

          for (var i = 0; i < result.data.empresas.length; i++) {
            var element = result.data.empresas[i];

            _this2.formData.empresas.push(element.id);
            _this2.config.list.empresas.push(element);
          }

          for (var _i = 0; _i < result.data.empresas_processar.length; _i++) {
            var _element = result.data.empresas_processar[_i];

            _this2.formData.empresas_processar.push(_element.id);
            _this2.config.list.empresas_processar.push(_element);
          }
        }
      });
    },
    salvar: function salvar(formName) {
      var _this3 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post('esocial/configuracao/editar', this.formData, false).then(function (result) {

        _this3.config.loading.save = false;

        result = result[0];

        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg('Dados atualizados com sucesso');
          _this3.getEsocialConfiguracao();
        }
      });
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_filtrar__ = __webpack_require__(821);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-gerar-lote",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.formFilter.id_empresa": function parentFormFilterId_empresa() {
      this.config.disabled.id_fdt = this.parent.formFilter.id_empresa ? false : true;
      this.config.disabled.id_funcionario = this.parent.formFilter.id_empresa ? false : true;

      this.parent.formFilter.id_fdt = null;
      this.parent.formFilter.id_funcionario = null;

      this.getFdt();
      this.getFuncionario();
    },
    "parent.formData.layout": function parentFormDataLayout() {},
    "parent.formFilter.empresa_envio_automatico": function parentFormFilterEmpresa_envio_automatico() {
      this.config.disabled.id_empresa = this.parent.formFilter.empresa_envio_automatico;
      this.parent.formFilter.id_tipo_status = [];

      if (this.parent.formFilter.empresa_envio_automatico) {
        this.parent.formFilter.id_empresa = null;
        this.parent.formFilter.id_fdt = null;
        this.parent.formFilter.id_funcionario = null;
        this.parent.formFilter.id_tipo_status = [328, 331, 336, 335, 330];
      }
    }
  },

  data: function data() {
    return {
      config: {
        tipo: [327],
        click: {
          id_empresa: this.getEmpresa,
          id_fdt: this.getFdt,
          id_funcionario: this.getFuncionario,
          mostrar: this.getMostrar,
          empresa_envio_automatico: null
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          mostrar: false,
          empresa_envio_automatico: false
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: [],
          mostrar: [],
          empresa_envio_automatico: []
        },
        disabled: {
          id_fdt: true,
          id_funcionario: true,
          empresa_envio_automatico: false
        },
        title: {
          model: 'empresa_envio_automatico',
          empresa_envio_automatico: 'Selecionar empresas com processamento automático dos lotes'
        },
        description: {
          empresa_envio_automatico: 'Essa campo permite selecionar automaticamente as empresas que estão definidas para processamento automático dos lotes em Esocial > Configurações >  Processar Lote'
        }
      },
      response: {},
      filterItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.filterItems = __WEBPACK_IMPORTED_MODULE_3__form_filtrar__["a" /* default */];

    this.getEmpresa();
    this.getMostrar();
  },


  methods: {
    getMostrar: function getMostrar() {
      this.config.list.mostrar = [{ id: 1, nome: "Apenas arquivos SEM XML gerado" }, { id: 2, nome: "Apenas arquivos COM XML gerado" }, { id: 3, nome: "Apenas arquivos SEM conflitos" }, { id: 4, nome: "Apenas arquivos COM conflitos" }];
    },
    getEmpresa: function getEmpresa(search) {
      var _this = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then(function (result) {
        result = result[0];

        _this.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this.config.list.id_empresa = result.data.data;
        }
      });
    },
    getFdt: function getFdt(search) {
      var _this2 = this;

      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.parent.formFilter.id_empresa, {
        search: search
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },


    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.parent.formFilter.id_empresa, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-logs",
  mixins: [],
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a },

  props: {

    showForm: {
      type: Boolean,
      default: false
    },

    formData: {
      type: Object,
      default: {}
    }

  },

  watch: {
    showForm: function showForm() {
      this.showLogs = !this.showLogs;
      this.initialize();
    },
    formData: function formData() {}
  },

  data: function data() {
    return {
      showLogs: false,
      tabSelected: 'error'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.initialize();
  },


  methods: {
    initialize: function initialize() {
      if (this.formData.item && this.formData.item && this.formData.item.log_erro.length) {
        this.tabSelected = 'error';
      } else if (this.formData.item && this.formData.item && this.formData.item.log_warning.length) {
        this.tabSelected = 'warning';
      } else {
        this.tabSelected = 'file';
      }
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_template__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_layout__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_logs__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__includes_logs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_filter__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__s0000__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__s0000___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__s0000__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__s2210__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__s2210___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__s2210__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__s2220__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__s2220___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__s2220__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__s2240__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__s2240___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__s2240__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__s3000__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__s3000___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__s3000__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial",
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    Filters: __WEBPACK_IMPORTED_MODULE_7__includes_filter___default.a,
    Logs: __WEBPACK_IMPORTED_MODULE_6__includes_logs___default.a,
    s0000: __WEBPACK_IMPORTED_MODULE_8__s0000___default.a,
    s2220: __WEBPACK_IMPORTED_MODULE_10__s2220___default.a,
    s2210: __WEBPACK_IMPORTED_MODULE_9__s2210___default.a,
    s2240: __WEBPACK_IMPORTED_MODULE_11__s2240___default.a,
    s3000: __WEBPACK_IMPORTED_MODULE_12__s3000___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_4_template__["e" /* EdAlert */]
  },
  watch: {
    "formData.esocial_tabela": function formDataEsocial_tabela() {
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico: 0,
        avulso: this.avulso,
        data_cadastro: [],
        mostrar: []
      };
      this.formData.layout = this.formData.esocial_tabela.codigo;
      this.getEsocial();
    },
    "layout": function layout() {
      this.formData.layout = this.layout;
    },
    "lote": function lote() {
      this.getEsocial();
    }
  },
  props: {
    layout: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    lote: {
      type: [String, Number],
      default: function _default() {
        return null;
      }
    },
    avulso: {
      type: [Number],
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      tabConfig: 'tab-geral',
      config: {
        click: {
          esocial_tabela: this.getEsocialTabela
        },
        loading: {
          esocial_tabela: false,
          content: false,
          table: false,
          tableAntigo: false
        },
        list: {
          esocial_tabela: []
        },
        hidden: {
          esocial_tabela: this.layout ? true : false
        }
      },
      formData: {
        layout: null,
        esocial_tabela: null,
        item: null,
        search: null,
        page: null,
        pagination: null,
        filter: null,
        empresa: null,
        arquivoConfig: {},
        result: {}
      },
      formDataXml: {},
      layoutItems: [],
      formFilter: {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico: 0,
        avulso: 1,
        data_cadastro: [],
        mostrar: []
      },
      pagination: {},
      response: {},
      filterBadge: 0,
      showLogAntigo: false,
      showNovoXml: false,
      paginationAntigo: {},
      responseAntigo: {},
      filterBadgeAntigo: 0,
      tableHead: [],
      tableData: [],
      tableHeadAntigo: [],
      tableDataAntigo: [],
      showLogs: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.layoutItems = __WEBPACK_IMPORTED_MODULE_5__form_layout__["a" /* default */];
    this.getEsocialTabela();

    this.getEsocial();
  },


  methods: {
    onClear: function onClear() {
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico: 0,
        avulso: this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: []
      }, this.getEsocial();
    },
    onRegister: function onRegister() {
      this.formDataXml = {};
      this.showNovoXml = !this.showNovoXml;
    },
    onEditXml: function onEditXml(data) {
      this.showNovoXml = !this.showNovoXml;
      this.formDataXml = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {});
    },
    onEdit: function onEdit(data) {
      this.onGerarArquivoXML([data.id], data.layout);
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var arrayExcluir = [];
      var avulso = false;

      if (data && data.id) {
        arrayExcluir.push(data.id);

        if (data.avulso == '1' && [328].indexOf(data.tipo_status.id) != -1) {
          avulso = true;
        }
      }

      if (!arrayExcluir.length) {
        this.edAlert("Arquivo indispoível para exclusão.", "error");
        return;
      }

      var msg = "O sistema vai excluir " + arrayExcluir.length + " arquivo(s) diretamente no eSocial e o processo não poderá ser desfeito. Deseja prosseguir?";

      if (!data.recibo) {
        msg = "O sistema vai excluir " + arrayExcluir.length + " arquivo(s) e o processo não poderá ser desfeito. Deseja prosseguir?";
      }

      this.$confirm(msg, "Atenção", {
        type: "warning"
      }).then(function () {
        _this.$root.$loading.set(true);
        _this.config.loading.content = true;

        var filter = {
          ids: [data.id]
        };

        var empresa_id = null;

        _this.post("esocial/" + _this.formData.layout + "/deletar", { ids: arrayExcluir }).then(function (result) {
          result = result[0];
          _this.config.loading.content = false;
          _this.$root.$loading.set(false);

          _this.getEsocial();

          if (result.status == 200) {

            if (avulso) {
              _this.edAlert("Evento excluído com sucesso.");
            } else {
              _this.edAlert("Evento de exclusão enviado para o eSocial.");
            }
          }
        });
      });
    },
    onGerarLote: function onGerarLote(data) {
      var _this2 = this;

      this.$confirm("O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this2.config.loading.content = true;
        _this2.$root.$loading.set(true);

        var filter = {
          ids: [data.id],
          avulso: _this2.avulso
        };

        var empresa_id = null;

        if (data.empresa) {
          empresa_id = data.empresa.id;
        } else if (data.ghe && data.ghe.ltcat) {
          empresa_id = data.ghe.ltcat.empresa.id;
        }

        _this2.get("esocial/lotes/gerar/" + data.layout + "/" + empresa_id, { filter: filter }).then(function (result) {
          result = result[0];
          _this2.config.loading.content = false;
          _this2.$root.$loading.set(false);

          _this2.getEsocial();

          if (result.status == 200) {
            _this2.edAlert("Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo.");
          } else {
            _this2.edAlert(result.msg, "error");
          }
        });
      });
    },
    onGerarArquivoXML: function onGerarArquivoXML(ids) {
      var _this3 = this;

      var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$confirm("Tem certeza que deseja gerar o xml dos registro(s) selecionados?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this3.config.loading.content = true;
        _this3.$root.$loading.set(true);

        var filter = {
          ids: [ids],
          avulso: _this3.avulso
        };

        _this3.get("esocial/" + (layout ? layout : _this3.formData.layout) + "/gerar-arquivo-xml", {
          filter: filter
        }).then(function (result) {
          result = result[0];

          _this3.config.loading.content = false;
          _this3.$root.$loading.set(false);

          _this3.getEsocial();

          if (result.status == 200) {
            _this3.edMsg("Operação realizada com sucesso");
          } else {
            _this3.edAlert(result.msg, "error");
          }
        });
      });
    },
    onDownloadXML: function onDownloadXML(data) {
      if (data.xml) {
        var contents = data.xml;
        var filename = data.uid + ".xml";
        var contentType = "application/xml";

        var blob = this.b64toBlob(contents, contentType);

        this.download(blob, filename);
      }
    },
    onLogs: function onLogs(data) {
      this.formData.item = data;
      this.showLogs = !this.showLogs;
    },
    getEsocialTabela: function getEsocialTabela(_search, _page, _pagination) {
      var _this4 = this;

      this.config.loading.esocial_tabela = true;
      this.config.list.esocial_tabela = [];

      this.get("esocial/tabelas/conteudo/9", {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];

        _this4.config.loading.esocial_tabela = false;

        if (result.status == 200) {
          _this4.config.list.esocial_tabela = result.data.data;

          if (_this4.config.list.esocial_tabela.length && !_this4.formData.esocial_tabela) {
            _this4.formData.esocial_tabela = _this4.config.list.esocial_tabela[0];
            _this4.formData.layout = _this4.config.list.esocial_tabela[0].codigo;
          }
        }
      });
    },
    getEsocial: function getEsocial(_search, _page, _pagination) {
      var _this5 = this;

      this.$root.$loading.set(true);

      this.filterBadge = (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.empresa_envio_automatico ? 1 : 0) + (this.formFilter.data_cadastro && this.formFilter.data_cadastro[0] && this.formFilter.data_cadastro[1] ? 1 : 0) + (this.formFilter.mostrar && this.formFilter.mostrar.length > 0 ? 1 : 0);

      if (this.lote) {
        this.formFilter['lote'] = this.lote;
      }

      this.formData.search = _search;
      this.formData.page = _page;
      this.formData.pagination = _pagination;

      this.config.loading.table = true;
      this.response = {};
      this.pagination = {};

      this.config.loading.tableAntigo = true;
      this.responseAntigo = {};
      this.paginationAntigo = {};

      if (this.layout) {
        this.formData.layout = this.layout;
      }

      var url = "esocial/" + this.formData.layout;
      if (this.avulso) {
        url = "esocial/avulso";
      }

      this.get(url, {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this5.response = result;
        _this5.config.loading.table = false;
        _this5.$root.$loading.set(false);

        if (result.status == 200) {
          _this5.pagination = result;
        }
      });
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "esocial-lotes",
    mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
    components: {},
    data: function data() {
        return {
            loadingContent: true,
            loadingDownload: false,
            error: null,
            formData: {}
        };
    },
    created: function created() {
        $('.carregando').hide();
    },
    mounted: function mounted() {
        this.getEsocialLote();
    },


    methods: {

        toDate: function toDate(data, disableHours) {
            return __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a.toDate(data, disableHours);
        },

        getEsocialLote: function getEsocialLote() {
            var _this = this;

            this.loadingContent = true;
            this.loadingDownload = true;
            this.error = null;

            var _email = this.$route.params.email ? this.$route.params.email : null;

            this.get('/util/esocial/arquivo/' + this.$route.params.link, { email: _email }).then(function (result) {

                result = result[0];

                _this.loadingContent = false;

                if (result.status == 200) {
                    _this.formData = result.data;
                    _this.onDownloadArquivo();
                } else {
                    _this.error = result.msg;
                }
            });
        },

        onDownloadArquivo: function onDownloadArquivo() {

            this.loadingDownload = false;

            if (this.formData.contents) {

                var contents = this.formData.contents;
                var filename = this.formData.filename;
                var contentType = this.formData.contentType;

                var blob = __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a.b64toBlob(contents, contentType);

                __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a.download(blob, filename);

                this.getEsocialLotes();
            } else {

                this.$alert('Não foi possível baixar o arquivo', 'Atenção', {
                    confirmButtonText: 'OK',
                    type: 'info'
                });
            }
        }

    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_log_email_index__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_log_email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsWeb_log_email_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_lote_email_cadastro__ = __webpack_require__(824);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-email",
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, LogEmail: __WEBPACK_IMPORTED_MODULE_4_appsWeb_log_email_index___default.a },
  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },

  watch: {
    'parent.formData.id': function parentFormDataId() {},
    showForm: function showForm() {
      this.showFormList = !this.showFormList;
    }
  },
  data: function data() {
    return {
      config: {
        click: {},
        loading: {
          save: false
        },
        list: {}
      },
      response: {},
      pagination: {},
      tableHead: [{
        key: 'destinatario',
        sortable: true,
        label: 'Destinatário'
      }, {
        key: 'tipo_status',
        label: 'Status'
      }, {
        key: 'updated_at',
        sortable: true,
        show_user: true,
        label: 'Atualização'
      }],
      formData: {
        destinatario: null
      },
      tableData: [],
      formItems: [],
      showFormList: false,
      showFormRegister: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_lote_email_cadastro__["a" /* default */];
  },


  methods: {
    onRegister: function onRegister() {
      this.showFormRegister = !this.showFormRegister;
    },
    salvar: function salvar() {
      var _this = this;

      this.config.loading.save = true;
      this.response = {};

      this.post('esocial/lotes/' + this.parent.formData.id + '/email', this.formData).then(function (result) {

        _this.config.loading.save = false;

        result = result[0];
        _this.response = result;

        if (result.status == 200) {
          _this.edMsg('Email cadastrado com sucesso');
          _this.showFormRegister = !_this.showFormRegister;
          _this.$root.$session.event = 'LogEmailNotifyEvent';
        }
      });
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: {
    EdModal: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdModal */],
    EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdForm */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_1_template__["h" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdInputSelect */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_1_template__["g" /* EdInputDate */]
  },
  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  watch: {
    showForm: function showForm() {
      this.showFormEdit = !this.showFormEdit;
    },
    "formData.id_emp": function formDataId_emp() {
      this.getFdt();
      this.getFuncionario();
    }
  },
  data: function data() {
    return {
      config: {
        loading: {
          save: false,
          id_emp: false,
          layout: false,
          id_fdt: false,
          id_fun: false
        },
        list: {
          id_emp: [],
          layout: [],
          id_fdt: [],
          id_fun: []
        }
      },
      response: {},
      pagination: {},
      formData: {
        id_emp: null,
        layout: null,
        avulso: 0,
        created_at: [],
        fdts: [],
        funcionarios: [],
        funcionarios_delete: []
      },
      showFormEdit: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLayout();
    this.getEmpresa();
  },


  methods: {
    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];
        _this.config.loading.id_emp = false;

        if (result.status == 200) {
          _this.config.list.id_emp = result.data.data;
        }
      });
    },

    getFdt: function getFdt(_search) {
      var _this2 = this;

      if (!this.formData.id_emp) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formData.id_emp, { search: _search }).then(function (result) {
        result = result[0];
        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.formData.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_fun = false;

        if (result.status == 200) {
          _this3.config.list.id_fun = result.data.data;
        }
      });
    },
    getLayout: function getLayout(_search) {
      var _this4 = this;

      this.config.loading.layout = true;
      this.config.list.layout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(function (result) {
        result = result[0];

        _this4.config.loading.layout = false;

        if (result.status == 200) {
          _this4.config.list.layout = result.data.data;
        }
      });
    },

    salvar: function salvar() {
      var _this5 = this;

      this.$confirm("O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this5.config.loading.save = true;
        _this5.response = {};

        var filter = {
          id_empresa: _this5.formData.id_emp,
          created_at: _this5.formData.created_at,
          fdts: _this5.formData.fdts,
          funcionarios: _this5.formData.funcionarios,
          funcionarios_delete: _this5.formData.funcionarios_delete,
          avulso: _this5.formData.avulso
        };

        _this5.get("esocial/lotes/gerar/" + _this5.formData.layout.codigo, {
          filter: filter
        }).then(function (result) {
          _this5.config.loading.save = false;

          result = result[0];
          _this5.response = result;

          if (result.status == 200) {
            _this5.showFormEdit = !_this5.showFormEdit;

            if (_this5.parent.getEsocialLotes) _this5.parent.getEsocialLotes();

            _this5.edAlert("Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo.");
          } else {
            _this5.edAlert(result.msg, "error");
          }
        });
      });
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: {
    XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdButton */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdInputSelect */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_1_template__["g" /* EdInputDate */]
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    },
    loadingFuncionario: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getFuncionario", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {},
    loadingFuncionario: function loadingFuncionario() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      },
      lstLayout: [{
        codigo: "S-1000",
        nome: "S-1000"
      }, {
        codigo: "S-1005",
        nome: "S-1005"
      }, {
        codigo: "S-1010",
        nome: "S-1010"
      }, {
        codigo: "S-1020",
        nome: "S-1020"
      }, {
        codigo: "S-1030",
        nome: "S-1030"
      }, {
        codigo: "S-1035",
        nome: "S-1035"
      }, {
        codigo: "S-1040",
        nome: "S-1040"
      }, {
        codigo: "S-1050",
        nome: "S-1050"
      }, {
        codigo: "S-1060",
        nome: "S-1060"
      }, {
        codigo: "S-1065",
        nome: "S-1065"
      }, {
        codigo: "S-1070",
        nome: "S-1070"
      }, {
        codigo: "S-1080",
        nome: "S-1080"
      }, {
        codigo: "S-1200",
        nome: "S-1200"
      }, {
        codigo: "S-1202",
        nome: "S-1202"
      }, {
        codigo: "S-1207",
        nome: "S-1207"
      }, {
        codigo: "S-1210",
        nome: "S-1210"
      }, {
        codigo: "S-1250",
        nome: "S-1250"
      }, {
        codigo: "S-1260",
        nome: "S-1260"
      }, {
        codigo: "S-1270",
        nome: "S-1270"
      }, {
        codigo: "S-1280",
        nome: "S-1280"
      }, {
        codigo: "S-1295",
        nome: "S-1295"
      }, {
        codigo: "S-1298",
        nome: "S-1298"
      }, {
        codigo: "S-1299",
        nome: "S-1299"
      }, {
        codigo: "S-1300",
        nome: "S-1300"
      }, {
        codigo: "S-2190",
        nome: "S-2190"
      }, {
        codigo: "S-2200",
        nome: "S-2200"
      }, {
        codigo: "S-2205",
        nome: "S-2205"
      }, {
        codigo: "S-2206",
        nome: "S-2206"
      }, {
        codigo: "S-2210",
        nome: "S-2210"
      }, {
        codigo: "S-2220",
        nome: "S-2220"
      }, {
        codigo: "S-2230",
        nome: "S-2230"
      }, {
        codigo: "S-2240",
        nome: "S-2240"
      }, {
        codigo: "S-2241",
        nome: "S-2241"
      }, {
        codigo: "S-2245",
        nome: "S-2245"
      }, {
        codigo: "S-2250",
        nome: "S-2250"
      }, {
        codigo: "S-2298",
        nome: "S-2298"
      }, {
        codigo: "S-2299",
        nome: "S-2299"
      }, {
        codigo: "S-2300",
        nome: "S-2300"
      }, {
        codigo: "S-2306",
        nome: "S-2306"
      }, {
        codigo: "S-2399",
        nome: "S-2399"
      }, {
        codigo: "S-2400",
        nome: "S-2400"
      }, {
        codigo: "S-3000",
        nome: "S-3000"
      }, {
        codigo: "S-5001",
        nome: "S-5001"
      }, {
        codigo: "S-5002",
        nome: "S-5002"
      }, {
        codigo: "S-5011",
        nome: "S-5011"
      }, {
        codigo: "S-5012",
        nome: "S-5012"
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    consultar: function consultar() {
      var _this = this;

      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/evento-empresa", this.formData).then(function (result) {
        _this.$root.$loading.set(false);

        console.log("result", result);
        if (result.status == 200) {
          _this.formData.strXml = result.data;
        } else if (result.status != 400) {}
      });
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: {
    XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdButton */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["c" /* EdInputSelect */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputDate */]
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      },
      lstFuncionario: [],
      loadingFuncionario: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    getFuncionario: function getFuncionario(_search) {
      var _this = this;

      if (!this.formData.id_emp) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search
      }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          _this.lstFuncionario = result.data.data;
        }
        _this.loadingFuncionario = false;
      });
    },
    consultar: function consultar() {
      var _this2 = this;

      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/" + this.formData.id_fun + "/evento-funcionario", this.formData).then(function (result) {
        _this2.$root.$loading.set(false);

        console.log("result", result);
        if (result.status == 200) {
          _this2.formData.strXml = result.data;
        } else {}
      });
    }
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: { XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdForm */], EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdButton */], EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdInputSelect */], EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputText */] },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getFuncionario", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    consultar: function consultar() {
      var _this = this;

      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/protocolo", this.formData).then(function (result) {
        _this.$root.$loading.set(false);

        console.log('result', result);
        if (result.status == 200) {
          _this.formData.strXml = result.data;
        } else {}
      });
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: { XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdForm */], EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdButton */], EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdInputSelect */], EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputText */] },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getFuncionario", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    consultar: function consultar() {
      var _this = this;

      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/recibo", this.formData).then(function (result) {
        _this.$root.$loading.set(false);

        console.log("result", result);
        if (result.status == 200) {
          _this.formData.strXml = result.data;
        } else {}
      });
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_template__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_consulta_protocolo_vue__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_consulta_protocolo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_consulta_protocolo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_consulta_recibo_vue__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_consulta_recibo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__includes_consulta_recibo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_trabalhador_vue__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_trabalhador_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_trabalhador_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_consulta_evento_empresa_vue__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_consulta_evento_empresa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_consulta_evento_empresa_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gerar__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gerar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gerar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__email_index__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__email_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__processar_index__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__processar_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__processar_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__item_index__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__item_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__item_index__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes",
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a,
    GerarLote: __WEBPACK_IMPORTED_MODULE_8__gerar___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_3_template__["a" /* EdButton */],
    EmailLote: __WEBPACK_IMPORTED_MODULE_9__email_index___default.a,
    Processar: __WEBPACK_IMPORTED_MODULE_10__processar_index___default.a,
    Item: __WEBPACK_IMPORTED_MODULE_11__item_index___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_3_template__["b" /* EdForm */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_3_template__["c" /* EdInputSelect */],
    EdModal: __WEBPACK_IMPORTED_MODULE_3_template__["d" /* EdModal */],
    EdAlert: __WEBPACK_IMPORTED_MODULE_3_template__["e" /* EdAlert */],
    ConsultaProtocolo: __WEBPACK_IMPORTED_MODULE_4__includes_consulta_protocolo_vue___default.a,
    ConsultaRecibo: __WEBPACK_IMPORTED_MODULE_5__includes_consulta_recibo_vue___default.a,
    ConsultaEventoTrabalhador: __WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_trabalhador_vue___default.a,
    ConsultaEventoEmpresa: __WEBPACK_IMPORTED_MODULE_7__includes_consulta_evento_empresa_vue___default.a
  },
  provide: function provide() {
    return {
      formData: this.formData,
      getEmpresa: this.getEmpresa,
      getFuncionario: this.getFuncionario,
      getLayout: this.getLayout,
      parent: this
    };
  },
  data: function data() {
    return {
      response: {},
      pagination: {},
      formData: {},
      tableHead: [{
        key: "lote",
        sortable: true,
        width: "150px",
        label: "Lote"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "layout",
        sortable: true,
        label: "Layout"
      }, {
        key: "eventos",
        sortable: true,
        label: "Eventos"
      }, {
        key: "arquivo",
        show_arquivo: true,
        label: "Arquivo"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstLayout: [],
      formFilter: {
        id_empresa: null,
        id_funcionario: null,
        layout: null
      },
      showFormEdit: false,
      showFormEmail: false,
      showFormProcessar: false,
      loadingTable: false,
      loadingEmpresa: false,
      loadingFuncionario: false,
      boolExibirConsultaProtocolo: false,
      showFormItem: false,
      filterBadge: 0,
      tabSelected: "tab-consulta-protocolo"
    };
  },
  created: function created() {
    this.getEsocialLotes(this.$route.params.lote);
  },
  mounted: function mounted() {
    this.getEmpresa();
    this.getLayout();
  },


  methods: {
    onRegister: function onRegister(init) {
      this.showFormEdit = !this.showFormEdit;
    },
    onEmail: function onEmail(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout
      };
      this.showFormEmail = !this.showFormEmail;
    },
    onItem: function onItem(data) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        id: data.id,
        lote: data.lote,
        layout: data.layout,
        avulso: data.avulso
      }, {});
      this.showFormItem = !this.showFormItem;
    },
    onProcessar: function onProcessar(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout
      };
      this.showFormProcessar = !this.showFormProcessar;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingTable = true;

        _this.post("esocial/lotes/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getEsocialLotes();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },
    getLayout: function getLayout(_search) {
      var _this2 = this;

      this.lstLayout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this2.lstLayout = result.data.data;
        }
      });
    },
    getEmpresa: function getEmpresa(_search) {
      var _this3 = this;

      this.lstEmpresa = [];
      this.loadingEmpresa = true;

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          _this3.lstEmpresa = result.data.data;
        }
        _this3.loadingEmpresa = false;
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this4 = this;

      if (!this.formFilter.id_empresa) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search
      }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          _this4.lstFuncionario = result.data.data;
        }
        _this4.loadingFuncionario = false;
      });
    },
    getEsocialLotes: function getEsocialLotes(_search, _page) {
      var _this5 = this;

      this.loadingTable = true;
      this.response = {};

      this.filterBadge = (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.layout ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0);

      this.get("esocial/lotes", {
        page: _page,
        search: _search,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this5.response = result;

        _this5.loadingTable = false;

        if (result.status == 200) {
          _this5.formataLista(result);
        }
      });
    },
    formataLista: function formataLista(result) {
      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        var info_evento = '<br><span style="color:' + (arrData[i].total_evento_enviado ? "green" : "") + '"><b>Eventos enviado:</b> ' + arrData[i].total_evento_enviado + "</span>";

        info_evento += '<br><span style="color:' + (arrData[i].total_evento_erro ? "red" : "") + '"><b>Eventos com erro:</b> ' + arrData[i].total_evento_erro + "</span>";

        var item = {
          lote: arrData[i].lote,
          empresa: arrData[i].empresa.nome,
          layout: arrData[i].layout,
          eventos: "<span>Total eventos: " + arrData[i].total_evento + "</span>" + info_evento,
          arquivo: arrData[i].arquivo,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          updated_at: this.toDate(arrData[i].updated_at, false),
          _data: arrData[i],
          buttons: [{
            icon: "fa fa-envelope",
            color: "warning",
            title: "Enviar Lote por Email",
            click: this.onEmail
          }],
          options: {
            disable_delete: arrData[i].processos_count
          }
        };

        if (this.$root.$session.validarPacote(30)) {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Processar Lote",
            click: this.onProcessar
          });
        }

        if (true) {
          item.buttons.push({
            icon: "fa fa-th-list",
            color: "primary",
            title: "Visualizar items no arquivo",
            click: this.onItem
          });
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    }
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_esocial_index__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_esocial_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsWeb_esocial_index__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-email",
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, eSocial: __WEBPACK_IMPORTED_MODULE_4_appsWeb_esocial_index___default.a },
  props: {
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  inject: ["formData", "parent"],
  watch: {
    showForm: function showForm() {
      this.showFormList = !this.showFormList;
      this.getEsocialLotes();
    }
  },
  data: function data() {
    return {
      tableHead: [{
        key: "funcionario",
        label: "Funcionário"
      }],
      tableData: [],
      formItems: [],
      showFormList: false,
      loadingTable: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    getEsocialLotes: function getEsocialLotes() {}
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_xml_viewer__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-processar",
  mixins: [],
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdForm */], EdModal: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdModal */], XmlViewer: __WEBPACK_IMPORTED_MODULE_1_vue_xml_viewer___default.a, EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputText */], EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdButton */] },
  inject: ["parent"],
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    formData: function formData() {
      this.getEsocialLotesProcessar();
    },
    showForm: function showForm() {}
  },

  data: function data() {
    return {
      loadingContent: false,
      loadingConsultarLote: false,
      showFormDialog: false,
      showLogs: false,
      showModo: false,
      showConsultarOutrosLotes: false,
      titleLogsReq: null,
      showLogsReq: false,
      messageLogsReq: null,
      pagination: {},
      formDataLogs: {},
      tableHead: [{
        key: "id",
        sortable: true,
        width: "150px",
        label: "ID"
      }, {
        key: "modo",
        label: "Modo"
      }, {
        key: "status",
        label: "Status"
      }, {
        key: "mensagem",
        label: "Mensagem"
      }, {
        key: "protocolo",
        label: "Protocolo"
      }, {
        key: "data_recepcao",
        label: "Data Recepção"
      }, {
        key: "data_envio",
        label: "Data Envio"
      }],
      tableData: [],
      formDataProtocolo: {
        strProtocolo: null,
        arrayProtocolo: null
      },
      boolExibirConsultaProtocolo: false
    };
  },
  mounted: function mounted() {
    this.getEsocialLotesProcessar();
  },


  methods: {
    toDate: function toDate(date, disabledHours) {
      return this.$utilidade.toDate(date, disabledHours);
    },

    getEsocialLotesProcessar: function getEsocialLotesProcessar() {
      var _this = this;

      if (!this.formData.id) return;

      this.loadingContent = true;

      this.$root.$request.get("esocial/lotes/processar/" + this.formData.id).then(function (result) {
        _this.loadingContent = false;

        if (result.status == 200) {
          _this.formataLista(result);
        }
      });
    },
    onRegister: function onRegister(data, modo) {
      if (!modo) {
        this.showModo = !this.showModo;
        return;
      }

      var self = this;
      this.$root.$dialog.confirm("Tem certeza que deseja enviar esse lote para o eSocial?").then(function () {
        self.$root.$loading.set(true);

        self.$root.$request.get("esocial/lotes/processar/" + self.formData.id + "/enviar-lote/" + modo).then(function (result) {
          self.$root.$loading.set(false);

          if (result.status == 200) {
            self.formataLista(result);
            self.showModo = false;
          } else if (result.msg) {
            self.$root.$dialog.alert(result.msg, "error");
          }
        });
      });
    },
    consultarProtocolo: function consultarProtocolo() {
      var _this2 = this;

      if (!this.formDataProtocolo.strProtocolo) {
        this.$root.$dialog.alert("Informe o protocolo", "error");
        return;
      }

      this.$root.$loading.set(true);
      this.formDataProtocolo.arrayProtocolo = null;

      this.$root.$request.get("esocial/lotes/consultar/" + this.formData.id + "/" + this.formDataProtocolo.strProtocolo).then(function (result) {
        _this2.$root.$loading.set(false);

        console.log("result", result);

        if (result.status == 200) {
          _this2.formDataProtocolo.arrayProtocolo = result.data;
        } else if (result.msg) {
          _this2.$alert(result.msg, "Atenção", {
            confirmButtonText: "OK"
          });
        }
      });
    },
    onAtualizarProtocolo: function onAtualizarProtocolo(data) {
      var _this3 = this;

      this.loadingContent = true;

      this.$root.$request.get("esocial/lotes/processar/" + this.formData.id + "/" + data.id + "/consultar-lote").then(function (result) {
        _this3.loadingContent = false;

        if (result.status == 200) {
          _this3.formataLista(result);
          _this3.parent.getEsocialLotes();
        } else if (result.msg) {
          _this3.$alert(result.msg, "Atenção", {
            confirmButtonText: "OK"
          });
        }
      });
    },
    onLogs: function onLogs(data) {
      this.formDataLogs = data;
      this.showLogs = !this.showLogs;
    },
    onLogsReqSend: function onLogsReqSend(data) {
      this.titleLogsReq = "Dados enviados";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_request;
    },
    onLogsReqReceiv: function onLogsReqReceiv(data) {
      this.titleLogsReq = "Dados recebidos";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_response;
    },


    parseModo: function parseModo(modo) {
      if (!modo) return;

      return modo.replace("INC", "Inclusão").replace("ALT", "Alteração").replace("EXC", "Exclusão");
    },

    checkEnableModo: function checkEnableModo(modo) {
      var last_modo = this.tableData.length ? this.tableData[0]._data.modo : "",
          last_status = this.tableData.length ? this.tableData[0]._data.status : "";

      switch (modo) {
        case "INC":
          if (["", "INC"].indexOf(last_modo) != -1 && last_status != "201") {
            return true;
          }

          return false;

          break;

        case "ALT":
          if (["ALT", "INC"].indexOf(last_modo) != -1 && last_status == "201" || ["ALT", "EXC"].indexOf(last_modo) != -1 && last_status != "201") {
            return true;
          }

          return false;

          break;

        case "EXC":
          if (["ALT", "INC"].indexOf(last_modo) != -1 && last_status == "201" || ["EXC", "ALT"].indexOf(last_modo) != -1 && last_status != "201") {
            return true;
          }

          return false;

          break;
      }

      return false;
    },

    formataLista: function formataLista(result) {
      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i].loading = false;
        arrData[i].log_retorno = arrData[i].log_retorno ? this.$utilidade.stringToArray(arrData[i].log_retorno) : null;

        var item = {
          id: arrData[i].id,
          modo: this.parseModo(arrData[i].modo),
          status: arrData[i].status,
          mensagem: arrData[i].msg,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          request: arrData[i].request,
          response: arrData[i].response,
          data_recepcao: this.$utilidade.toDate(arrData[i].data_recepcao, false),
          data_envio: this.$utilidade.toDate(arrData[i].created_at, false),
          _data: arrData[i],
          buttons: [],
          options: {}
        };

        item.buttons.push({
          icon: "fa fa-refresh",
          color: "primary",
          title: "Consultar Protocolo",
          click: this.onAtualizarProtocolo
        });

        if (arrData[i].log_retorno && arrData[i].log_retorno.length > 0) {
          item.buttons.push({
            icon: "fa fa-search",
            color: "warning",
            title: "Detalhes do Envio",
            click: this.onLogs
          });

          if (arrData[i].log_request) {
            item.buttons.push({
              icon: "fa fa-cloud-upload",
              color: "warning",
              title: "Visualizar dados enviados",
              click: this.onLogsReqSend
            });
          }

          if (arrData[i].log_response) {
            item.buttons.push({
              icon: "fa fa-cloud-download",
              color: "warning",
              title: "Visualizar dados recebidos",
              click: this.onLogsReqReceiv
            });
          }
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    }
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__s2220__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__s2220___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__s2220__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__s2240__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__s2240___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__s2240__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_template__ = __webpack_require__(27);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2220",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {
    EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_4_template__["b" /* EdForm */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_4_template__["f" /* EdInputText */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_4_template__["c" /* EdInputSelect */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_4_template__["h" /* EdInputAutoComplete */],
    s2220: __WEBPACK_IMPORTED_MODULE_2__s2220___default.a,
    s2240: __WEBPACK_IMPORTED_MODULE_3__s2240___default.a
  },

  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  conputed: {},

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    },
    "formData.id_emp": function formDataId_emp() {},
    "parent.showNovoXml": function parentShowNovoXml() {
      this.initialize();
    }
  },

  data: function data() {
    return {
      tableHead: [{
        key: "layout",
        sortable: true,
        label: "Layout"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Data Atualização"
      }],
      bind: {
        loadingEmpresa: false,
        loadingFuncionario: false,
        loadingCategoria: false,
        loadingFdt: false,
        funcionarios: [],
        empresas: [],
        estados: [],
        fdt: [],
        categorias: null
      },
      response: null,
      formData: {
        id: 0,
        funcionario: null,
        empresa: null,
        id_emp: null,
        id_fun: null,
        layout: null,
        valor: {
          id_esocial_categoria: null,
          id_fdt: null,
          matricula: null,
          consulta: {
            aptidao: 186,
            id_tipo_aso: 47,
            aso_dt: this.$utilidade.toDate(null, true)
          },
          medico: {},
          responsavel_pcmso: {},
          responsavel: {},
          ambiente: {
            dtIniCondicao: null,
            dscAtivDes: null
          },
          exames: [],
          riscos: []
        }
      }
    };
  },
  mounted: function mounted() {
    this.formataLista();
    this.getEstados();
    this.getCategoria();
    this.getEmpresa();
    this.initialize();
  },


  methods: {
    initialize: function initialize() {
      this.formData = {
        id: 0,
        funcionario: null,
        empresa: null,
        id_emp: null,
        id_fun: null,
        layout: null,
        valor: {
          id_esocial_categoria: null,
          id_fdt: null,
          matricula: null,
          consulta: {
            aptidao: 186,
            id_tipo_aso: 47,
            aso_dt: this.$utilidade.toDate(null, true)
          },
          medico: {},
          responsavel_pcmso: {},
          responsavel: {},
          ambiente: {
            dtIniCondicao: null,
            dscAtivDes: null
          },
          exames: [],
          riscos: []
        }
      };
      if (this.parent.formDataXml && this.parent.formDataXml.id) {
        this.bind.funcionarios = [this.parent.formDataXml.funcionario];
        this.bind.empresas = [this.parent.formDataXml.empresa];

        this.formData = {
          id: this.parent.formDataXml.id,
          id_emp: this.parent.formDataXml.empresa.id,
          id_fun: this.parent.formDataXml.funcionario.id,
          funcionario: this.parent.formDataXml.funcionario,
          empresa: this.parent.formDataXml.empresa,
          layout: this.parent.formDataXml.layout,
          valor: this.parent.formDataXml.esocial_avulso.valor
        };

        if (!this.formData.valor.responsavel_pcmso || !this.formData.valor.responsavel_pcmso.nome) {
          this.formData.valor.responsavel_pcmso = {
            nome: null,
            crm: null,
            crm_uf: null
          };
        }

        this.formData.id_fun = this.parent.formDataXml.funcionario.id;
      }
    },
    setFuncionario: function setFuncionario(obj) {

      console.log('objobjobj', obj);
      if (obj) {
        this.formData.id_fun = obj.id;
        this.formData.matricula = obj.mat;
        this.formData.id_esocial_categoria = obj.id_esocial_categoria;

        if (obj.funcao) {
          this.formData.valor.ambiente.dscAtivDes = obj.funcao.descricao;
        }
      }
    },
    setEmpresa: function setEmpresa(obj) {
      if (obj) {
        this.formData.id_emp = obj.id;
        this.getFuncionario();
        this.getFdt();
      }
    },
    getEstados: function getEstados() {
      var _this = this;

      this.bind.estados = [];

      this.$root.$request.get("common/estado", null, true).then(function (result) {
        console.log("resultresultresult", result);
        if (result.status == 200) {
          result.data.forEach(function (element) {
            _this.bind.estados.push({ id: element.uf, nome: element.uf });
          });
        }
      });
    },
    getCategoria: function getCategoria(_search) {
      var _this2 = this;

      this.bind.categorias = [];
      this.bind.loadingCategoria = false;

      this.$root.$request.get("esocial/tabelas/conteudo/1", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this2.bind.loadingCategoria = false;

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            var item = {
              id: element.id,
              nome: element.codigo + " - " + element.nome
            };

            if (item.nome.length > 50) {
              item.nome = item.nome.substring(0, 100);
            }

            _this2.bind.categorias.push(item);
          });
        }
      });
    },
    getTabelas: function getTabelas() {
      var tabelas = [];

      this.parent.config.list.esocial_tabela.forEach(function (element) {
        if (["S-2220", "S-2240"].indexOf(element.codigo) != -1) {
          tabelas.push({
            id: element.codigo,
            nome: element.codigo + " - " + element.nome
          });
        }
      });

      return tabelas;
    },
    getEmpresa: function getEmpresa(_search) {
      var _this3 = this;

      this.bind.empresas = [];
      this.bind.loadingEmpresa = false;

      this.$root.$request.get("empresa", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this3.bind.loadingFuncionario = false;

        if (result.status == 200) {
          _this3.bind.empresas = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this4 = this;

      this.bind.funcionarios = [];
      this.bind.loadingFuncionario = false;

      this.$root.$request.get("empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this4.bind.loadingFuncionario = false;

        if (result.status == 200) {
          _this4.bind.funcionarios = result.data.data;
        }
      });
    },
    getFdt: function getFdt() {
      var _this5 = this;

      if (!this.formData.id_emp) return;

      this.bind.loadingFdt = true;
      this.bind.fdt = [];

      this.$root.$request.get("pcmso/fdt/" + this.formData.id_emp, { pagination: 100 }).then(function (result) {

        _this5.bind.loadingFdt = false;
        console.log('fdt', result);

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            _this5.bind.fdt.push({ id: element.id, nome: element.pcmso + ' (' + element.descricao + ')' });
          });
        }
      });
    },


    formataLista: function formataLista() {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var lote = "";

        if (arrData[i].lote) {
          lote = "<span>";
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + "</span>";
          lote += "</span>";
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + "</span>";
          lote += "</a>";
        }
        var item = {
          layout: arrData[i].layout + "<br><b>Avulso</b>",
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          id: arrData[i].id,
          lote: lote ? lote : "----",
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].created_at, false) + "</span>",
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }
        }

        if (arrData[i].avulso == "1" && [328].indexOf(arrData[i].tipo_status.id) != -1 || arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
          item.buttons.push({
            icon: "fa fa-times-circle",
            color: "default",
            title: "Excluir arquivo XML",
            style: "color:#d82d2d",
            click: this.parent.onDelete
          });
        }

        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title: item._data.log_erro.length + item._data.log_warning.length + " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },

    salvar: function salvar() {
      var _this6 = this;

      this.$root.$loading.set(true);
      this.$root.$request.post("esocial/avulso/editar", this.formData).then(function (result) {
        _this6.$root.$loading.set(false);

        if (result.status == 200) {
          _this6.parent.showNovoXml = !_this6.parent.showNovoXml;
          _this6.parent.getEsocial();
        }
      });
    }
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2220",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {},

  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "cat",
        sortable: true,
        label: "CAT"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Data Atualização"
      }]
    };
  },
  mounted: function mounted() {
    this.formataLista();
  },


  methods: {
    formataLista: function formataLista() {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        var lote = '';

        if (arrData[i].lote) {
          lote = '<span>';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + '</span>';
          lote += '</span>';
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + '</span>';
          lote += '</a>';
        }
        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          cat: arrData[i].cat ? arrData[i].cat.id : '---',
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : '----',
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + '</span>',
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].updated_at, false) + '</span>',
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].created_at, false) + '</span>',
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }

          if (arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete
            });
          }
        }

        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title: item._data.log_erro.length + item._data.log_warning.length + " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2220",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {
    EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_1_template__["g" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_1_template__["h" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_1_template__["i" /* EdInputSelectTipo */],
    EdModal: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdModal */]
  },

  props: {
    avulso: {
      type: Number,
      default: 0
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false
      },
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "consulta",
        sortable: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Data Atualização"
      }],
      showProcedimento: false
    };
  },
  mounted: function mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getProcedimento();
    }
  },


  methods: {
    inserirProcedimento: function inserirProcedimento() {
      var _this = this;

      if (this.bind.procedimento) {
        var encontrado = false;

        this.formData.exames.forEach(function (element) {
          if (element.codigo == _this.bind.procedimento.codigo) {
            encontrado = true;
          }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.exames.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          data: this.$utilidade.toDate(null, true),
          resultado: 1
        });
        this.showProcedimento = !this.showProcedimento;
      }
    },
    removerProcedimento: function removerProcedimento(index) {
      this.formData.exames.splice(index, 1);
    },
    getProcedimento: function getProcedimento(_search) {
      var _this2 = this;

      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request.get("esocial/tabelas/conteudo/27", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this2.bind.loadingProcedimento = false;

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            var item = {
              id: element.id,
              codigo: element.codigo,
              nome: element.codigo + " - " + element.nome
            };

            if (item.nome.length > 50) {
              item.nome = item.nome.substring(0, 100);
            }

            _this2.bind.procedimentos.push(item);
          });
        }
      });
    },


    formataLista: function formataLista() {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var lote = "";

        if (arrData[i].lote) {
          lote = "<span>";
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + "</span>";
          lote += "</span>";
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + "</span>";
          lote += "</a>";
        }
        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : "----",
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].created_at, false) + "</span>",
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }

          if (arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete
            });
          }
        }

        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title: item._data.log_erro.length + item._data.log_warning.length + " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2240",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {
    EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_1_template__["g" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_1_template__["h" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_1_template__["i" /* EdInputSelectTipo */],
    EdModal: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdModal */]
  },

  props: {
    avulso: {
      type: Number,
      default: 0
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false
      },
      showProcedimento: false,
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "consulta",
        sortable: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "pgr",
        sortable: true,
        label: "PPRA/PGR"
      }, {
        key: "ghe",
        sortable: true,
        label: "GHE (SETOR)"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }]
    };
  },
  mounted: function mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getRisco();
    }
  },


  methods: {
    inserirProcedimento: function inserirProcedimento() {
      var _this = this;

      if (this.bind.procedimento) {
        var encontrado = false;

        this.formData.riscos.forEach(function (element) {
          if (element.codigo == _this.bind.procedimento.codigo) {
            encontrado = true;
          }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.riscos.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          dscAgNoc: null,
          tpAval: 1,
          intConc: null,
          limTol: null,
          unMed: null,
          tecMedicao: null
        });
        this.showProcedimento = !this.showProcedimento;
      }
    },
    removerProcedimento: function removerProcedimento(index) {
      this.formData.riscos.splice(index, 1);
      this.$forceUpdate();
    },
    getRisco: function getRisco(_search) {
      var _this2 = this;

      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request.get("esocial/tabelas/conteudo/24", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this2.bind.loadingProcedimento = false;

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            var item = {
              id: element.id,
              codigo: element.codigo,
              nome: element.codigo + " - " + element.nome
            };

            if (item.nome.length > 50) {
              item.nome = item.nome.substring(0, 100);
            }

            _this2.bind.procedimentos.push(item);
          });
        }
      });
    },


    formataLista: function formataLista() {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        console.log('i ' + i);

        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].ghe = arrData[i].ghe ? arrData[i].ghe : null;

        var pgr = "";
        var lote = "";

        if (arrData[i].ghe && arrData[i].ghe.revisao) {
          pgr = arrData[i].ghe.revisao.rev + " (" + arrData[i].ghe.revisao.descricao + ")";

          if (arrData[i].ghe.revisao.parent) {
            pgr += " / " + arrData[i].ghe.revisao.parent.rev + " (" + arrData[i].ghe.revisao.parent.descricao + ")";
          }

          pgr = '<a target="_blank" href="' + this.$root.$session.env.url_cs + "/app/ppra.php?emp=" + arrData[i].empresa.id + "&pcmso=" + (arrData[i].funcionario && arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt.id : '') + "&rev=" + (arrData[i].ghe && arrData[i].ghe.revisao ? arrData[i].ghe.revisao.id : '') + "&ghe=" + (arrData[i].ghe ? arrData[i].ghe.id : '') + '" arget="_blank">' + pgr + "</a>";
        }

        if (arrData[i].lote) {
          lote = '<a target="_blank" href="/esocial/lotes/' + arrData[i].lote + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + "</span>";
          lote += "</a>";
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + "</span>";
          lote += "</a>";
        }

        var item = {
          consulta: arrData[i].id_con ? arrData[i].id_con : "---",
          pgr: pgr,
          empresa: arrData[i].empresa.nome,
          ghe: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].ghe ? arrData[i].ghe.ghe + " (" + arrData[i].ghe.descricao + ")" : "---") + "</span>",
          funcionario: arrData[i].funcionario.nome,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          id: arrData[i].id,
          lote: lote ? lote : "---",
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].created_at, false) + "</span>",
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          fdt: arrData[i].fdt,
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }

          if (arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete
            });
          }
        }

        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title: item._data.log_erro.length + item._data.log_warning.length + " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s3000",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {},

  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "layout",
        sortable: true,
        label: "Layout Excluído"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }]
    };
  },
  mounted: function mounted() {
    this.formataLista();
  },


  methods: {
    formataLista: function formataLista() {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var lote = '';

        if (arrData[i].lote) {
          lote = '<a target="_blank" href="/esocial/lotes/' + arrData[i].lote + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + '</span>';
          lote += '</a>';
        }

        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          layout: arrData[i].parent ? arrData[i].parent.layout + '<br>' + arrData[i].parent.recibo : '---',
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : '---',
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].created_at, true) + "</span>",
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }
        }

        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title: item._data.log_erro.length + item._data.log_warning.length + " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_laboratorio_cadastrar__ = __webpack_require__(230);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame-editar",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.inicialize();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [],
        hidden: {},
        click: {
          laboratorio: this.getLaboratorio
        },
        loading: {
          laboratorio: false
        },
        list: {
          laboratorio: []
        }
      },
      formData: {
        laboratorio: null
      },
      response: {},
      formItems: [],
      showForm: false,
      tableData: [],
      tableHedad: [{
        key: "laboratorio",
        sortable: true,
        label: "Laboratório"
      }, {
        key: "valor_custo",
        show_money: true,
        label: "Valor Custo (R$)",
        width: "130px"
      }, {
        key: "valor_venda",
        show_money: true,
        label: "Valor Venda (R$)",
        width: "130px"
      }, {
        key: "id_lab",
        show_radio: true,
        label: "Padrao",
        width: "90px"
      }, {
        key: "buttons",
        label: "",
        width: "50px"
      }]
    };
  },


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_laboratorio_cadastrar__["a" /* default */];
    this.getLaboratorio();
    this.inicialize();
  },

  methods: {
    inicialize: function inicialize() {
      var tableData = [];

      for (var i = 0; i < this.parent.formData.laboratorios.length; i++) {
        var element = this.parent.formData.laboratorios[i];

        var item = {
          id_lab: element.laboratorio.id,
          laboratorio: element.laboratorio.nome,
          valor_custo: element.valor_custo,
          valor_venda: element.valor_venda,
          _data: element
        };

        tableData.push(item);
      }

      this.tableData = tableData;
    },
    onRegister: function onRegister() {
      if (!this.formData.laboratorio) {
        this.edAlert("Por favor selecione um laboratório", "error");
        return;
      }

      if (this.arrFindByField(this.tableData, "id_lab", this.formData.laboratorio.id)) {
        this.edAlert("O laboratório selecionado já está cadastrado", "error");
        return;
      }

      var data = {
        id: 0,
        id_lab: this.formData.laboratorio.id,
        laboratorio: this.formData.laboratorio,
        valor_custo: "0,00",
        valor_venda: "0,00"
      };

      this.tableData.push({
        id: 0,
        id_lab: this.formData.laboratorio.id,
        laboratorio: this.formData.laboratorio.nome,
        valor_custo: "0,00",
        valor_venda: "0,00",
        _data: data
      });

      this.showForm = !this.showForm;
      this.formData.laboratorio = null;
      this.formatData();
    },
    onDelete: function onDelete(item) {
      this.tableData.splice(item.index, 1);
      this.formatData();
    },
    formatData: function formatData() {
      this.parent.formData.laboratorios = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var element = this.tableData[i];
        this.parent.formData.laboratorios.push(element._data);
      }
    },


    getLaboratorio: function getLaboratorio(_search) {
      var _this = this;

      this.config.loading.laboratorio = true;
      this.config.list.laboratorio = [];

      this.get("laboratorio", { search: _search }).then(function (result) {
        result = result[0];
        _this.config.loading.laboratorio = false;

        if (result.status == 200) {
          _this.config.list.laboratorio = result.data.data;
        }
      });
    }
  }
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_laboratorio__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_laboratorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__includes_laboratorio__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat-risco-cadastrar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, Laboratorios: __WEBPACK_IMPORTED_MODULE_3__includes_laboratorio___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	watch: {},
	data: function data() {
		return {
			config: {
				tipo: [269, 290],
				hidden: {},
				click: {
					save: this.salvar,
					id_tab: this.getTabelaDinamica,
					esocial_atividade_per: this.getEscocialTabela28
				},
				loading: {
					save: false,
					id_tab: false,
					esocial_atividade_per: false
				},
				list: {
					id_tab: [],
					esocial_atividade_per: []
				}
			},
			formData: {
				id: 0,
				nome: null,
				nome_comercial: null,
				cod_cas: null,
				cod_esocial: '00.00.000',
				cod_metodologia: null,
				desc_metodologia: null,
				id_tipo_unidade_medida: null,
				id_tab: null,
				un_medida: null,
				amostra: null,
				vazao: null,
				volume: null,
				cod_amostrador: null,
				desc_amostrador: null,
				usuario: null,
				laboratorio: null,
				id_lab: null,
				laboratorios: [],
				esocial_atividade_per: [],
				ativo: 1
			},
			response: {},
			exameItems: []
		};
	},


	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__["a" /* default */];
		this.getTabelaDinamica();
		this.getEscocialTabela28();
	},

	methods: {

		onChangeProprio: function onChangeProprio() {},

		getEscocialTabela28: function getEscocialTabela28(_search) {
			var _this = this;

			this.config.loading.esocial_atividade_per = true;
			this.config.list.esocial_atividade_per = [];

			this.get("/esocial/tabelas/conteudo/28", { search: _search }).then(function (result) {
				result = result[0];

				_this.config.loading.esocial_atividade_per = false;

				if (result.status == 200) {
					_this.config.list.esocial_atividade_per = result.data.data;
				}
			});
		},

		getTabelaDinamica: function getTabelaDinamica(_search) {
			var _this2 = this;

			this.config.loading.id_tab = true;
			this.config.list.id_tab = [];

			this.get('/ltcat/tabela-dinamica', { search: _search }).then(function (result) {

				result = result[0];

				_this2.config.loading.id_tab = false;

				if (result.status == 200) {
					_this2.config.list.id_tab = result.data.data;
				}
			});
		},


		salvar: function salvar() {
			var _this3 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('fator-risco/editar', this.formData).then(function (result) {

				result = result[0];

				_this3.config.loading.save = false;
				_this3.response = result;

				if (result.status == 200) {

					_this3.$message({
						message: 'Registro salvo com sucesso!',
						type: 'success'
					});

					_this3.toRoute({ name: 'ltcat.risco.editar', params: { id: result.data.id } });
				}
			});
		}
	}
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_laboratorio_cadastrar__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_laboratorio__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_laboratorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_laboratorio__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame-editar",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, Laboratorios: __WEBPACK_IMPORTED_MODULE_4__includes_laboratorio___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {},
  data: function data() {
    return {
      config: {
        tipo: [269, 290],
        hidden: {},
        click: {
          save: this.salvar,
          id_tab: this.getTabelaDinamica,
          esocial_atividade_per: this.getEscocialTabela28
        },
        loading: {
          save: false,
          content: false,
          id_tab: false,
          esocial_atividade_per: false
        },
        list: {
          id_tab: [],
          esocial_atividade_per: []
        }
      },
      formData: {
        id: 0,
        nome: null,
        nome_comercial: null,
        cod_cas: null,
        cod_esocial: null,
        cod_metodologia: null,
        desc_metodologia: null,
        id_tipo_unidade_medida: null,
        id_tab: null,
        un_medida: null,
        amostra: null,
        vazao: null,
        volume: null,
        cod_amostrador: null,
        desc_amostrador: null,
        usuario: null,
        laboratorio: null,
        id_lab: null,
        laboratorios: [],
        esocial_atividade_per: [],
        ativo: 1
      },
      response: {},
      fatorRiscoItems: []
    };
  },


  mounted: function mounted() {
    this.fatorRiscoItems = __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__["a" /* default */];
    this.laboratorioItems = __WEBPACK_IMPORTED_MODULE_3__form_laboratorio_cadastrar__["a" /* default */];
    this.getFatorRisco();
    this.getTabelaDinamica();
    this.getEscocialTabela28();
  },

  methods: {
    getEscocialTabela28: function getEscocialTabela28(_search) {
      var _this = this;

      this.config.loading.esocial_atividade_per = true;
      this.config.list.esocial_atividade_per = [];

      this.get("/esocial/tabelas/conteudo/28", { search: _search }).then(function (result) {
        result = result[0];

        _this.config.loading.esocial_atividade_per = false;

        if (result.status == 200) {
          _this.config.list.esocial_atividade_per = result.data.data;
        }
      });
    },

    getTabelaDinamica: function getTabelaDinamica(_search) {
      var _this2 = this;

      this.config.loading.id_tab = true;
      this.config.list.id_tab = [];

      this.get("/ltcat/tabela-dinamica", { search: _search }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_tab = false;

        if (result.status == 200) {
          _this2.config.list.id_tab = result.data.data;
        }
      });
    },
    getFatorRisco: function getFatorRisco() {
      var _this3 = this;

      this.config.loading.content = true;

      this.get("fator-risco/" + this.$route.params.id).then(function (result) {
        result = result[0];

        _this3.config.loading.content = false;

        if (result.status == 200) {
          _this3.formatData(result);
        }
      });
    },
    formatData: function formatData(result) {
      this.formData = result.data;
    },
    salvar: function salvar() {
      var _this4 = this;

      this.response = {};
      this.config.loading.save = true;

      this.post("fator-risco/editar", this.formData).then(function (result) {
        result = result[0];

        _this4.config.loading.save = false;
        _this4.response = result;

        if (result.status == 200) {
          _this4.formatData(result);
          _this4.$message({
            message: "Registro salvo com sucesso!",
            type: "success"
          });
        }
      });
    }
  }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_template__ = __webpack_require__(27);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_4_template__["b" /* EdForm */], EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_4_template__["i" /* EdInputSelectTipo */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        tuss: null,
        interpr: null,
        ordem: null,
        ex_id_min: null,
        ex_id_max: null,
        tipo: null,
        proprio: null
      },
      formFilter: {
        cat_esocial: []
      },
      pagination: {},
      response: {},
      filterBadge: 0,
      tableHead: [{
        key: "id",
        sortable: true,
        label: "CÓD"
      }, {
        key: "nome",
        sortable: true,
        label: "Nome"
      }, {
        key: "cat_esocial",
        sortable: true,
        label: "CATEGORIA"
      }, {
        key: "cod_metodologia",
        sortable: true,
        label: "CÓD METODOLOGIA"
      }, {
        key: "cod_esocial",
        sortable: true,
        label: "CÓD ESOCIAL"
      }, {
        key: "cas",
        sortable: true,
        label: "CÓD CAS"
      }, {
        key: "ativo",
        sortable: true,
        label: "Ativo"
      }],
      tableData: [],
      loadingTable: false,
      showFormEdit: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.getFatorRisco();
  },

  methods: {
    onExcel: function onExcel() {
      this.open("fator-risco/excel", { filter: {} });
    },


    onRegister: function onRegister() {
      this.toRoute({ name: "ltcat.risco.cadastrar" });
    },

    onEdit: function onEdit(data) {
      this.toRoute({ name: "ltcat.risco.editar", params: { id: data.id } });
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;

        _this.post("/fator-risco/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getFatorRisco();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getFatorRisco: function getFatorRisco(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.filterBadge = this.formFilter.cat_esocial.length;

      this.get("fator-risco", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this2.response = result;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cas: data[i].cod_cas,
              cat_esocial: data[i].cat_esocial,
              cod_metodologia: data[i].cod_metodologia,
              cod_esocial: data[i].cod_esocial,
              ativo: data[i].ativo == 1 ? "Sim" : "Não",
              _data: data[i],
              options: {
                disable_delete: !_this2.validarPermissao(568),
                disable_edit: !_this2.validarPermissao(568)
              },
              buttons: []
            };

            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    }
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_filters__ = __webpack_require__(825);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_common_rest___default.a],
  props: {
    point_id: {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    point_type: {
      type: [String],
      default: function _default() {
        return null;
      }
    },
    filter: {
      type: [Object],
      default: function _default() {
        return {};
      }
    },
    onRegister: {
      type: [Function],
      default: null
    }
  },
  watch: {
    point_id: function point_id() {
      this.getLog();
    },
    point_type: function point_type() {
      this.formatarCabecalho();
      this.getLog();
    },
    '$root.$session.event': function $root$sessionEvent() {

      switch (this.$root.$session.event) {
        case 'DisparoNotifyEvent':
        case 'LogEmailNotifyEvent':
          this.getLog();
          this.$root.$session.event = null;
          break;

        default:
          break;
      }
    }
  },

  data: function data() {
    return {
      config: {
        click: {},
        list: {},
        loading: {}
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        mensagem: null
      },
      formFilter: {
        created_at: [],
        tabela: this.tabela,
        registro: this.registro
      },
      tableHead: [{
        key: "id",
        sortable: true,
        label: " Nº Envio"
      }, {
        key: "point",
        sortable: true,
        label: "Identificação"
      }, {
        key: "remetente",
        sortable: true,
        label: "Remetente"
      }, {
        key: "destinatario",
        sortable: true,
        label: "Destinatário"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }, {
        key: "created_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      filterItems: [],
      loadingTable: false,
      showFormMsg: false,
      disabledConfigCell: true,
      filterBadge: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {
    this.formatarCabecalho();
  },


  mounted: function mounted() {
    this.getLog();
    this.filterItems = __WEBPACK_IMPORTED_MODULE_5__form_filters__["a" /* default */];
  },

  methods: {
    formatarCabecalho: function formatarCabecalho() {
      switch (this.point_type) {
        case "consulta":
          this.tableHead[1].label = "Consulta";
          break;

        case "empresa":
          this.tableHead[1].label = "Empresa";
          break;

        case "funcionario":
          this.tableHead[1].label = "Funcionário";
          break;

        case "esocial-lote":
          this.tableHead[1].label = "Lote";
          break;
      }
    },
    formatarPoint: function formatarPoint(data) {
      switch (this.point_type) {

        case "consulta":
          return data.id_con;
          break;

        case "funcionario":
          return "<span>" + data.nome + "</span>" + (data.empresa ? "<br><span>" + data.empresa.nome + "</span>" : "");
          break;

        case "esocial-lote":
          return data.lote;
          break;

        default:
          return data.nome;
          break;
      }
    },
    onMensagem: function onMensagem(data) {
      this.formData = {
        id: data.id,
        mensagem: data.mensagem
      };

      this.open("log/email/html/" + this.formData.id);
    },
    onError: function onError(data) {
      this.formData = {
        id: data.id,
        mensagem: data.obs
      };
      this.showFormMsg = !this.showFormMsg;
    },
    getLog: function getLog(_search, _page, _pagination) {
      var _this = this;

      if (!this.point_type) return;

      this.loadingTable = true;
      this.disabledConfigCell = true;
      this.response = {};

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      if (this.formFilter.created_at.length < 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-1, null, "y"), true),
            amanha = this.toDate(this.addDate(1, null, "D"), true);

        this.formFilter.created_at.push(ontem, amanha);
      }

      this.filterBadge = this.formFilter.created_at.length > 0 ? 1 : 0;
      var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.filter, this.formFilter);

      this.get("log/email/" + this.point_type + (this.point_id ? "/" + this.point_id : ""), {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: filters
      }).then(function (result) {
        result = result[0];
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {
          data = result.data.data, tableData = [], pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              remetente: data[i].remetente,
              destinatario: data[i].destinatario ? data[i].destinatario.split(";").join("<br>") : "---",
              point: data[i].point ? _this.formatarPoint(data[i].point) : "---",
              status: data[i].obs ? data[i].obs : "",
              created_at: _this.toDate(data[i].created_at),
              _data: data[i],
              options: {},
              buttons: []
            };

            if (data[i].mensagem) {
              _this.disabledConfigCell = false;
              item.buttons.push({
                icon: "fa fa-file-text-o",
                color: "success",
                title: "Visualizar Mensagem",
                click: _this.onMensagem
              });
            }

            if (data[i].obs) {
              _this.disabledConfigCell = false;
              item.buttons.push({
                icon: "fa fa-window-close",
                color: "danger",
                title: "Visualizar Erro",
                click: _this.onError
              });
            }
            tableData.push(item);
          }
        }

        _this.pagination = pagination;
        _this.tableData = tableData;
        _this.loadingTable = false;
      });
    }
  }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_equipamento_cadastrar__ = __webpack_require__(829);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		anexo: {
			type: Object,
			default: function _default() {
				return {
					id: 0,
					descricao: null,
					arquivo: null,
					updated_at: null,
					usuario: null,
					ativo: 1
				};
			}
		},
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'anexo.id': function anexoId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
			if (this.anexo.id != 0) {
				this.getAnexo();
			}
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [],
				loading: {
					save: false,
					content: false
				},
				list: {}
			},
			formData: {
				id: 0,
				descricao: null,
				arquivo: null,
				updated_at: null,
				usuario: null
			},
			response: {},
			exameItems: [],
			loadingSave: false,
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.exameItems = __WEBPACK_IMPORTED_MODULE_4__form_equipamento_cadastrar__["a" /* default */];

		this.$events.on('upload-arquivo', function (eventData) {
			_this.formData.arquivo = eventData;
		});

		this.$events.on('upload-arquivo-delete', function (eventData) {
			_this.getAnexo();
		});

		this.$events.on('onClienteEvent', function (eventData) {
			_this.parent.getLtcatAnexo();
		});
	},


	methods: {
		init: function init() {
			this.formData = {
				id: 0,
				descricao: null,
				arquivo: null,
				updated_at: null,
				usuario: null,
				ativo: 1
			};
		},
		getAnexo: function getAnexo() {
			var _this2 = this;

			this.config.loading.content = true;
			this.formData = {};

			this.get('ltcat/anexo/' + this.parent.ltcat.id + '/' + this.anexo.id).then(function (result) {

				result = result[0];

				_this2.config.loading.content = false;

				if (result.status == 200) {
					_this2.formataData(result);
				}
			});
		},
		formataData: function formataData(result) {
			this.formData = {
				id: result.data.id,
				descricao: result.data.descricao,
				arquivo: result.data.arquivo,
				usuario: result.data.usuario,
				updated_at: result.data.updated_at
			};
		},
		salvar: function salvar() {
			var _this3 = this;

			this.response = {};
			this.loadingSave = true;

			this.post('/ltcat/anexo/' + this.parent.ltcat.id + '/editar', this.toFormUpload(this.formData)).then(function (result) {

				result = result[0];

				_this3.loadingSave = false;
				_this3.response = result;

				if (result.status == 200) {
					_this3.edMsg('Registro salvo com sucesso!');
					_this3.formataData(result);
					_this3.showFormEdit = !_this3.showFormEdit;

					if (_this3.parent.getLtcatAnexo) _this3.parent.getLtcatAnexo();
				}
			});
		}
	}
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Editar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		ltcat: {
			type: Object,
			default: null
		}
	},
	watch: {
		'$store.state.ltcat.data': function $storeStateLtcatData() {
			this.getLtcatAnexo();
		}
	},
	data: function data() {
		return {
			formData: {},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'Cód'
			}, {
				key: 'descricao',
				sortable: true,
				label: 'Descrição'
			}, {
				key: 'imagem',
				show_arquivo: true,
				label: 'Anexo'
			}, {
				key: 'status',
				show_status: true,
				label: 'Status'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: false,
			showFormEdit: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getLtcatAnexo();
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: 0
			};
		},

		onEdit: function onEdit(data) {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: data.id,
				nome: data.nome,
				usuario: data.usuario,
				updated_at: data.updated_at
			};
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				_this.post('/ltcat/anexo/' + _this.$store.state.ltcat.data.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getLtcatAnexo();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getLtcatAnexo: function getLtcatAnexo(_search, _page, _pagination) {
			var _this2 = this;

			if (!this.$store.state.ltcat.data) return;

			this.loadingTable = true;
			this.response = {};

			this.get('ltcat/anexo/' + this.$store.state.ltcat.data.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						data[i].collapse = null;

						var item = {
							'id': data[i].id,
							'descricao': data[i].descricao,
							'link': data[i].arquivo ? data[i].arquivo.url : '',
							'updated_at': _this2.toDate(data[i].updated_at),
							'imagem': data[i].arquivo,
							'status': data[i].obs ? data[i].obs : '',
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(576) || data[i].tipo_status && data[i].tipo_status.id != 79,
								disable_edit: !_this2.validarPermissao(576) || data[i].tipo_status && data[i].tipo_status.id != 79
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
					_this2.loadingTable = false;
				}
			});
		}

	}
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_ltcat_cadastrar__ = __webpack_require__(826);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat-risco-cadastrar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	watch: {
		'formData.id_emp': function formDataId_emp() {
			this.config.disabled.id_fdt = this.formData.id_emp ? false : true;
			this.formData.id_fdt = null;
			this.formData.id_rev = null;
			this.ultima_revisao = null;
			this.getFdt();
		},
		'formData.id_fdt': function formDataId_fdt() {
			this.config.disabled.id_rev = this.formData.id_fdt ? false : true;
			this.config.disabled.id_tipo_ltcat = this.formData.id_fdt ? false : true;
			this.config.disabled.id_tipo_revisao = this.formData.id_fdt ? false : true;
			this.config.disabled.data = this.formData.id_fdt ? false : true;
			this.config.disabled.obs = this.formData.id_fdt ? false : true;
			this.formData.id_rev = null;
			this.ultima_revisao = null;
			this.getUltimaRevisao();
			this.getRevisaoPpra();
		},
		'formData.id_tipo_ltcat': function formDataId_tipo_ltcat() {
			this.config.hidden.id_rev = this.formData.id_tipo_ltcat == 205 ? false : true;
			this.config.hidden.id_ltcat = this.formData.id_tipo_ltcat == 206 ? false : true;
			this.formData.id_rev = null;
			this.formData.id_ltcat = null;
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [1, 203],
				tipo_exclude: [],
				hidden: {
					id_rev: true,
					id_ltcat: true
				},
				title: {
					ppra: 'Empresa sem PPRA'
				},
				disabled: {
					id_fdt: true,
					data: true,
					obs: true,
					id_rev: true,
					id_tipo_ltcat: true,
					id_tipo_revisao: true
				},
				click: {
					save: this.salvar,
					id_emp: this.getEmpresa,
					id_fdt: this.getFdt,
					id_rev: this.getRevisaoPpra,
					id_ltcat: this.getLtcat
				},
				list: {
					id_emp: [],
					id_fdt: [],
					id_rev: [],
					id_ltcat: []
				},
				loading: {
					save: false,
					data: false,
					id_emp: false,
					id_fdt: false,
					id_rev: false,
					id_ltcat: false
				},
				options: {
					data: {
						disabledDate: this.handlerDisableYesterdayDate
					}
				}
			},
			formData: {
				id: 0,
				id_tipo_ltcat: 228,
				id_tipo_revisao: 2,
				id_emp: null,
				id_fdt: null,
				id_rev: null,
				id_ltcat: null,
				obs: null,
				data: this.toDate(null, true),
				ppra: 0
			},
			ultima_revisao: null,
			response: {},
			exameItems: []
		};
	},


	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_ltcat_cadastrar__["a" /* default */];
		this.getEmpresa();
		this.getLtcat();
	},

	methods: {

		onChangeProprio: function onChangeProprio() {},

		getEmpresa: function getEmpresa(search) {
			var _this = this;

			this.config.loading.id_emp = true;
			this.config.list.id_emp = [];

			this.get('empresa', { search: search }).then(function (result) {
				result = result[0];

				_this.config.loading.id_emp = false;

				if (result.status == 200) {
					_this.config.list.id_emp = result.data.data;
				}
			});
		},
		getFdt: function getFdt(search) {
			var _this2 = this;

			if (!this.formData.id_emp) return;

			this.config.loading.id_fdt = true;
			this.config.list.id_fdt = [];

			this.get('/pcmso/fdt/' + this.formData.id_emp, { search: search }).then(function (result) {
				result = result[0];

				_this2.config.loading.id_fdt = false;

				if (result.status == 200) {
					_this2.config.list.id_fdt = result.data.data;
				}
			});
		},
		getRevisaoPpra: function getRevisaoPpra(search) {
			var _this3 = this;

			if (!this.formData.id_emp || !this.formData.id_fdt) return;

			this.config.loading.id_rev = true;
			this.config.list.id_rev = [];

			this.get('/pcmso/revisao/' + this.formData.id_emp + '/' + this.formData.id_fdt, { search: search }).then(function (result) {
				result = result[0];

				_this3.config.loading.id_rev = false;

				if (result.status == 200) {
					_this3.config.list.id_rev = _this3.formataRevisao(result.data.data);
				}
			});
		},
		getLtcat: function getLtcat(search) {
			var _this4 = this;

			this.config.loading.id_ltcat = true;
			this.config.list.id_ltcat = [];

			this.get('/ltcat', { search: search }).then(function (result) {
				result = result[0];

				_this4.config.loading.id_ltcat = false;

				if (result.status == 200) {
					_this4.config.list.id_ltcat = _this4.formataRevisao(result.data.data);
				}
			});
		},
		getUltimaRevisao: function getUltimaRevisao() {
			var _this5 = this;

			if (!this.formData.id_emp || !this.formData.id_fdt) return;

			this.config.loading.data = true;
			this.ultima_revisao = null;

			this.get('/ltcat/ultima-revisao/' + this.formData.id_fdt).then(function (result) {
				result = result[0];

				_this5.config.loading.data = false;

				if (result.status == 200 && result.data) {
					_this5.ultima_revisao = result.data;
				}
				_this5.handlerValidarTipoRevisao();
			});
		},
		handlerValidarTipoRevisao: function handlerValidarTipoRevisao() {

			if (this.ultima_revisao) {
				var diff = this.diffDays(this.toDate(null, true, 'YYYY-MM-DD'), this.ultima_revisao.data, 'y');

				this.config.tipo_exclude = [2];
				this.formData.id_tipo_revisao = diff > 1 ? 4 : 3;
			} else {
				this.config.tipo_exclude = [3, 4];
				this.formData.id_tipo_revisao = 2;
			}
		},
		handlerDisableYesterdayDate: function handlerDisableYesterdayDate(date) {

			if (!this.ultima_revisao) return false;

			var hoje = this.ultima_revisao.parent ? this.ultima_revisao.parent.data : this.ultima_revisao.data;
			date = this.toDate(date, true, 'YYYY-MM-DD');

			return date < hoje;
		},
		salvar: function salvar() {
			var _this6 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('ltcat/cadastrar', this.formData).then(function (result) {

				result = result[0];

				_this6.config.loading.save = false;
				_this6.response = result;

				if (result.status == 200) {
					_this6.edMsg('Registro salvo com sucesso!');
					_this6.toRoute({ name: 'ltcat.editar', params: { id: result.data.id } });
				}
			});
		}
	}
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_conclusao_cadastrar__ = __webpack_require__(830);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		conclusao_tecnica: {
			type: Object,
			default: null
		},
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'conclusao_tecnica.id': function conclusao_tecnicaId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
			if (this.conclusao_tecnica.id != 0) {
				this.getConclusaoTecnica();
			}
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [92, 96, 100],
				hidden: {
					padrao: true
				},
				click: {
					id_esocial_procedimento: this.getEscocialTabela
				},
				loading: {
					save: false,
					content: false,
					id_esocial_procedimento: false
				},
				list: {
					id_esocial_procedimento: []
				}
			},
			formData: {
				id: 0,
				nome: null,
				descricao: null,
				updated_at: null,
				usuario: null,
				ativo: 1
			},
			response: {},
			exameItems: [],
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_conclusao_cadastrar__["a" /* default */];
	},


	methods: {
		init: function init() {
			this.formData = {
				id: 0,
				nome: null,
				descricao: null,
				updated_at: null,
				usuario: null,
				ativo: 1
			};
		},
		getConclusaoTecnica: function getConclusaoTecnica() {
			var _this = this;

			this.config.loading.content = true;
			this.formData = {};
			this.response = {};

			this.get('conclusao-tecnica/' + this.conclusao_tecnica.id).then(function (result) {

				result = result[0];

				_this.response = result;
				_this.config.loading.content = false;

				if (result.status == 200) {
					_this.formataData(result);
				}
			});
		},
		formataData: function formataData(result) {
			this.formData = {
				id: result.data.id,
				nome: result.data.nome,
				descricao: result.data.descricao,
				usuario: result.data.usuario,
				updated_at: result.data.updated_at,
				ativo: result.data.ativo
			};
		},
		salvar: function salvar() {
			var _this2 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('conclusao-tecnica/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Registro salvo com sucesso!');
					_this2.formataData(result);
					_this2.showFormEdit = !_this2.showFormEdit;

					if (_this2.parent.getConclusaoTecnica) _this2.parent.getConclusaoTecnica();
				}
			});
		}
	}
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Editar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			formData: {},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'CÓD'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'descricao',
				show_colapse: true,
				label: 'Descrição'
			}, {
				key: 'ativo',
				label: 'Ativo'
			}],
			tableData: [],
			loadingTable: false,
			showFormEdit: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getConclusaoTecnica();
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: 0,
				nome: null,
				descricao: null,
				usuario: null,
				updated_at: null
			};
		},

		onEdit: function onEdit(data) {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: data.id,
				nome: data.nome,
				descricao: data.descricao,
				usuario: data.usuario,
				updated_at: data.updated_at
			};
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				_this.post('/conclusao-tecnica/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getConclusaoTecnica();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getConclusaoTecnica: function getConclusaoTecnica(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('conclusao-tecnica', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'nome': data[i].nome,
							'descricao': data[i].descricao,
							'ativo': data[i].ativo == 1 ? 'Sim' : 'Não',
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(573),
								disable_edit: !_this2.validarPermissao(573)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
					_this2.loadingTable = false;
				}
			});
		}

	}
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modelo_index__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modelo_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modelo_index__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdAlert: __WEBPACK_IMPORTED_MODULE_0_common_alert___default.a, Conclusao: __WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index___default.a, Modelo: __WEBPACK_IMPORTED_MODULE_2__modelo_index___default.a },
	mixins: [],
	props: {},
	watch: {},
	data: function data() {
		return {
			tagConfig: 'tab-conclusao'

		};
	},
	created: function created() {},


	mounted: function mounted() {},
	methods: {}
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_conteudo_editar__ = __webpack_require__(831);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		modelo: {
			type: Object,
			default: null
		}
	},
	watch: {
		'modelo.id': function modeloId() {
			this.getModeloConteudo();
		},
		'formData.ocultar': function formDataOcultar() {
			this.config.disabled.fator_riscos = this.formData.ocultar == 0;
			this.config.disabled.ocultar_texto = this.formData.ocultar == 0;
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [],
				click: {
					fator_riscos: this.getFatorRisco
				},
				loading: {
					save: false,
					content: false,
					fator_riscos: false
				},
				disabled: {
					fator_riscos: true,
					ocultar_texto: true
				},
				list: {
					fator_riscos: []
				}
			},
			formData: {
				id: 0,
				titulo: null,
				ocultar: 0,
				ocultar_texto: null,
				updated_at: null,
				usuario: null,
				fator_riscos: []
			},
			response: {},
			pagination: {},
			tableHead: [{
				key: 'titulo',
				sortable: true,
				label: 'Título'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			conteudoItems: [],
			showFormEdit: false,
			tagConfig: 'tab-editar'
		};
	},
	mounted: function mounted() {
		this.getModeloConteudo();
		this.getFatorRisco();
		this.conteudoItems = __WEBPACK_IMPORTED_MODULE_4__form_conteudo_editar__["a" /* default */];
	},


	methods: {
		onEdit: function onEdit(data) {
			this.config.list.fator_riscos = [];
			this.tagConfig = 'tab-editar';

			this.formData = {
				id: data.id,
				titulo: data.titulo,
				ocultar: data.ocultar,
				ocultar_texto: data.ocultar_texto,
				updated_at: data.updated_at,
				usuario: data.usuario,
				fator_riscos: []
			};

			this.showFormEdit = !this.showFormEdit;

			for (var i = 0; i < data.fator_riscos.length; i++) {
				var element = data.fator_riscos[i];
				this.config.list.fator_riscos.push(element);
				this.formData.fator_riscos.push(element.id);
			}
		},
		getFatorRisco: function getFatorRisco(_search) {
			var _this = this;

			this.config.loading.fator_riscos = true;
			this.config.list.fator_riscos = [];

			this.get('fator-risco', { search: _search }).then(function (result) {

				result = result[0];

				_this.config.loading.fator_riscos = false;

				if (result.status == 200) {
					_this.config.list.fator_riscos = result.data.data;
				}
			});
		},


		getModeloConteudo: function getModeloConteudo(_search, _page, _pagination) {
			var _this2 = this;

			if (!this.modelo) return;

			_pagination = !_pagination ? 100 : _pagination;

			this.config.loading.content = true;
			this.response = {};

			this.get('ltcat/modelo/conteudo/' + this.modelo.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;

				_this2.config.loading.content = false;

				if (result.status == 200) {

					if (result.status == 200) {
						var data = result.data.data,
						    tableData = [],
						    pagination = result.data;

						for (var i = 0; i < data.length; i++) {

							var item = {
								'id': data[i].id,
								'titulo': data[i].tipo == 0 ? '***' : data[i].titulo,
								'updated_at': _this2.toDate(data[i].updated_at),
								_data: data[i],
								options: {
									disable_delete: !_this2.validarPermissao(569),
									disable_edit: !_this2.validarPermissao(569) || data[i].tipo != 0,
									style: 'color:' + (data[i].ocultar == 1 ? 'red' : '')
								},
								buttons: []
							};

							tableData.push(item);
						}

						console.log(pagination);
						_this2.pagination = pagination;
						_this2.tableData = tableData;
					}
				}
			});
		},

		salvar: function salvar() {
			var _this3 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('ltcat/modelo/conteudo/' + this.modelo.id + '/editar', this.toFormUpload(this.formData)).then(function (result) {

				result = result[0];

				_this3.config.loading.save = false;
				_this3.response = result;

				if (result.status == 200) {
					_this3.edMsg('Registro salvo com sucesso!');
					_this3.getModeloConteudo();
					_this3.showFormEdit = !_this3.showFormEdit;
				}
			});
		}
	}
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conteudo__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conteudo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__conteudo__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Conteudo: __WEBPACK_IMPORTED_MODULE_2__conteudo___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			tableData: [],
			tagConfig: '0',
			loadingContent: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getModelo();
	},

	methods: {

		getModelo: function getModelo(_search, _page, _pagination) {
			var _this = this;

			this.loadingContent = true;

			this.get('ltcat/modelo', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this.loadingContent = false;

				if (result.status == 200) {
					_this.tableData = result.data.data;
				}
			});
		}
	}
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_ltcat_editar__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ghe_index__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ghe_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ghe_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anexo_index__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anexo_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__anexo_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orcamento_index__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orcamento_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__orcamento_index__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat-risco-cadastrar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, LtcatGhe: __WEBPACK_IMPORTED_MODULE_5__ghe_index___default.a, LtcatAnexo: __WEBPACK_IMPORTED_MODULE_6__anexo_index___default.a, LtcatOrcamento: __WEBPACK_IMPORTED_MODULE_7__orcamento_index___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	watch: {
		'formData.id_emp': function formDataId_emp() {},
		'formData.id_fdt': function formDataId_fdt() {},
		'formData.id_rev': function formDataId_rev() {},
		'formData.id': function formDataId() {
			this.handlerDisableYesterdayDate();
			this.config.disabled.id_tipo_revisao = this.formData.id_tipo_revisao == 2;
		}
	},
	data: function data() {
		var _config, _formData;

		return {
			config: (_config = {
				tipo: [1, 203],
				tipo_exclude: [],
				hidden: {
					ppra: false,
					id_rev: true
				},
				title: {
					ppra: ''
				},
				disabled: {
					id_emp: true,
					id_fdt: true,
					id_tipo_ltcat: true,
					id_tipo_revisao: false,
					id_rev: true
				},
				click: {
					save: this.salvar,
					id_emp: this.getEmpresa,
					id_fdt: this.getFdt,
					id_rev: this.getRevisaoLtcat,
					id_res: this.getProfissionais,
					id_mod: this.getModelo
				},
				list: {
					id_emp: [],
					id_fdt: [],
					id_rev: [],
					id_res: [],
					id_mod: []
				},
				change: {
					id_rev: this.getLtcat
				},
				loading: {
					save: false,
					id_emp: false,
					id_fdt: false,
					id_rev: false,
					id_res: false,
					id_mod: false
				}
			}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'title', {
				id_emp: 'Editar Cadastro'
			}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'options', {
				data: {
					disabledDate: this.handlerDisableYesterdayDate
				}
			}), _config),
			formData: (_formData = {
				id: 0,
				id_tipo_revisao: null,
				id_emp: null,
				id_rev: null,
				id_fdt: null
			}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'id_rev', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'id_res', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'obs', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'data', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'usuario', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'empresa', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'ppra', 0), _formData),
			response: {},
			exameItems: [],
			tagConfig: 'tab-ghe'
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_4__form_ltcat_editar__["a" /* default */];
		this.getLtcat();
		this.getModelo();
	},


	methods: {
		gerarDocumento: function gerarDocumento() {
			if (this.formData.id == 0) return;

			if (!this.formData.id_mod) {
				this.edAlert('Selecione um modelo e o responsável pelo LTCAT', 'error');
				return;
			}

			window.open(this.env.url_cs + '/app/ltcat_gera.php?p=' + this.base64Encode(this.formData.id), 'blank');
		},
		getLtcat: function getLtcat(id) {
			var _this = this;

			this.config.loading.content = true;

			id = id ? id : this.$route.params.id;

			this.get('ltcat/' + id).then(function (result) {
				result = result[0];

				_this.config.loading.content = false;

				var revisao = '555';

				if (result.data.revisao) {
					revisao = (result.data.revisao.parent ? result.data.revisao.parent.rev + ' (' + result.data.revisao.parent.descricao + ' em ' + result.data.revisao.parent.descricao + ') / ' : '') + result.data.revisao.rev + ' (' + result.data.revisao.descricao + ' em ' + result.data.revisao.descricao + ')';
				}
				if (result.status == 200) {
					var _this$formData;

					_this.formData = (_this$formData = {
						id: result.data.id,
						id_rev: result.data.id,
						id_tipo_revisao: result.data.id_tipo_revisao,
						id_emp: result.data.empresa.id,
						id_fdt: result.data.fdt.id,
						id_res: result.data.responsavel ? result.data.responsavel.id : null,
						id_mod: result.data.modelo ? result.data.modelo.id : null,
						rev: result.data.rev,
						obs: result.data.obs,
						empresa: result.data.empresa,
						id_tipo_ltcat: result.data.id_tipo_ltcat
					}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, 'id_rev', revisao), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, 'revisao', result.data), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, 'data', _this.toDate(result.data.data, true)), _this$formData);

					_this.config.list.id_emp = [result.data.empresa];
					_this.$store.dispatch("ltcat/setLtcat", _this.formData);

					if (result.data.id_tipo_ltcat == 205) {
						_this.config.hidden.id_rev = false;
					}

					_this.getFdt();
					_this.getRevisaoLtcat();
					_this.getProfissionais();
				} else {
					_this.$router.push({ name: 'ltcat' });
				}
			});
		},
		getEmpresa: function getEmpresa() {

			if (!this.formData.id_emp) return;

			window.open(this.env.url_cs + 'app/empresas_info.php?abre=' + this.formData.id_emp, 'blank');
		},
		getModelo: function getModelo(search) {
			var _this2 = this;

			this.config.loading.id_mod = true;
			this.config.list.id_mod = [];

			this.get('/ltcat/modelo', { search: search }).then(function (result) {
				result = result[0];

				_this2.config.loading.id_mod = false;

				if (result.status == 200) {
					_this2.config.list.id_mod = result.data.data;
				}
			});
		},
		getProfissionais: function getProfissionais(search) {
			var _this3 = this;

			this.config.loading.id_res = true;
			this.config.list.id_res = [];

			this.formData.empresa.id_eng.push(0);
			this.formData.empresa.id_tec.push(0);

			var filter = {
				ids: [],
				profissionais: [0, 1, 2]
			};

			for (var index = 0; index < this.formData.empresa.id_eng.length; index++) {
				var element = this.formData.empresa.id_eng[index];
				filter.ids.push(element);
			}

			for (var _index = 0; _index < this.formData.empresa.id_med.length; _index++) {
				var _element = this.formData.empresa.id_med[_index];
				filter.ids.push(_element);
			}

			for (var _index2 = 0; _index2 < this.formData.empresa.id_tec.length; _index2++) {
				var _element2 = this.formData.empresa.id_tec[_index2];
				filter.ids.push(_element2);
			}

			console.log('asdf', filter);
			this.get('/profissionais/-1', { search: search, filter: filter }).then(function (result) {
				result = result[0];

				_this3.config.loading.id_res = false;

				if (result.status == 200) {
					_this3.config.list.id_res = result.data.data;
				}
			});
		},
		getFdt: function getFdt(search) {
			var _this4 = this;

			if (!this.formData.id_emp || this.config.list.id_fdt.length > 0) return;

			this.config.loading.id_fdt = true;
			this.config.list.id_fdt = [];

			this.get('/pcmso/fdt/' + this.formData.id_emp, { search: search }).then(function (result) {
				result = result[0];

				_this4.config.loading.id_fdt = false;

				if (result.status == 200) {
					_this4.config.list.id_fdt = result.data.data;
				}
			});
		},
		getRevisaoLtcat: function getRevisaoLtcat() {
			var _this5 = this;

			if (!this.formData.id_emp || !this.formData.id_fdt || this.config.list.id_rev.length > 0) return;

			this.config.loading.id_rev = true;
			this.config.list.id_rev = [];

			var filter = {
				id_empresa: this.formData.id_emp
			};

			this.get('/ltcat', { filter: filter }).then(function (result) {
				result = result[0];

				_this5.config.loading.id_rev = false;

				if (result.status == 200) {
					_this5.config.list.id_rev = _this5.formataRevisao(result.data.data);
				}
			});
		},
		handlerDisableYesterdayDate: function handlerDisableYesterdayDate(date) {

			if (this.config.list.id_rev.length == 0) return false;

			var primeira_revisao = this.config.list.id_rev[0];

			var hoje = primeira_revisao.parent ? primeira_revisao.parent.data : primeira_revisao.data;
			date = this.toDate(date, true, 'YYYY-MM-DD');

			return date < hoje;
		},
		salvar: function salvar() {
			var _this6 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('ltcat/editar', this.formData).then(function (result) {

				result = result[0];

				_this6.config.loading.save = false;
				_this6.response = result;

				if (result.status == 200) {
					_this6.edMsg('Registro salvo com sucesso!');
				}
			});
		}
	}
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_cadastrar__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcao__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__funcao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__medicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, Funcao: __WEBPACK_IMPORTED_MODULE_6__funcao___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, Medicao: __WEBPACK_IMPORTED_MODULE_7__medicao___default.a, ConclusaoTecnica: __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showFormCadastro": function parentShowFormCadastro() {
      this.showFormEdit = !this.showFormEdit;
      this.inicialize();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.inicialize();
    }
  },
  data: function data() {
    return {
      config: {
        click: {
          copiar: this.getGhe
        },
        loading: {
          save: false,
          config: false,
          copiar: false,
          content: false
        },
        list: {
          copiar: []
        }
      },
      response: {},
      formItems: [],
      formData: {
        id: 0,
        copiar: null,
        ghes: []
      },
      tagConfig: "tab-cadastro",
      title: null,
      showFormEdit: false,
      tableHead: [{
        key: "ordem",
        show_numeric: true,
        sortable: true,
        width: "200px",
        label: "Ordem"
      }, {
        key: "ghe",
        show_text: true,
        sortable: true,
        width: "200px",
        label: "GHE"
      }, {
        key: "descricao",
        show_text: true,
        sortable: true,
        label: "Descrição"
      }, {
        key: "buttons",
        label: "",
        width: "50px"
      }],
      tableData: []
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_cadastrar__["a" /* default */];
  },
  methods: {
    inicialize: function inicialize(formData) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, formData ? formData : this.parent.formData);

      this.tagConfig = "tab-cadastro";
      this.tableData = [];
      this.getGhe();
    },
    onRegister: function onRegister() {
      var ordem = this.tableData.length + 1,
          ghe = this.tableData.length + 1;

      if (this.tableData.length == 0 && this.config.list.copiar.length > 0) {
        var _data = this.config.list.copiar[this.config.list.copiar.length - 1];

        ordem = _data.ordem + 1;
        ghe = _data.ordem + 1;
      } else {
        var _data = this.tableData[this.tableData.length - 1];

        if (_data) {
          ordem = _data.ordem + 1;
          ghe = _data.ordem + 1;
        } else {
          ordem = 1;
          ghe = 1;
        }
      }

      var data = {
        id: 0,
        ordem: ordem,
        ghe: ghe,
        descricao: null
      };

      this.tableData.push({
        id: 0,
        ordem: data.ordem,
        ghe: data.ghe,
        descricao: null,
        _data: data
      });
    },
    onDelete: function onDelete(item) {
      this.tableData.splice(item.index, 1);
    },
    onClose: function onClose() {
      this.parent.getLtcat();
    },
    getGhe: function getGhe(_search) {
      var _this = this;

      this.config.loading.copiar = true;
      this.config.list.copiar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this.config.loading.copiar = false;

        if (result.status == 200) {
          _this.config.list.copiar = result.data.data;
        }

        if (_this.tableData.length == 0) _this.onRegister();
      });
    },
    formatData: function formatData() {
      this.formData.ghes = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var element = this.tableData[i];
        this.formData.ghes.push(element._data);
      }
    },
    salvar: function salvar() {
      var _this2 = this;

      this.formatData();

      this.config.loading.save = true;
      this.response = {};

      this.post("/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/cadastrar", this.formData).then(function (result) {
        result = result[0];

        _this2.config.loading.save = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg("Dados atualizados");
          _this2.showFormEdit = !_this2.showFormEdit;
          _this2.parent.getLtcat();
        }
      });
    }
  }
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_conclusao_cadastrar__ = __webpack_require__(833);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat.ghe.funcao",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		ltcat: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.formData.id': function parentFormDataId() {
			this.getLtcatConclusaoTecnica();
			this.getGhe();
		},
		'$store.state.ltcat.data.id': function $storeStateLtcatDataId() {
			this.getGhe();
		},
		'formData.id_fun': function formDataId_fun() {
			this.config.disabled.cbo = this.formData.id_fun ? false : true;
			this.config.disabled.descricao = this.formData.id_fun ? false : true;

			var funcao = this.arrFindByField(this.config.list.id_fun, 'id', this.formData.id_fun);

			if (funcao) {
				this.formData.cbo = funcao.cbo;
				this.formData.descricao = funcao.descricao;
			}
		},
		'formData.id_con_tec': function formDataId_con_tec() {
			if (this.formData.id_con_tec) {
				this.formData.nome = this.formData.id_con_tec.nome;
				this.formData.descricao = this.formData.id_con_tec.descricao;
			}
		}
	},
	data: function data() {
		return {
			config: {
				click: {
					id_con_tec: this.getConclusaoTecnica,
					replicar: this.getGhe
				},
				loading: {
					save: false,
					content: false,
					id_con_tec: false,
					replicar: false
				},
				list: {
					id_con_tec: [],
					replicar: []
				},
				disabled: {
					id_con_tec: false
				},
				hidden: {
					id_con_tec: false,
					inserir: false
				},
				title: {
					equipamentos_insert: 'Inserir Equipamento',
					replicar_subs: 'Sobrescrever medição caso existir'
				},
				description: {
					replicar_subs: 'Se habilitar esse campo, o sistema vai excluir as medições existentes nos GHE selecionados e inserir novamente baseado nessa medição.'
				}
			},
			pagination: {},
			response: {},
			formData: {
				id: 0,
				id_ghe: this.parent.formData.id,
				id_con_tec: null,
				nome: null,
				descricao: null,
				usuario: null,
				updated_at: null,
				replicar: [],
				replicar_subs: 0
			},
			formItems: [],
			tableHead: [{
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'descricao',
				sortable: true,
				show_colapse: true,
				label: 'Descrição'
			}, {
				key: 'updated_at',
				width: '180px',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: true,
			showFormEdit: false
		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},
	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_conclusao_cadastrar__["a" /* default */];
		this.getLtcatConclusaoTecnica();
		this.getConclusaoTecnica();
		this.getGhe();
	},


	methods: {

		onRegister: function onRegister() {
			this.formData = {
				id: 0,
				id_ghe: this.parent.formData.id,
				id_con_tec: null,
				nome: null,
				descricao: null,
				usuario: null,
				inserir: 1,
				updated_at: null,
				replicar: [],
				replicar_subs: 0
			};
			this.config.hidden.id_con_tec = false;
			this.config.hidden.inserir = false;
			this.showFormEdit = !this.showFormEdit;
		},

		onEdit: function onEdit(data) {
			var _this = this;

			this.showFormEdit = !this.showFormEdit;
			this.config.loading.content = true;
			this.config.hidden.id_con_tec = true;
			this.config.hidden.inserir = true;

			this.get('ltcat/ghe/conclusao-tecnica/' + this.parent.formData.id + '/' + data.id).then(function (result) {

				result = result[0];
				_this.response = result;
				_this.config.loading.content = false;

				if (result.status == 200) {
					_this.formData = {
						id: data.id,
						id_ghe: _this.parent.formData.id,
						id_con_tec: null,
						nome: data.nome,
						descricao: data.descricao,
						usuario: data.usuario,
						updated_at: data.updated_at,
						inserir: 0,
						replicar: [],
						replicar_subs: 0
					};
				}
			});
		},

		onDelete: function onDelete(data) {
			var _this2 = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;
				self.loadingTable = true;

				_this2.post('/ltcat/ghe/conclusao-tecnica/' + _this2.parent.formData.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {
						self.getLtcatConclusaoTecnica();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getGhe: function getGhe(_search) {
			var _this3 = this;

			if (!this.$store.state.ltcat.data) return;

			this.config.loading.replicar = true;
			this.config.list.replicar = [];

			this.get('ltcat/ghe/' + this.$store.state.ltcat.data.id, { search: _search }).then(function (result) {

				result = result[0];
				_this3.config.loading.replicar = false;

				if (result.status == 200) {

					var data = result.data.data;

					for (var i = 0; i < data.length; i++) {
						var element = data[i];
						if (element.id != _this3.parent.formData.id) {
							_this3.config.list.replicar.push(element);
						}
					}
				}
			});
		},

		getConclusaoTecnica: function getConclusaoTecnica(_search) {
			var _this4 = this;

			this.config.loading.id_con_tec = true;
			this.config.list.id_con_tec = [];

			this.get('conclusao-tecnica', { search: _search }).then(function (result) {

				result = result[0];

				_this4.config.loading.id_con_tec = false;

				if (result.status == 200) {
					_this4.config.list.id_con_tec = result.data.data;
				}
			});
		},

		getLtcatConclusaoTecnica: function getLtcatConclusaoTecnica(_search, _page, _pagination) {
			var _this5 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('ltcat/ghe/conclusao-tecnica/' + this.parent.formData.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this5.response = result;
				_this5.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this5,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'nome': data[i].nome,
							'descricao': data[i].descricao,
							'updated_at': _this5.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								disable_delete: !_this5.validarPermissao(567),
								disable_edit: !_this5.validarPermissao(567)
							},
							buttons: []
						};
						tableData.push(item);
					}

					_this5.pagination = pagination;
					_this5.tableData = tableData;
				}
			});
		},

		salvar: function salvar() {
			var _this6 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/ghe/conclusao-tecnica/' + this.parent.formData.id + '/editar', this.formData).then(function (result) {

				result = result[0];

				_this6.config.loading.save = false;
				_this6.response = result;

				if (result.status == 200) {
					_this6.edMsg('Dados atualizados');
					_this6.showFormEdit = !_this6.showFormEdit;
					_this6.getLtcatConclusaoTecnica();
					_this6.getConclusaoTecnica();
				}
			});
		}
	}
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_ltcat_ghe_editar__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funcao__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funcao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__funcao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcionario__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcionario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__funcionario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__medicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a,
    Funcao: __WEBPACK_IMPORTED_MODULE_5__funcao___default.a,
    Funcionario: __WEBPACK_IMPORTED_MODULE_6__funcionario___default.a,
    Medicao: __WEBPACK_IMPORTED_MODULE_7__medicao___default.a,
    ConclusaoTecnica: __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showFormEdit": function parentShowFormEdit() {
      this.showFormEdit = !this.showFormEdit;
      this.inicialize();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.inicialize();
    }
  },
  data: function data() {
    return {
      config: {
        click: {
          copiar: this.getGhe
        },
        loading: {
          save: false,
          config: false,
          copiar: false
        },
        list: {
          copiar: []
        }
      },
      response: {},
      formItems: [],
      formData: {
        id: 0,
        ordem: 1,
        ghe: null,
        descricao: null,
        obs: null,
        copiar: null,
        updated_at: null,
        usuario: null,
        ordenar: 0,
        funcoes: [],
        medicoes: [],
        conclusoes: [],
        funcionarios: []
      },
      tagConfig: "tab-cadastro",
      title: null,
      showFormEdit: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_ltcat_ghe_editar__["a" /* default */];
  },

  methods: {
    inicialize: function inicialize(formData) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, formData ? formData : this.parent.formData);
      this.tagConfig = "tab-cadastro";
      this.getGhe();
    },
    onClose: function onClose() {
      this.parent.getLtcat();
    },
    getGhe: function getGhe(_search) {
      var _this = this;

      this.config.loading.copiar = true;
      this.config.list.copiar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this.config.loading.copiar = false;

        if (result.status == 200) {
          _this.config.list.copiar = result.data.data;
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/editar", this.formData).then(function (result) {
        result = result[0];

        _this2.config.loading.save = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg("Dados atualizados");
          _this2.inicialize(result.data);
          _this2.parent.getLtcat();
        }
      });
    }
  }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_funcao_cadastrar__ = __webpack_require__(835);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat.ghe.funcao",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    },
    ltcat: {
      type: Object,
      default: null
    }
  },
  computed: {
    event: {
      cache: false,
      get: function get() {
        return this.$store.state.common.event;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEvent", value);
      }
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.getLtcatFuncao();
      this.getGhe();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.getGhe();
    },
    "formData.id_fun": function formDataId_fun() {
      this.config.disabled.cbo = this.formData.id_fun ? false : true;
      this.config.disabled.descricao = this.formData.id_fun ? false : true;

      var funcao = this.arrFindByField(this.config.list.id_fun, "id", this.formData.id_fun);

      if (funcao) {
        this.formData.cbo = funcao.cbo;
        this.formData.descricao = funcao.descricao;
      }
    }
  },
  data: function data() {
    return {
      config: {
        click: {
          id_fun: this.getFuncao,
          replicar: this.getGhe
        },
        loading: {
          save: false,
          content: false,
          id_fun: false,
          replicar: false
        },
        list: {
          id_fun: [],
          replicar: []
        },
        disabled: {
          cbo: true,
          descricao: true,
          id_fun: false
        },
        title: {
          equipamentos_insert: "Inserir Equipamento",
          replicar_subs: "Sobrescrever medição caso existir"
        },
        description: {
          replicar_subs: "Se habilitar esse campo, o sistema vai excluir as medições existentes nos GHE selecionados e inserir novamente baseado nessa medição."
        }
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_fun: null,
        cbo: null,
        descricao: null,
        usuario: null,
        updated_at: null,
        replicar: [],
        replicar_subs: 0
      },
      formItems: [],
      tableHead: [{
        key: "cbo",
        sortable: true,
        width: "80px",
        label: "CBO"
      }, {
        key: "funcao",
        sortable: true,
        label: "Função"
      }, {
        key: "descricao",
        sortable: true,
        show_colapse: true,
        label: "Descrição"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_funcao_cadastrar__["a" /* default */];
    this.getLtcatFuncao();
    this.getGhe();
  },


  methods: {
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_fun: null,
        cbo: null,
        descricao: null,
        usuario: null,
        updated_at: null,
        replicar: [],
        replicar_subs: 0
      };
      this.config.disabled.id_fun = false;
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function onEdit(data) {
      var _this = this;

      this.showFormEdit = !this.showFormEdit;
      this.config.loading.content = true;
      this.config.disabled.id_fun = true;
      this.config.list.id_fun = [];

      this.get("ltcat/ghe/funcao/" + this.parent.formData.id + "/" + data.id).then(function (result) {
        result = result[0];
        _this.response = result;
        _this.config.loading.content = false;

        if (result.status == 200) {
          _this.formData = {
            id: data.id,
            id_ghe: _this.parent.formData.id,
            id_fun: data.funcao.id,
            cbo: data.cbo,
            descricao: data.descricao,
            usuario: data.usuario,
            updated_at: data.updated_at,
            replicar: [],
            replicar_subs: 0
          };
          _this.config.list.id_fun.push(data.funcao);
        }
      });
    },

    onDelete: function onDelete(data) {
      var _this2 = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this2.post("/ltcat/ghe/funcao/" + _this2.parent.formData.id + "/deletar", {
          ids: data
        }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatFuncao();
            self.edMsg("Registo excluido com sucesso");
            self.event = new Date().getTime() + "-funcoes-save";
          }
        });
      });
    },

    getGhe: function getGhe(_search) {
      var _this3 = this;

      if (!this.$store.state.ltcat.data) return;

      this.config.loading.replicar = true;
      this.config.list.replicar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this3.config.loading.replicar = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (var i = 0; i < data.length; i++) {
            var element = data[i];
            if (element.id != _this3.parent.formData.id) {
              _this3.config.list.replicar.push(element);
            }
          }
        }
      });
    },

    getFuncao: function getFuncao(_search) {
      var _this4 = this;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("funcao", { search: _search }).then(function (result) {
        result = result[0];

        _this4.config.loading.id_fun = false;

        if (result.status == 200) {
          _this4.config.list.id_fun = result.data.data;
        }
      });
    },

    getLtcatFuncao: function getLtcatFuncao(_search, _page, _pagination) {
      var _this5 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("ltcat/ghe/funcao/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this5.response = result;
        _this5.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this5,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              funcao: data[i].funcao.nome,
              cbo: data[i].cbo,
              descricao: data[i].descricao,
              updated_at: _this5.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this5.validarPermissao(567),
                disable_edit: !_this5.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this5.pagination = pagination;
          _this5.tableData = tableData;
        }
      });
    },
    salvar: function salvar() {
      var _this6 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("/ltcat/ghe/funcao/" + this.parent.formData.id + "/editar", this.formData).then(function (result) {
        result = result[0];

        _this6.config.loading.save = false;
        _this6.response = result;

        if (result.status == 200) {
          _this6.edMsg("Dados atualizados");
          _this6.showFormEdit = !_this6.showFormEdit;
          _this6.getLtcatFuncao();
          _this6.event = new Date().getTime() + "-funcoes-save";
        }
      });
    }
  }
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat.ghe.funcao",
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdForm */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputAutoComplete */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputText */],
    EdInputTextArea: __WEBPACK_IMPORTED_MODULE_2_template__["j" /* EdInputTextArea */]
  },
  mixins: [],
  props: {
    parent: {
      type: Object,
      default: null
    },
    ltcat: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.getLtcatFuncionario();
      this.getFuncionario();
      this.getLtcatFuncao();
    },
    "parent.formData.funcoes": function parentFormDataFuncoes() {},
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {},
    "$store.state.common.event": function $storeStateCommonEvent() {
      this.getLtcatFuncao();
    }
  },
  data: function data() {
    return {
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_funcionario: null,
        descricao: null,
        usuario: null,
        updated_at: null
      },
      tableHead: [{
        key: "cpf",
        sortable: true,
        width: "80px",
        label: "CPF"
      }, {
        key: "nome",
        sortable: true,
        label: "Nome"
      }, {
        key: "funcao",
        sortable: true,
        label: "Função"
      }, {
        key: "descricao",
        sortable: true,
        show_colapse: true,
        label: "Descrição Atividades"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      funcionario: null,
      lstFuncionario: [],
      lstFuncoes: [],
      loadingFuncionario: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcatFuncionario();
    this.getLtcatFuncao();
    this.getFuncionario();
  },


  methods: {
    setFuncionario: function setFuncionario() {
      if (this.lstFuncoes) {
        var self = this;
        var funcionario = this.lstFuncionario.find(function (c) {
          return c.id == self.formData.id_funcionario;
        });
        var funcao = this.lstFuncoes.find(function (c) {
          return c.funcao && funcionario && c.funcao.id == funcionario.id_funcao;
        });

        if (funcao && funcao.descricao) {
          this.formData.descricao = funcao.descricao;
        } else if (funcionario && funcionario.funcao) {
          this.formData.descricao = funcionario.funcao.descricao;
        } else {
          this.formData.descricao = null;
        }
      }
    },
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_funcionario: null,
        descricao: null,
        usuario: null,
        updated_at: null
      };
      this.showFormEdit = !this.showFormEdit;
    },
    onEdit: function onEdit(data) {
      this.formData = {
        id: data.id,
        id_ghe: this.parent.formData.id,
        id_funcionario: data.funcionario.id,
        funcionario: data.funcionario,
        descricao: data.descricao,
        usuario: data.usuario,
        updated_at: data.updated_at
      };

      console.log("formData", this.formData);
      this.showFormEdit = !this.showFormEdit;
    },


    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this.$root.$request.post("/ltcat/ghe/funcionario/" + _this.parent.formData.id + "/deletar", {
          ids: data
        }).then(function (result) {
          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatFuncionario();
            self.$root.$dialog.alert("Registo excluido com sucesso");
          }
        });
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.$root.$request.get("/empresa/funcionario/" + this.ltcat.id_emp, { search: _search }).then(function (result) {
        _this2.loadingFuncionario = false;
        if (result.status == 200) {
          _this2.lstFuncionario = result.data.data;
        }
      });
    },
    getLtcatFuncionario: function getLtcatFuncionario(_search, _page, _pagination) {
      var _this3 = this;

      this.loadingTable = true;
      this.response = {};

      this.$root.$request.get("ltcat/ghe/funcionario/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        _this3.response = result;
        _this3.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this3,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              cpf: data[i].funcionario.cpf,
              nome: data[i].funcionario.nome,
              funcao: data[i].funcionario.funcao ? data[i].funcionario.funcao.nome : "",
              descricao: data[i].descricao,
              updated_at: _this3.$utilidade.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this3.$root.$session.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this3.pagination = pagination;
          _this3.tableData = tableData;
        }
      });
    },
    getLtcatFuncao: function getLtcatFuncao() {
      var _this4 = this;

      this.lstFuncoes = [];
      this.$root.$request.get("ltcat/ghe/funcao/" + this.parent.formData.id).then(function (result) {
        if (result.status == 200) {
          _this4.lstFuncoes = result.data.data;
        }
      });
    },
    salvar: function salvar() {
      var _this5 = this;

      this.$root.$loading.set(true);
      this.response = {};

      this.$root.$request.post("/ltcat/ghe/funcionario/" + this.parent.formData.id + "/editar", this.formData).then(function (result) {
        _this5.$root.$loading.set(false);
        _this5.response = result;

        if (result.status == 200) {
          _this5.$root.$dialog.alert("Dados atualizados");
          _this5.showFormEdit = !_this5.showFormEdit;
          _this5.getLtcatFuncionario();
        }
      });
    }
  }
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editar__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastrar__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastrar__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Editar: __WEBPACK_IMPORTED_MODULE_3__editar___default.a, Cadastrar: __WEBPACK_IMPORTED_MODULE_4__cadastrar___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    ltcat: {
      type: Object,
      default: null
    }
  },
  watch: {
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.getLtcat();
    },
    "$store.state.common.event": function $storeStateCommonEvent() {
      this.getLtcat();
    }
  },
  data: function data() {
    return {
      pagination: {},
      response: {},
      formData: {},
      tableHead: [{
        key: "ordem",
        width: "50px",
        sortable: true,
        show_fdt: true,
        label: "Ordem"
      }, {
        key: "ghe",
        sortable: true,
        show_fdt: true,
        label: "GHE (Setor)"
      }, {
        key: "medicoes",
        sortable: true,
        show_colapse: true,
        label: "Medições"
      }, {
        key: "funcoes",
        sortable: true,
        show_colapse: true,
        label: "Funções"
      }, {
        key: "funcionarios",
        sortable: true,
        show_colapse: true,
        label: "Funcionários"
      }, {
        key: "conclusoes",
        sortable: true,
        show_colapse: true,
        label: "Conclusão Técnica"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      showFormCadastro: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
    this.formData = {};
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcat();
  },


  methods: {
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        copiar: null,
        ghes: []
      };
      this.showFormCadastro = !this.showFormCadastro;
    },
    onEdit: function onEdit(data) {
      this.formData = {
        id: data.id,
        ordem: data.ordem,
        ghe: data.ghe,
        descricao: data.descricao,
        copiar: null,
        updated_at: data.updated_at,
        usuario: data.usuario,
        funcoes: data.funcoes,
        medicoes: data.medicoes,
        conclusoes: data.conclusoes,
        funcionarios: data.funcionarios,
        obs: data.obs,
        ordenar: 0
      };
      this.showFormEdit = !this.showFormEdit;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this.post("/ltcat/ghe/" + _this.$store.state.ltcat.data.id + "/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcat();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },
    getLtcat: function getLtcat(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this2.response = result;
        _this2.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this2,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var funcoes = "",
                funcionarios = "",
                medicoes = "",
                conclusoes = "";

            for (var j = 0; j < data[i].funcoes.length; j++) {
              var element = data[i].funcoes[j];
              funcoes += "<li>" + element.funcao.nome + "</li><br>";
            }

            for (var _j = 0; _j < data[i].funcionarios.length; _j++) {
              var _element = data[i].funcionarios[_j];
              funcionarios += "<li>" + _element.funcionario.nome + "</li><br>";
            }

            for (var _j2 = 0; _j2 < data[i].medicoes.length; _j2++) {
              var _element2 = data[i].medicoes[_j2];
              medicoes += "<li>" + (_element2.data_medicao ? _this2.toDate(_element2.data_medicao, true) + ": " : "") + _element2.fator_risco.nome + "</li><br>";
            }

            for (var _j3 = 0; _j3 < data[i].conclusoes.length; _j3++) {
              var _element3 = data[i].conclusoes[_j3];
              conclusoes += "<li>" + _element3.nome + "<br>" + _element3.descricao + "</li><br>";
            }

            var item = {
              ordem: data[i].ordem,
              ghe: data[i].ghe + " (" + data[i].descricao + ")",
              funcoes: funcoes,
              funcionarios: funcionarios,
              conclusoes: conclusoes,
              medicoes: medicoes,
              obs: data[i].obs ? data[i].obs.replace(/(?:\r\n|\r|\n)/g, "<br>") : "",
              updated_at: _this2.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this2.validarPermissao(567),
                disable_edit: !_this2.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_template__ = __webpack_require__(27);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat.ghe.medicao",
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_5_template__["e" /* EdAlert */],
    EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_5_template__["b" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a,
    EdInputText: __WEBPACK_IMPORTED_MODULE_5_template__["f" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_5_template__["g" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_5_template__["h" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_5_template__["c" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_5_template__["i" /* EdInputSelectTipo */],
    EdInputSwitch: __WEBPACK_IMPORTED_MODULE_5_template__["l" /* EdInputSwitch */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    },
    ltcat: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.getLtcatRisco();
      this.getGhe();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.getGhe();
    },
    "formData.id_age": function formDataId_age() {
      if (this.formData.id_age && this.formData.id_age.tabela) {
        this.formData.id_tab = this.formData.id_age.tabela;
      } else if (this.formData.id == 0) {
        this.getTabelaDinamicaColuna();
      }
    },
    "formData.id_tab": function formDataId_tab() {
      this.getTabelaDinamicaColuna();
    }
  },
  data: function data() {
    return {
      config: {
        loading: {
          save: false,
          content: false,
          id_age: false,
          id_tab: false,
          lancamentos: false,
          equipamentos: false,
          replicar: false,
          aposentadoria_especial: false,
          periculosidade: false,
          insalubridade: false,
          epi: false
        },
        list: {
          id_age: [],
          id_tab: [],
          lancamentos: [],
          equipamentos: [],
          replicar: [],
          aposentadoria_especial: [],
          periculosidade: [],
          insalubridade: [],
          epi: [],
          utilizEPC: [{ id: 0, nome: 'Não se aplica' }, { id: 1, nome: 'Não implementa' }, { id: 2, nome: 'Implementa' }]
        }
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: null,
        id_age: null,
        id_tab: null,
        usuario: null,
        updated_at: null,
        epi: null,
        aposentadoria_especial: 0,
        periculosidade: 0,
        insalubridade: 0,
        obs: null,
        data_medicao: null,
        replicar: [],
        replicar_subs: 0,
        amostragem: 1,
        fator_riscos: [],
        equipamentos: []
      },
      formItems: [],
      tableHead: [{
        key: "risco",
        sortable: true,
        label: "Fator de Risco"
      }, {
        key: "amostragem",
        sortable: true,
        label: "Nº Amostragem"
      }, {
        key: "data_medicao",
        sortable: true,
        label: "Data Medição"
      }, {
        key: "obs",
        sortable: true,
        label: "Observações"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      showFormEquipamento: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcatRisco();
    this.getFatorRisco();
    this.getTabelaDinamica();
    this.getEquipamento();
    this.getGhe();
    this.getAposentadoriaEspecial();
    this.getPericulosidade();
    this.getInsalubridade();
  },


  methods: {
    getAposentadoriaEspecial: function getAposentadoriaEspecial() {
      this.config.list.aposentadoria_especial = [{ id: '0', nome: 'Não' }, { id: '1', nome: 'Sim' }];
    },
    getPericulosidade: function getPericulosidade() {
      this.config.list.periculosidade = [{ id: 0, nome: 'Não' }, { id: 1, nome: 'Sim' }];
    },
    getInsalubridade: function getInsalubridade() {
      this.config.list.insalubridade = [{ id: 0, nome: 'Não' }, { id: 1, nome: 'Sim' }];
    },
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_age: null,
        id_tab: null,
        usuario: null,
        updated_at: null,
        epi: null,
        aposentadoria_especial: 0,
        periculosidade: 0,
        insalubridade: 0,
        obs: null,
        data_medicao: this.toDate(),
        lancamentos: [],
        equipamentos: [],
        replicar: [],
        replicar_subs: 0,
        amostragem: 1,
        utilizEPC: 0,
        utilizEPI: 0,
        eficEpi: 1,
        eficEpc: 1
      };
      this.showFormEdit = !this.showFormEdit;
    },
    removeEPI: function removeEPI(index) {
      this.formData.equipamentos.splice(index, 1);
    },
    addEPI: function addEPI() {
      var _this = this;

      if (!this.formData.equipamentos) {
        this.formData.equipamentos = [];
      }

      if (this.formData.epi && this.formData.equipamentos.findIndex(function (x) {
        return x.id_epi == _this.formData.epi.id;
      }) == -1) {

        var equipamento = {
          id_ghe_med: this.formData.id,
          id_epi: this.formData.epi.id,
          epi: this.formData.epi,
          medProtecao: 1,
          condFuncto: 1,
          usoInint: 1,
          przValid: 1,
          periodicTroca: 1,
          higienizacao: 1
        };

        this.formData.equipamentos.push(equipamento);
      }

      this.formData.epi = null;

      console.log('formData', this.formData);
    },
    onEdit: function onEdit(data) {
      var _this2 = this;

      this.$root.$loading.set(true, "Carregando medição");

      this.config.loading.lancamentos = true;
      this.showFormEdit = !this.showFormEdit;
      this.config.list.id_age = [];
      this.config.list.equipamentos = [];
      this.response = {};

      this.get("/ltcat/ghe/medicao/" + this.parent.formData.id + "/" + data.id).then(function (result) {
        result = result[0];

        _this2.response = result;

        if (result.status == 200) {
          _this2.formData = {
            id: result.data.id,
            id_ghe: _this2.parent.formData.id,
            id_age: result.data.fator_risco,
            id_tab: result.data.tabela,
            usuario: result.data.usuario,
            tabela: result.data.tabela,
            updated_at: result.data.updated_at,
            obs: result.data.obs,
            data_medicao: result.data.data_medicao,
            lancamentos: result.data.lancamentos,
            amostragem: result.data.amostragem,
            epi: null,
            aposentadoria_especial: !result.data.aposentadoria_especial ? 0 : parseInt(result.data.aposentadoria_especial),
            periculosidade: !result.data.periculosidade ? 0 : parseInt(result.data.periculosidade),
            insalubridade: !result.data.insalubridade ? 0 : parseInt(result.data.insalubridade),
            utilizEPC: !result.data.utilizEPC ? 0 : parseInt(result.data.utilizEPC),
            utilizEPI: !result.data.utilizEPI ? 0 : parseInt(result.data.utilizEPI),
            eficEpi: !result.data.eficEpi ? 0 : parseInt(result.data.eficEpi),
            eficEpc: !result.data.eficEpc ? 0 : parseInt(result.data.eficEpc),
            equipamentos: result.data.equipamentos,
            replicar: [],
            replicar_subs: 0
          };

          _this2.config.list.id_age.push(data.fator_risco);
        }

        _this2.config.loading.lancamentos = false;
        _this2.$root.$loading.set(false);
      });
    },
    onInserirLinha: function onInserirLinha(coluna, i) {
      for (var _i = 0; _i < coluna.tabela_valores.length; _i++) {
        var element = coluna.tabela_valores[_i];

        element.linhas.push({
          id: element.id,
          id_tab_col: element.id_tab_col,
          id_tipo_campo: element.id_tipo_campo,
          tipo_campo: element.tipo_campo,
          nome: null,
          ordem: element.linhas.length + 1,
          unidade: element.unidade,
          padrao: element.padrao,
          ativo: element.ativo
        });
      }
    },
    onDeleteLinha: function onDeleteLinha(coluna, index) {
      if (index == 0) return;

      for (var i = 0; i < coluna.tabela_valores.length; i++) {
        var element = coluna.tabela_valores[i];

        if (element.linhas.length > 1) {
          element.linhas.splice(index, 1);
        }
      }
    },
    onInserirEquipamento: function onInserirEquipamento() {
      this.showFormEquipamento = !this.showFormEquipamento;
    },
    onDelete: function onDelete(data) {
      var _this3 = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this3.post("/ltcat/ghe/medicao/" + _this3.parent.formData.id + "/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatRisco();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },


    getGhe: function getGhe(_search) {
      var _this4 = this;

      if (!this.$store.state.ltcat.data) return;

      this.config.loading.replicar = true;
      this.config.list.replicar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this4.config.loading.replicar = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (var i = 0; i < data.length; i++) {
            var element = data[i];
            if (element.id != _this4.parent.formData.id) {
              element.nome = element.ghe + ' (' + element.descricao + ')';
              _this4.config.list.replicar.push(element);
            }
          }
        }
      });
    },

    getEquipamento: function getEquipamento(_search) {
      var _this5 = this;

      this.config.loading.epi = true;
      this.config.list.epi = [];

      this.get("epi", { search: _search }).then(function (result) {
        result = result[0];
        _this5.config.loading.epi = false;

        if (result.status == 200) {
          _this5.config.list.epi = result.data.data;
        }
      });
    },

    getFatorRisco: function getFatorRisco(_search) {
      var _this6 = this;

      console.log('asdf', _search);
      this.config.loading.id_age = true;
      this.config.list.id_age = [];

      this.get("fator-risco", { search: _search }).then(function (result) {
        result = result[0];

        _this6.config.loading.id_age = false;

        if (result.status == 200) {
          _this6.config.list.id_age = result.data.data;
        }
      });
    },
    getTabelaDinamica: function getTabelaDinamica(_search) {
      var _this7 = this;

      this.config.loading.id_tab = true;
      this.config.list.id_tab = [];

      this.get("/ltcat/tabela-dinamica", { search: _search }).then(function (result) {
        result = result[0];

        _this7.config.loading.id_tab = false;

        if (result.status == 200) {
          _this7.config.list.id_tab = result.data.data;
        }
      });
    },
    getTabelaDinamicaColuna: function getTabelaDinamicaColuna() {
      var _this8 = this;

      if (!this.formData.id_tab) return;

      this.config.loading.lancamentos = true;
      this.config.list.lancamentos = [];
      this.response = {};
      var filter = {
        id_ghe_med: this.formData.id
      };

      this.get("/ltcat/tabela-dinamica/coluna/" + this.formData.id_tab.id, {
        filter: filter
      }).then(function (result) {
        result = result[0];
        _this8.response = result;

        _this8.config.loading.lancamentos = false;

        if (result.status == 200) {
          var data = result.data.data,
              coluna = null,
              tabela_valor = null,
              lancamento = null,
              item = null;

          for (var i = 0; i < data.length; i++) {
            coluna = data[i];

            if (!coluna.valor && _this8.formData.id_age && coluna.tipo_vinculo) {
              coluna.valor = _this8.formData.id_age[coluna.tipo_vinculo.valor];
            }

            for (var j = 0; j < coluna.tabela_valores.length; j++) {
              tabela_valor = coluna.tabela_valores[j];
            }

            _this8.config.list.lancamentos.push(coluna);
          }

          data = null;
          coluna = null;
          tabela_valor = null;
          lancamento = null;
          item = null;
        }
      });
    },
    getLtcatRisco: function getLtcatRisco(_search, _page, _pagination) {
      var _this9 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("/ltcat/ghe/medicao/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this9.response = result;
        _this9.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this9,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              data_medicao: data[i].data_medicao ? _this9.toDate(data[i].data_medicao, true) : "---",
              obs: data[i].obs ? data[i].obs : "---",
              risco: data[i].fator_risco.nome,
              amostragem: data[i].amostragem,
              updated_at: _this9.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this9.validarPermissao(567),
                disable_edit: !_this9.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this9.pagination = pagination;
          _this9.tableData = tableData;
        }
      });
    },
    showCategoria: function showCategoria(coluna, i) {
      var tabela_categoria = coluna.tabela_categoria,
          coluna_anterior = this.config.list.lancamentos[i - 1];

      if (!tabela_categoria || !coluna_anterior) return true;else if (coluna_anterior && !coluna_anterior.tabela_categoria) return true;else if (coluna.tabela_categoria.id != coluna_anterior.tabela_categoria.id) return true;else return false;
    },
    salvar: function salvar() {
      var _this10 = this;

      this.config.loading.save = true;
      this.response = {};

      this.formData.lancamentos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.config.list.lancamentos);

      this.$root.$request.post("/ltcat/ghe/medicao/" + this.parent.formData.id + "/editar", this.formData).then(function (result) {

        _this10.config.loading.save = false;
        _this10.response = result;

        if (result.status == 200) {
          _this10.edMsg("Dados atualizados");
          _this10.showFormEdit = !_this10.showFormEdit;
          _this10.getLtcatRisco();
        }
      });
    }
  }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_ltcat_filter__ = __webpack_require__(828);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  data: function data() {
    return {
      config: {
        click: {
          id_empresa: this.getEmpresa
        },
        list: {
          id_empresa: []
        },
        loading: {
          id_empresa: false
        }
      },
      formFilter: {
        id_empresa: null,
        vencimento: []
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        label: "Empresa"
      }, {
        key: "revisao",
        sortable: true,
        label: "Tipo de Revisão"
      }, {
        key: "vencimento",
        sortable: true,
        label: "Vencimento"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      filterItems: [],
      loadingTable: true,
      loadingEditAll: false,
      filterBadge: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcat();
    this.getEmpresa();
    this.filterItems = __WEBPACK_IMPORTED_MODULE_4__form_ltcat_filter__["a" /* default */];
  },


  methods: {
    onRegister: function onRegister() {
      this.$router.push({ name: "ltcat.cadastrar" });
    },

    onEdit: function onEdit(data) {
      this.$router.push({ name: "ltcat.editar", params: { id: data.id } });
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this.post("/ltcat/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcat();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getEmpresa: function getEmpresa(search) {
      var _this2 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this2.config.list.id_empresa = result.data.data;
        }
      });
    },


    getLtcat: function getLtcat(_search, _page, _pagination, _loading) {
      var _this3 = this;

      this.loadingTable = true;
      this.response = {};

      this.filterBadge = (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.vencimento && this.formFilter.vencimento.length == 2 ? 1 : 0);

      this.get("ltcat", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this3.response = result;
        _this3.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this3,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var revisao = data[i].rev + " (" + data[i].descricao + " em " + _this3.toDate(data[i].data, true) + ")";

            if (data[i].parent) {
              revisao = data[i].parent.rev + " (" + data[i].parent.descricao + " em " + _this3.toDate(data[i].parent.data, true) + ") / " + revisao;
            }

            var item = {
              empresa: data[i].empresa.nome,
              vencimento: data[i].vencimento ? _this3.toDate(data[i].vencimento, true) : "---",
              revisao: revisao,
              updated_at: _this3.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                style: !data[i].parent ? "font-weight:bold" : "",
                disable_delete: !_this3.validarPermissao(567),
                disable_edit: !_this3.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this3.pagination = pagination;
          _this3.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__ = __webpack_require__(232);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				estado: true,
				cnae: true,
				click: {
					save: this.salvar
				},
				loading: {
					save: false
				}
			},
			response: {},
			credenciadaItems: [],
			formData: {
				id: 0,
				nome: null,
				cnpj: null,
				ie: null,
				cnae: null,
				cep: null,
				id_estado: null,
				id_cidade: null,
				end: null,
				num: null,
				comp: null,
				bairro: null,
				tel_com: null,
				tel_cel: null,
				email: null,
				site: null,
				obs: null,
				resp: null
			},
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.credenciadaItems = __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__["a" /* default */];
	},
	methods: {

		salvar: function salvar() {
			var _this = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/laboratorio/editar', this.formData).then(function (result) {

				result = result[0];

				_this.config.loading.save = false;
				_this.response = result;

				if (result.status == 200) {
					_this.edMsg('Dados atualizados');
					_this.$router.push({ name: 'ltcat.laboratorio.editar', params: { id: result.data.id } });
				}
			});
		}

	}
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fator_risco_index__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fator_risco_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fator_risco_index__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, FatorRisco: __WEBPACK_IMPORTED_MODULE_3__fator_risco_index___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				estado: true,
				cnae: true,
				click: {
					save: this.salvar
				},
				loading: {
					save: false
				}
			},
			response: {},
			parceiroItems: [],
			formData: {
				id: this.$route.params.id
			},
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.parceiroItems = __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__["a" /* default */];
		this.getLaboratorio();
	},
	methods: {

		onDelete: function onDelete(data) {

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.config.loading.save = true;

				self.delete('/laboratorio/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.config.loading.save = false;

					if (result.status == 200) {
						self.edMsg('Registo excluido com sucesso');
						self.getLaboratorio();
					}
				});
			});
		},

		getLaboratorio: function getLaboratorio() {
			var _this = this;

			this.config.loading.save = true;
			this.response = {};

			this.get('laboratorio/' + this.$route.params.id).then(function (result) {
				result = result[0];

				_this.config.loading.save = false;
				_this.response = {};

				if (result.status == 200) {
					_this.formData = {
						id: result.data.id,
						nome: result.data.nome,
						cnpj: result.data.cnpj,
						cei: result.data.cei,
						ie: result.data.ei,
						cnae: { cnae: result.data.cnae },
						cep: result.data.cep,
						id_estado: result.data.id_estado,
						id_cidade: result.data.id_cidade,
						end: result.data.end,
						num: result.data.num,
						comp: result.data.comp,
						bairro: result.data.bairro,
						tel_com: result.data.tel_com,
						tel_cel: result.data.tel_cel,
						email: result.data.email,
						site: result.data.site,
						obs: result.data.obs,
						resp: result.data.resp
					};
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/laboratorio/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.getLaboratorio();
				}
			});
		}

	}
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_parceiro_form_parceiro_exame_cadastrar__ = __webpack_require__(593);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "parceiro.exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		laboratorio: {
			type: Object,
			default: null
		}
	},
	watch: {
		laboratorio: function laboratorio() {},
		'formData.id_lab': function formDataId_lab() {
			this.config.disabled.id_exa = this.formData.id_par ? true : false;
			this.config.disabled.padrao = this.formData.id_par ? false : true;
			this.config.disabled.atualizar_tb_empresa = this.formData.id_par ? false : true;
		}
	},
	data: function data() {
		return {
			config: {
				click: {
					id_lab: this.getLaboratorio
				},
				list: {
					id_lab: []
				},
				disabled: {
					valor_custo: true,
					valor_venda: true,
					padrao: true,
					parceiro_padrao: true,
					atualizar_tb_empresa: true
				},
				hidden: {
					id_lab: true,
					parceiro_padrao: false
				},
				loading: {
					id_lab: false,
					save: false,
					table: false
				}
			},
			formData: {
				id: 0,
				id_exa: null,
				valor_custo: 0,
				valor_venda: 0,
				padrao: 0,
				atualizar_tb_empresa: 0
			},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'Cód'
			}, {
				key: 'risco',
				sortable: true,
				label: 'Fator de Risco'
			}, {
				key: 'id_lab',
				sortable: true,
				edit: 'select-custom',
				info: 'Esse é o laboratório padrão para esse Fator de Risco',
				label: 'Laboratório Padrão'
			}, {
				key: 'valor_custo',
				sortable: true,
				edit: 'money',
				label: 'Valor de Custo'
			}, {
				key: 'valor_venda',
				sortable: true,
				edit: 'money',
				label: 'Valor de Venda'
			}],
			tableData: [],
			formItems: [],
			loadingTable: false,
			loadingSave: false,
			showFormEdit: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_4_appsWeb_parceiro_form_parceiro_exame_cadastrar__["a" /* default */];
		this.getRiscoLaboratorio();
	},

	methods: {
		onEditAll: function onEditAll(data) {
			var _this = this;

			this.config.loading.table = true;

			this.post('/laboratorio/fator-risco/' + this.laboratorio.id + '/editar-todos', { items: data }).then(function (result) {

				result = result[0];

				_this.config.loading.table = false;

				if (result.status == 200) {
					_this.getRiscoLaboratorio();
				}
			});
		},
		getLaboratorio: function getLaboratorio(_search) {
			var _this2 = this;

			this.config.loading.id_lab = true;
			this.config.list.id_lab = [];

			this.get('laboratorio', { search: _search }).then(function (result) {

				result = result[0];

				_this2.config.loading.id_lab = false;

				if (result.status == 200) {
					_this2.config.list.id_lab = result.data.data;
				}
			});
		},


		getRiscoLaboratorio: function getRiscoLaboratorio(_search, _page, _pagination) {
			var _this3 = this;

			this.config.loading.table = true;
			this.config.list.id_lab = [];
			this.response = {};

			this.get('/laboratorio/fator-risco/' + this.laboratorio.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this3.response = result;
				_this3.config.loading.table = false;

				var data = [],
				    tableData = [],
				    pagination = {};

				if (result.status == 200) {

					data = result.data.data;

					for (var i = 0; i < data.length; i++) {

						if (data[i].laboratorio && !_this3.arrFindByField(_this3.config.list.id_lab, 'id', data[i].id_lab)) {
							_this3.config.list.id_lab.push({
								id: data[i].id_lab,
								nome: data[i].laboratorio.nome
							});
						}

						var item = {
							'id': data[i].id,
							'risco': data[i].nome,
							'id_lab': data[i].laboratorio ? data[i].laboratorio.nome : '---',
							'valor_custo': data[i].valor_custo,
							'valor_venda': data[i].valor_venda,
							_data: data[i],
							options: {
								disable_delete: !_this3.validarPermissao(303),
								disable_edit: !_this3.validarPermissao(303),
								style: 'color:' + (data[i].laboratorio && data[i].laboratorio.id == _this3.laboratorio.id ? 'green' : 'red')
							},
							buttons: []
						};

						tableData.push(item);
					}

					pagination = result.data;
				}

				_this3.tableData = tableData;
				_this3.pagination = pagination;
			});
		},

		salvar: function salvar() {
			var _this4 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/parceiro/exames/' + this.parceiro.id + '/editar', this.formData).then(function (result) {

				result = result[0];
				_this4.response = result;

				_this4.config.loading.save = false;

				if (result.status == 200) {
					_this4.edMsg('Dados a com sucesso!');
					_this4.showFormEdit = !_this4.showFormEdit;
					_this4.getRiscoLaboratorio();
				}
			});
		}
	}
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			formData: {
				id: 0,
				nome: null,
				cbo: null,
				descricao: null
			},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'cnpj',
				sortable: true,
				width: '150px',
				label: 'CNPJ'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'telefone',
				sortable: true,
				label: 'Telefone'
			}, {
				key: 'responsavel',
				sortable: true,
				label: 'Responsável'
			}, {
				key: 'email',
				sortable: true,
				label: 'Email'
			}],
			tableData: [],
			loadingTable: true,
			loadingEditAll: false,
			showFormEdit: false,
			showFormVinculo: false,
			lstTipoPagamento: []

		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.getLaboratorio();
	},

	methods: {

		onRegister: function onRegister() {
			this.$router.push({ name: 'ltcat.laboratorio.cadastrar' });
		},

		onEdit: function onEdit(data) {
			this.$router.push({ name: 'ltcat.laboratorio.editar', params: { id: data.id } });
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;

				_this.post('/laboratorio/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {
						self.getLaboratorio();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getLaboratorio: function getLaboratorio(_search, _page, _pagination, _loading) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('laboratorio', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;
				_this2.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this2,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'cnpj': data[i].cnpj,
							'nome': data[i].nome,
							'telefone': data[i].tel_com,
							'email': data[i].email,
							'responsavel': data[i].resp,
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(570),
								disable_edit: !_this2.validarPermissao(570)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
				}
			});
		}

	}
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_orcamento_cadastrar__ = __webpack_require__(836);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		anexo: {
			type: Object,
			default: function _default() {
				return {
					id: 0,
					descricao: null,
					arquivo: null,
					updated_at: null,
					usuario: null,
					ativo: 1
				};
			}
		},
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'$store.state.ltcat.data.id': function $storeStateLtcatDataId() {},
		'formData.id_tipo_orcamento': function formDataId_tipo_orcamento() {
			this.config.hidden.id_orc_cp = this.formData.id_tipo_orcamento != 236;
		},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [234],
				click: {
					id_orc_cp: this.getOrcamento
				},
				list: {
					id_orc_cp: []
				},
				loading: {
					save: false,
					content: false,
					id_orc_cp: false
				},
				hidden: {
					id_orc_cp: true
				}
			},
			formData: {
				id: 0,
				id_tipo_orcamento: 235,
				descricao: null,
				updated_at: null,
				usuario: null,
				id_orc_cp: null
			},
			response: {},
			exameItems: [],
			loadingSave: false,
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_orcamento_cadastrar__["a" /* default */];
	},


	methods: {
		init: function init() {
			this.formData = {
				id: 0,
				id_tipo_orcamento: 235,
				descricao: null,
				updated_at: null,
				usuario: null,
				id_orc_cp: null
			};
			this.getOrcamento();
		},


		getOrcamento: function getOrcamento(_search) {
			var _this = this;

			this.config.loading.id_orc_cp = true;
			this.config.list.id_orc_cp = [];

			this.get('ltcat/orcamento/' + this.$store.state.ltcat.data.id, { search: _search }).then(function (result) {

				result = result[0];
				_this.config.loading.id_orc_cp = false;

				if (result.status == 200) {
					_this.config.list.id_orc_cp = result.data.data;
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.response = {};
			this.loadingSave = true;

			this.post('/ltcat/orcamento/' + this.$store.state.ltcat.data.id + '/cadastrar', this.formData).then(function (result) {

				result = result[0];

				_this2.loadingSave = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Registro salvo com sucesso!');
					_this2.showFormEdit = !_this2.showFormEdit;

					if (_this2.parent.getLtcatOrcamento) _this2.parent.getLtcatOrcamento();
				}
			});
		}
	}
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_orcamento_editar__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicao__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__medicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servico__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__servico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame-editar",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, Medicao: __WEBPACK_IMPORTED_MODULE_4__medicao___default.a, Servico: __WEBPACK_IMPORTED_MODULE_5__servico___default.a, LogEmail: __WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: [Object, Window],
      default: null
    },
    orcamento: {
      type: Object,
      default: null
    },
    showForm: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "orcamento.id": function orcamentoId() {
      if (this.orcamento && this.orcamento.id != 0) {
        this.getOrcamento();
      }
    },
    showForm: function showForm() {
      alert("asdf");
      this.showFormEdit = !this.showFormEdit;
      this.init();

      if (this.orcamento && this.orcamento.id != 0) {
        this.getOrcamento();
      }
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [234, 229],
        click: {
          save: this.salvar
        },
        loading: {
          save: false,
          content: false
        },
        list: {},
        disabled: {
          codigo: true
        }
      },
      formData: {
        id: 0,
        id_tipo_status: null,
        descricao: null,
        updated_at: null,
        usuario: null
      },
      response: {},
      formItems: [],
      loadingSave: false,
      showFormEdit: false,
      tagConfig: "tab-cadastro",
      tagConfigResumo: "tab-res-med"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.formItems = __WEBPACK_IMPORTED_MODULE_3__form_orcamento_editar__["a" /* default */];
    this.getOrcamento();

    this.$events.on('orcamentoProposta', function (eventData) {
      _this.getOrcamento();
    });
  },


  methods: {
    init: function init() {
      this.formData = {
        id: 0,
        codigo: null,
        id_tipo_status: null,
        descricao: null,
        updated_at: null,
        usuario: null
      };
    },
    getOrcamento: function getOrcamento() {
      var _this2 = this;

      if (!this.orcamento || this.orcamento.id == 0) return;

      this.config.loading.content = true;
      this.tagConfig = "tab-cadastro";
      this.formData = {};

      this.get("ltcat/orcamento/" + this.$store.state.ltcat.data.id + "/" + this.orcamento.id).then(function (result) {
        result = result[0];

        _this2.config.loading.content = false;

        if (result.status == 200) {
          _this2.formataData(result);
        }
      });
    },
    formataData: function formataData(result) {
      this.formData = {
        id: result.data.id,
        id_tipo_status: result.data.tipo_status.id,
        codigo: result.data.codigo,
        descricao: result.data.descricao,
        usuario: result.data.usuario,
        updated_at: result.data.updated_at
      };
    },
    salvar: function salvar() {
      var _this3 = this;

      this.response = {};
      this.loadingSave = true;

      this.post("/ltcat/orcamento/" + this.$store.state.ltcat.data.id + "/editar", this.formData).then(function (result) {
        result = result[0];

        _this3.loadingSave = false;
        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg("Registro salvo com sucesso!");
          _this3.formataData(result);
          _this3.showFormEdit = !_this3.showFormEdit;

          if (_this3.parent.getLtcatOrcamento) _this3.parent.getLtcatOrcamento();
        }
      });
    }
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastrar__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Cadastrar: __WEBPACK_IMPORTED_MODULE_3__cadastrar___default.a, Editar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		ltcat: {
			type: Object,
			default: null
		}
	},
	watch: {
		'$store.state.ltcat.data.id': function $storeStateLtcatDataId() {
			this.getLtcatOrcamento();
		}
	},
	data: function data() {
		return {
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'CÓDIGO'
			}, {
				key: 'descricao',
				sortable: true,
				label: 'Descrição'
			}, {
				key: 'tipo_status',
				sortable: true,
				label: 'Status'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: false,
			showFormEdit: false,
			showFormCadastro: false,
			tagConfig: 'tab-listar',
			orcamentos: []

		};
	},
	created: function created() {},


	mounted: function mounted() {
		var _this = this;

		this.getLtcatOrcamento();

		this.$events.on('ckeditor-pdf', function (eventData) {
			_this.formData.pdf = eventData;
		});

		this.$events.on('orcamentoProposta', function (eventData) {
			_this.getLtcatOrcamento();
		});
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormCadastro = !this.showFormCadastro;
			this.orcamentos = [];
		},

		onEdit: function onEdit(data) {

			var index = this.orcamentos.length - 1;

			if (!this.arrFindByField(this.orcamentos, 'id', data.id)) {
				this.orcamentos.push(data);
			}

			for (var i = 0; i < this.orcamentos.length; i++) {
				var element = this.orcamentos[i];
				if (data.id == element.id) {
					index = i;
				}
			}
			this.tagConfig = 'tab-editar-' + index;
		},

		onDelete: function onDelete(data) {
			var _this2 = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				_this2.post('/ltcat/orcamento/' + _this2.$store.state.ltcat.data.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getLtcatOrcamento();
						self.handleTabsDelete();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		handleTabsDelete: function handleTabsDelete(targetName, action) {
			this.tagConfig = 'tab-listar';

			var index = this.onlyNumber(targetName);

			for (var i = 0; i < this.orcamentos.length; i++) {
				var element = this.orcamentos[i];

				if (i == index) {
					this.orcamentos.splice(i, 1);
				}
			}
		},


		getLtcatOrcamento: function getLtcatOrcamento(_search, _page, _pagination) {
			var _this3 = this;

			if (!this.$store.state.ltcat.data) return;

			this.loadingTable = true;
			this.response = {};

			this.get('ltcat/orcamento/' + this.$store.state.ltcat.data.id, { search: _search, page: _page, pagination: _pagination, filter: { show_emp_email: 1 } }).then(function (result) {

				result = result[0];
				_this3.response = result;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						data[i].collapse = null;

						var item = {
							'id': data[i].codigo,
							'descricao': data[i].descricao ? data[i].descricao : '---',
							'tipo_status': data[i].tipo_status ? data[i].tipo_status.descricao : '---',
							'updated_at': _this3.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								disable_delete: !_this3.validarPermissao(577) || data[i].tipo_status.bloqueado == 1,
								disable_edit: !_this3.validarPermissao(577)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this3.pagination = pagination;
					_this3.tableData = tableData;
				}

				_this3.loadingTable = false;
			});
		}

	}
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_1_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  props: {
    orcamento: {
      type: Object,
      default: null
    }
  },
  watch: {
    "orcamento.id": function orcamentoId() {
      this.inicialize();
    },
    "formData.point_type": function formDataPoint_type() {
      this.getLtcatOrcamentoMedicao();
    },
    tableData: function tableData() {
      this.formataDados();
    }
  },
  data: function data() {
    return {
      formData: {
        point_type: "ghe"
      },
      pagination: {},
      response: {},
      tableData: [],
      tableMedicaoChecked: [],
      tablePointChecked: [],
      loadingTable: false,
      showFormEdit: false,
      showFormCadastro: false,
      showPopover: false
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.getLtcatOrcamentoMedicao();
    this.inicialize();
  },

  methods: {
    inicialize: function inicialize() {
      if (this.orcamento) {
        this.formData.point_type = this.orcamento.agrupar;
      }
    },


    onRegister: function onRegister() {
      this.showFormCadastro = !this.showFormCadastro;
      this.formData = {
        id: 0
      };
    },

    onEdit: function onEdit(data) {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: data.id,
        descricao: data.descricao,
        tipo_status: data.tipo_status,
        usuario: data.usuario,
        updated_at: data.updated_at
      };
    },

    formataDados: function formataDados() {
      for (var i = 0; i < this.tableData.length; i++) {
        var data = this.tableData[i];

        for (var j = 0; j < data.orcamento_medicoes.length; j++) {
          var medicao = data.orcamento_medicoes[j];

          var valor_venda = this.moneyToFloat(medicao.valor_venda),
              amostragem = parseInt(medicao.amostragem);

          medicao.valor_venda = this.floatToMoney(valor_venda);
          medicao.valor_total = this.floatToMoney(valor_venda * amostragem);
        }
      }
    },


    getLtcatOrcamentoMedicao: function getLtcatOrcamentoMedicao(_search, _page, _pagination) {
      var _this = this;

      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.tableData = [];

      this.get("ltcat/orcamento/medicao/" + this.orcamento.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formData
      }).then(function (result) {
        result = result[0];
        _this.response = result;

        if (result.status == 200) {
          _this.tableData = result.data;
        }

        _this.loadingTable = false;
      });
    },

    restaurar: function restaurar() {
      var _this2 = this;

      var self = this;

      this.$confirm("O sistema vai restaurar o orçamento de acordo com o cadastro inicial. Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this2.loadingTable = true;
        _this2.response = {};

        _this2.get("ltcat/orcamento/medicao/" + _this2.orcamento.id + "/restaurar").then(function (result) {
          result = result[0];
          _this2.response = result;

          _this2.loadingTable = false;

          if (result.status == 200) {
            _this2.getLtcatOrcamentoMedicao();
            _this2.edMsg("Dados atualizados com sucesso");
            _this2.$events.fire("orcamentoMedicao." + _this2.orcamento.id, []);
          }
        });
      });
    },
    agrupar: function agrupar() {
      var _this3 = this;

      var self = this;

      this.$confirm("O sistema vai agrupar " + this.tablePointChecked.length + " " + this.formData.point_type.toUpperCase() + ". Esse processo NÃO poderá ser desfeito. Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this3.loadingTable = true;
        _this3.response = {};

        _this3.post("ltcat/orcamento/medicao/" + _this3.orcamento.id + "/agrupar", {
          arrayPoint: _this3.tablePointChecked,
          filter: _this3.formData
        }).then(function (result) {
          result = result[0];
          _this3.response = result;

          _this3.loadingTable = false;

          if (result.status == 200) {
            _this3.getLtcatOrcamentoMedicao();
            _this3.edMsg("Dados atualizados com sucesso");
            _this3.$events.fire("orcamentoMedicao." + _this3.orcamento.id, []);
            _this3.tablePointChecked = [];
          }
        });
      });
    },
    salvar: function salvar() {
      var _this4 = this;

      this.loadingTable = true;
      this.response = {};

      this.post("ltcat/orcamento/medicao/" + this.orcamento.id + "/editar", {
        arrayMedicao: this.tableData
      }).then(function (result) {
        result = result[0];
        _this4.response = result;

        _this4.loadingTable = false;

        if (result.status == 200) {
          _this4.getLtcatOrcamentoMedicao();
          _this4.edMsg("Dados atualizados com sucesso");
          _this4.$events.fire("orcamentoMedicao." + _this4.orcamento.id, []);

          _this4.tableMedicaoChecked = [];
        }
      });
    }
  }
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_orcamento_email__ = __webpack_require__(838);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_0_common_button___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  props: {
    orcamento: {
      type: Object,
      default: null
    }
  },
  watch: {
    "orcamento.id": function orcamentoId() {
      this.inicialize();
    }
  },
  computed: {},
  data: function data() {
    return {
      config: {
        click: {
          id_conta_email: this.getContaEmail
        },
        list: {
          id_conta_email: []
        },
        loading: {
          id_conta_email: false
        }
      },
      pagination: {},
      response: {},
      formData: {
        id_conta_email: null,
        destinatario: null,
        mensagem: null,
        pdf: null,
        forma_pagamento: null,
        qtde_medicao: 0,
        valor_medicao: 0,
        qtde_servico: 0,
        valor_servico: 0,
        valor_desconto: "0,00",
        valor_total: "0,00",
        valor_lucro: "0,00",
        percent_lucro: "0,00",
        servicos: []
      },
      loadingTable: false,
      showFormEmail: false,
      formItems: []
    };
  },
  created: function created() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_orcamento_email__["a" /* default */];
  },


  mounted: function mounted() {
    var _this = this;

    this.getLtcatOrcamentoServico();
    this.getLtcatOrcamentoMedicaoResumo();
    this.getContaEmail();
    this.inicialize();

    this.$events.on("orcamentoMedicao." + this.orcamento.id, function (eventData) {
      _this.getLtcatOrcamentoMedicaoResumo();
    });

    this.$events.on("ckeditor-mensagem", function (eventData) {
      _this.formData.mensagem = eventData;
    });

    this.$events.on("ckeditor-pdf", function (eventData) {
      _this.formData.pdf = eventData;
    });
  },

  methods: {
    inicialize: function inicialize() {
      if (this.orcamento) {
        this.formData.mensagem = this.orcamento.mensagem;
        this.formData.destinatario = this.orcamento.empresa ? this.orcamento.empresa.email : null;
        this.formData.valor_desconto = this.orcamento.valor_desconto;
        this.formData.pdf = this.orcamento.pdf;
      }
    },
    onRegister: function onRegister() {
      this.formData.servicos.push({
        id: 0,
        descricao: null,
        qtde: 1,
        padrao: 0,
        valor: "0,00",
        usuario: null
      });
      this.formataCustoServicos();
    },
    onDelete: function onDelete(index) {
      this.formData.servicos.splice(index, 1);
      this.formataCustoServicos();
    },


    getContaEmail: function getContaEmail(_search) {
      var _this2 = this;

      this.config.list.id_conta_email = [];
      this.config.loading.id_conta_email = true;

      this.get("conta-email", {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this2.config.loading.id_conta_email = false;

        if (result.status == 200) {
          _this2.config.list.id_conta_email = result.data.data;
        }
      });
    },

    getLtcatOrcamentoServico: function getLtcatOrcamentoServico(_search, _page, _pagination) {
      var _this3 = this;

      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.formData.servicos = [];

      this.get("ltcat/orcamento/servico/" + this.orcamento.id, {
        search: _search,
        page: _page,
        pagination: 100
      }).then(function (result) {
        result = result[0];
        _this3.response = result;
        _this3.loadingTable = false;

        if (result.status == 200) {
          _this3.formData.servicos = result.data.data;
          _this3.formataCustoServicos();
        }
      });
    },
    getLtcatOrcamentoMedicaoResumo: function getLtcatOrcamentoMedicaoResumo() {
      var _this4 = this;

      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.formData.servicosMedicao = [];

      this.get("ltcat/orcamento/medicao/" + this.orcamento.id + "/resumo").then(function (result) {
        result = result[0];
        _this4.response = result;
        _this4.loadingTable = false;
        if (result.status == 200) {
          _this4.formData.servicosMedicao = result.data;
          _this4.formataCustoMedicoes();
        }
      });
    },
    formataCustoMedicoes: function formataCustoMedicoes() {
      var qtde = 0,
          valor = 0,
          self = this;

      this.formData.servicosMedicao.forEach(function (objMedicao) {
        qtde += parseInt(objMedicao.total);
        valor += self.moneyToFloat(objMedicao.valor_venda);
      });

      this.formData.qtde_medicao = qtde;
      this.formData.valor_medicao = this.floatToMoney(valor);

      this.formataCustoTotal();
    },
    formataCustoServicos: function formataCustoServicos() {
      var qtde = 0,
          valor = 0,
          self = this;

      this.formData.servicos.forEach(function (objServico) {
        qtde += parseInt(objServico.qtde);
        valor += self.moneyToFloat(objServico.valor);
      });

      this.formData.qtde_servico = qtde;
      this.formData.valor_servico = this.floatToMoney(valor);

      this.formataCustoTotal();
    },
    formataCustoTotal: function formataCustoTotal() {
      var valor_medicao = this.moneyToFloat(this.formData.valor_medicao),
          valor_servico = this.moneyToFloat(this.formData.valor_servico),
          valor_desconto = this.moneyToFloat(this.formData.valor_desconto),
          valor_total = valor_medicao + valor_servico - valor_desconto,
          valor_lucro = valor_medicao - valor_servico - valor_desconto,
          percent_lucro = valor_lucro / valor_total * 100;

      if (valor_desconto && valor_desconto > valor_lucro) {
        this.edAlert("O valor de desconto não pode ser maior que o lucro líquido", "warning");
        this.formData.valor_desconto = "0,00";
        return;
      }

      this.formData.valor_total = this.floatToMoney(valor_total);
      this.formData.valor_lucro = this.floatToMoney(valor_lucro);
      this.formData.percent_lucro = this.floatToMoney(percent_lucro);
    },
    validar_formulario: function validar_formulario() {
      var erro = "";
      this.formData.servicos.forEach(function (objServico) {
        if (!objServico.descricao) {
          erro = "Favor preencher a descrição de todos os campos";
        }
      });

      if (erro) {
        this.edAlert(erro, "danger");
        return false;
      }

      return true;
    },
    salvar: function salvar() {
      var _this5 = this;

      if (this.validar_formulario()) {
        this.loadingTable = true;
        this.response = {};

        this.post("ltcat/orcamento/servico/" + this.orcamento.id + "/editar", this.formData).then(function (result) {
          result = result[0];
          _this5.response = result;
          _this5.loadingTable = false;

          if (result.status == 200) {
            _this5.edMsg("Dados atualizados com sucesso");
            _this5.getLtcatOrcamentoServico();
          }
        });
      }
    },
    proposta: function proposta() {
      var _this6 = this;

      if (this.validar_formulario()) {
        this.loadingTable = true;
        this.response = {};

        this.post("ltcat/orcamento/servico/" + this.orcamento.id + "/enviar-proposta", this.formData).then(function (result) {
          result = result[0];
          _this6.response = result;
          _this6.loadingTable = false;

          if (result.status == 200) {
            _this6.showFormEmail = !_this6.showFormEmail;
            _this6.edMsg("Dados atualizados com sucesso");
            _this6.getLtcatOrcamentoServico();

            _this6.$events.fire("orcamentoProposta", []);
          }
        });
      }
    },
    previa: function previa(method) {
      this.open("ltcat/orcamento/servico/" + this.orcamento.id + "/previa");
    }
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__ = __webpack_require__(233);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				click: {
					save: this.salvar,
					copiar: this.getTabaleDinamica
				},
				loading: {
					save: false,
					copiar: false
				},
				list: {
					copiar: []
				}
			},
			response: {},
			formItems: [],
			formData: {
				id: 0,
				nome: null,
				cor: null,
				ativo: 1,
				obs: null
			},
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__["a" /* default */];
		this.getTabaleDinamica();
	},
	methods: {
		getTabaleDinamica: function getTabaleDinamica(search) {
			var _this = this;

			this.config.loading.copiar = true;
			this.config.list.copiar = [];

			var filter = { ativo: 1 };

			this.get('/ltcat/tabela-dinamica', { search: search, filter: filter }).then(function (result) {

				result = result[0];

				_this.config.loading.copiar = false;

				if (result.status == 200) {
					_this.config.list.copiar = result.data.data;
				}
			});
		},
		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.$router.push({ name: 'ltcat.tabela.editar', params: { id: result.data.id } });
				}
			});
		}
	}
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_tabela_categoria_cadastrar__ = __webpack_require__(839);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		tabela: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		},
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'tabela.id': function tabelaId() {
			this.getTabelaDinamicaCategoria();
		},
		'parent.formData.id': function parentFormDataId() {
			this.getTabelaDinamicaCategoria();
		},
		'parent.showFormVersao': function parentShowFormVersao() {
			this.showFormEdit = !this.showFormEdit;
		}
	},
	data: function data() {
		return {
			config: {
				click: {},
				loading: {
					content: false,
					save: false
				},
				disabled: {
					versao: true
				}
			},
			response: {},
			formItems: [],
			showFormEdit: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_3__form_tabela_categoria_cadastrar__["a" /* default */];
		this.getTabelaDinamicaCategoria();
	},
	methods: {

		getTabelaDinamicaCategoria: function getTabelaDinamicaCategoria() {
			var _this = this;

			if (this.parent.formData.id == 0) return;

			this.config.loading.content = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/categoria/' + this.tabela.id + '/' + this.parent.formData.id).then(function (result) {
				result = result[0];

				_this.config.loading.content = false;
				_this.response = {};

				if (result.status == 200) {
					_this.parent.formData = {
						id: result.data.id,
						nome: result.data.nome,
						updated_at: result.data.updated_at,
						usuario: result.data.usuario,
						ativo: result.data.ativo
					};
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/categoria/' + this.tabela.id + '/editar', this.parent.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.parent.getTabelaDinamicaCategoria();
					_this2.showFormEdit = !_this2.showFormEdit;
				}
			});
		}

	}
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editar__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__editar__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, CategoriaEdit: __WEBPACK_IMPORTED_MODULE_4__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		tabela: {
			type: Object,
			default: null
		}
	},
	watch: {
		'tabela.id': function tabelaId() {
			this.getTabelaDinamicaCategoria();
		}
	},
	data: function data() {
		return {
			formData: {
				id: 0,
				nome: null,
				ativo: 1
			},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'ativo',
				sortable: true,
				label: 'Ativo'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: true,
			loadingEditAll: false,
			showFormVersao: false,
			lstTipoPagamento: []

		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.getTabelaDinamicaCategoria();
	},

	methods: {

		onRegister: function onRegister() {

			this.formData = {
				id: 0,
				nome: null,
				usuario: null,
				updated_at: null,
				ativo: 1
			};
			this.showFormVersao = !this.showFormVersao;
		},

		onEdit: function onEdit(data) {

			this.formData = {
				id: data.id,
				nome: data.nome,
				usuario: data.usuario,
				updated_at: data.updated_at,
				ativo: data.ativo
			};
			this.showFormVersao = !this.showFormVersao;
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;

				_this.post('/ltcat/tabela-dinamica/categoria/' + _this.tabela.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {
						self.getTabelaDinamicaCategoria();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getTabelaDinamicaCategoria: function getTabelaDinamicaCategoria(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/categoria/' + this.tabela.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;
				_this2.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this2,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'nome': data[i].nome,
							'ativo': data[i].ativo == 1 ? 'Sim' : 'Não',
							'updated_at': _this2.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								style: 'color:' + (data[i].ativo == 0 ? 'red' : ''),
								disable_delete: !_this2.validarPermissao(571),
								disable_edit: !_this2.validarPermissao(571)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
				}
			});
		}

	}
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_tabela_coluna_cadastrar__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__valores__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__valores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__valores__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, Valores: __WEBPACK_IMPORTED_MODULE_6__valores___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		tabela: {
			type: Object,
			default: null
		}
	},
	watch: {
		'tabela.id': function tabelaId() {
			this.getTabelaDinamicaColuna();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [207, 218],
				click: {
					id_cat: this.getTabelaDinamicaCategoria
				},
				loading: {
					content: false,
					id_cat: false,
					save: false
				},
				list: {
					id_cat: []
				}
			},
			response: {},
			pagination: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'ordem',
				sortable: true,
				width: '60px',
				label: 'Ordem'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'id_tipo_campo',
				sortable: true,
				label: 'Tipo Conteúdo'
			}, {
				key: 'unidade',
				sortable: true,
				label: 'Unidade Medida'
			}, {
				key: 'valor_ref',
				sortable: true,
				label: 'Valor de Referência'
			}, {
				key: 'id_cat',
				sortable: true,
				label: 'Categoria'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			formData: {},
			formItems: [],
			showFormEdit: false,
			showForm: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_tabela_coluna_cadastrar__["a" /* default */];
		this.getTabelaDinamicaColuna();
		this.getTabelaDinamicaCategoria();
	},
	methods: {
		onRegister: function onRegister() {

			this.formData = {
				id: 0,
				id_tab: this.tabela.id,
				id_cat: null,
				id_tipo_campo: 208,
				id_tipo_vinculo: null,
				nome: null,
				ordem: this.tableData.length + 1,
				unidade: null,
				mascara: null,
				valor_ref_min: null,
				valor_ref_max: null,
				ativo: 1,
				obrigatorio: 0,
				ordenar: 0,
				tabela_valores: []
			};
			this.showForm = !this.showForm;
		},
		onEdit: function onEdit(data) {
			this.formData = {
				id: data.id,
				id_tab: this.tabela.id,
				id_cat: data.tabela_categoria ? data.tabela_categoria.id : null,
				id_tipo_campo: data.tipo_campo.id,
				id_tipo_vinculo: data.tipo_vinculo ? data.tipo_vinculo.id : null,
				nome: data.nome,
				ordem: data.ordem,
				unidade: data.unidade,
				mascara: data.mascara,
				valor_ref_min: data.valor_ref_min,
				valor_ref_max: data.valor_ref_min,
				ativo: data.ativo,
				obrigatorio: data.obrigatorio,
				updated_at: data.updated_at,
				usuario: data.usuario,
				tabela_valores: data.tabela_valores,
				ordenar: 0
			};
			this.showForm = !this.showForm;
		},
		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;
			this.response = {};

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.config.loading.content = true;

				_this.post('/ltcat/tabela-dinamica/coluna/' + _this.tabela.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.response = result;
					self.config.loading.content = false;

					if (result.status == 200) {
						self.getTabelaDinamicaColuna();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},


		getTabelaDinamicaCategoria: function getTabelaDinamicaCategoria(_search) {
			var _this2 = this;

			this.config.loading.id_cat = true;
			this.config.list.id_cat = [];

			var filter = {
				ativo: 1
			};
			this.get('/ltcat/tabela-dinamica/categoria/' + this.tabela.id, { search: _search, filter: filter }).then(function (result) {

				result = result[0];

				_this2.config.loading.id_cat = false;

				if (result.status == 200) {
					_this2.config.list.id_cat = result.data.data;
				}
			});
		},

		getTabelaDinamicaColuna: function getTabelaDinamicaColuna(_search, _page, _pagination) {
			var _this3 = this;

			if (this.tabela.id == 0) return;

			this.config.loading.content = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/coluna/' + this.tabela.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
				result = result[0];

				_this3.config.loading.content = false;
				_this3.response = result;
				_this3.tableData = [];

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this3,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {
						var valor_ref = '';

						if (data[i].valor_ref_min) {
							valor_ref = data[i].valor_ref_min;
						}

						if (data[i].valor_ref_max) {
							valor_ref += valor_ref ? ' a ' + data[i].valor_ref_max : data[i].valor_ref_max;
						}

						var item = {
							'id': data[i].id,
							'ordem': data[i].ordem,
							'nome': data[i].nome,
							'id_tipo_campo': data[i].tipo_campo.descricao,
							'unidade': data[i].unidade,
							'id_cat': data[i].tabela_categoria ? data[i].tabela_categoria.nome : '---',
							'valor_ref': valor_ref ? valor_ref : '---',
							'updated_at': _this3.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								style: 'color:' + (data[i].ativo == 0 ? 'red' : ''),
								disable_delete: !_this3.validarPermissao(571),
								disable_edit: !_this3.validarPermissao(571)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this3.pagination = pagination;
					_this3.tableData = tableData;
				}
			});
		},


		salvar: function salvar() {
			var _this4 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/coluna/' + this.tabela.id + '/editar', this.formData).then(function (result) {

				result = result[0];

				_this4.config.loading.save = false;
				_this4.response = result;

				if (result.status == 200) {
					_this4.edMsg('Dados atualizados');
					_this4.getTabelaDinamicaColuna();
					_this4.showForm = !_this4.showForm;
				}
			});
		}

	}
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdButton: __WEBPACK_IMPORTED_MODULE_0_common_button___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.showForm': function parentShowForm() {
			this.inicialize();
		},
		'parent.formData.id': function parentFormDataId() {
			this.inicialize();
		},
		'parent.formData.id_tipo_campo': function parentFormDataId_tipo_campo() {}
	},
	data: function data() {
		return {
			tableHead: [{
				key: 'ordem',
				show_numeric: true,
				sortable: true,
				width: '200px',
				label: 'Ordem'
			}, {
				key: 'nome',
				show_text: true,
				sortable: true,
				label: 'Nome'
			}, {
				key: 'unidade',
				show_text: true,
				sortable: true,
				label: 'Unidade'
			}, {
				key: 'id_tipo_campo',
				show_select: true,
				sortable: true,
				label: 'Tipo de Campo'
			}, {
				key: 'ativo',
				show_boolean: true,
				sortable: true,
				width: '200px',
				label: 'Item Ativo?'
			}, {
				key: 'buttons',
				label: '',
				width: '50px'
			}],
			tableData: [],
			tipo_campos: []
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.inicialize();
		this.handleParametros();
	},

	methods: {
		inicialize: function inicialize() {

			var tableData = [];

			for (var i = 0; i < this.parent.formData.tabela_valores.length; i++) {
				var element = this.parent.formData.tabela_valores[i];

				var item = {
					id: element.id,
					id_tab_ver_col: this.parent.formData.id,
					id_tipo_campo: element.tipo_campo ? element.tipo_campo.id : null,
					ordem: element.ordem,
					nome: element.nome,
					unidade: element.unidade,
					padrao: element.padrao,
					ativo: element.ativo,
					_data: element
				};

				tableData.push(item);
			}

			this.tableData = tableData;
		},
		onRegister: function onRegister() {

			var data = {
				id: 0,
				id_tab_ver_col: this.parent.formData.id,
				id_tipo_campo: null,
				unidade: null,
				ordem: this.parent.formData.tabela_valores.length + 1,
				nome: 'ITEM ' + (this.parent.formData.tabela_valores.length + 1),
				ativo: 1,
				padrao: 0
			};

			this.tableData.push({
				id: 0,
				id_tab_ver_col: this.parent.formData.id,
				id_tipo_campo: null,
				ordem: this.parent.formData.tabela_valores.length + 1,
				nome: null,
				unidade: null,
				ativo: 1,
				padrao: 0,
				_data: data
			});
			this.formatData();
		},
		onDelete: function onDelete(item) {
			this.tableData.splice(item.index, 1);
			this.formatData();
		},
		formatData: function formatData() {

			this.parent.formData.tabela_valores = [];

			for (var i = 0; i < this.tableData.length; i++) {
				var element = this.tableData[i];
				this.parent.formData.tabela_valores.push(element._data);
			}
		},
		handleParametros: function handleParametros() {
			var _this = this;

			this.post('tipo/parent', { codigo: [207], exclude: [210, 211, 212, 213, 214] }).then(function (result) {

				result = result[0];

				_this.tipo_campos = [];

				if (result.status == 200) {
					_this.tipo_campos = result.data['207'];
				}
			});
		}
	}
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coluna_index__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coluna_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__coluna_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categoria_index__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categoria_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__categoria_index__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, TabelaDinamicaColuna: __WEBPACK_IMPORTED_MODULE_3__coluna_index___default.a, TabelaDinamicaCategoria: __WEBPACK_IMPORTED_MODULE_4__categoria_index___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				click: {
					save: this.salvar
				},
				loading: {
					save: false
				},
				hidden: {
					copiar: true
				}
			},
			response: {},
			formItems: [],
			formData: {
				id: this.$route.params.id
			},
			boolExibir: false,
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__["a" /* default */];
		this.boolExibir = [1, 914].indexOf(this.$root.$session.cliente.logged.id) != -1 || this.$root.$session.usuario.logged.usuario == 'SuporteSA';
		this.getTabelaDinamica();
	},

	methods: {

		onDelete: function onDelete(data) {

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.config.loading.save = true;

				self.delete('/ltcat/tabela-dinamica/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.config.loading.save = false;

					if (result.status == 200) {
						self.edMsg('Registo excluido com sucesso');
						self.getTabelaDinamica();
					}
				});
			});
		},

		getTabelaDinamica: function getTabelaDinamica() {
			var _this = this;

			this.config.loading.save = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/' + this.$route.params.id).then(function (result) {
				result = result[0];

				_this.config.loading.save = false;
				_this.response = {};

				if (result.status == 200) {
					_this.formData = {
						id: result.data.id,
						nome: result.data.nome,
						cor: result.data.cor,
						obs: result.data.obs,
						ativo: result.data.ativo,
						updated_at: result.data.updated_at,
						usuario: result.data.usuario
					};
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.getTabelaDinamica();
				}
			});
		}

	}
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdButton */], EdAlert: __WEBPACK_IMPORTED_MODULE_1_template__["e" /* EdAlert */], EdModal: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdModal */] },
  mixins: [],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        cbo: null,
        descricao: null
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "id",
        sortable: true,
        width: "60px",
        label: "Cód"
      }, {
        key: "nome",
        sortable: true,
        show_html: true,
        label: "Nome"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      loadingEditAll: false,
      showFormEdit: false,
      showHtml: false,
      showFormVinculo: false,
      lstTipoPagamento: []
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.getTabelaDinamica();
  },

  methods: {
    onExportar: function onExportar() {
      this.$root.$request.open("ltcat/tabela-dinamica/exportar");
    },
    onRegister: function onRegister() {
      this.$router.push({ name: "ltcat.tabela.cadastrar" });
    },
    onEdit: function onEdit(data) {
      this.$router.push({
        name: "ltcat.tabela.editar",
        params: { id: data.id }
      });
    },
    onHtml: function onHtml(data) {
      this.showHtml = !this.showHtml;
      this.formData = data;
    },


    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$root.$dialog.confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?").then(function () {
        self.loadingEditAll = true;

        _this.$root.$request.post("/ltcat/tabela-dinamica/deletar", { ids: data }).then(function (result) {
          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getTabelaDinamica();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getTabelaDinamica: function getTabelaDinamica(_search, _page, _pagination, _loading) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.$root.$request.get("/ltcat/tabela-dinamica", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        _this2.response = result;
        _this2.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this2,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: '<div style="width:30px;float:left;margin-right:5px;background:' + data[i].cor + '">&nbsp;</div> ' + data[i].nome,
              updated_at: _this2.$utilidade.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this2.$root.$session.validarPermissao(571),
                disable_edit: !_this2.$root.$session.validarPermissao(571)
              },
              buttons: []
            };

            if (data[i].html || true) {
              item.buttons.push({
                icon: 'fa fa-eye',
                color: 'warning',
                title: 'Visualizar tabela',
                click: _this2.onHtml
              });
            }

            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_periodico_desativado_cadastrar_js__ = __webpack_require__(842);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.inicialize();
		},
		'formData.id_emp': function formDataId_emp() {
			this.config.disabled.id_fun = !this.formData.id_emp ? true : false;
			this.getFuncionario();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [244, 250],
				click: {
					id_emp: this.getEmpresa,
					id_fun: this.getFuncionario
				},
				loading: {
					save: false,
					id_emp: false,
					id_fun: false
				},
				list: {
					id_emp: [],
					id_fun: []
				},
				disabled: {
					id_fun: true,
					funcionario_todos: true
				},
				hidden: {
					ativo: true
				}
			},
			response: {},
			disparoItems: [],
			formData: {
				id: 0,
				empresa_todos: 1,
				funcionario_todos: 0,
				id_emp: null,
				id_fun: []
			},
			showFormEdit: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.disparoItems = __WEBPACK_IMPORTED_MODULE_3__form_periodico_desativado_cadastrar_js__["a" /* default */];
		this.getEmpresa();
	},
	methods: {
		inicialize: function inicialize() {
			this.formData = {
				id: 0,
				empresa_todos: 1,
				funcionario_todos: 0,
				id_emp: null,
				id_fun: []
			};
		},
		getEmpresa: function getEmpresa(search) {
			var _this = this;

			this.config.loading.id_emp = true;
			this.config.list.id_emp = [];

			this.get('empresa', { search: search }).then(function (result) {
				result = result[0];

				_this.config.loading.id_emp = false;

				if (result.status == 200) {
					_this.config.list.id_emp = result.data.data;
				}
			});
		},
		getFuncionario: function getFuncionario(search) {
			var _this2 = this;

			if (!this.formData.id_emp) return;

			this.config.loading.id_fun = true;
			this.config.list.id_fun = [];

			this.get('empresa/funcionario/' + this.formData.id_emp, { search: search }).then(function (result) {
				result = result[0];

				_this2.config.loading.id_fun = false;

				if (result.status == 200) {
					_this2.config.list.id_fun = result.data.data;
				}
			});
		},


		salvar: function salvar() {
			var _this3 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/periodico/desativado/editar', this.formData).then(function (result) {

				result = result[0];

				_this3.config.loading.save = false;
				_this3.response = result;

				if (result.status == 200) {
					_this3.edMsg('Dados atualizados');
					_this3.showFormEdit = !_this3.showFormEdit;
					if (_this3.parent) _this3.parent.getDesativado();
				}
			});
		}

	}
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastrar__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "periodicos-disparo",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Cadastrar: __WEBPACK_IMPORTED_MODULE_3__cadastrar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'empresa',
				sortable: true,
				label: 'Empresa'
			}, {
				key: 'funcionario',
				sortable: true,
				label: 'Funcionário'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: true,
			showFormCadastro: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getDesativado();
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormCadastro = !this.showFormCadastro;
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;

				_this.post('/periodico/desativado/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {

						_this.getDesativado();
						_this.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getDesativado: function getDesativado(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('periodico/desativado', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;
				_this2.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this2,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'empresa': data[i].empresa.nome,
							'funcionario': data[i].funcionario ? data[i].funcionario.nome : '---',
							'updated_at': _this2.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(310)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
				}
			});
		}

	}
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_5_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a,
    ConsultaHistorico: __WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico___default.a,
    Pcmso: __WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    "formData.id_empresa": function formDataId_empresa() {
      this.config.disabled.id_funcionario = this.formData.id_empresa ? false : true;
      this.config.disabled.id_fdt = this.formData.id_empresa ? false : true;

      this.formData.id_funcionario = [];
      this.formData.id_fdt = [];

      this.getFdt();
      this.getFuncionario();
      this.getPeriodico();
    },
    "formData.periodo": function formDataPeriodo() {
      this.config.disabled.id_empresa = this.formData.periodo.length == 2 ? false : true;
    }
  },
  data: function data() {
    return {
      loadingTable: false,
      pagination: {},
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario,
          id_fdt: this.getFdt
        },
        list: {
          id_empresa: [],
          id_funcionario: [],
          id_fdt: []
        },
        loading: {
          id_empresa: false,
          id_funcionario: false,
          id_fdt: false
        },
        disabled: {
          id_empresa: true,
          id_funcionario: true,
          id_fdt: true
        }
      },
      formData: {
        id_empresa: null,
        id_fdt: [],
        id_funcionario: [],
        periodo: []
      },
      formDataConsulta: {
        funcionario: []
      },
      tabPeriodico: "tab-ok",
      tabExame: "tab-exames",
      tableData: [],
      tableDataForaPeriodo: [],
      tableDataError: [],
      tableDataExame: [],
      tableFooterExame: [],
      tableDataTabelaPreco: [],
      tableHeadTabelaPreco: [{
        key: "exame",
        sortable: true,
        label: "Exame"
      }, {
        key: "quantidade",
        sortable: true,
        label: "Quantidade"
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Unitário (R$)"
      }, {
        key: "valor_total",
        sortable: true,
        label: "Valor Total (R$)"
      }],
      tableHeadExame: [{
        key: "exame",
        sortable: true,
        label: "Exame"
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Aproximado (R$)"
      }, {
        key: "consulta",
        sortable: true,
        width: "215px",
        label: "Última Consulta Realizada"
      }, {
        key: "tipo",
        sortable: true,
        label: "Tipo"
      }, {
        key: "data",
        sortable: true,
        width: "215px",
        label: "Data Ideal Para Refazê-lo"
      }, {
        key: "obs",
        sortable: true,
        label: "Observações"
      }],
      tableHead: [{
        key: "nome",
        sortable: true,
        show_funcionario_link: true,
        show_funcao: true,
        label: "Nome"
      }, {
        key: "fdt",
        sortable: true,
        label: "Frente de Trabalho"
      }, {
        key: "ghe",
        sortable: true,
        label: "GHE (Setor)"
      }, {
        key: "dt_per_rea",
        sortable: true,
        label: "DATA SUGERIDA PARA O PERIÓDICO"
      }, {
        key: "obs",
        sortable: true,
        show_html: true,
        label: "Observações"
      }],
      funcionario: null,
      showModal: false,
      showConsultaLote: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
    this.tableDataError = [];
    this.tableDataExame = [];
    this.tableDataForaPeriodo = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmpresa();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__["a" /* default */];
  },


  methods: {
    onConsultaLote: function onConsultaLote(data) {
      if (data.id) {
        data = [data];
      }

      this.formDataConsulta.funcionario = data;
      this.showConsultaLote = !this.showConsultaLote;
    },
    onExcel: function onExcel() {
      this.open("periodico/excel", { filter: this.formData });
    },
    onExames: function onExames(data) {
      var tableDataExame = [];
      var tableFooterExame = [];
      var valor_total = 0;
      var item = null;

      for (var i = 0; i < data.exames.length; i++) {
        item = {
          id: data.exames[i].id,
          exame: data.exames[i].nome,
          consulta: data.exames[i].id_con ? "Consulta " + data.exames[i].id_con + " (" + this.toDate(data.exames[i].dt_cad, true) + ")" + (data.exames[i].validade > 0 ? '<br><span>Exame válido por ' + data.exames[i].validade + ' dias</span>' : '') : "---",
          tipo: data.exames[i].dt_rea ? data.exames[i].tipo : "---",
          data: data.exames[i].dt_rea ? this.toDate(data.exames[i].dt_rea, true) : "---",
          obs: data.exames[i].obs ? data.exames[i].obs : "---",
          valor_venda: data.exames[i].tabela_preco ? this.floatToMoney(data.exames[i].tabela_preco.valor_venda) : "---",
          _data: data.exames[i],
          options: {
            style: "color:" + data.exames[i].cor
          },
          buttons: [{
            color: "success",
            icon: "fa fa-user-md",
            title: "Visualizar Exames",
            click: this.onExames
          }]
        };
        tableDataExame.push(item);

        if (data.exames[i].tabela_preco) {
          valor_total += Number(data.exames[i].tabela_preco.valor_venda);
        }
      }

      item = {
        id: 0,
        exame: "TOTAL",
        consulta: "---",
        tipo: "---",
        data: "---",
        obs: "---",
        valor_venda: this.floatToMoney(valor_total),
        _data: {},
        options: {
          style: "color:#000;font-weight:bold"
        },
        buttons: []
      };
      tableDataExame.push(item);

      this.tabExame = "tab-exames";
      this.showModal = !this.showModal;
      this.tableDataExame = tableDataExame;
      this.tableFooterExame = tableFooterExame;
      this.funcionario = data;
    },
    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this.config.list.id_empresa = result.data.data;
        }
      });
    },
    getFdt: function getFdt(search) {
      var _this2 = this;

      if (!this.formData.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("/pcmso/fdt/" + this.formData.id_empresa, {
        search: search
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.formData.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("empresa/funcionario/" + this.formData.id_empresa, {
        search: _search,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },
    getPeriodico: function getPeriodico(search, page, pagination) {
      var _this4 = this;

      if (!this.formData.id_empresa) return;

      this.loadingTable = true;
      this.tabPeriodico = "tab-ok";

      if (this.formData.periodo.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-30, null, "D"), true),
            amanha = this.toDate(this.addDate(30, null, "D"), true);

        this.formData.periodo = [ontem, amanha];
      }

      this.get("periodico", {
        search: search,
        page: page,
        pagination: pagination,
        filter: this.formData
      }).then(function (result) {
        result = result[0];

        _this4.loadingTable = false;
        _this4.response = result;

        var data = [],
            tableData = [],
            tableDataForaPeriodo = [],
            tableDataTabelaPreco = [],
            tableDataError = [],
            pagination = {};

        if (result.status == 200) {
          result.data.per_tabela_preco.forEach(function (tabela_preco, index) {
            var item = {
              id: index,
              exame: tabela_preco.fdt.nome,
              valor_venda: '---',
              valor_total: '---',
              quantidade: tabela_preco.fdt.quantidade,
              _data: tabela_preco,
              options: {
                style: "color:red;font-weight:bold"
              },
              buttons: []
            };
            tableDataTabelaPreco.push(item);

            tabela_preco.exames.forEach(function (tabela_preco_exame, indexExame) {
              var item = {
                id: index + indexExame,
                exame: tabela_preco_exame.nome,
                valor_venda: tabela_preco_exame.quantidade == 0 ? '---' : _this4.floatToMoney(tabela_preco_exame.valor_venda),
                valor_total: _this4.floatToMoney(Number(tabela_preco_exame.valor_venda) * Number(tabela_preco_exame.quantidade)),
                quantidade: tabela_preco_exame.quantidade,
                _data: tabela_preco_exame,
                buttons: []
              };
              tableDataTabelaPreco.push(item);
            });
          });

          data = result.data.per_dentro_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")" : "---",
              ghe: data[i].ghe && data[i].ghe.ghe ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")" : "---",
              dt_per_rea: data[i].dt_per_rea ? _this4.toDate(data[i].dt_per_rea, true) + "<br>" + data[i].tipo_ultima_consulta : "---",
              _data: data[i],
              buttons: [{
                color: "success",
                icon: "fa fa-user-md",
                title: "Visualizar Exames (" + data[i].exames.length + " no total)",
                click: _this4.onExames
              }]
            };
            tableData.push(item);
          }

          data = result.data.per_fora_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")" : "---",
              ghe: data[i].ghe && data[i].ghe.ghe ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")" : "---",
              dt_per_rea: "---",
              _data: data[i],
              buttons: [{
                color: "success",
                icon: "fa fa-user-md",
                title: "Visualizar Exames (" + data[i].exames.length + " no total)",
                click: _this4.onExames
              }]
            };
            tableDataForaPeriodo.push(item);
          }

          data = result.data.per_erro;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")" : "---",
              ghe: data[i].ghe && data[i].ghe.ghe ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")" : "---",
              dt_per_rea: "---",
              _data: data[i],
              buttons: []
            };
            tableDataError.push(item);
          }
        }

        _this4.tableData = tableData;
        _this4.tableDataForaPeriodo = tableDataForaPeriodo;
        _this4.tableDataError = tableDataError;
        _this4.tableDataTabelaPreco = tableDataTabelaPreco;
      });
    }
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apps_template_500__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_apps_template_500__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: { EmpresaHeader: __WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2___default.a, EmpresaFooter: __WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2___default.a, Erro500: __WEBPACK_IMPORTED_MODULE_3_apps_template_500___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: true,
      noTenant: null
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.validarLogin(to, from, next);
  },
  mounted: function mounted() {
    this.getTenant();
  },
  created: function created() {
    this.sub_domain = "credenciada";
    this.validarLogin();
    this.tenant = this.$route.params.tenant;
  },


  methods: {

    getTenant: function getTenant() {
      var _this = this;

      this.noTenant = null;

      this.get("config").then(function (result) {

        result = result[0];

        if (result.status == 200 && result.data) {
          _this.cliente = result.data;
          _this.getUsuario();
        } else {
          _this.noTenant = result.msg;
        }
      });
    },

    getUsuario: function getUsuario() {
      var _this2 = this;

      this.get('usuario/menu').then(function (result) {

        result = result[0];

        if (result.status == 200 && result.data) {
          _this2.usuario = result.data.usuario;
          _this2.jwt = _this2.logged();
        }

        _this2.loadingContent = false;
      });
    },

    validarLogin: function validarLogin(to, from, next) {

      if (!to) to = this.$route;

      $('body').removeClass('bg-login');
      if (to.name == 'credenciada.login') $('body').addClass('bg-login');

      if (to.meta && to.meta.title && to.meta.navigation) {
        this.navigation = to.meta.navigation;
        this.setTitle(to.meta.title);
      }

      if (!to.matched.some(function (record) {
        return record.meta.requiresAuth;
      })) {
        if (next) next();
      } else {
        if (!this.logged()) {} else {
          if (next) next();
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apps_template_500__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_apps_template_500__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: { EmpresaHeader: __WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2___default.a, EmpresaFooter: __WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2___default.a, Erro500: __WEBPACK_IMPORTED_MODULE_2_apps_template_500___default.a },
  mixins: [],
  data: function data() {
    return {
      loadingContent: true,
      noTenant: null
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.validarLogin(to, from, next);
  },
  mounted: function mounted() {
    this.getTenant();
  },
  created: function created() {
    this.$root.$session.sub_domain = "empresa";
    this.$root.$loading.set(true, 'Carregando');
    this.validarLogin();
    this.$root.$session.tenant = this.$route.params.tenant;
  },


  methods: {
    getTenant: function getTenant() {
      var _this = this;

      this.noTenant = null;

      this.$root.$request.get("config").then(function (result) {

        if (result.status == 200 && result.data) {
          _this.$root.$session.cliente = result.data;

          _this.getUsuario();
        } else {
          _this.noTenant = result.msg;
        }
      });
    },
    getEmpresa: function getEmpresa() {
      var _this2 = this;

      this.$root.$request.get("meu-cadastro").then(function (result) {

        if (result.status == 200) {
          _this2.$root.$session.empresa = result.data;
        }

        _this2.loadingContent = false;
        _this2.$root.$loading.set(false);
      });
    },
    getUsuario: function getUsuario() {
      var _this3 = this;

      this.$root.$request.get('usuario/menu').then(function (result) {

        if (result.status == 200 && result.data) {
          _this3.$root.$session.usuario = result.data.usuario;
          _this3.$root.$session.jwt = _this3.$root.$session.logged();
          _this3.validarSenha();
        }

        _this3.getEmpresa();
      });
    },
    validarSenha: function validarSenha() {},
    validarLogin: function validarLogin(to, from, next) {

      if (!to) to = this.$route;

      $('body').removeClass('bg-login');
      if (to.name == 'empresa.login') $('body').addClass('bg-login');

      if (to.meta && to.meta.title && to.meta.navigation) {
        this.$root.$session.navigation = to.meta.navigation;
        this.$root.$session.setTitle(to.meta.title);
      }

      if (!to.matched.some(function (record) {
        return record.meta.requiresAuth;
      })) {
        if (next) next();
      } else {
        if (!this.$root.$session.logged()) {
          this.$router.push({ name: 'empresa.login' });
        } else {
          if (next) next();
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_root__ = __webpack_require__(843);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    EdSocket: __WEBPACK_IMPORTED_MODULE_0_root__["a" /* EdSocket */],
    EdSession: __WEBPACK_IMPORTED_MODULE_0_root__["b" /* EdSession */],
    EdRequest: __WEBPACK_IMPORTED_MODULE_0_root__["c" /* EdRequest */],
    EdNotify: __WEBPACK_IMPORTED_MODULE_0_root__["d" /* EdNotify */],
    EdDialog: __WEBPACK_IMPORTED_MODULE_0_root__["e" /* EdDialog */],
    EdLoading: __WEBPACK_IMPORTED_MODULE_0_root__["f" /* EdLoading */]
  },
  data: function data() {
    return {
      loadingContent: true
    };
  },
  mounted: function mounted() {

    this.$root.$session = this.$refs.session;
    this.$root.$socket = this.$refs.socket;
    this.$root.$request = this.$refs.request;
    this.$root.$notify = this.$refs.notify;
    this.$root.$dialog = this.$refs.dialog;
    this.$root.$loading = this.$refs.loading;

    this.$root.$session.sub_domain = "web";

    $(".carregando").html("Carregando ambiente...");
    this.getEnv();
    this.getWindow();
  },
  created: function created() {},


  methods: {
    getWindow: function getWindow() {
      var self = this;

      this.$root.$session.window = {
        height: window.innerHeight,
        width: window.innerWidth
      };

      window.addEventListener("resize", function (e) {
        self.$root.$session.window = {
          height: window.innerHeight,
          width: window.innerWidth
        };
      });
    },
    getEnv: function getEnv() {
      var _this = this;

      this.loadingContent = true;

      this.$root.$request.get("common/env").then(function (result) {

        $(".carregando").hide();

        if (result.status == 200 && result.data) {
          _this.$root.$session.deleteCookie("version");
          _this.$root.$session.setCookie("version", result.data.app_version);

          _this.$root.$session.env = result.data;
          _this.loadingContent = false;
        } else {
          $(".carregando").html(result.msg);
          $(".carregando").css({ color: "red" });
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdDialog",
  components: {},
  data: function data() {
    return {
      dialog: false,
      message: null,
      title: null,
      promise: null,
      isAlert: false,
      promiseResolve: function promiseResolve() {},
      promiseReject: function promiseReject() {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.$utilidade.console("::EdConfirmDialog module loaded::");
  },

  methods: {
    confirm: function confirm() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "warning";
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Atenção";


      var self = this;
      this.promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        self.$confirm(message, title, {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: type
        }).then(function () {
          resolve();
        }).catch(function () {
          reject();
        });
      });

      return this.promise;
    },
    alert: function alert() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Atenção";

      this.promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$alert(message, title, {
          confirmButtonText: "OK",
          type: type
        }).then(function () {
          resolve();
        }).catch(function () {
          reject();
        });
      });
      return this.promise;
    },
    reset: function reset() {
      this.promise = null;
      this.promiseResolve = null;
      this.promiseReject = null;
      this.message = null;
      this.title = null;
      this.dialog = false;
    }
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(571);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EdLoading',
  data: function data() {
    return {
      loading: false,
      text: null
    };
  },
  mounted: function mounted() {
    this.$utilidade.console('::EdLoading module loaded::');
  },

  methods: {
    set: function set(loading, text) {
      this.loading = loading;
      this.text = text;
    }
  },
  computed: {},
  watch: {
    loading: function loading() {},
    text: function text() {}
  }
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdNotify",
  components: {},
  data: function data() {
    return {
      visible: false,
      snackbar: {
        enabled: false,
        color: "success",
        mode: "multi-line",
        timeout: 4000,
        message: "Success!",
        callback: null,
        location: "bottom",
        close: {
          text: "Close",
          color: ""
        }
      }
    };
  },
  mounted: function mounted() {
    this.$utilidade.console("::EdNotification module loaded::");
  },

  methods: {
    error: function error(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "error";
      this.setOptions(options);
    },
    success: function success(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "success";
      this.setOptions(options);
    },
    warning: function warning(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "warning";
      this.setOptions(options);
    },
    info: function info(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "primary";
      this.setOptions(options);
    },
    hide: function hide() {
      this.visible = false;
      if (this.snackbar.callback) {
        this.snackbar.callback();
      }
    },
    setOptions: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$message({
        message: this.snackbar.message,
        type: this.snackbar.color
      });
    },
    reset: function reset() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_stringify_safe__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_json_stringify_safe__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "rest",
  components: {},
  mixins: [],

  data: function data() {
    return {
      requestParam: {
        force_web: false,
        url: "web1.softwareatento.com.br",
        xToken: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).X_TOKEN,
        appVersion: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).APP_VERSION,
        service: null,
        method: null,
        encryptData: null,
        jwt: null,
        headers: null,
        loginRedirect: true,
        uploadProgress: null
      }
    };
  },
  mounted: function mounted() {},


  computed: {
    dados: {
      cache: false,
      get: function get() {
        return this.$store.state.common.request;
      },
      set: function set(value) {
        this.$store.dispatch("common/setRequest", value);
      }
    }
  },
  methods: {
    getUrl: function getUrl(method) {
      this.setUrl();
      return this.requestParam.url + method + "?token=" + this.$root.$session.logged();
    },

    get: function get(_service, _params, _force_web) {
      _params = !_params ? "" : "?" + $.param(_params);

      this.requestParam.service = _service + _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "GET";

      return this.request();
    },
    post: function post(_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "POST";

      return this.request();
    },

    put: function put(_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "PUT";

      return this.request();
    },

    delete: function _delete(_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "DELETE";

      return this.request();
    },

    open: function open(_service, _params) {
      this.setUrl();

      _params = !_params ? "" : "&" + $.param(_params);

      var token = this.$root.$session.logged();

      if (token) _service += "?token=" + token + _params;

      window.open(this.requestParam.url + _service, "_blank");
    },

    cs: function cs(_service, _params) {
      var _target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_top';

      _params = !_params ? "" : "?" + $.param(_params);
      window.open(this.$root.$session.env.url_cs + _service + _params, _target);
    },

    removeStyle: function removeStyle() {
      $("body").removeAttr("style");
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
    },

    getReq: function getReq() {
      var req = {
        date: null,
        hash: null
      };

      req.date = this.$utilidade.addDate(1, null, "m");
      req.date = this.$utilidade.toDate(req.date, false, "YYYY-MM-DD HH:mm:ss");

      req.hash = this.$utilidade.toMd5(req.date + "6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E");

      return this.$utilidade.base64Encode(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(req));
    },


    getHeaders: function getHeaders(onlyeJWT) {
      var jwt = this.$root.$session.logged(),
          version = this.$root.$session.getCookie("version"),
          req = {
        date: null,
        hash: null
      };

      if (onlyeJWT) {
        return {
          authorization: jwt ? "Bearer " + jwt : null
        };
      }

      var headers = {
        Authorization: jwt ? "Bearer " + jwt : null,
        Version: version ? version : "null",
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type"
      };

      headers["xToken"] = this.getReq();

      return headers;
    },

    setHeaders: function setHeaders() {
      this.requestParam.headers = this.getHeaders();

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common = this.requestParam.headers;
    },

    setUrl: function setUrl() {
      var sub_domain = this.requestParam.force_web == true ? "web" : this.$root.$session.sub_domain,
          url = "https://" + __webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"})[sub_domain];

      if (true) {
        url += "/commtrol/api/";
      } else {
        url += "/api/";
      }

      if (sub_domain != "web") url += this.$root.$session.tenant + "/";


      if (sub_domain != "web") console.log(this.$root.$session.tenant);

      this.requestParam.url = url;

      return url;
    },

    request: function request() {
      var _this = this;

      this.setUrl();
      this.setHeaders();
      console.log('URL API Chamada: ' + this.requestParam.url + this.requestParam.service);

      var response = {};
      this.dados = null;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        response = { msg: "OK", status: 200, data: null };
        var promisses = [],
            self = _this;

        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: _this.requestParam.method,
          url: _this.requestParam.service,
          data: _this.requestParam.param,
          baseURL: _this.requestParam.url,

          onUploadProgress: function onUploadProgress(progressEvent) {
            var uploadProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);

            if (uploadProgress == 100) {
              uploadProgress = 99;
            }

            self.requestParam.uploadProgress = uploadProgress;
          },
          onDownloadProgress: function onDownloadProgress(progressEvent) {}
        }).then(function (result) {
          response = result.data;
          promisses.push(response);

          _this.removeStyle();
          _this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
            resolve(success[0]);
          }, function (err) {});
        }).catch(function (err) {
          var error = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, err).response;
          _this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

          if (!error) {
            error = {
              status: 500,
              msg: "Não foi possível completar a requisição. Precione as teclas CTRL+F5 para recarregar a página e tente novamente.",
              data: null
            };

            error.data = error;
          }

          if (error) {
            response = error.data;

            switch (response.status) {

              case 401:
                if (_this.$route.meta.requiresAuth) {
                  _this.$root.$session.logout();
                }
                break;

              case 413:
                response.msg = "A requisição excedeu o tamanho limite.";
                response.data = "A requisição excedeu o tamanho limite.";
                break;

              case 426:
                window.location.reload(true);
                break;

              case 429:
                _this.$root.$dialog.alert("Servico indisponível. Aguarde 5 minutos e tente novamente.", "error");
                break;
            }
          }

          promisses.push(response);

          if (_this.requestParam.method != "GET" && response.status != 200 && response.status != 426 && response.status != 403 && response.status != 401 && response.status != 404) {
            _this.$root.$dialog.alert(response.msg, "error");
            _this.dados = response;
          }

          _this.removeStyle();

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
            resolve(success[0]);
          }, function (err) {});
        });
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "session",
  components: {},
  mixins: [],
  computed: {
    cliente: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setCliente", value);
      }
    },
    production: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    usuario: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.inicialize();
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    empresa: {
      cache: false,
      get: function get() {
        return this.$store.state.empresa.logged;
      },
      set: function set(value) {
        this.inicialize();
        this.$store.dispatch("empresa/setEmpresa", value);
      }
    },
    jwt: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario.jwt;
      },
      set: function set(jwt) {
        this.$store.dispatch("usuario/setJwt", jwt);
      }
    },
    sub_domain: {
      cache: false,
      get: function get() {
        return this.$store.state.common.sub_domain;
      },
      set: function set(value) {
        this.$store.dispatch("common/setSubDomain", value);
      }
    },
    tenant: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente.tenant;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setTenant", value);
      }
    },
    env: {
      cache: false,
      get: function get() {
        return this.$store.state.common.env;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEnv", value);
      }
    },
    event: {
      cache: false,
      get: function get() {
        return this.$store.state.common.event;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEvent", value);
      }
    },
    navigation: {
      cache: false,
      get: function get() {
        return this.$store.state.common.navigation;
      },
      set: function set(value) {
        this.$store.dispatch("common/setNavigation", value);
      }
    },
    window: {
      cache: false,
      get: function get() {
        return this.$store.state.common.window;
      },
      set: function set(value) {
        this.$store.dispatch("common/setWindow", value);
      }
    },
    device: {
      cache: false,
      get: function get() {
        return this.$store.state.common.device;
      }
    },
    pcmso: {
      cache: false,
      get: function get() {
        return this.$store.state.common.pcmso;
      },
      set: function set(value) {
        this.$store.dispatch("common/setPcmso", value);
      }
    }
  },
  watch: {
    sub_domain: function sub_domain() {},
    navigation: function navigation() {},
    window: function window() {},
    "cliente.logged": function clienteLogged() {
      this.setTitle();
    },
    "usuario.logged": function usuarioLogged() {}
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    inicialize: function inicialize() {
      var self = this;

      this.$root.$socket.publicChannel("AuthChannel").listen(".DisparoNotifyEvent", function (obj) {
        console.log(obj);
        if (obj.data.error) {
          self.$root.$notify.warning(obj.data.error);
        } else {
          self.$root.$notify.success(obj.data);
        }

        self.event = 'DisparoNotifyEvent';
      });

      this.$root.$socket.publicChannel("AuthChannel").listen(".LogEmailNotifyEvent", function (obj) {
        console.log(obj);
        self.event = 'LogEmailNotifyEvent';
      });
    },
    logout: function logout(reload) {
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
      this.clearSession(true);

      this.$router.push({ name: this.sub_domain + ".login" });
    },
    clearSession: function clearSession() {
      this.deleteCookie(this.getJwt());
    },
    validarAcesso: function validarAcesso(modulo) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_modulo.indexOf(modulo) != -1;
    },
    validarPermissao: function validarPermissao(permissao) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_permissao.indexOf(permissao) != -1;
    },
    validarPacote: function validarPacote(pacote) {
      return (this.cliente.logged && this.cliente.logged.pacotes.indexOf(pacote)) != -1;
    },
    toRoute: function toRoute(route, type) {
      type = type ? type : "name";

      var query = this.$route.query;

      switch (type) {
        case "location":
          window.open(route, "_top");
          break;

        default:
          if ((typeof route === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(route)) == "object") {
            route.query = query;
          }

          this.$router.push(route);
          break;
      }
    },
    logged: function logged() {
      var jwt = this.getJwt(),
          cookie = null;

      if (!jwt) return null;

      cookie = __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(jwt);

      return cookie;
    },
    getJwt: function getJwt(parse) {
      var jwt = null;

      try {
        jwt = this.env["jwt_" + this.sub_domain];

        if (!jwt) return null;

        if (parse) return __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(jwt);

        return jwt;
      } catch (error) {
        this.edAlert(error, "error");
      }
    },
    setTitle: function setTitle(title) {
      if (!title) {
        var to = this.$route;
        if (to.meta && to.meta.title && to.meta.navigation) {
          title = to.meta.title;
        }
      }

      title = title.toUpperCase();

      switch (this.sub_domain) {
        case "web":
          document.title = title + " :: " + (this.cliente.logged ? this.cliente.logged.nome : "");
          break;

        case "empresa":
          document.title = "Area da Empresa" + (title ? " :: " + title : "");
          break;

        case "credenciada":
          document.title = "Area da Credenciada" + (title ? " :: " + title : "");
          break;

        case "parceiro":
          document.title = "Area do Parceiro" + (title ? " :: " + title : "");
          break;
      }
    },
    setCookie: function setCookie(key, value, _expires, toJSONString) {
      if (this.getCookie(key)) return;

      _expires = _expires ? _expires : 8;

      if (toJSONString) {
        value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
      }

      if (_expires == -1) {
        _expires = 720;
      }

      var date = this.$utilidade.addDate(_expires, null, "h");

      var test = __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(key, value, {
        expires: date,

        secure: false,
        path: "/"
      });
    },
    getCookie: function getCookie(key, toJSON) {
      if (toJSON) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(key));
      }
      return __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(key);
    },
    deleteCookie: function deleteCookie(key) {
      if (__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(key)) {
        __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.delete(key);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laravel_echo__ = __webpack_require__(409);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdSocket",
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    inicialize: function inicialize() {
      if (!window.Echo) {
        var host = __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).URL_SOCKET;

        if (!__webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).PRODUCTION) {
          host = "https://" + window.location.hostname;
        }

        window.io = __webpack_require__(1030);
        window.Echo = new __WEBPACK_IMPORTED_MODULE_0_laravel_echo__["a" /* default */]({
          broadcaster: "socket.io",
          encrypted: true,
          key: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).SOCKET_KEY,
          host: host,
          transports: ['websocket', 'polling', 'flashsocket']
        });
      }
    },
    publicChannel: function publicChannel(_channel) {
      this.inicialize();
      return window.Echo.channel(this.$root.$session.env.app_name + '.' + this.$root.$session.cliente.logged.id + '.' + _channel);
    },
    privateChannel: function privateChannel(_channel) {
      this.inicialize();
      return window.Echo.private(this.$root.$session.env.app_name + '.' + this.$root.$session.cliente.logged.id + '.' + _channel);
    }
  }
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdAlert",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    type: {
      type: String,
      required: false,
      default: "success"
    },
    description: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdButton",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  props: {
    text: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: [Boolean, String],
      required: false,
      default: null
    },
    type: {
      type: String,
      default: function _default() {
        return "primary";
      }
    },
    size: {
      type: String,
      default: function _default() {
        return "medium";
      }
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdButton__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EdButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdAlert__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdAlert__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdForm",
  mixins: [],
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_0__EdButton___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_1__EdAlert___default.a },
  props: {
    block: {
      type: Boolean,
      required: false,
      default: false
    },
    reset: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    blockMessage: {
      type: String,
      required: false,
      default: 'Você não tem permissão para acessar essa funcionalidade'
    },
    handlerSave: {
      type: Function,
      required: false,
      default: null
    },
    labelButton: {
      type: String,
      required: false,
      default: "Salvar"
    },
    colorButton: {
      type: String,
      required: false,
      default: "primary"
    },
    iconButton: {
      type: String,
      required: false,
      default: "fa fa-floppy-o"
    },
    classFooter: {
      type: String,
      default: "text-right"
    },
    recaptcha: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: "form-" + this.$utilidade.randomString(),
      recaptchaKey: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).GOOGLE_RECAPTCHA,
      recaptchaId: 1
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    validar: function validar() {

      if (this.handlerSave) {
        this.handlerSave();
      }
    },
    resetValidation: function resetValidation() {
      this.$refs[this.ref].resetValidation();
    },
    onRecaptchaVerify: function onRecaptchaVerify(ev) {
      this.$emit("recaptcha", ev);
    },
    onRecaptchaError: function onRecaptchaError(ev) {
      this.$emit("recaptcha", null);
    },
    onRecaptchaRender: function onRecaptchaRender(id) {}
  },
  watch: {
    block: function block() {},
    loading: function loading() {},
    blockMessage: function blockMessage() {},
    recaptchaResponse: function recaptchaResponse() {},
    reset: function reset() {
      this.resetValidation();
    },
    "formData.recaptcha": function formDataRecaptcha() {},
    "$root.$request.getResponse": function $root$requestGetResponse() {
      var response = this.$root.$request.getResponse;

      if (response && response.status == 503) {
        this.recaptchaId++;
      }
    }
  }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputAutoComplete",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    items: {
      type: [Array],
      required: false,
      default: function _default() {
        return [];
      }
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id"
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome"
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      search: null,
      timerId: null
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.remoteMethod = _.debounce(this.remoteMethod, 1000);
  },

  computed: {},
  methods: {
    remoteMethod: function remoteMethod(val) {
      this.$emit("search", val);
    },
    getLabel: function getLabel(item) {
      var retorno = item[this.itemText];

      switch (this.itemText) {
        case "fdt":
          retorno = item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          retorno = item.rev + " (" + item.descricao + ")";
          break;

        case "ghe":
          retorno = item.ghe + " (" + item.descricao + ")";
          break;

        case "funcionario":
          retorno = item.nome;
          break;

        case "esocial":
          retorno = item.codigo + " - " + item.nome;
          break;
      }

      return retorno;
    },
    getValue: function getValue(item) {
      if (this.isObject) {
        return item;
      }

      return item[this.itemValue];
    },
    getHtml: function getHtml(item) {
      switch (this.itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo + " - " + item.nome;
          break;

        case "funcionario":
          return item.nome + (item.funcao ? '<br><span style="font-size:8pt"><b>' + item.funcao.nome + "</b></span>" : "");
          break;

        case "epi":
          return (this.maxLenght ? '<span title="' + item.nome + '">' + this.$utilidade.textLimit(item.nome, this.maxLenght) + "</span>" : item.nome) + (item.ca ? " | <b>CA:</b> " + item.ca : "") + (item.categoria ? " | <b>Categoria:</b> " + item.categoria.nome : "");
          break;

        default:
          return this.maxLenght ? '<span title="' + item[this.itemText] + '">' + this.$utilidade.textLimit(item[this.itemText], this.maxLenght) + '</span>' : item[this.itemText];
          break;
      }
    }
  },
  watch: {
    items: function items() {}
  }
});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputDate",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    maxDaysTomorrow: {
      type: [String, Number],
      required: false,
      default: null
    },
    tomorrowDisabled: {
      type: [Boolean],
      required: false,
      default: false
    },
    yesterdayDisabled: {
      type: [Boolean],
      required: false,
      default: false
    },
    type: {
      type: [String],
      required: false,
      default: "date"
    },
    format: {
      type: [String],
      required: false,
      default: "dd/MM/yyyy"
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    handleDateOptions: function handleDateOptions() {
      var options = {};

      if (this.yesterdayDisabled || this.tomorrowDisabled) {
        options.disabledDate = this.handlerDisable;
      }

      return options;
    }
  },
  methods: {
    handlerDisable: function handlerDisable(date) {
      var hoje = this.$utilidade.toDate(null, true, "YYYY-MM-DD");
      date = this.$utilidade.toDate(date, true, "YYYY-MM-DD");

      if (this.tomorrowDisabled && this.maxDaysTomorrow) {
        var amanha = this.$utilidade.toDate(this.$utilidade.addDate(this.maxDaysTomorrow, hoje, "d"), true, "YYYY-MM-DD");

        if (date > amanha) {
          return true;
        }
      }

      return date < hoje;
    }
  }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputEditor",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    }
  },
  data: function data() {
    return {
      id: "ckeditor-" + this.$utilidade.randomString(),
      editorUrl: "https://www1.softwareatento.com.br" + "/0.recursos/ckeditor_447_full/ckeditor.js?v=" + this.$root.$session.getCookie("version"),
      editorConfig: {
        language: "pt-br"
      }
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.inicialize();
  },

  computed: {},
  methods: {
    inicialize: function inicialize() {}
  }
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputItem",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    getError: function getError() {
      if (this.$root.$request.dados && this.$root.$request.dados.status == 400 && this.$root.$request.dados.options && this.$root.$request.dados.options.data && this.name) {
        return this.$root.$request.dados.options.data[this.name];
      }
    }
  },
  methods: {}
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputAutoComplete",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    items: {
      type: [Array],
      required: false,
      default: function _default() {
        return [];
      }
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id"
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome"
    },
    itemGroup: {
      type: [Boolean],
      required: false,
      default: null
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      search: null,
      timerId: null
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.remoteMethod = _.debounce(this.remoteMethod, 1000);
  },

  computed: {},
  methods: {
    remoteMethod: function remoteMethod(val) {
      this.$emit("search", val);
    },
    getLabel: function getLabel(item) {

      var itemText = item.itemText ? item.itemText : this.itemText;

      switch (itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + " EM " + this.$utilidade.toDate(item.vencimento, true) + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo;
          break;

        case "tabela_dinamica":
          return item.nome;
          break;

        default:
          return item[this.itemText];
          break;
      }
    },
    getValue: function getValue(item) {
      if (this.isObject) {
        return item;
      }

      return item[this.itemValue];
    },
    getHtml: function getHtml(item) {

      var itemText = item.itemText ? item.itemText : this.itemText;

      switch (itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + " EM " + this.$utilidade.toDate(item.vencimento, true) + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo;
          break;

        case "tabela_dinamica":
          return '<span style="width:40px;margin-bottom:1px;margin-rigth:5px;float:left;background:' + item.cor + '">&nbsp;</span>' + item.nome;
          break;
        case "fator_risco":

          return "<b>" + item.nome + "</b>" + (item.cod_esocial ? '<br><span style="font-size:9pt">' + item.cod_esocial + "</span>" : "") + (item.cod_metodologia && item.cod_metodologia != "***" ? (!item.cod_esocial ? "<br>" : "") + '<span style="font-size:9pt"> (' + item.cod_metodologia + ")</span>" : "");
          break;

        default:
          return item[this.itemText];
          break;
      }
    }
  },
  watch: {
    items: function items() {}
  }
});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputSelectTipo",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    tipo: {
      type: [String, Number],
      required: true
    },
    exclude: {
      type: [Array],
      required: false,
      default: function _default() {
        return [];
      }
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false
    },
    isRadio: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      items: [],
      loadingTipo: false
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.getTipo();
  },

  computed: {},
  methods: {
    getTipo: function getTipo() {
      var _this = this;

      if (!this.tipo) return;

      this.items = [];
      this.loadingTipo = true;

      this.$root.$request.post("tipo/parent", {
        codigo: [this.tipo],
        exclude: this.exclude
      }).then(function (result) {
        _this.loadingTipo = false;
        if (result.status == 200) {
          _this.items = result.data[_this.tipo];
        }
      });
    }
  },
  watch: {
    tipo: function tipo() {
      this.getTipo();
    }
  }
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputSwitch",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {},
  data: function data() {
    return {
      items: [{
        id: 1,
        descricao: "Sim"
      }, {
        id: 0,
        descricao: "Não"
      }]
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {},
  watch: {}
});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputText",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputText",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputText",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_download__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdInputItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EdInputItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputUpload",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { Download: __WEBPACK_IMPORTED_MODULE_1_common_download___default.a, EdInputItem: __WEBPACK_IMPORTED_MODULE_2__EdInputItem___default.a },
  props: {
    extensoes: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    isBase: {
      type: Boolean,
      required: false,
      default: false
    },
    accept: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    currentFile: {
      type: [Object, Array, File],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    getAccept: function getAccept() {
      var arrayExtensoes = [];

      var extensoes = {
        doc: ["application/msword"],
        jpg: ["image/jpeg"],
        text: ["text/plain"],
        svg: ["image/svg+xml"],
        xls: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
        pfx: ["application/x-pkcs12"],
        crt: ["application/pkix-cert"]
      };

      this.extensoes.forEach(function (value) {
        if (extensoes[value]) {
          arrayExtensoes.push(extensoes[value].join(","));
        }
      });

      return arrayExtensoes.join(",");
    }
  },
  methods: {
    onChangeFile: function onChangeFile(e) {

      e.preventDefault();
      var file = e.target.files[0];

      this.$emit("input", file);
      this.$emit("change", file);
    },
    clearFiles: function clearFiles() {
      this.$refs["file-input-" + this.input].reset();
    },
    handleChange: function handleChange(e) {
      if (this.onChangeFile) this.onChangeFile(e);

      e.preventDefault();

      this.$events.fire("upload-" + this.input, e.target.files[0]);
    }
  },

  watch: {
    accept: function accept() {},
    extensoes: function extensoes() {}
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-modal",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_1_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_session___default.a],
  props: {
    title: {
      type: String,
      default: 'Modal'
    },
    modal: {
      type: Boolean,
      default: false
    },
    loadingSave: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '95%'
    },
    saveIcon: {
      type: String,
      default: 'fa fa-save'
    },
    closeESC: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: true
    },
    closeCLICK: {
      type: Boolean,
      default: false
    },
    lodingSave: {
      type: Boolean,
      default: false
    },
    saveName: {
      type: String,
      default: 'Salvar'
    },
    onSave: {
      type: Function,
      default: null
    },
    onClose: {
      type: Function,
      default: null
    }

  },
  watch: {
    title: function title() {},
    modal: function modal() {
      this.showModal = !this.showModal;
    },
    loading: function loading() {},
    loadingSave: function loadingSave() {},
    width: function width() {},
    saveIcon: function saveIcon() {},
    closeESC: function closeESC() {},
    isModal: function isModal() {},
    closeCLICK: function closeCLICK() {},
    lodingSave: function lodingSave() {},
    saveName: function saveName() {},
    onSave: function onSave() {}
  },

  data: function data() {
    return {
      showModal: false
    };
  },
  mounted: function mounted() {},


  methods: {
    handlerClose: function handlerClose() {
      if (this.onClose) {
        this.onClose();
      } else {
        this.showModal = false;
      }
    }
  }
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _props;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-form-mixin",
  components: {},
  props: (_props = {
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: [Boolean, Number],
      required: false,
      default: false
    },
    disabledItem: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: [String],
      required: false,
      default: null
    },
    color: {
      type: [String],
      required: false,
      default: null
    },
    width: {
      type: [Number, String],
      required: false,
      default: "auto"
    },
    info: {
      type: [Number, String],
      required: false,
      default: null
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: null
    },
    maxLenght: {
      type: [Number, String],
      required: false,
      default: null
    },
    label: {
      type: [Number, String, Boolean],
      required: false,
      default: ''
    },
    title: {
      type: [Number, String],
      required: false,
      default: null
    },
    value: {
      type: [Number, String, Boolean, Array, Object, Date, File, Event],
      required: false,
      default: null
    },
    valueKey: {
      type: [String],
      required: false,
      default: 'id'
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "color", {
    type: [String],
    required: false,
    default: "primary"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "iconRight", {
    type: String,
    required: false,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "iconLeft", {
    type: String,
    required: false,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "classe", {
    type: [String],
    required: false,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "filterable", {
    type: Boolean,
    required: false,
    default: false
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "multiple", {
    type: Boolean,
    required: false,
    default: false
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "remote", {
    type: Boolean,
    required: false,
    default: false
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "placeholder", {
    type: String,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "rules", {
    type: [String],
    required: false,
    default: function _default() {
      return null;
    }
  }), _props),
  data: function data() {
    return {
      intUniqId: Date.now(),
      validateClass: "",
      labelHtml: "",
      errors: {}
    };
  },

  methods: {
    setEvent: function setEvent(event, data) {
      this.$emit(event, data);
      this.$root.$session.event = {
        event: event,
        data: data
      };
    },
    focus: function focus() {
      if (this.$refs.field) {
        this.$refs.field.focus();
      }
    },
    validate: function validate($event) {}
  },
  mounted: function mounted() {},

  computed: {
    getError: function getError() {

      if (this.errors[this.name]) {
        return this.errors[this.name];
      }
      return false;
    },
    getErrorContents: function getErrorContents() {
      var response = this.$root.$request.getResponse;

      if (response && response.status == 400) {
        for (var field in response.data.error.options) {
          if (field == this.name) {
            return response.data.error.options[field];
          }
        }
      }

      return [];
    },
    getRules: function getRules() {
      var _this = this;

      var rules = [];
      var arrayAux = [];

      if (this.rules) {
        arrayAux = this.rules.split("|").concat(arrayAux);

        arrayAux.forEach(function (rule) {
          if (rule.indexOf("required") != -1) {
            rules.push(function (v) {
              return !!v || "Campo obrigatório";
            });
          }

          if (rule.indexOf("email") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isEmail(v) || "Email inválido";
            });
          }

          if (rule.indexOf("numeric") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isNumeric(v) || "Digite um número válido";
            });
          }

          if (rule.indexOf("cpf") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isCpf(v) || "Digite um CPF válido";
            });
          }

          if (rule.indexOf("date") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isDate(v) || "Digite uma data válida no formato dd/mm/aaaa";
            });
          }

          if (rule.indexOf("cnpj") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isCnpj(v) || "Digite um CNPJ válido";
            });
          }

          if (rule.indexOf("min:") != -1) {
            var min = parseInt(rule.split(":")[1]);

            rules.push(function (v) {
              return v && v.length >= min || "Campo deve conter ao menos " + min + " caracteres";
            });
          }

          if (rule.indexOf("max:") != -1) {
            var max = parseInt(rule.split(":")[1]);

            rules.push(function (v) {
              return v && v.length <= max || "Campo deve conter até " + max + " caracteres";
            });
          }
        });
      }

      return rules;
    }
  },
  watch: {
    name: function name() {},
    label: function label() {},
    value: function value() {},
    multiple: function multiple() {},
    clearable: function clearable() {},
    required: function required() {},
    loading: function loading() {},
    disabled: function disabled() {},
    readonly: function readonly() {},
    valueKey: function valueKey() {},
    maxLenght: function maxLenght() {}
  }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'Digite sua senha para continuar',
    placeholder: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Informe abaixo o motivo do cancelamento da consulta',
    placeholder: '',
    maxlength: 1000,
    rows: 5,
    rules: ['required']
}]);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Gerais'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'grau_estudo',
    label: 'Grau de Estudo',
    clearable: true,
    tipo: 122,
    valor: 'valor',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'pa1',
    maxlength: 3,
    label: 'Pressão Arterial Baixa (mmHg)',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'pa2',
    maxlength: 3,
    label: 'Pressão Arterial Alta (mmHg)',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'peso',
    label: 'Peso (Kg)',
    mask: 'money',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'altura',
    label: 'Altura (metros)',
    mask: 'money',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'ESTILO DE VIDA E ANTECEDENTES'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q18',
    label: 'Bebida Alcoólica',
    valor: 'valor',
    tipo: 134,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q132',
    label: 'Tem boa Visão',
    valor: 'id',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q164',
    label: 'Usa Óculos ou Lente de Contato',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q1128',
    label: 'Diabetes',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q1128',
    label: 'Pressão Alta',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q1128',
    label: 'Câncer',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q14',
    label: 'Fuma',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd14',
    label: 'Quantos cigarros ao dia/tempo',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q116',
    label: 'Pratica Esporte',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd116',
    label: 'Qual esporte e quantas vezes na semana',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q11024',
    label: 'Cirurgia ou Operação',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd11024',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q12048',
    label: 'Toma Algum Medicamento',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd12048',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q14096',
    label: 'Alergia',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd14096',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q18192',
    label: 'Já Esteve Internado',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd18192',
    label: 'Porquê',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q116384',
    label: 'Já Recebeu Sangue de Alguém',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd116384',
    label: 'Quando',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q132768',
    label: 'Tem Alguma Doença',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd132768',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q165536',
    label: 'Algum Acidente de Trabalho',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd165536',
    label: 'Quando',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q22',
    label: 'Tem Alguma Queixa',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd22',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'PELE E MUCOSAS'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q34',
    label: '',
    tipo: 139,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'CABEÇA E PESCOÇO'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q44',
    label: '',
    tipo: 144,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'TÓRAX'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q54',
    label: '',
    tipo: 152,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'ABDOME'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q64',
    label: '',
    tipo: 158,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'MÃOS/PUNHOS/OMBROS/COTOVELOS'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q74',
    label: '',
    tipo: 164,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'MEMBROS INFERIORES'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q84',
    label: '',
    tipo: 167,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'COLUNA'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q94',
    label: '',
    tipo: 171,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'CONCLUSÃO MÉDICA'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'conclusao',
    label: 'Conclusão',
    valor: 'valor',
    tipo: 180,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'observacoes',
    label: 'Observações Gerais',
    rules: ['']
}]);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'aptidao',
    label: 'Aptidão',
    valor: 'valor',
    tipo: 185,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_alt',
    label: 'Trabalho em Altura',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_esp',
    label: 'Trabalho em Espaço Confinado',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'exames',
    label: 'Informe os Exames Alterados (caso existir algum)',
    clearable: true,
    multiple: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'upload',
    field: 'arquivo_aso',
    label: 'Selecionar ASO (em PDF)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'upload',
    field: 'arquivo_femo',
    label: 'Selecionar Ficha Clínica (em PDF)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'upload',
    field: 'arquivo_exame',
    label: 'Selecionar Exames Complementares (em PDF)',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 53,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'Digite sua Senha',
    placeholder: 'Para continuar você deve inserir sua senha',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    placeholder: 'Digite algo sobre a liberação',
    rules: ['required']
}]);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações da Consulta'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7',
    type: 'text',
    field: 'funcionario',
    label: 'Trabalhador (a)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_funcao',
    label: 'Função',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'id_ghe',
    label: 'GHE (Setor)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    field: 'data_age',
    label: 'Data do Agendamento da Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    tipo: 46,
    field: 'id_tipo_aso',
    label: 'Tipo de Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Selecione uma Ação'
}]);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'agendamento_at',
    label: 'Data do Agendamento',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'deleted',
    label: 'Mostrar Consultas Excluídas',
    rules: ['']
}]);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'SENHA',
    prefix: 'fa fa-key',
    rules: ['required']
}]);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}]);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações de Cadastro'
}, {
    id: 1,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    rules: ['required']
}, {
    id: 2,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
    type: 'text',
    field: 'nome',
    maxlength: 255,
    label: 'Nome',
    rules: ['required']
}, {
    id: 3,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'email',
    field: 'email',
    maxlength: 100,
    label: 'Email',
    rules: ['required', 'email']
}, {
    id: 4,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'tel_com',
    label: 'Telefone',
    mask: 'telefone',
    rules: ['required']
}, {
    id: 5,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'cep',
    maxlength: 10,
    field: 'cep',
    label: 'CEP',
    mask: 'cep',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 500,
    field: 'end',
    label: 'Endereço',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 50,
    field: 'num',
    label: 'Número',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'bairro',
    label: 'Bairro',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 50,
    field: 'comp',
    label: 'Complemento',
    rules: ['required']
}, {
    id: 8,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    rules: ['required']
}, {
    id: 9,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    rules: ['required']
}, {
    id: 14,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Representante Legal da Empresa'
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_nome',
    label: 'Nome',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_email',
    label: 'Email',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_tel_com',
    label: 'Telefone',
    mask: 'celular',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Alterar Minha Senha'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_cpf',
    label: 'Login',
    mask: 'cpf',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_email',
    label: 'Email',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_atual',
    label: 'Senha Atual',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_nova',
    label: 'Nova Senha (Mínimo 6 caracteres)',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_confirma',
    label: 'Confirmar Nova Senha',
    rules: []
}]);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações da Consulta'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7',
    type: 'text',
    field: 'funcionario',
    label: 'Trabalhador (a)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_funcao',
    label: 'Função',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'id_ghe',
    label: 'GHE (Setor)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'date',
    field: 'data_age',
    info: 'A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.',
    yesterdayDisabledDate: true,
    label: 'Data do Agendamento da Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    tipo: 46,
    field: 'id_tipo_aso',
    label: 'Tipo de Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    rules: ['required']
}]);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'agendamento_at',
    label: 'Data do Agendamento',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_cre',
    label: 'Credenciada',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'deleted',
    label: 'Mostrar Consultas Excluídas',
    rules: ['']
}]);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}]);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'SENHA',
    prefix: 'fa fa-key',
    rules: ['required']
}]);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}]);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'email',
    label: 'Email',
    maxlength: 500,
    info: 'Digite apenas um ou mais emails separados por ; (ponto e vírgula)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'tipo',
    tipo: 32,
    label: 'Setor (Tipo de Email)',
    multiple: true,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    multiple: true,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ativo',
    label: 'Ativo',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    info: '',
    rules: ['']
}]);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações de Cadastro'
}, {
    id: 1,
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    rules: ['required']
}, {
    id: 2,
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'text',
    field: 'nome',
    maxlength: 255,
    label: 'Nome',
    rules: ['required']
}, {
    id: 4,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'tel_com',
    label: 'Telefone',
    mask: 'telefone',
    rules: ['required']
}, {
    id: 5,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'cep',
    maxlength: 10,
    field: 'cep',
    label: 'CEP',
    mask: 'cep',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 500,
    field: 'end',
    label: 'Endereço',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 50,
    field: 'num',
    label: 'Número',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'bairro',
    label: 'Bairro',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 50,
    field: 'comp',
    label: 'Complemento',
    rules: ['required']
}, {
    id: 8,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    rules: ['required']
}, {
    id: 9,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    rules: ['required']
}, {
    id: 14,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Representante Legal da Empresa'
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_nome',
    label: 'Nome',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_email',
    label: 'Email',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_tel_com',
    label: 'Telefone',
    mask: 'celular',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Alterar Minha Senha'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_cpf',
    label: 'Login',
    mask: 'cpf',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_email',
    label: 'Email',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_atual',
    label: 'Senha Atual',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_nova',
    label: 'Nova Senha (Mínimo 6 caracteres)',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_confirma',
    label: 'Confirmar Nova Senha',
    rules: []
}]);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Filtrar Periódico'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'periodo',
    label: 'Período',
    mask: 'date',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    multiple: true,
    label: 'Frente de Trabalho',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    option: {
        key: 'id',
        label: 'funcionario',
        value: 'id'
    },
    label: 'Funcionário',
    multiple: true,
    rules: ['']
}]);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'agendamento_at',
    label: 'Data do Agendamento',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    clearable: true,
    option: {
        label: 'fdt',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcao',
    label: 'Função',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'deleted',
    label: 'Mostrar Consultas Excluídas',
    rules: ['']
}]);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'aptidao',
    label: 'Aptidão',
    valor: 'valor',
    tipo: 185,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_alt',
    label: 'Trabalho em Altura',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_esp',
    label: 'Trabalho em Espaço Confinado',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'exames',
    label: 'Informe os Exames Alterados (caso existir algum)',
    clearable: true,
    multiple: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 53,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'Digite sua Senha',
    placeholder: 'Para continuar você deve inserir sua senha',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    placeholder: 'Digite algo sobre a liberação',
    rules: ['required']
}]);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'boolean',
    field: 'id_arquivo_aso',
    label: 'Mostrar Apenas Consultas com ASO Digitalizado ',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'boolean',
    field: 'inativo',
    label: 'Mostrar Apenas Consultas Excluídas ',
    rules: ['']
}]);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'number',
    field: 'page',
    label: 'Página',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Empresa',
    option: {
        label: 'empresa',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fun',
    label: 'Trabalhador',
    option: {
        label: 'funcionario',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_con',
    label: 'Consulta',
    option: {
        label: 'consulta',
        value: 'id_con'
    },
    rules: ['required']
}]);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-912 col-lg-912 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-912 col-lg-912 col-xl-12',
    type: 'text',
    field: 'email',
    label: 'Email',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'usuario',
    label: 'Usuário',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'password',
    field: 'senha',
    label: 'Senha',
    maxlength: 500,
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'servidor_smtp',
    label: 'Servidor SMTP',
    maxlength: 500,
    info: 'Servidor STMP do seu provedor. Exemplo: smtp.gmail.com, stmp.google.com, etc',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'porta',
    label: 'Porta',
    maxlength: 500,
    info: 'A maioria dos servidores utilizam a porta 587. Na dúvida entre em contato com seu provedor para saber qual a porta de autenticação.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'boolean',
    field: 'autenticacao',
    label: 'Seu servidor requer autenticação?',
    info: 'A maioria dos servidores requerem autenticação. É recomendado que deixe esse campo habilitado.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'tipo',
    label: 'Serviços Vinculados',
    tipo: 32,
    multiple: true,
    info: 'Selecione os serviços que utilizarão essa conta de email',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'conexao_seg',
    tipo: 240,
    valor: 'valor',
    label: 'Seu Servidor Requer uma Conexão de Segurança?',
    info: 'A maioria dos servidores requerem autenticação TLS.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'number',
    field: 'tempo_espera',
    label: 'Tempo de Espera (Segundos)',
    info: 'Recomenda-se deixar 0 (zero)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'number',
    field: 'n_msg_pct',
    label: 'MARKETING - Nº Mensagens por Pacote',
    info: 'Recomenda-se deixar 50',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'number',
    field: 't_esp_pct',
    label: 'MARKETING - Tempo espera entre Pacote(s)',
    info: 'Recomenda-se deixar 600',
    rules: ['required']
}]);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-912 col-lg-912 col-xl-12',
    type: 'text',
    field: 'email',
    label: 'Digite um Email',
    rules: ['required']
}]);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    title: {
        model: 'empresa_envio_automatico',
        description: 'ssss'
    },
    info: '',
    clearable: true,
    placeholder: 'Todas',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    info: '',
    clearable: true,
    placeholder: 'Todas',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionario',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    clearable: true,
    placeholder: 'Todos',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 327,
    multiple: true,
    placeholder: 'Todos',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'data_cadastro',
    label: 'Data de Cadastro',
    info: '',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'esocial_tabela',
    label: 'Layout',
    option: {
        key: 'id',
        label: 'esocial',
        value: 'object'
    },
    info: 'Selecione um LAYOUT para gerar os arquivos XML',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Habilitar envio de Lotes',
    info: 'Ao habilitar essa opção o sistema vai enviar automaticamente (todo dia as 00:00) os lotes para seus clientes.',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10',
    type: 'date',
    field: 'data_inicio',
    label: 'Iniciar Envio EM',
    info: 'Data de inicio do envio dos Lotes.',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'empresas',
    label: 'Empresa - Gerar Lote',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Selecione as empresas que receberam os emails de Lotes do Esocial. Deixe em branco para enviar a todas as empresas.',
    placeholder: 'Todas',
    clearable: true,
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'empresas_processar',
    label: 'Empresa - Processar Lote',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Selecione as empresas que serão enviados os lotes processados diretamente para o eSocial.',
    clearable: true,
    multiple: true,
    rules: ['']
}]);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'destinatario',
    label: 'Destinatário',
    info: 'Para enviar mais de um destinatário, por favor separe os emails com `;` (ponto e vírgula)',
    rules: ['required']
}]);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadstro',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_ltcat',
    tipo: 203,
    label: 'Como deseja gerar o LTCAT',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-8',
    type: 'select-tipo',
    field: 'id_tipo_revisao',
    tipo: 1,
    label: 'Tipo da Revisão',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'date',
    field: 'data',
    label: 'Data Documento',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-revisao',
    field: 'id_rev',
    label: 'Selecione o PPRA para copiar',
    info: '',
    option: {
        key: 'id',
        label: 'revisao',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-revisao',
    field: 'id_ltcat',
    option: {
        key: 'id',
        label: 'revisao',
        value: 'id'
    },
    label: 'Selecione o LTCAT para copiar',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    info: '',
    rules: ['']
}]);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações do Documento'
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    title: {
        link: 'id_emp',
        icon: 'fa fa-pencil-square-o'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-tipo',
    field: 'id_tipo_revisao',
    tipo: 1,
    label: 'Tipo da Revisão',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'date',
    field: 'data',
    label: 'Data Documento',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5',
    type: 'select-custom',
    field: 'id_mod',
    label: 'Modelo do Documento',
    option: {
        key: 'id',
        label: 'modelo',
        value: 'id'
    },
    info: 'Para criar novos modelos acesso o menú LTCAT Modelos',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'id_res',
    label: 'Responsável pelo LTCAT',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_ltcat',
    tipo: 203,
    label: 'Tipo do cadastro do LTCAT',
    info: '',
    disabled: true,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'id_rev',
    label: 'PPRA Copiado',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    info: '',
    rules: ['']
}]);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'vencimento',
    label: 'Vencimento',
    info: '',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'descricao',
    label: 'Descrição',
    maxlength: 300,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'upload',
    field: 'arquivo',
    multiple: false,
    accept: '.jpg, .png, .jpeg, .pdf, .zip',
    label: 'Selecione o Arquivo - Até 50 MB (imagem,pdf,zip)',
    info: 'Caso precisar fazer upload de mais de um arquivo, você pode compactar esses arquivos no formato ZIP e fazer upload do arquivo compactado.',
    rules: ['']
}]);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 255,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao',
    label: 'Descrição',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ativo',
    label: 'Registro Ativo?',
    rules: ['required']
}]);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ocultar',
    label: 'Ocultar Conteúdo',
    info: 'Se esse campo estiver habilitado, esse conteúdo não será exibido no documento final LTCAT',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'ocultar_texto',
    label: 'Substituir o Conteúdo pelo Texto Abaixo',
    placeholder: 'Não se aplica',
    info: 'Ao ocultar o item, você pode definir um teste padrão que será mostrado no item em questão',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'fator_riscos',
    label: 'Mostrar SOMENTE para os seguintes Fatores de Riscos',
    multiple: true,
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Aqui você pode definir uma exceção para o bloqueio do campo. Insira os fatores de riscos que permitirão a visualização do conteúdo no documento LTCAT. Deixe em branco para bloquear totalmente.',
    rules: ['']
}]);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'copiar',
    label: 'Copiar Medições e Funções do seguinte GHE',
    option: {
        key: 'id',
        label: 'ghe',
        value: 'id'
    },
    info: 'Selecione um GHE para copiar as medições e funções já cadastradas.',
    rules: ['']
}]);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'replicar',
    label: 'Replicar Medição para os Seguintes GHE',
    multiple: [],
    option: {
        key: 'id',
        label: 'ghe',
        value: 'id'
    },
    title: {
        model: 'replicar_subs'
    },
    info: 'Caso essa medição seja igual em vários GHE, você pode replicar essa configuração em vez de cadastrar individualmente para cada setor.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_con_tec',
    label: 'Selecionar uma Conclusão Técnica Existente',
    option: {
        key: 'id',
        label: 'nome',
        value: 'object'
    },
    info: 'Para incluir uma conclusão técnica na base de dados, acesse o menú LTCAT > Confgurações > Conclusão Técnica',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 255,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao',
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'number',
    field: 'ordem',
    label: 'Ordem',
    info: 'Esse campo é utilizado para ordenar o GHE',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'ghe',
    label: 'GHE',
    maxlength: 15,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'text',
    field: 'descricao',
    label: 'Descrição',
    maxlength: 150,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ordenar',
    label: 'Ordenar as colunas a partir daqui',
    info: 'Habilite essa opção se quiser ordenar as os GHE a partir desse item. Isso funciona caso precisar incluir um GHE entre vários outros.',
    rules: ['']
}]);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'replicar',
    label: 'Replicar Função para os Seguintes GHE',
    multiple: [],
    option: {
        key: 'id',
        label: 'ghe',
        value: 'id'
    },
    title: {
        model: 'replicar_subs'
    },
    info: 'Caso essa medição seja igual em vários GHE, você pode replicar essa configuração em vez de cadastrar individualmente para cada setor.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fun',
    label: 'Função',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cbo',
    label: 'CBO',
    mask: 'cbo',
    maxlength: 45,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao',
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_orcamento',
    tipo: 234,
    label: 'Como deseja gerar o Orçamento',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_orc_cp',
    label: 'Selecione o Orçamento para copiar',
    info: '',
    option: {
        key: 'id',
        label: 'ltcat_orcamento',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'descricao',
    maxlength: 255,
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'codigo',
    label: 'Código',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    tipo: 229,
    label: 'Status',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'descricao',
    maxlength: 255,
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_conta_email',
    option: {
        key: 'id',
        label: 'email',
        value: 'id'
    },
    label: 'Conta de Email',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'destinatario',
    maxlength: 255,
    label: 'Destinatário',
    info: 'Separe os emails por `;` (ponto e vírgula) para enviar a varios destinatários',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'editor',
    field: 'mensagem',
    label: 'Enviar Email com a Seguinte Mensagem',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'editor',
    field: 'pdf',
    label: 'Modelo da Proposta (em PDF)',
    rules: ['required']
}]);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ativo',
    label: 'Registro Ativo?',
    rules: ['']
}]);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Gerais'
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'number',
    field: 'ordem',
    label: 'Ordem',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_campo',
    tipo: 207,
    label: 'Tipo de Campo',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_vinculo',
    clearable: true,
    tipo: 218,
    label: 'Vínculo com Fator de Risco',
    info: 'Aqui você pode relacionar esse campo com os campos dos Fatores de Riscos. Esse vínculo vai automatizar o cadastro dos fatores de riscos no LTCAT.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'unidade',
    label: 'Unidade de Medida',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'mascara',
    label: 'Máscara',
    info: 'Utilize esse campo para formatar o conteúdo do campo. Exemplo: Telefone: (99) 9999-9999 ou CPF: 999.999.999-99',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'valor_ref_min',
    label: 'Valor de Referência (mínimo)',
    mask: 'money',
    info: 'Utlize esse campo se quiser aplicar um valor de refrência para o campo. Esse valor pode ser utilizado para comparação se o valor de lançamento está dentro dos parâmetros definidos nas normas.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'valor_ref_max',
    label: 'Valor de Refrência (máximo)',
    mask: 'money',
    info: 'Utlize esse campo se quiser aplicar um valor de refrência para o campo. Esse valor pode ser utilizado para comparação se o valor de lançamento está dentro dos parâmetros definidos nas normas.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Registro Ativo?',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'obrigatorio',
    label: 'Preenchimento Obrigatório?',
    info: 'Se habilitar esse campo, o mesmo deverá ser preenchido obrigatoriamente no momento do cadastro do LTCAT',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'boolean',
    field: 'ordenar',
    label: 'Ordenar as colunas a partir daqui',
    info: 'Habilite essa opção se quiser ordenar as colunas a partir desse item. Isso funciona caso precisar incluir uma coluna entre várias outras.',
    rules: ['']
}]);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Filtrar Periódico'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'periodo',
    label: 'Período',
    mask: 'date',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    label: 'Empresa',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    multiple: true,
    label: 'Frente de Trabalho',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    option: {
        key: 'id',
        label: 'funcionario',
        value: 'id'
    },
    label: 'Funcionário',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'periodico_data_adm',
    label: 'Calcular periódico somente de funcionários sem consulta cadastrado',
    rules: ['']
}]);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Selecione a Empresa',
    placeholder: 'Selecione',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Selecione a empresa que deseja desativar o envio dos periódicos.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fun',
    label: 'Funcionário',
    placeholder: 'Todos',
    option: {
        key: 'id',
        label: 'funcionario',
        value: 'id'
    },
    multiple: true,
    info: 'Selecione a empresa que deseja desativar o envio dos periódicos.',
    rules: ['']
}]);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdSession__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdSession___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EdSession__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__EdSession___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdSocket__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdSocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdSocket__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EdSocket___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdRequest__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EdRequest__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__EdRequest___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdDialog__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EdDialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__EdDialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdNotify__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdNotify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EdNotify__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__EdNotify___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdLoading__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EdLoading__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__EdLoading___default.a; });







/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_awesome_mask__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('mask', __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default.a);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_events__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_theme_index_css__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_pt_br__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directive__ = __webpack_require__(574);


__webpack_require__(582);
__webpack_require__(581);
__webpack_require__(586);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(587);
window._ = __webpack_require__(588);















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_pt_br___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);





$('.carregando').show();

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  localStorage: __WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default.a,
  element: __WEBPACK_IMPORTED_MODULE_6_element_ui___default.a,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__app___default.a);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_layouts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_apps_template_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_apps_template_511__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_apps_template_200__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_apps_template_500__);
















var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default.a
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_0_layouts_index___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default.a,
    meta: {
      requiresAuth: false,
      disablePageHeader: true,
      title: 'Cliente não Encontardo',
      navigation: [{ text: 'Cliente não Encontardo', active: true }]
    }
  }, {
    path: '/:tenant',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'login',
      name: 'credenciada.login',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3_common_logout___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'credenciada.home',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'credenciada.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'meu-cadastro',
      name: 'credenciada.cadastro',
      component: __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Meu Cadastro',
        navigation: [{ text: 'Meu Cadastro', to: { name: 'credenciada.cadastro' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'credenciada.consulta',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'credenciada.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas/editar/:consulta',
      name: 'credenciada.consulta.edt',
      component: __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'credenciada.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'credenciada.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_layouts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_empresa__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_empresa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_layouts_empresa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_periodico_index__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_periodico_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_appsEmpresa_periodico_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsEmpresa_liberacao_index__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsEmpresa_liberacao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_appsEmpresa_liberacao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apps_template_404__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apps_template_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_apps_template_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apps_template_511__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apps_template_511___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_apps_template_511__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apps_template_200__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apps_template_200___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_apps_template_200__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apps_template_500__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_apps_template_500__);

























var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_13_apps_template_404___default.a
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_0_layouts_index___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_14_apps_template_511___default.a,
    meta: {
      requiresAuth: false,
      disablePageHeader: true,
      title: 'Cliente não Encontardo',
      navigation: [{ text: 'Cliente não Encontardo', active: true }]
    }
  }, {
    path: '/:tenant',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_1_layouts_empresa___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'login',
      name: 'empresa.login',
      component: __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3_common_logout___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'empresa.home',
      component: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'meu-cadastro',
      name: 'empresa.cadastro',
      component: __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Meu Cadastro',
        navigation: [{ text: 'Meu Cadastro', to: { name: 'empresa.cadastro' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'empresa.consulta',
      component: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas/editar/:consulta',
      name: 'empresa.consulta.edt',
      component: __WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'empresa.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'consultas/cadastrar/:funcionario?',
      name: 'empresa.consulta.cad',
      component: __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Cadastrar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Cadastrar', to: { name: 'empresa.consulta.cad' }, icon: 'fa fa-plus-circle', active: true }]
      }
    }, {
      path: 'liberacao',
      name: 'empresa.liberacao',
      component: __WEBPACK_IMPORTED_MODULE_12_appsEmpresa_liberacao_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Liberação de ASO',
        navigation: [{ text: 'Liberação', to: { name: 'empresa.liberacao' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'funcionarios',
      name: 'empresa.funcionario',
      component: __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Funcionários',
        navigation: [{ text: 'Funcionários', to: { name: 'empresa.funcionario' }, active: true }]
      }
    }, {
      path: 'funcionarios/editar/:id',
      name: 'empresa.funcionario.edt',
      component: __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Funcionário',
        navigation: [{ text: 'Funcionários', to: { name: 'empresa.funcionario' }, icon: 'fa fa-users', active: false }, { text: 'Editar', to: { name: 'empresa.funcionario.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'funcionarios/cadastrar',
      name: 'empresa.funcionario.cad',
      component: __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Cadastrar Funcionário',
        navigation: [{ text: 'Funcionários', to: { name: 'empresa.funcionario' }, icon: 'fa fa-users', active: false }, { text: 'Cadastrar', to: { name: 'empresa.funcionario.cad' }, icon: 'fa fa-plus-circle', active: true }]
      }
    }, {
      path: 'periodicos',
      name: 'empresa.periodico',
      component: __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_periodico_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Periódicos',
        navigation: [{ text: 'Periódicos', to: { name: 'empresa.periodico' }, active: true }]
      }
    }, {
      path: 'consulta/aproveitamento',
      name: 'empresa.aproveitamento',
      component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1308));
      },
      meta: {
        requiresAuth: true,
        title: 'Aproveitamento de ASO',
        navigation: [{ text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, active: true }]
      }
    }, {
      path: 'consulta/aproveitamento/editar/:consulta',
      name: 'empresa.aproveitamento.edt',
      component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1307));
      },
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Aproveitamento',
        navigation: [{ text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'consultas/aproveitamento/cadastrar/:funcionario?',
      name: 'empresa.aproveitamento.cad',
      component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1306));
      },
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Cadastrar Aproveitamento',
        navigation: [{ text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, icon: 'fa fa-address-card', active: false }, { text: 'Cadastrar', to: { name: 'empresa.aproveitamento.cad' }, icon: 'fa fa-plus-circle', active: true }]
      }
    }, {
      path: 'esocial/gerar-xml',
      name: 'esocial.gerarXML',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 130));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social',
        navigation: [{ text: 'E-Social', active: false, cs: false, to: '' }, { text: 'Gerar XML', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'esocial/gerar-xml-avulso',
      name: 'esocial.gerarXMLAvulso',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 594));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social Avulso',
        navigation: [{ text: 'E-Social Avulso', active: false, cs: false, to: '' }, { text: 'Gerar XML', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'esocial/gerar-lote/:lote?',
      name: 'empresa',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 561));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social',
        navigation: [{ text: 'E-Social', to: { name: 'esocial.gerarXML' }, icon: 'fa fa-pencil-square-o', active: false }, { text: 'Gerar Lote', to: null, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'esocial/certificado',
      name: 'esocial.certificado',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 560));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social',
        navigation: [{ text: 'E-Social', to: { name: 'esocial.gerarXML' }, icon: 'fa fa-pencil-square-o', active: false }, { text: 'Certificado', to: null, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_layouts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_apps_template_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_apps_template_511__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_apps_template_200__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_apps_template_500__);
















var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default.a
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_0_layouts_index___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default.a,
    meta: {
      requiresAuth: false,
      disablePageHeader: true,
      title: 'Cliente não Encontardo',
      navigation: [{ text: 'Cliente não Encontardo', active: true }]
    }
  }, {
    path: '/:tenant',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'login',
      name: 'parceiro.login',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3_common_logout___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'parceiro.home',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'meu-cadastro',
      name: 'parceiro.cadastro',
      component: __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Meu Cadastro',
        navigation: [{ text: 'Meu Cadastro', to: { name: 'parceiro.cadastro' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'parceiro.consulta',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas/editar/:consulta',
      name: 'parceiro.consulta.edt',
      component: __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'parceiro.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_appsWeb_periodico_index__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_appsWeb_periodico_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_appsWeb_periodico_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_desativado_index__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_desativado_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_desativado_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_appsWeb_ltcat_index__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_appsWeb_ltcat_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_appsWeb_ltcat_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_cadastrar__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_editar__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_fator_risco_index__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_fator_risco_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsWeb_fator_risco_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_cadastrar__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_editar__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsWeb_ltcat_laboratorio_index__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsWeb_ltcat_laboratorio_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsWeb_ltcat_laboratorio_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_editar__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_cadastrar__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_tabela_dinamica_index__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_tabela_dinamica_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_tabela_dinamica_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_editar__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_cadastrar__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_configuracao_index__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_configuracao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_appsWeb_consulta_liberacao_index__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_appsWeb_consulta_liberacao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_appsWeb_consulta_liberacao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_externa_index__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_externa_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_externa_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_appsWeb_esocial_index__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_appsWeb_esocial_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_appsWeb_esocial_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_appsWeb_esocial_certificado_index__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_appsWeb_esocial_certificado_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_appsWeb_esocial_certificado_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_lotes_index__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_lotes_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_lotes_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_configuracao_index__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_configuracao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_download__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_download__);


































var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
  }
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
  },
  children: [{
    path: '/',
    meta: { requiresAuth: false },
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1339));
    },
    children: [{
      path: '',
      meta: { requiresAuth: false, disablePageHeader: true, title: 'Login', navigation: [] },
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 595));
      }
    }, {
      path: 'login',
      name: 'web.login',
      meta: { requiresAuth: false, disablePageHeader: true, title: 'Login', navigation: [] },
      component: function component() {
        return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 595));
      }
    }, {
      path: 'logout',
      name: 'logout',
      omponent: function omponent() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
      },
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: '',
      name: 'web.home',
      component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1323));
      },
      meta: {
        requiresAuth: true,
        navigation: [{ text: 'Home', active: false }]
      }
    }, {
      path: 'empresas',
      name: 'empresa',
      component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1317));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, cs: true, to: '/app/empresas.php' }]
      }
    }, {
      path: 'empresas/cadastrar',
      name: 'empresa.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1315));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, to: '/empresas' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'empresas/editar/:id',
      name: 'empresa.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1316));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, to: '/empresas' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'empresa/tabela-balcao',
      name: 'empresa.tabelabalcao',
      component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1318));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, to: '/empresas' }, { text: 'Tabela Preço Balcão', active: true }]
      }
    }, {
      path: 'consultas/liberacao',
      name: 'consultas.liberacao',
      component: __WEBPACK_IMPORTED_MODULE_16_appsWeb_consulta_liberacao_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' }, { text: 'Liberação', active: true }]
      }
    }, {
      path: 'consultas/externas',
      name: 'consultas.externa',
      component: __WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_externa_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Consultas Externas',
        navigation: [{ text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' }, { text: 'Consulta Externa', active: true }]
      }
    }, {
      path: 'consultas/aproveitamento',
      name: 'consultas.aproveitamento',
      component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1311));
      },
      meta: {
        requiresAuth: true,
        title: 'Aproveitamento de ASO',
        navigation: [{ text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' }, { text: 'Aproveitamento de ASO', active: true }]
      }
    }, {
      path: 'credenciadas',
      name: 'credenciada',
      component: function component() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1314));
      },
      meta: {
        requiresAuth: true,
        title: 'Credenciadas',
        navigation: [{ text: 'Credenciadas', active: true }]
      }
    }, {
      path: 'credenciadas/cadastrar',
      name: 'credenciada.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1312));
      },
      meta: {
        requiresAuth: true,
        title: 'Credenciadas',
        navigation: [{ text: 'Credenciadas', active: false, to: '/credenciadas' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'credenciadas/editar/:id',
      name: 'credenciada.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1313));
      },
      meta: {
        requiresAuth: true,
        title: 'Credenciadas',
        navigation: [{ text: 'Credenciadas', active: false, to: '/credenciadas' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'financeiro/boleto/bradesco',
      name: 'financeiro.boleto.bradesco',
      component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1320));
      },
      meta: {
        requiresAuth: true,
        title: 'Financeiro',
        navigation: [{ text: 'Financeiro', active: false, cs: true, to: '/app/fin_boletos.php' }, { text: 'Boletos', active: true }]
      }
    }, {
      path: 'financeiro/boleto/inter',
      name: 'financeiro.boleto.inter',
      component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1321));
      },
      meta: {
        requiresAuth: true,
        title: 'Financeiro',
        navigation: [{ text: 'Financeiro', active: false, cs: true, to: '/app/fin_boletos.php' }, { text: 'Boletos', active: true }]
      }
    }, {
      path: 'cat',
      name: 'cat',
      component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1309));
      },
      meta: {
        requiresAuth: true,
        title: 'Comunicação de Acidente de Trabalho',
        navigation: [{ text: 'Comunicação de Acidente de Trabalho', active: true }]
      }
    }, {
      path: 'cat/modelo',
      name: 'cat.modelo',
      component: function component() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1310));
      },
      meta: {
        requiresAuth: true,
        title: 'Comunicação de Acidente de Trabalho',
        navigation: [{ text: 'Comunicação de Acidente de Trabalho', active: false, to: '/cat' }, { text: 'Modelo', active: true }]
      }
    }, {
      path: 'pcmso/vencido',
      name: 'pcmso.vencido',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 598));
      },
      meta: {
        requiresAuth: true,
        title: 'PCMSO Vencido',
        navigation: [{ text: 'PCMSO Vencido', active: true }]
      }
    }, {
      path: 'pcmso/disparador',
      name: 'pcmso.disparo',
      component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1330));
      },
      meta: {
        requiresAuth: true,
        title: 'Disparador',
        navigation: [{ text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' }, { text: 'Disparador', active: true }]
      }
    }, {
      path: 'pcmso/disparador/cadastrar',
      name: 'pcmso.disparo.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 597));
      },
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' }, { text: 'Disparador', active: false, to: '/pcmso/disparador' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'pcmso/disparador/editar/:id',
      name: 'pcmso.disparo.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 597));
      },
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' }, { text: 'Disparador', active: false, to: '/pcmso/disparador' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'pcmso/config',
      name: 'pcmso.config',
      component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 596));
      },
      meta: {
        requiresAuth: true,
        title: 'Configuração',
        navigation: [{ text: 'PCMSO', active: false, cs: true, to: '/app/pcmso.php' }, { text: 'Configuração', active: true }]
      }
    }, {
      path: 'ppra/vencido',
      name: 'ppra.vencido',
      component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 598));
      },
      meta: {
        requiresAuth: true,
        title: 'PPRA Vencido',
        navigation: [{ text: 'PPRA Vencido', active: true }]
      }
    }, {
      path: 'ppra/disparador',
      name: 'ppra.disparo',
      component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1335));
      },
      meta: {
        requiresAuth: true,
        title: 'Disparador',
        navigation: [{ text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' }, { text: 'Disparador', active: true }]
      }
    }, {
      path: 'ppra/disparador/cadastrar',
      name: 'ppra.disparo.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 600));
      },
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' }, { text: 'Disparador', active: false, to: '/ppra/disparador' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ppra/disparador/editar/:id',
      name: 'ppra.disparo.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 600));
      },
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' }, { text: 'Disparador', active: false, to: '/ppra/disparador' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ppra/config',
      name: 'ppra.config',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 596));
      },
      meta: {
        requiresAuth: true,
        title: 'Configuração',
        navigation: [{ text: 'PPRA', active: false, cs: true, to: '/app/ppra.php' }, { text: 'Configuração', active: true }]
      }
    }, {
      path: 'config/funcoes',
      name: 'funcao',
      component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1322));
      },
      meta: {
        requiresAuth: true,
        title: 'Funções',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Funções', active: true }]
      }
    }, {
      path: 'config/exames',
      name: 'exame',
      component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1319));
      },
      meta: {
        requiresAuth: true,
        title: 'Exames',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Exames', active: true }]
      }
    }, {
      path: 'config/riscos',
      name: 'risco',
      component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1338));
      },
      meta: {
        requiresAuth: true,
        title: 'Riscos',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Riscos', active: true }]
      }
    }, {
      path: 'config/conta-email',
      name: 'contaemail',
      component: __WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Contas de Emails',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Contas de Emails', active: true }]
      }
    }, {
      path: 'periodicos',
      name: 'periodico',
      component: __WEBPACK_IMPORTED_MODULE_1_appsWeb_periodico_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Periódicos',
        navigation: [{ text: 'Periódicos', active: true }]
      }
    }, {
      path: 'periodicos/disparador',
      name: 'periodico.disparo',
      component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1331));
      },
      meta: {
        requiresAuth: true,
        title: 'Disparador',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Disparador', active: true }]
      }
    }, {
      path: 'periodicos/disparador/cadastrar',
      name: 'periodico.disparo.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 599));
      },
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Disparador', active: false, to: '/periodicos/disparador' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'periodicos/disparador/editar/:id',
      name: 'periodico.disparo.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 599));
      },
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Disparador', active: false, to: '/periodicos/disparador' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'periodicos/desativados',
      name: 'periodico.desativado',
      component: __WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_desativado_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Desativados',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Desativados', active: true }]
      }
    }, {
      path: 'ltcat',
      name: 'ltcat',
      component: __WEBPACK_IMPORTED_MODULE_3_appsWeb_ltcat_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'LTCAT',
        navigation: [{ text: 'LTCAT', active: true }]
      }
    }, {
      path: 'ltcat/cadastrar',
      name: 'ltcat.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/editar/:id',
      name: 'ltcat.editar',
      component: __WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/fator-risco',
      name: 'ltcat.risco',
      component: __WEBPACK_IMPORTED_MODULE_6_appsWeb_fator_risco_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Fator de Risco',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Fator de Risco', active: true }]
      }
    }, {
      path: 'ltcat/fator-risco/cadastrar',
      name: 'ltcat.risco.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Fator de Risco', active: false, to: '/ltcat/fator-risco' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/fator-risco/editar/:id',
      name: 'ltcat.risco.editar',
      component: __WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Fator de Risco', active: false, to: '/ltcat/fator-risco' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/modelo',
      name: 'ltcat.modelo',
      meta: {
        requiresAuth: true,
        title: 'Modelos',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Modelos', active: true }]
      }
    }, {
      path: 'ltcat/laboratorio',
      name: 'ltcat.laboratorio',
      component: __WEBPACK_IMPORTED_MODULE_9_appsWeb_ltcat_laboratorio_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Laboratórios',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Laboratórios', active: true }]
      }
    }, {
      path: 'ltcat/laboratorio/cadastrar',
      name: 'ltcat.laboratorio.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Laboratórios', active: false, to: '/ltcat/laboratorio' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/laboratorio/editar/:id',
      name: 'ltcat.laboratorio.editar',
      component: __WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Laboratórios', active: false, to: '/ltcat/laboratorio' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/tabela-dinamica',
      name: 'ltcat.tabela',
      component: __WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_tabela_dinamica_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Tabela Dinâmica',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Tabela Dinâmica', active: true }]
      }
    }, {
      path: 'ltcat/tabela-dinamica/cadastrar',
      name: 'ltcat.tabela.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Tabela Dinâmica', active: false, to: '/ltcat/tabela-dinamica' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/tabela-dinamica/editar/:id',
      name: 'ltcat.tabela.editar',
      component: __WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Tabela Dinâmica', active: false, to: '/ltcat/tabela-dinamica' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/configuracao',
      name: 'ltcat.configuracao',
      component: __WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_configuracao_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Configurações',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Configurações', active: false }]
      }
    }, {
      path: 'pgr',
      name: 'pgr',
      component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1334));
      },
      meta: {
        requiresAuth: true,
        title: 'PGR',
        navigation: [{ text: 'PGR', active: true }]
      }
    }, {
      path: 'pgr/cadastrar',
      name: 'pgr.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1332));
      },
      meta: {
        requiresAuth: true,
        title: 'PGR',
        navigation: [{ text: 'PGR', active: false, to: '/pgr' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'pgr/editar/:id',
      name: 'pgr.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1333));
      },
      meta: {
        requiresAuth: true,
        title: 'PGR',
        navigation: [{ text: 'PGR', active: false, to: '/pgr' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'relatorio/anual',
      name: 'relatorio.anual',
      component: function component() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1337));
      },
      meta: {
        requiresAuth: true,
        title: 'Relatório Analítico',
        navigation: [{ text: 'Relatório Analítico', active: true, to: '/relatorio/anual' }]
      }
    }, {
      path: 'config/profissionais',
      name: 'profissionais',
      component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1336));
      },
      meta: {
        requiresAuth: true,
        title: 'Profissionais Responsáveis',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Profissionais Responsáveis', active: true }]
      }
    }, {
      path: 'config/parceiros',
      name: 'parceiro',
      component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1329));
      },
      meta: {
        requiresAuth: true,
        title: 'Parceiros',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Parceiros', active: true }]
      }
    }, {
      path: 'config/parceiros/cadastrar',
      name: 'parceiro.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1327));
      },
      meta: {
        requiresAuth: true,
        title: 'Parceiros',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Parceiros', active: true, to: '/config/parceiros' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'config/parceiros/editar/:id',
      name: 'parceiro.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1328));
      },
      meta: {
        requiresAuth: true,
        title: 'Parceiros',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Parceiros', active: true, to: '/config/parceiros' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'config/medicos',
      name: 'medico',
      component: function component() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1326));
      },
      meta: {
        requiresAuth: true,
        title: 'Medicos Examinadores',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Medicos Examinadores', active: true }]
      }
    }, {
      path: 'config/medicos/cadastrar',
      name: 'medico.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1324));
      },
      meta: {
        requiresAuth: true,
        title: 'Medicos Examinadores',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Medicos Examinadores', active: true, to: '/config/medicos' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'config/medicos/editar/:id',
      name: 'medico.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1325));
      },
      meta: {
        requiresAuth: true,
        title: 'Medicos Examinadores',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Medicos Examinadores', active: true, to: '/config/medicos' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'log/tarefa',
      name: 'log.tarefa',
      component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1305));
      },
      meta: {
        requiresAuth: true,
        title: 'Tarefa',
        navigation: [{ text: 'Log', active: false }, { text: 'Tarefa', active: true }]
      }
    }, {
      path: 'esocial',
      name: 'esocial',
      component: __WEBPACK_IMPORTED_MODULE_18_appsWeb_esocial_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Esocial',
        navigation: [{ text: 'Esocial', active: false }]
      }
    }, {
      path: 'esocial/avulso',
      name: 'esocial.avulso',
      component: function component() {
        return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 594));
      },
      meta: {
        requiresAuth: true,
        title: 'Esocial Avulso',
        navigation: [{ text: 'Esocial Avulso', active: false }]
      }
    }, {
      path: 'esocial/lotes/:lote?',
      name: 'esocial.lotes',
      component: __WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_lotes_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Lotes',
        navigation: [{ text: 'Esocial', active: false, to: '/esocial' }, { text: 'Lotes', active: true }]
      }
    }, {
      path: 'esocial/certificados',
      name: 'esocial.certificado',
      component: __WEBPACK_IMPORTED_MODULE_19_appsWeb_esocial_certificado_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Certificados',
        navigation: [{ text: 'Esocial', active: false, to: '/esocial' }, { text: 'Certificados', active: true }]
      }
    }, {
      path: 'esocial/configuracao',
      name: 'esocial.configuracao',
      component: __WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_configuracao_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Configuração',
        navigation: [{ text: 'Esocial', active: false, to: '/esocial' }, { text: 'Configuração', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_64__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_md5__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_md5__);







var Cookie = __webpack_require__(544);

var VueCookie = {
  install: function install(Vue) {
    Vue.prototype.$cookie = this;
    Vue.cookie = this;
  },
  set: function set(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    var opts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
      expires: '24h',
      secure: false,
      path: '/'
    }, options);

    return Cookie.set(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value), opts);
  },
  get: function get(key) {

    if (!key) return null;

    var cookie = Cookie.get(key);

    if (!cookie) return null;

    try {
      return JSON.parse(cookie);
    } catch (error) {
      return cookie;
    }
  },
  delete: function _delete(key) {
    Cookie.remove(key);
  }
};

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(VueCookie);

/* unused harmony default export */ var _unused_webpack_default_export = (VueCookie);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_base_64__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_md5__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_md5__);










var VueUtilidade = {
  install: function install(Vue) {
    Vue.prototype.$utilidade = this;
    Vue.utilidade = this;
  },
  getLocation: function getLocation(type) {
    var hostname = window.location;

    type = type ? type : 'hostname';

    return hostname[type];
  },
  stringToArray: function stringToArray(string) {
    if (!string) return [];

    return JSON.parse(string);
  },
  getIcone: function getIcone(icone) {
    var _icones;

    var icones = (_icones = {
      'cadastrar': 'fa fa-plus-circle',
      'buscar': 'fa fa-search',
      'filtrar': 'fa fa-filter',
      'editar': 'fa fa-pencil-square',
      'deletar': 'fa fa-trash-o',
      'link': 'fa fa-external-link-square',
      'salvar': 'fa fa-floppy-o',
      'fechar': 'fa fa-times',
      'info': 'fa fa-info-circle',
      'pdf': 'fa fa-file-pdf-o',
      'texto': 'fa fa-file-text-o',
      'empresa': 'fa fa-building'
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, "empresa", 'fa fa-building'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'usuarios', 'fa fa fa-users'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'usuario', 'fa fa-user'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'medico', 'fa fa-user-md'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'download', 'fa fa-cloud-download'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'upload', 'fa-cloud-upload'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'email', 'fa fa-envelope'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'historico', 'fa fa-history'), _icones);

    if (icones[icone]) {
      return icones[icone];
    }

    return null;
  },
  randomMumber: function randomMumber(min, max) {
    min = !min ? 1 : min;
    max = !max ? 10 : max;
    return Math.random() * (max - min) + min;
  },
  randomString: function randomString() {
    var math = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return this.toMd5(math + new Date().getTime());
  },
  arrFindByField: function arrFindByField(arr, field, value, index) {
    if (!field || !arr || !arr.length > 0) return null;

    var arr = arr.filter(function (x) {
      return x[field] == value;
    });
    var arrIndex = arr.findIndex(function (x) {
      return x[field] == value;
    });

    if (index) return arrIndex;
    if (arr.length == 1) return arr[0];

    return null;
  },
  onlyNumber: function onlyNumber(value) {
    if (!value) return "";

    value = value.toString();

    return value.replace(/[\. ,:-]+/g, "-").replace(/[^0-9\.]+/g, "");
  },
  onlyText: function onlyText(value) {
    if (!value) return "";

    value = this.toString(value);
    return value.replace(/(<([^>]+)>)/gi, "");
  },
  isEmail: function isEmail(value) {
    var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return value && pattern.test(value);
  },
  isDate: function isDate(value) {
    if (!value) return false;

    var arrayValue = value.toString().split('/');

    if (arrayValue.length != 3) return false;

    var dia = arrayValue[0];
    var mes = arrayValue[1];
    var ano = arrayValue[2];
    var data = ano + '-' + mes + '-' + dia;

    if (parseInt(mes) > 12 || parseInt(mes) < 1 || parseInt(dia) < 1 || parseInt(dia) > 31 || parseInt(ano) < 1900) return false;

    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(data).isValid();
  },
  isCpf: function isCpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') return false;

    if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") return false;

    var add = 0;
    for (var i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }var rev = 11 - add % 11;
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(9))) return false;

    add = 0;
    for (i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }rev = 11 - add % 11;
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(10))) return false;
    return true;
  },
  mascara: function mascara(val, mask) {

    if (!val) return val;

    val = this.onlyNumber(val);

    var num = this.onlyNumber(val);

    if (this.isCnpj(num)) {
      mask = 'cnpj';
    } else if (this.isCpf(num)) {
      mask = 'cpf';
    } else if (num.toString().length == 10) {
      mask = 'telefone';
    } else if (num.toString().length == 1) {
      mask = 'celular';
    }

    switch (mask) {

      case 'cnpj':
        mask = '##.###.###/####-##';
        break;

      case 'cpf':
        mask = '###.###.###-##';
        break;

      case 'telefone':
        mask = '(##) ####-####';
        break;

      case 'celular':
        mask = '(##) #####-#####';
        break;

      default:
        mask = '';
        break;
    }

    var maskared = '';
    var k = 0;

    for (var i = 0; i <= mask.length - 1; i++) {

      if (mask[i] == '#') {
        if (val[k]) maskared += val[k++];
      } else {
        if (mask[i]) maskared += mask[i];
      }
    }

    return maskared;
  },
  isCnpj: function isCnpj(value) {

    if (!value) return false;

    var cnpj = this.onlyNumber(value);

    if (cnpj.length !== 14) return false;

    if (/^(\d)\1+$/.test(cnpj)) return false;

    var t = cnpj.length - 2,
        d = cnpj.substring(t),
        d1 = parseInt(d.charAt(0)),
        d2 = parseInt(d.charAt(1)),
        calc = function calc(x) {
      var n = cnpj.substring(0, x),
          y = x - 7,
          s = 0,
          r = 0;

      for (var i = x; i >= 1; i--) {
        s += n.charAt(x - i) * y--;
        if (y < 2) y = 9;
      }

      r = 11 - s % 11;
      return r > 9 ? 0 : r;
    };

    return calc(t) === d1 && calc(t + 1) === d2;
  },
  isNumeric: function isNumeric(value) {
    var pattern = /[0-9]/;

    return value && pattern.test(value);
  },
  buildFormData: function buildFormData(formData, data, parentKey) {
    var _this = this;

    if (data && (typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {

        console.log('key', [key, data[key]]);
        _this.buildFormData(formData, data[key], parentKey ? parentKey + "[" + key + "]" : key);
      });
    } else {

      console.log('parentKey', value);
      var value = data == null ? '' : data;

      formData.append(parentKey, value);
    }
  },
  toFormUpload: function toFormUpload(data) {
    var formData = new FormData();

    this.buildFormData(formData, data);

    return formData;
  },
  booleanToInteger: function booleanToInteger(form) {
    for (var key in form) {
      if (form[key] === true) form[key] = 1;

      if (form[key] === false) form[key] = 0;
    }

    return form;
  },
  base64Decode: function base64Decode(value) {
    try {
      return __WEBPACK_IMPORTED_MODULE_7_base_64___default.a.decode(value);
    } catch (err) {
      return null;
    }
  },
  base64Encode: function base64Encode(value) {
    try {
      return __WEBPACK_IMPORTED_MODULE_7_base_64___default.a.encode(value);
    } catch (err) {
      return null;
    }
  },
  fileToBase64: function fileToBase64(file) {

    var reader = new FileReader();
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      reader.onerror = function () {
        reader.abort();reject(new Error("Error parsing file"));
      };
      reader.onload = function () {
        var bytes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(new Uint8Array(this.result));

        var base64StringFile = btoa(bytes.map(function (item) {
          return String.fromCharCode(item);
        }).join(""));

        resolve({
          size: file.size,
          content: base64StringFile,
          name: file.name,
          type: file.type
        });
      };
      reader.readAsArrayBuffer(file);
    });
  },
  utf8Decode: function utf8Decode(t) {
    if (!t) return t;

    try {
      return decodeURIComponent(escape(t));
    } catch (err) {
      return t;
    }
  },
  toDate: function toDate(date, disableHours, format) {
    if (!date) {
      date = new Date();
    }

    if (!format) {
      format = "DD/MM/YYYY HH:mm:ss";

      if (disableHours) {
        format = "DD/MM/YYYY";
      }
    }

    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(format);
  },
  convertDate: function convertDate(date, format) {
    if (!date) {
      return new Date();
    }

    format = format ? format : 'DD/MM/YYYY';

    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(format);
  },
  addDate: function addDate(value, date) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'D';
    var format = arguments[3];


    if (!date) {
      date = new Date();
    } else {
      date = new Date(date);
    }

    switch (type) {
      case "y":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'years').toDate();
        break;
      case "M":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'months').toDate();
        break;
      case "D":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'days').toDate();
        break;
      case "h":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'hours').toDate();
        break;
      case "m":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'minutes').toDate();
        break;
      case "s":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'secounds').toDate();
        break;
      default:
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'days').toDate();
    }

    if (format) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(format);
    }
    return date;
  },
  diffDays: function diffDays(date1, date2, type) {
    type = !type ? "d" : type;
    date1 = !date1 ? __WEBPACK_IMPORTED_MODULE_6_moment___default()() : __WEBPACK_IMPORTED_MODULE_6_moment___default()(date1);
    date2 = !date2 ? __WEBPACK_IMPORTED_MODULE_6_moment___default()() : __WEBPACK_IMPORTED_MODULE_6_moment___default()(date2);

    switch (type) {
      case "y":
        return date1.diff(date2, "years", true);
        break;
      case "d":
        return date1.diff(date2, "days", true);
        break;
      case "h":
        return date1.diff(date2, "hours", true);
        break;
      case "m":
        return date1.diff(date2, "minutes", true);
        break;
      case "s":
        return date1.diff(date2, "seconds", true);
        break;
      default:
        return date1.diff(date2, "days", true);
        break;
    }
  },
  moneyToFloat: function moneyToFloat(value) {
    if (!value || value == "") {
      return 0;
    }

    value = this.toString(value);

    return parseFloat(value.replace(".", "").replace(",", "."));
  },
  floatToMoney: function floatToMoney(value) {
    if (!value) {
      return "0,00";
    }

    var formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    });

    value = formatter.format(value).replace("R$", "").trim();

    return value;
  },
  formataCampo: function formataCampo(text, left, format) {

    format = !format ? '0' : format;
    left = !left ? 0 : left;

    if (!text) return text;

    return text.toString().padStart(left, format);
  },


  toMb: function toMb(bytes) {

    if (!bytes) return '0 MB';

    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return bytes + " " + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
  },

  toString: function toString(value) {
    if (value == null || value == undefined) return '';

    return value.toString();
  },
  toMd5: function toMd5(text) {

    try {
      text = this.toString(text);
      text = __WEBPACK_IMPORTED_MODULE_8_js_md5___default()(text);
      return text;
    } catch (e) {
      return text;
    }
  },
  validateEmail: function validateEmail(email) {

    email = email ? email.trim() : null;

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  },
  textLimit: function textLimit(value, limit) {

    limit = limit ? limit : 100;

    if (value && value.length > limit) {
      return value.substring(0, limit) + "...";
    }

    return value;
  },
  console: function (_console) {
    function console(_x2) {
      return _console.apply(this, arguments);
    }

    console.toString = function () {
      return _console.toString();
    };

    return console;
  }(function (data) {
    if (__webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).LOG) {
      console.log(data);
    }
  }),
  removerAcentos: function removerAcentos() {
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!source) {
      return '';
    }

    var accent = [/[\300-\306]/g, /[\340-\346]/g, /[\310-\313]/g, /[\350-\353]/g, /[\314-\317]/g, /[\354-\357]/g, /[\322-\330]/g, /[\362-\370]/g, /[\331-\334]/g, /[\371-\374]/g, /[\321]/g, /[\361]/g, /[\307]/g, /[\347]/g],
        noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

    for (var i = 0; i < accent.length; i++) {
      source = source.replace(accent[i], noaccent[i]);
    }

    return source;
  },
  getEstado: function getEstado() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var arrayEstados = [{
      "uf": "AC",
      "estado": "Acre"
    }, {
      "uf": "AL",
      "estado": "Alagoas"
    }, {
      "uf": "AP",
      "estado": "Amapá"
    }, {
      "uf": "AM",
      "estado": "Amazonas"
    }, {
      "uf": "BA",
      "estado": "Bahia"
    }, {
      "uf": "CE",
      "estado": "Ceará"
    }, {
      "uf": "DF",
      "estado": "Distrito Federal"
    }, {
      "uf": "ES",
      "estado": "Espírito Santo"
    }, {
      "uf": "GO",
      "estado": "Goiás"
    }, {
      "uf": "MA",
      "estado": "Maranhão"
    }, {
      "uf": "MT",
      "estado": "Mato Grosso"
    }, {
      "uf": "MS",
      "estado": "Mato Grosso do Sul"
    }, {
      "uf": "MG",
      "estado": "Minas Gerais"
    }, {
      "uf": "PA",
      "estado": "Pará"
    }, {
      "uf": "PB",
      "estado": "Paraíba"
    }, {
      "uf": "PR",
      "estado": "Paraná"
    }, {
      "uf": "PE",
      "estado": "Pernambuco"
    }, {
      "uf": "PI",
      "estado": "Piauí"
    }, {
      "uf": "RJ",
      "estado": "Rio de Janeiro"
    }, {
      "uf": "RN",
      "estado": "Rio Grande do Norte"
    }, {
      "uf": "RS",
      "estado": "Rio Grande do Sul"
    }, {
      "uf": "RO",
      "estado": "Rondônia"
    }, {
      "uf": "RR",
      "estado": "Roraima"
    }, {
      "uf": "SP",
      "estado": "São Paulo"
    }, {
      "uf": "SC",
      "estado": "Santa Catarina"
    }, {
      "uf": "SE",
      "estado": "Sergipe"
    }, {
      "uf": "TO",
      "estado": "Tocantins"
    }];

    return arrayEstados.filter(function (objEstado) {
      objEstado.estado = objEstado.estado.toUpperCase();

      return !search || objEstado.uf.indexOf(search) !== -1;
    });
  },
  pluck: function pluck(array, key) {
    return array.map(function (o) {
      return o[key];
    });
  }
};

__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(VueUtilidade);

/* unused harmony default export */ var _unused_webpack_default_export = (VueUtilidade);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCliente", function() { return setCliente; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTenant", function() { return setTenant; });

var setCliente = function setCliente(context, cliente) {
	context.commit('SET_CLIENTE', cliente);
};

var setTenant = function setTenant(context, tenant) {
	context.commit('SET_TENANT', tenant);
};



/***/ }),
/* 853 */
/***/ (function(module, exports) {



/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(852);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CLIENTE", function() { return SET_CLIENTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TENANT", function() { return SET_TENANT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);



var SET_CLIENTE = function SET_CLIENTE(state, cliente) {
	state.logged = cliente;

	if (cliente && cliente.google_analytics_key) {
		__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
			id: cliente.google_analytics_key,
			linkers: [cliente.url_web, cliente.url_empresa, cliente.url_credenciada, cliente.url_parceiro],
			checkDuplicatedScript: true
		});
	}
};

var SET_TENANT = function SET_TENANT(state, tenant) {
	state.tenant = tenant;
};



/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	logged: null,
	tenant: null
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubDomain", function() { return setSubDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLog", function() { return setLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLocation", function() { return setLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRequest", function() { return setRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNavigation", function() { return setNavigation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEnv", function() { return setEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWindow", function() { return setWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEvent", function() { return setEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPcmso", function() { return setPcmso; });

var setSubDomain = function setSubDomain(context, sub_domain) {
	context.commit('SET_SUB_DOMAIN', sub_domain);
};

var setEvent = function setEvent(context, event) {
	context.commit('SET_EVENT', event);
};

var setLog = function setLog(context, log) {
	context.commit('SET_LOG', log);
};

var setLocation = function setLocation(context, location) {
	context.commit('SET_LOCATION', location);
};

var setRequest = function setRequest(context, request) {
	context.commit('SET_REQUEST', request);
};

var setNavigation = function setNavigation(context, navigation) {
	context.commit('SET_NAVIGATION', navigation);
};

var setEnv = function setEnv(context, env) {
	context.commit('SET_ENV', env);
};

var setUrlApi = function setUrlApi(context, url_api) {
	context.commit('SET_URL_API', url_api);
};

var setPcmso = function setPcmso(context, pcmso) {
	context.commit('SET_PCMSO', pcmso);
};

var setWindow = function setWindow(context, window) {
	context.commit('SET_WINDOW', window);

	var device = 'lg';

	if (window.width >= 1200) {
		device = 'lg';
	} else if (window.width >= 992) {
		device = 'md';
	} else if (window.width >= 785) {
		device = 'sm';
	} else {
		device = 'xs';
	}

	context.commit('SET_DEVICE', device);
};



/***/ }),
/* 858 */
/***/ (function(module, exports) {



/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(857);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUB_DOMAIN", function() { return SET_SUB_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOG", function() { return SET_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NAVIGATION", function() { return SET_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ENV", function() { return SET_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_URL_API", function() { return SET_URL_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_WINDOW", function() { return SET_WINDOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICE", function() { return SET_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REQUEST", function() { return SET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_EVENT", function() { return SET_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PCMSO", function() { return SET_PCMSO; });

var SET_SUB_DOMAIN = function SET_SUB_DOMAIN(state, sub_domain) {
	state.sub_domain = sub_domain;
};

var SET_EVENT = function SET_EVENT(state, event) {
	state.event = event;
};

var SET_LOG = function SET_LOG(state, log) {
	state.log = log;
};

var SET_PCMSO = function SET_PCMSO(state, pcmso) {
	state.pcmso = pcmso;
};

var SET_LOCATION = function SET_LOCATION(state, location) {
	state.location = location;
};

var SET_NAVIGATION = function SET_NAVIGATION(state, navigation) {
	state.navigation = navigation;
};

var SET_ENV = function SET_ENV(state, env) {
	state.env = env;
};

var SET_URL_API = function SET_URL_API(state, url_api) {
	state.url_api = url_api;
};

var SET_WINDOW = function SET_WINDOW(state, window) {
	state.window = window;
};

var SET_DEVICE = function SET_DEVICE(state, device) {
	state.device = device;
};

var SET_REQUEST = function SET_REQUEST(state, request) {
	state.request = request;
};



/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  device: 'lg',
  log: {
    request: false,
    request_error: false
  },
  window: {
    width: 0,
    height: 0
  },
  request: null,
  event: null,
  url_api: null,
  pcmso: null,
  navigation: [],
  env: {},
  sub_domain: null
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTotalContato", function() { return setTotalContato; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTotalProcedimento", function() { return setTotalProcedimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCredenciada", function() { return setCredenciada; });

var setTotalContato = function setTotalContato(context, total) {
	context.commit('SET_TOTAL_CONTATO', total);
};

var setTotalProcedimento = function setTotalProcedimento(context, total) {
	context.commit('SET_TOTAL_PROCEDIMENTO', total);
};

var setCredenciada = function setCredenciada(context, credenciada) {
	context.commit('SET_CREDENCIADA', credenciada);
};



/***/ }),
/* 863 */
/***/ (function(module, exports) {



/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(862);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOTAL_CONTATO", function() { return SET_TOTAL_CONTATO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOTAL_PROCEDIMENTO", function() { return SET_TOTAL_PROCEDIMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CREDENCIADA", function() { return SET_CREDENCIADA; });


var SET_TOTAL_CONTATO = function SET_TOTAL_CONTATO(state, total_contato) {
	state.total_contato = total_contato;
};

var SET_TOTAL_PROCEDIMENTO = function SET_TOTAL_PROCEDIMENTO(state, total_procedimento) {
	state.total_procedimento = total_procedimento;
};

var SET_CREDENCIADA = function SET_CREDENCIADA(state, credenciada) {
	state.logged = credenciada;
};



/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	total_contato: 0,
	total_procedimento: 0,
	logged: null
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmpresa", function() { return setEmpresa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPeriodico", function() { return setPeriodico; });

var setEmpresa = function setEmpresa(context, empresa) {
	context.commit('SET_EMPRESA', empresa);
};

var setPeriodico = function setPeriodico(context, periodico) {
	context.commit('SET_PERIODICO', periodico);
};



/***/ }),
/* 868 */
/***/ (function(module, exports) {



/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(867);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_EMPRESA", function() { return SET_EMPRESA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PERIODICO", function() { return SET_PERIODICO; });


var SET_EMPRESA = function SET_EMPRESA(state, empresa) {
	state.logged = empresa;
};

var SET_PERIODICO = function SET_PERIODICO(state, periodico) {
	state.periodico = periodico;
};



/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	logged: null,
	periodoco: null
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLtcat", function() { return setLtcat; });

var setLtcat = function setLtcat(context, ltcat) {
	context.commit('SET_LTCAT', ltcat);
};



/***/ }),
/* 873 */
/***/ (function(module, exports) {



/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(872);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LTCAT", function() { return SET_LTCAT; });


var SET_LTCAT = function SET_LTCAT(state, ltcat) {
	state.data = ltcat;

	var title = '';

	if (ltcat && ltcat.empresa) {
		title += ltcat.empresa.nome;
	}

	if (ltcat.revisao) {
		title += ' :: ';

		if (ltcat.revisao.parent) {
			title += ltcat.revisao.parent.rev + ' (' + ltcat.revisao.parent.descricao + ') / ';
		}
		title += ltcat.revisao.rev + ' (' + ltcat.revisao.descricao + ')';
	}

	if (title) {
		title += ' :: ';
	}

	state.title = title;
};



/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	data: null,
	title: null
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUsuario", function() { return setUsuario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMenu", function() { return setMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setJwt", function() { return setJwt; });

var setUsuario = function setUsuario(context, usuario) {

	var menu = usuario && usuario.menu ? usuario.menu : [],
	    acesso_permissao = usuario && usuario.acesso_permissao ? usuario.acesso_permissao : [],
	    acesso_modulo = usuario && usuario.acesso_modulo ? usuario.acesso_modulo : [];

	context.commit('SET_USUARIO', usuario);
	context.commit('SET_MENU', menu);
	context.commit('SET_ACESSO_PERMISSAO', acesso_permissao);
	context.commit('SET_ACESSO_MODULO', acesso_modulo);
};

var setMenu = function setMenu(context, menu) {
	context.commit('SET_MENU', menu);
};

var setJwt = function setJwt(context, jwt) {
	context.commit('SET_JWT', jwt);
};



/***/ }),
/* 878 */
/***/ (function(module, exports) {



/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(877);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USUARIO", function() { return SET_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MENU", function() { return SET_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACESSO_MODULO", function() { return SET_ACESSO_MODULO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACESSO_PERMISSAO", function() { return SET_ACESSO_PERMISSAO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_JWT", function() { return SET_JWT; });
var SET_USUARIO = function SET_USUARIO(state, logged) {
	state.logged = logged;
};

var SET_MENU = function SET_MENU(state, menu) {
	state.menu = menu;
};

var SET_JWT = function SET_JWT(state, jwt) {
	state.jwt = jwt;
};

var SET_ACESSO_MODULO = function SET_ACESSO_MODULO(state, acesso_modulo) {
	state.acesso_modulo = acesso_modulo;
};

var SET_ACESSO_PERMISSAO = function SET_ACESSO_PERMISSAO(state, acesso_permissao) {
	state.acesso_permissao = acesso_permissao;
};



/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	logged: null,
	jwt: null,
	acesso_permissao: [],
	acesso_modulo: [],
	menu: []
});

/***/ }),
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 410,
	"./af.js": 410,
	"./ar": 417,
	"./ar-dz": 411,
	"./ar-dz.js": 411,
	"./ar-kw": 412,
	"./ar-kw.js": 412,
	"./ar-ly": 413,
	"./ar-ly.js": 413,
	"./ar-ma": 414,
	"./ar-ma.js": 414,
	"./ar-sa": 415,
	"./ar-sa.js": 415,
	"./ar-tn": 416,
	"./ar-tn.js": 416,
	"./ar.js": 417,
	"./az": 418,
	"./az.js": 418,
	"./be": 419,
	"./be.js": 419,
	"./bg": 420,
	"./bg.js": 420,
	"./bm": 421,
	"./bm.js": 421,
	"./bn": 422,
	"./bn.js": 422,
	"./bo": 423,
	"./bo.js": 423,
	"./br": 424,
	"./br.js": 424,
	"./bs": 425,
	"./bs.js": 425,
	"./ca": 426,
	"./ca.js": 426,
	"./cs": 427,
	"./cs.js": 427,
	"./cv": 428,
	"./cv.js": 428,
	"./cy": 429,
	"./cy.js": 429,
	"./da": 430,
	"./da.js": 430,
	"./de": 433,
	"./de-at": 431,
	"./de-at.js": 431,
	"./de-ch": 432,
	"./de-ch.js": 432,
	"./de.js": 433,
	"./dv": 434,
	"./dv.js": 434,
	"./el": 435,
	"./el.js": 435,
	"./en-SG": 436,
	"./en-SG.js": 436,
	"./en-au": 437,
	"./en-au.js": 437,
	"./en-ca": 438,
	"./en-ca.js": 438,
	"./en-gb": 439,
	"./en-gb.js": 439,
	"./en-ie": 440,
	"./en-ie.js": 440,
	"./en-il": 441,
	"./en-il.js": 441,
	"./en-nz": 442,
	"./en-nz.js": 442,
	"./eo": 443,
	"./eo.js": 443,
	"./es": 446,
	"./es-do": 444,
	"./es-do.js": 444,
	"./es-us": 445,
	"./es-us.js": 445,
	"./es.js": 446,
	"./et": 447,
	"./et.js": 447,
	"./eu": 448,
	"./eu.js": 448,
	"./fa": 449,
	"./fa.js": 449,
	"./fi": 450,
	"./fi.js": 450,
	"./fo": 451,
	"./fo.js": 451,
	"./fr": 454,
	"./fr-ca": 452,
	"./fr-ca.js": 452,
	"./fr-ch": 453,
	"./fr-ch.js": 453,
	"./fr.js": 454,
	"./fy": 455,
	"./fy.js": 455,
	"./ga": 456,
	"./ga.js": 456,
	"./gd": 457,
	"./gd.js": 457,
	"./gl": 458,
	"./gl.js": 458,
	"./gom-latn": 459,
	"./gom-latn.js": 459,
	"./gu": 460,
	"./gu.js": 460,
	"./he": 461,
	"./he.js": 461,
	"./hi": 462,
	"./hi.js": 462,
	"./hr": 463,
	"./hr.js": 463,
	"./hu": 464,
	"./hu.js": 464,
	"./hy-am": 465,
	"./hy-am.js": 465,
	"./id": 466,
	"./id.js": 466,
	"./is": 467,
	"./is.js": 467,
	"./it": 469,
	"./it-ch": 468,
	"./it-ch.js": 468,
	"./it.js": 469,
	"./ja": 470,
	"./ja.js": 470,
	"./jv": 471,
	"./jv.js": 471,
	"./ka": 472,
	"./ka.js": 472,
	"./kk": 473,
	"./kk.js": 473,
	"./km": 474,
	"./km.js": 474,
	"./kn": 475,
	"./kn.js": 475,
	"./ko": 476,
	"./ko.js": 476,
	"./ku": 477,
	"./ku.js": 477,
	"./ky": 478,
	"./ky.js": 478,
	"./lb": 479,
	"./lb.js": 479,
	"./lo": 480,
	"./lo.js": 480,
	"./lt": 481,
	"./lt.js": 481,
	"./lv": 482,
	"./lv.js": 482,
	"./me": 483,
	"./me.js": 483,
	"./mi": 484,
	"./mi.js": 484,
	"./mk": 485,
	"./mk.js": 485,
	"./ml": 486,
	"./ml.js": 486,
	"./mn": 487,
	"./mn.js": 487,
	"./mr": 488,
	"./mr.js": 488,
	"./ms": 490,
	"./ms-my": 489,
	"./ms-my.js": 489,
	"./ms.js": 490,
	"./mt": 491,
	"./mt.js": 491,
	"./my": 492,
	"./my.js": 492,
	"./nb": 493,
	"./nb.js": 493,
	"./ne": 494,
	"./ne.js": 494,
	"./nl": 496,
	"./nl-be": 495,
	"./nl-be.js": 495,
	"./nl.js": 496,
	"./nn": 497,
	"./nn.js": 497,
	"./pa-in": 498,
	"./pa-in.js": 498,
	"./pl": 499,
	"./pl.js": 499,
	"./pt": 501,
	"./pt-br": 500,
	"./pt-br.js": 500,
	"./pt.js": 501,
	"./ro": 502,
	"./ro.js": 502,
	"./ru": 503,
	"./ru.js": 503,
	"./sd": 504,
	"./sd.js": 504,
	"./se": 505,
	"./se.js": 505,
	"./si": 506,
	"./si.js": 506,
	"./sk": 507,
	"./sk.js": 507,
	"./sl": 508,
	"./sl.js": 508,
	"./sq": 509,
	"./sq.js": 509,
	"./sr": 511,
	"./sr-cyrl": 510,
	"./sr-cyrl.js": 510,
	"./sr.js": 511,
	"./ss": 512,
	"./ss.js": 512,
	"./sv": 513,
	"./sv.js": 513,
	"./sw": 514,
	"./sw.js": 514,
	"./ta": 515,
	"./ta.js": 515,
	"./te": 516,
	"./te.js": 516,
	"./tet": 517,
	"./tet.js": 517,
	"./tg": 518,
	"./tg.js": 518,
	"./th": 519,
	"./th.js": 519,
	"./tl-ph": 520,
	"./tl-ph.js": 520,
	"./tlh": 521,
	"./tlh.js": 521,
	"./tr": 522,
	"./tr.js": 522,
	"./tzl": 523,
	"./tzl.js": 523,
	"./tzm": 525,
	"./tzm-latn": 524,
	"./tzm-latn.js": 524,
	"./tzm.js": 525,
	"./ug-cn": 526,
	"./ug-cn.js": 526,
	"./uk": 527,
	"./uk.js": 527,
	"./ur": 528,
	"./ur.js": 528,
	"./uz": 530,
	"./uz-latn": 529,
	"./uz-latn.js": 529,
	"./uz.js": 530,
	"./vi": 531,
	"./vi.js": 531,
	"./x-pseudo": 532,
	"./x-pseudo.js": 532,
	"./yo": 533,
	"./yo.js": 533,
	"./zh-cn": 534,
	"./zh-cn.js": 534,
	"./zh-hk": 535,
	"./zh-hk.js": 535,
	"./zh-tw": 536,
	"./zh-tw.js": 536
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;

/***/ }),
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1001)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1184),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1215),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1000)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1213),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1180),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1012)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1183),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1210),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1190),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1187),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1236),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1274),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1264),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1241),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1205),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1175),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(1221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1223),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(999)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1191),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1219),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1003)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1201),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1248),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1218),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(994)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1148),
  /* scopeId */
  "data-v-01fc01fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1179),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1188),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1222),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1217),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1189),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1173),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1013)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('ed-modal', {
    attrs: {
      "title": 'FILTRAR RESULTADO' + ' (' + _vm.filterBadge + ')',
      "modal": _vm.showFilter,
      "onSave": _vm.handleFilter,
      "onClear": _vm.handleClear,
      "isModal": false,
      "width": "80%",
      "saveName": "Filtrar",
      "saveIcon": "fa fa-filter"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_vm._t("table-filter-content")], 2)]), _vm._v(" "), (_vm.onRegister || !_vm.disableInputSearch || !_vm.disableInputButtons) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row d-flex align-items-baseline"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "table-button d-flex flex-row"
  }, [(_vm.onRegister) ? _c('ed-button', {
    staticClass: "mb-1 mr-1",
    attrs: {
      "type": "primary",
      "icon": _vm.registerIcon,
      "loading": _vm.loadingRegister,
      "value": _vm.registerName
    },
    on: {
      "click": _vm.onRegister
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("table-button")], 2)]), _vm._v(" "), (!_vm.disableInputSearch) ? _c('div', {
    class: _vm.onRegister ?
      'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' :
      'col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12'
  }, [_c('b-input-group', {
    staticClass: "mt-3"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Digite aqui sua pesquisa e pressione ENTER..."
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.formData.search),
      callback: function($$v) {
        _vm.$set(_vm.formData, "search", $$v)
      },
      expression: "formData.search"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "title": "Clique para relizar sua busca..."
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("Buscar")])]), _vm._v(" "), (_vm.onFilter) ? _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "title": _vm.filterBadge + ' filtro(s) ativados, clique para saber mais...'
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    class: 'fa fa-filter' +
      (_vm.filterBadge > 0 ? ' faa-flash animated' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("Filtrar")])]) : _vm._e()], 1)], 1)], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-popover', {
    ref: "deleteAll",
    attrs: {
      "placement": "top",
      "trigger": "manual"
    },
    model: {
      value: (_vm.showPopoverCheckAll),
      callback: function($$v) {
        _vm.showPopoverCheckAll = $$v
      },
      expression: "showPopoverCheckAll"
    }
  }, [_c('div', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3"
  }, [_c('b', [_vm._v("O que deseja fazer com os registro(s) selecionado(s)?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-1"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-window-close-o",
      "type": "info",
      "size": "mini",
      "title": "Calcelar",
      "value": "Cancelar"
    },
    on: {
      "click": _vm.handleSearch
    }
  }), _vm._v(" "), (_vm.onDelete && _vm.checkItem.length > 0) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-trash",
      "type": "danger",
      "size": "mini",
      "title": _vm.onDeleteName,
      "value": _vm.onDeleteName
    },
    on: {
      "click": _vm.handleDelete
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onEditAll && _vm.checkItem.length > 0) ? _c('ed-button', {
    attrs: {
      "icon": _vm.editAllIcon,
      "type": "warning",
      "size": "mini",
      "title": _vm.editAllTitle,
      "loading": _vm.loadingEditAll,
      "value": _vm.editAllName
    },
    on: {
      "click": _vm.handleEditAll
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), (_vm.onSearch) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "10px"
    }
  }, [_c('el-select', {
    style: ('width: ' + (this.device == 'xs' ? '100%' : '220px') + ' !important'),
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.formData.ppage),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ppage", $$v)
      },
      expression: "formData.ppage"
    }
  }, _vm._l((_vm.lstPages), function(page) {
    return _c('el-option', {
      key: page,
      attrs: {
        "label": 'Exibir ' + page + ' itens por página',
        "value": page
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.disableTableContent && _vm.loadingTable),
      expression: "disableTableContent && loadingTable"
    }],
    staticClass: "col-md-12"
  }, [(_vm.tableData.length > 0) ? _vm._t("table-export") : _vm._e(), _vm._v(" "), _vm._t("table-content"), _vm._v(" "), (!_vm.disableTableContent) ? _c('b-table', {
    ref: "selectableTable",
    staticClass: "table-v2",
    attrs: {
      "id": "table-v2",
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": _vm.response && _vm.response.status && _vm.response.status != 200 ?
        _vm.response.status + (_vm.response.msg ? ' - ' + _vm.response.msg : '') :
        _vm.emptyTable,
      "busy": _vm.loadingTable,
      "items": _vm.items,
      "fields": _vm.fields,
      "stacked": this.device == 'xs',
      "sort-by": _vm.formData.sortBy,
      "sort-desc": _vm.formData.sortDesc,
      "foot-clone": _vm.tableFooter.length > 0
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.formData, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.formData, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.formData, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.formData, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(data.label) + "\n        "), (
          _vm.formData.sortBy == data.field.key && _vm.formData.sortDesc == true
        ) ? _c('i', {
          staticClass: "fa fa-sort-alpha-desc"
        }) : _vm._e(), _vm._v(" "), (
          _vm.formData.sortBy == data.field.key && _vm.formData.sortDesc == false
        ) ? _c('i', {
          staticClass: "fa fa-sort-alpha-asc"
        }) : _vm._e(), _vm._v(" "), (data.field.info) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": data.field.info,
            "placement": "top"
          }
        }, [_c('a', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fa fa-question-circle",
          attrs: {
            "aria-hidden": "true"
          }
        })])]) : _vm._e()]
      }
    }, {
      key: "foot()",
      fn: function(data) {
        return [(data.field && data.field.value != undefined) ? _c('span', [_vm._v("\n          " + _vm._s(data.field.value) + "\n        ")]) : _vm._e()]
      }
    }, {
      key: "table-busy",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center my-2",
          staticStyle: {
            "color": "var(--primary)"
          }
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _vm._v(" "), _c('strong', [_vm._v("Carregando...")])], 1)]
      },
      proxy: true
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "head(selected)",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "popover",
            rawName: "v-popover:deleteAll",
            arg: "deleteAll"
          }],
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          on: {
            "change": _vm.handleSelectAll
          },
          model: {
            value: (_vm.checkAll),
            callback: function($$v) {
              _vm.checkAll = $$v
            },
            expression: "checkAll"
          }
        })], 1)]
      }
    }, {
      key: "cell(selected)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          attrs: {
            "label": data.item._data.id
          },
          on: {
            "change": _vm.handleSelectItem
          },
          model: {
            value: (_vm.checkItem),
            callback: function($$v) {
              _vm.checkItem = $$v
            },
            expression: "checkItem"
          }
        })], 1)]
      }
    }, {
      key: "cell(tipo_status)",
      fn: function(data) {
        return [(data.item._data.tipo_status) ? _c('div', {
          style: ('color:' + data.item._data.tipo_status.cor)
        }, [(data.item._data.tipo_status.icon) ? _c('i', {
          class: data.item._data.tipo_status.icon
        }) : _vm._e(), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })]) : _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })])]
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(
          data.field && data.field.show_tipo_aso && data.item._data.tipo_aso
        ) ? _c('div', [(
          (data.field.show_consulta_link ||
            data.field.show_link_consulta) &&
          data.item._data.id_con
        ) ? _c('a', {
          attrs: {
            "href": _vm.getUrlConsulta(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              CÓD: "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')]), _vm._v(" "), _c('span', {
          style: ('font-size: 7pt; color: #666;' + (data.item.options && data.item.options.style ? data.item.options.style : ''))
        }, [_vm._v("\n              " + _vm._s(data.item._data.tipo_aso.descricao) + "\n            ")])]) : _c('span', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_vm._v("\n              " + _vm._s(data.item._data.tipo_aso.descricao) + " " + _vm._s((data.item._data.periodicidade ? data.item._data.periodicidade + ' MESES' : '')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (
          (data.field.show_consulta_link ||
            data.field.show_link_consulta) &&
          data.item._data.id_con && data.item._data.consulta
        ) ? _c('a', {
          attrs: {
            "href": _vm.getUrlConsulta(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-calendar",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$utilidade.toDate(data.item._data.consulta.dt_cad, true)))]), _c('br')])]) : (data.field && data.field.show_empresa_link) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.getUrlEmpresa(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: (data.item.options && data.item.options.style ?
            ';' + data.item.options.style :
            ''),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')]), _vm._v(" "), (data.field.show_fdt && data.item._data.fdt && data.item._data.fdt.pcmso) ? _c('span', {
          style: ('font-size:7pt;color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              ''))
        }, [_vm._v("\n              " + _vm._s(data.item._data.fdt.pcmso) + " (" + _vm._s(data.item._data.fdt.descricao) + ")\n            ")]) : _vm._e()])]) : (data.field && data.field.show_revisao_link && data.item._data.revisao_tipo) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.env.url_cs +
              '/app/' + (data.item._data.revisao_tipo) + '.php?emp=' +
              (data.item._data.empresa ? data.item._data.empresa.id : data.item._data.empresa_id) +
              '&pcmso=' + (data.item._data.fdt ? data.item._data.fdt.id : data.item._data.fdt_id) +
              '&rev=' + (data.item._data.revisao ? data.item._data.revisao.id : data.item._data.revisao_id),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: (data.item.options && data.item.options.style ?
            ';' + data.item.options.style :
            ''),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')])])]) : (
          data.field && data.field.show_funcao && data.item._data.funcao
        ) ? _c('div', [(data.field.show_funcionario_link) ? _c('a', {
          attrs: {
            "href": _vm.getUrlFuncionario(data.item._data),
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(data.value)), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n                " + _vm._s(data.item._data.funcao.nome) + "\n              ")])])]) : _c('span', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n                " + _vm._s(data.item._data.funcao.nome) + "\n              ")])])])]) : (data.field && data.field.show_financeiro_link) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.env.url_cs +
              '/app/financeiro_rel.php?cod_tp=0&cod_n=' +
              data.value,
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])])]) : (
          data.field && data.field.show_lote_link && data.item._data
        ) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.getUrlLote(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })])])]) : (
          data.field && data.field.show_user && data.item._data.usuario
        ) ? _c('div', {
          style: (data.item.options && data.item.options.style ?
            data.item.options.style :
            '')
        }, [_vm._v("\n          " + _vm._s(data.value)), _c('br'), _vm._v(" "), _c('span', {
          style: ('font-size:7pt' +
            (data.item.options && data.item.options.style ?
              data.item.options.style :
              ''))
        }, [_vm._v("\n            " + _vm._s(data.item._data.usuario.usuario) + "\n          ")])]) : (data.field && data.field.show_arquivo) ? _c('div', [(data.value && data.value.id) ? _c('Download', {
          attrs: {
            "arquivo": data.value
          }
        }) : _c('span', [_vm._v("---")])], 1) : (data.field && data.field.show_input) ? _c('div', [(data.field.edit == 'money') ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field.edit == 'number') ? _c('el-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()], 1) : (data.field && data.field.show_point) ? _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n          "), (
          data.item._data.log_acesso.usuario &&
          data.item._data.log_acesso.usuario.point
        ) ? _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('br'), _vm._v(_vm._s(data.item._data.log_acesso.usuario.point.nome) + "\n          ")]) : _vm._e()]) : (
          data.field &&
          data.field.show_status &&
          data.item._data.tipo_status
        ) ? _c('div', [_c('span', {
          style: ('color:' + data.item._data.tipo_status.cor),
          attrs: {
            "title": data.value
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : data.value
          }
        }, [(data.item._data.tipo_status.icon) ? _c('i', {
          class: data.item._data.tipo_status.icon
        }) : _vm._e(), _vm._v("\n              " + _vm._s(data.item._data.tipo_status.descricao) + "\n            ")])])]) : (
          data.field && data.field.show_rea && data.item._data.id_con_rea
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "tp-exame-rea",
          staticStyle: {
            "font-size": "9pt"
          },
          attrs: {
            "title": "Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
          }
        }, [_vm._v("\n            Exame "), _c('b', [_vm._v("reaproveitado")]), _vm._v(" da consulta\n            "), _c('label', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(data.item._data.id_con_rea))]), _vm._v(" "), (data.item._data.con_rea_dt) ? _c('span', [_vm._v("\n              em " + _vm._s(_vm.toDate(data.item._data.con_rea_dt, true)) + "\n            ")]) : _vm._e()])]) : (
          data.field && data.field.show_dem && data.item._data.id_con_dem
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "tp-exame-dem",
          staticStyle: {
            "font-size": "9pt"
          },
          attrs: {
            "title": "Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
          }
        }, [_vm._v("\n            Exame "), _c('b', [_vm._v("demonstrativo")]), _vm._v(" na consulta\n            "), _c('label', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(data.item._data.id_con_dem))]), _vm._v(" "), (data.item._data.con_dem_dt) ? _c('span', [_vm._v("\n              em " + _vm._s(_vm.toDate(data.item._data.con_dem_dt, true)) + "\n            ")]) : _vm._e()])]) : (
          data.field && data.field.show_alt && data.item._data.alt == '1'
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          staticStyle: {
            "color": "#c64747"
          },
          attrs: {
            "title": "Esse exame teve resultado alterado e deverá ser refeito no próximo periódico."
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n            " + _vm._s(data.value) + "\n          ")])]) : (
          data.field && data.field.show_parceiro && data.item._data.parceiro
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "9pt",
            "color": "#c4c4c4"
          },
          attrs: {
            "title": "Parceiro que o exame será efetuado"
          }
        }, [_vm._v("\n            " + _vm._s(data.item._data.parceiro.nome) + "\n          ")])]) : (data.field && data.field.show_json) ? _c('div', [_c('el-popover', {
          attrs: {
            "placement": "top",
            "trigger": "click"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 text-center mt-2"
        }, [_c('b', [_vm._v("Detalhes")])]), _vm._v(" "), _vm._l((data.value), function(value, field, i) {
          return _c('div', {
            key: i,
            staticClass: "col-md-12"
          }, [_c('b', [_vm._v(_vm._s(field) + ": ")]), _vm._v(" "), (field == 'exame' && value && value.nome) ? _c('span', [_vm._v("\n                  " + _vm._s(value.nome) + "\n                ")]) : (field == 'parceiro' && value && value.nome) ? _c('span', [_vm._v("\n                  " + _vm._s(value.nome) + "\n                ")]) : (field == 'created_at' || field == 'updated_at') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.toDate(value)) + "\n                ")]) : (field == 'bl_his' || field == 'bl_his') ? _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.base64Decode(value))
            }
          })]) : _c('span', [_vm._v("\n                  " + _vm._s(value) + "\n                ")])])
        })], 2), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('b-link', [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v("\n                Ver mais...\n              ")])], 1)])], 1) : (data.field && data.field.show_html) ? _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })]) : (data.field && data.field.show_colapse) ? _c('div', [(!data.value) ? _c('span', [_vm._v("---")]) : _c('el-collapse', {
          attrs: {
            "title": "Clique para mostrar mais informações"
          },
          model: {
            value: (data.item._data[data.field.key].collapse),
            callback: function($$v) {
              _vm.$set(data.item._data[data.field.key], "collapse", $$v)
            },
            expression: "data.item._data[data.field.key].collapse"
          }
        }, [_c('el-collapse-item', {
          attrs: {
            "name": data.item._data.id.toString() + data.field.key
          }
        }, [_c('template', {
          slot: "title"
        }, [(
          data.item._data[data.field.key].collapse &&
          data.item._data[data.field.key].collapse[0]
        ) ? _c('i', {
          staticClass: "fa fa-minus-circle fa-1x",
          staticStyle: {
            "color": "#28a745"
          }
        }) : _c('i', {
          staticClass: "fa fa-plus-circle fa-1x",
          staticStyle: {
            "color": "#28a745"
          }
        })]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt"
          },
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })], 2)], 1)], 1) : _c('div', {
          style: (data.item.options && data.item.options.style ?
            data.item.options.style :
            ''),
          attrs: {
            "title": data.item.options && data.item.options.title ?
              data.item.options.title :
              null
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [(
          data.field.limit &&
          data.field.limit < _vm.toString(data.value).length
        ) ? _c('span', [_c('el-popover', {
          attrs: {
            "placement": "top",
            "trigger": "click"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 p-5"
        }, [_vm._v("\n                    " + _vm._s(data.value) + "\n                  ")])]), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('b-link', [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v("\n                    Ver mais...\n                  ")])], 1)])], 1) : _c('span', [(
          data.item &&
          data.item._data &&
          ((_vm.onEditAll &&
              _vm.checkItem.indexOf(data.item._data.id) != -1) ||
            _vm.editableRows)
        ) ? _c('span', [(data.field.edit == 'money') ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field.edit == 'text') ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (
          data.field.edit == 'select-custom' &&
          _vm.config.click &&
          _vm.config.click[data.field.key] &&
          _vm.config.list &&
          _vm.config.list[data.field.key]
        ) ? _c('el-select', {
          attrs: {
            "loading": _vm.config.loading[data.field.key],
            "placeholder": 'Pesquisar...',
            "filterable": "",
            "remote": "",
            "remote-method": _vm.config.click[data.field.key],
            "value-key": "id"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }, _vm._l((_vm.config.list[data.field.key]), function(val, j) {
          return _c('el-option', {
            key: j,
            attrs: {
              "label": val.nome,
              "value": val.id
            }
          })
        }), 1) : _c('span', [_vm._v("\n                  " + _vm._s(data.value) + "\n                ")])], 1) : _c('span', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _vm._v(" "), (
          data.field && data.field.show_cnpj && data.item._data.cnpj
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "CNPJ"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-credit-card-alt",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.cnpj) + "\n                ")]) : _vm._e(), _vm._v(" "), (
          data.field && data.field.show_cpf && data.item._data.cpf
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "CPF"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-address-card",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.cpf) + "\n                ")]) : _vm._e(), _vm._v(" "), (
          data.field &&
          data.field.show_telefone &&
          _vm.onlyNumber(data.item._data.telefone)
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "Telefone"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-phone-square",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.telefone) + "\n                ")]) : _vm._e()])])])])]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center tbutton"
        }, [(
          _vm.onEdit &&
          (!data.item.options ||
            (data.item.options && !data.item.options.disable_edit))
        ) ? _c('ed-button', {
          staticStyle: {
            "margin": "2px"
          },
          attrs: {
            "icon": "fa fa-pencil-square-o",
            "type": "primary",
            "size": "mini",
            "title": "Editar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(data.item._data)
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm._l((data.value), function(button, i) {
          return _c('ed-button', {
            key: i,
            staticStyle: {
              "margin": "2px"
            },
            style: (button.style),
            attrs: {
              "icon": button.icon,
              "type": button.color,
              "size": "mini",
              "title": button.title
            },
            on: {
              "click": function($event) {
                return button.click(data.item._data)
              }
            }
          })
        }), _vm._v(" "), (
          _vm.onDelete &&
          (!data.item.options ||
            (data.item.options && !data.item.options.disable_delete))
        ) ? _c('ed-button', {
          staticStyle: {
            "margin": "2px"
          },
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": _vm.onDeleteName
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(data.item._data)
            }
          }
        }) : _vm._e()], 2)]
      }
    }], null, false, 3590096355)
  }) : _vm._e(), _vm._v(" "), (_vm.pagination && _vm.pagination.total && _vm.pagination.total > 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('ed-paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "navigation": _vm.handleNavigate
    }
  })], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Número do Protocolo",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.busca),
      callback: function($$v) {
        _vm.$set(_vm.formData, "busca", $$v)
      },
      expression: "formData.busca"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "disabled": !_vm.formData.id_emp || !_vm.formData.busca ? true : false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": this.$store.state.ltcat.title + 'Gerar Novo Orçamento',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.parent.formData.id == 0 ? 'Nova Categoria' : 'Editar Categoria ' + _vm.parent.formData.nome + ' :: ' + _vm.tabela.nome,
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.parent.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [(_vm.noTenant) ? _c('Erro500', {
    attrs: {
      "erro": _vm.noTenant
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.$route.meta.disablePageHeader && !_vm.loadingContent && _vm.$root.$session.usuario.logged && _vm.$root.$session.usuario.logged.point) ? _c('div', [_c('EmpresaHeader')], 1) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent) ? _c('div', {
    staticClass: "pl-3 pr-3 pb-3",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [(!_vm.$route.meta.disablePageHeader) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$route.meta.title.toUpperCase()))]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": this.$root.$session.navigation
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent && _vm.$root.$session.cliente.logged) ? _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('EmpresaFooter')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Item Lote ' + this.parent.formData.lote,
      "modal": _vm.showFormList,
      "width": "98%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [(_vm.parent.formData.lote) ? _c('eSocial', {
    key: _vm.formData.id + '-' + (_vm.showForm ? 1 : 0),
    attrs: {
      "layout": _vm.parent.formData.layout,
      "lote": _vm.parent.formData.lote,
      "avulso": _vm.parent.formData.avulso ? _vm.parent.formData.avulso : 0
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ?
        'Novo GHE' :
        this.$store.state.ltcat.title +
        _vm.formData.ghe +
        ' (' +
        _vm.formData.descricao +
        ')',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onClose": _vm.onClose,
      "onSave": _vm.tagConfig == 'tab-cadastro' ? this.salvar : null,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações do GHE\n          ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Medições (" + _vm._s(_vm.formData.medicoes.length) + ")\n          ")]), _vm._v(" "), _c('Medicao', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-conclusao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wpforms"
  }), _vm._v(" Conclusão Técnica (" + _vm._s(_vm.formData.conclusoes.length) + ")\n          ")]), _vm._v(" "), _c('ConclusaoTecnica', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-funcao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Funções (" + _vm._s(_vm.formData.funcoes.length) + ")\n          ")]), _vm._v(" "), _c('Funcao', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-funcionarios"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Funcionário (" + _vm._s(_vm.formData.funcionarios.length) + ")\n          ")]), _vm._v(" "), _c('Funcionario', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Enviar Novo Email Lote' + this.parent.formData.lote,
      "modal": _vm.showFormRegister,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'Emails Lote ' + this.parent.formData.lote,
      "modal": _vm.showFormList,
      "width": "98%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('LogEmail', {
    attrs: {
      "point_type": "esocial-lote",
      "point_id": _vm.parent.formData.id,
      "onRegister": _vm.onRegister
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Consultar Informações no eSocial",
      "saveName": "Consultar",
      "width": "80%",
      "modal": _vm.boolExibirConsultaProtocolo,
      "isModal": false
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-3"
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n          Escolha abaixo o que gostaria de consiltar diretamente no eSocial\n        ")])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Situação do Protocolo",
      "name": "tab-consulta-protocolo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Situação do Protocolo")]), _vm._v(" "), _c('consulta-protocolo', {
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Informações do Recibo",
      "name": "tab-consulta-recibo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Informações do Recibo")]), _vm._v(" "), _c('consulta-recibo', {
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Eventos do Empregador",
      "name": "tab-consulta-evento-empresa"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Eventos do Empregador")]), _vm._v(" "), _c('consulta-evento-empresa', {
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Eventos do Trabalhador",
      "name": "tab-consulta-evento-trabalhador"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Eventos do Trabalhador")]), _vm._v(" "), _c('consulta-evento-trabalhador', {
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('GerarLote', {
    attrs: {
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('EmailLote', {
    attrs: {
      "parent": this,
      "showForm": _vm.showFormEmail
    }
  }), _vm._v(" "), _c('Item', {
    attrs: {
      "showForm": _vm.showFormItem
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'Processar Lote no eSocial Lote ' + this.formData.lote,
      "modal": _vm.showFormProcessar,
      "width": "90%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('Processar', {
    attrs: {
      "formData": _vm.formData
    }
  })], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Gerar Novo Lote",
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getEsocialLotes,
      "onDelete": _vm.onDelete,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onFilter": _vm.getEsocialLotes,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formFilter
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formFilter.id_empresa),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "id_empresa", $$v)
      },
      expression: "formFilter.id_empresa"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Trabalhador",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formFilter.id_funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "id_funcionario", $$v)
      },
      expression: "formFilter.id_funcionario"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Layout",
      "itemValue": "codigo",
      "itemText": "esocial",
      "items": _vm.lstLayout,
      "clearable": ""
    },
    model: {
      value: (_vm.formFilter.layout),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "layout", $$v)
      },
      expression: "formFilter.layout"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [(_vm.$root.$session.validarPacote(30)) ? _c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search"
    },
    on: {
      "click": function($event) {
        _vm.boolExibirConsultaProtocolo = !_vm.boolExibirConsultaProtocolo
      }
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": _vm.text
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Gerar Novo Lote',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Empresa",
      "placeholder": "Pesquisar empresa",
      "items": _vm.config.list.id_emp,
      "loading": _vm.config.loading.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Layout",
      "placeholder": "Pesquisar layout",
      "items": _vm.config.list.layout,
      "loading": _vm.config.loading.layout,
      "itemText": "esocial",
      "is-object": "",
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getLayout
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "\n            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\n            pt-3\n            text-left\n          "
  }, [_c('b', [_vm._v("Aplicar outros filtros")])]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.config.list.id_fdt,
      "loading": _vm.config.loading.id_fdt,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "itemText": "fdt",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.fdts),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fdts", $$v)
      },
      expression: "formData.fdts"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Funcionário",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios", $$v)
      },
      expression: "formData.funcionarios"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de cadastro do arquivo",
      "type": "daterange",
      "disabled": !_vm.formData.id_emp ||
        !_vm.formData.layout
    },
    model: {
      value: (_vm.formData.created_at),
      callback: function($$v) {
        _vm.$set(_vm.formData, "created_at", $$v)
      },
      expression: "formData.created_at"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Não incluir os seguintes funcionários",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios_delete),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios_delete", $$v)
      },
      expression: "formData.funcionarios_delete"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Somente eventos avulsos",
      "items": [{
        id: 1,
        nome: 'Sim'
      }, {
        id: 0,
        nome: 'Não'
      }],
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.avulso),
      callback: function($$v) {
        _vm.$set(_vm.formData, "avulso", $$v)
      },
      expression: "formData.avulso"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "isModal": false,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "pagination": _vm.paginationExame,
      "response": _vm.response,
      "loadingTable": _vm.loadingTableExame,
      "onSearch": _vm.getExame,
      "disableCheckAll": "",
      "disableInputSearch": "",
      "disabledConfigCell": ""
    }
  })], 1)]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 10 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loadingContent) ? _c('div', {
    staticClass: "row d-flex justify-content-center",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-md-offset-4"
  }, [_c('b-card', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tAcesso Restrito\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ed-modal', {
    attrs: {
      "title": "Recuperar Senha",
      "modal": _vm.showModal,
      "width": "50%",
      "onSave": _vm.recuperarSenha,
      "loadingSave": _vm.loadingRecuperarSenha,
      "saveName": "Recuperar Senha"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.resetitens
    }
  })], 1)]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.loginItens
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-sign-in",
      "type": "primary",
      "loading": _vm.loadingSave,
      "value": "Entrar"
    },
    on: {
      "click": _vm.login
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }, [_vm._v("Esqueci Minha Senha")])])], 1)])])], 1)])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.descricao,
        "value": Number(item.id)
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": (_vm.device == 'xs' ? '97%' : _vm.width),
      "close-on-press-escape": _vm.closeESC,
      "close-on-click-modal": _vm.closeCLICK,
      "modal": _vm.isModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": _vm.handlerClose
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title.toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._t("modal-content")], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.onSave) ? _c('ed-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave,
      "disabled": _vm.disabledSave,
      "icon": _vm.saveIcon,
      "value": _vm.saveName
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onClear) ? _c('ed-button', {
    attrs: {
      "type": "warning",
      "icon": "fa fa-refresh",
      "value": "Limpar"
    },
    on: {
      "click": _vm.onClear
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "icon": "fa fa-window-close",
      "value": "Fechar"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('div', {}, [_c('div', {}, [_c('b-form-file', {
    ref: 'file-input-' + this.name,
    attrs: {
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "placeholder": "Escolher arquivo...",
      "drop-placeholder": "Apagar arquivo...",
      "browse-text": "Procurar..."
    },
    on: {
      "change": _vm.onChangeFile
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function(ref) {
        var names = ref.names;

        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))]), _vm._v(" "), (names.length > 1) ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("\n           + " + _vm._s(names.length - 1) + " More files\n         ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), (_vm.currentFile != null) ? _c('div', {
    staticClass: "arquivo-info"
  }, [_c('Download', {
    attrs: {
      "arquivo": _vm.currentFile
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consulta) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabConfig),
      callback: function($$v) {
        _vm.tabConfig = $$v
      },
      expression: "tabConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v("\n\t\t\t\tInformações da Consulta\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row p-1"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0 border-right-0"
  }, [_c('b', [_vm._v("Cód")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.id) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("Funcionário")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcionario.nome) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("CPF")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcionario.cpf) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("Função")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcao.nome) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border  border-right-0"
  }, [_c('b', [_vm._v("Tipo da Consulta")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.tipo_aso.descricao) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta-exame"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v("\n\t\t\t\tInformações dos Exames\n\t\t\t")]), _vm._v(" "), _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    }
  }, [_vm._v("Exame")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _vm._l((_vm.consulta.exames), function(exame) {
    return _c('tr', {
      key: exame.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(exame.exame.nome) + "\n\t\t\t\t\t\t"), (exame.id_con_rea) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n\t\t\t\t\t\t\tExame reaproveitado na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.id_con_rea))]), _vm._v(" em " + _vm._s(_vm.toDate(exame.data, true)) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (exame.id_con_dem) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n\t\t\t\t\t\t\tExame demonstrativo na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.id_con_dem))])]) : _vm._e(), _vm._v(" "), (!exame.pcmso_exame) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('br'), _vm._v("Exame não encontrado no PCMSO")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((exame.id_con_rea ? '---' : _vm.toDate(exame.data, true))) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((exame.id_con_rea ? '---' : exame.valor)) + "\n\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n\t\t\t\tInformações dos Riscos\n\t\t\t")]), _vm._v(" "), _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Risco")])]), _vm._v(" "), _vm._l((_vm.consulta.riscos), function(risco) {
    return _c('tr', {
      key: risco.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [(risco.risco) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.risco.categoria.categoria) + "\n\t\t\t\t\t\t")]) : (risco.categoria) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.categoria.categoria) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [(risco.risco) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.risco.nome) + "\n\t\t\t\t\t\t")]) : (risco.nome) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.nome) + "\n\t\t\t\t\t\t")]) : _vm._e()])])
  })], 2)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [(_vm.formData.consulta) ? _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    }
  }, [_vm._v("Exame")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _vm._l((_vm.formData.consulta.exames), function(exame) {
    return _c('tr', {
      key: exame.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n          " + _vm._s(exame.exame.nome) + "\n          "), (exame.consulta_rea) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n            Exame reaproveitado na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.consulta_rea.id_con))]), _vm._v(" em " + _vm._s(_vm.toDate(exame.consulta_rea.dt_cad, true)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n          " + _vm._s((exame.consulta_rea ? '---' : _vm.toDate(exame.dt_cad, true))) + "\n        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s((exame.consulta_rea ? '---' : exame.valor)))])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 5 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onEditAll": _vm.onEditAll,
      "onSearch": _vm.getRiscoLaboratorio,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "config": _vm.config,
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Medição' : 'Editar Medição',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "ltcat-medicao",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Informações Gerais\n        ")]), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Replicar Medição para os Seguintes GHE",
      "items": _vm.config.list.replicar,
      "multiple": ""
    },
    model: {
      value: (_vm.formData.replicar),
      callback: function($$v) {
        _vm.$set(_vm.formData, "replicar", $$v)
      },
      expression: "formData.replicar"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Fator de Risco",
      "name": "id_tab.id",
      "items": _vm.config.list.id_age,
      "remote": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFatorRisco
    },
    model: {
      value: (_vm.formData.id_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_age", $$v)
      },
      expression: "formData.id_age"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Tabela Dinâmica",
      "name": "id_age.id",
      "items": _vm.config.list.id_tab,
      "itemText": "tabela_dinamica",
      "is-object": ""
    },
    model: {
      value: (_vm.formData.id_tab),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_tab", $$v)
      },
      expression: "formData.id_tab"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Nº de Amostragens Necessárias por Ponto",
      "type": "number"
    },
    model: {
      value: (_vm.formData.amostragem),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amostragem", $$v)
      },
      expression: "formData.amostragem"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Data Medição"
    },
    model: {
      value: (_vm.formData.data_medicao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_medicao", $$v)
      },
      expression: "formData.data_medicao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Equipamentos\n        ")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('ed-alert', [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('a', {
    attrs: {
      "href": "http://caepi.mte.gov.br/internet/ConsultaCAInternet.aspx",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Clique aqui para consultar a lista de CA\n                      ")])])])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0 text-left ",
    attrs: {
      "label": "Pesquisar Equipamento",
      "placeholder": "Digite o nome do EPI",
      "items": _vm.config.list.epi,
      "loading": _vm.config.loading.epi,
      "itemText": "epi",
      "maxLenght": "10",
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getEquipamento,
      "input": _vm.addEPI
    },
    model: {
      value: (_vm.formData.epi),
      callback: function($$v) {
        _vm.$set(_vm.formData, "epi", $$v)
      },
      expression: "formData.epi"
    }
  })], 1)])]), _vm._v(" "), (_vm.formData.equipamentos && _vm.formData.equipamentos.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("EPI")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Med. Protecao \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi tentada a implementação de medidas de proteção coletiva, de caráter administrativo ou de organização, optando-se pelo EPI por inviabilidade técnica, insuficiência ou interinidade, ou ainda em caráter complementar ou emergencial?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Cond. Funcionamento \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foram observadas as condições de funcionamento do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Uso Ininterrupto \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi observado o uso ininterrupto do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Validade \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi observado o prazo de validade do CA no momento da compra do EPI?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Troca \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "É observada a periodicidade de troca definida pelo fabricante nacional ou importador e/ou programas ambientais, comprovada mediante recibo assinado pelo usuário em época própria?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("\n                  Higienização\n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "É observada a higienização conforme orientação do fabricante nacional ou importador?"
    }
  })])])]), _vm._v(" "), _vm._l((_vm.formData.equipamentos), function(equipamento, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_vm._v("\n                " + _vm._s(equipamento.epi.nome) + "\n                \n                "), (equipamento.epi.ca) ? _c('span', [_c('br'), _c('b', [_vm._v("CA:")]), _vm._v(" " + _vm._s(equipamento.epi.ca) + "\n                ")]) : _vm._e(), _vm._v(" "), (equipamento.epi.categoria) ? _c('span', [_c('br'), _c('b', [_vm._v("Categoria:")]), _vm._v(" " + _vm._s(equipamento.epi.categoria.nome) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "medProtecao"
      },
      model: {
        value: (equipamento.medProtecao),
        callback: function($$v) {
          _vm.$set(equipamento, "medProtecao", $$v)
        },
        expression: "equipamento.medProtecao"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "condFuncto"
      },
      model: {
        value: (equipamento.condFuncto),
        callback: function($$v) {
          _vm.$set(equipamento, "condFuncto", $$v)
        },
        expression: "equipamento.condFuncto"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "usoInint"
      },
      model: {
        value: (equipamento.usoInint),
        callback: function($$v) {
          _vm.$set(equipamento, "usoInint", $$v)
        },
        expression: "equipamento.usoInint"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "przValid"
      },
      model: {
        value: (equipamento.przValid),
        callback: function($$v) {
          _vm.$set(equipamento, "przValid", $$v)
        },
        expression: "equipamento.przValid"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "periodicTroca"
      },
      model: {
        value: (equipamento.periodicTroca),
        callback: function($$v) {
          _vm.$set(equipamento, "periodicTroca", $$v)
        },
        expression: "equipamento.periodicTroca"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "higienizacao"
      },
      model: {
        value: (equipamento.higienizacao),
        callback: function($$v) {
          _vm.$set(equipamento, "higienizacao", $$v)
        },
        expression: "equipamento.higienizacao"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-button', {
      attrs: {
        "icon": "fa fa-times",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEPI(index)
        }
      }
    })], 1)])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          INFORMAÇÕES DA MEDIÇÃO\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.lancamentos),
      expression: "config.loading.lancamentos"
    }],
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [(_vm.formData.id_tab) ? _c('div', {}, _vm._l((_vm.config.list.lancamentos), function(coluna, i) {
    return _c('div', {
      key: i,
      staticClass: "col-12 text-left p-0 mb-2"
    }, [(_vm.showCategoria(coluna, i)) ? _c('div', {
      style: ('font-weight: bold;')
    }, [(coluna.tabela_categoria) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.tabela_categoria.nome) + "\n                ")]) : (!coluna.tabela_categoria) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.nome) + "\n                ")]) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 217) ? _c('ed-button', {
      attrs: {
        "icon": "fa fa-plus-circle",
        "type": "text",
        "value": "Inserir Nova Linha"
      },
      on: {
        "click": function($event) {
          return _vm.onInserirLinha(coluna, i)
        }
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      class: 'col-12 p-0 mt-1 mb-1'
    }, [(
      coluna.tipo_campo.id == 208 || coluna.tipo_campo.id == 216
    ) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (coluna.mascara ? coluna.mascara : ''),
        expression: "coluna.mascara ? coluna.mascara : ''"
      }],
      attrs: {
        "type": coluna.tipo_campo.valor
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, [(coluna.unidade) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(coluna.unidade))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 215) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      attrs: {
        "type": coluna.tipo_campo.valor
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, [(coluna.unidade) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(coluna.unidade))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 209) ? _c('el-input-number', {
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 210) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.nome) + "\n                ")]) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 210) ? _c('el-select', {
      attrs: {
        "clearable": true,
        "placeholder": "Selecione"
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, _vm._l((coluna.tabela_valores), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.nome,
          "value": item.id
        }
      })
    }), 1) : _vm._e()], 1), _vm._v(" "), (
      coluna.tabela_valores.length > 0 &&
      coluna.tipo_campo.id != 210
    ) ? _c('div', {
      staticClass: "row"
    }, _vm._l((coluna.tabela_valores), function(coluna_val, j) {
      return _c('div', {
        key: i + j,
        class: 'col-' +
          12 / coluna.tabela_valores.length +
          ' text-left mb-2'
      }, [_vm._v("\n                  " + _vm._s(coluna_val.nome) + "\n                  "), (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        (coluna_val.tipo_campo.id == 208 ||
          coluna_val.tipo_campo.id == 216)
      ) ? _c('el-input', {
        attrs: {
          "type": coluna_val.tipo_campo ?
            coluna_val.tipo_campo.valor :
            'text'
        },
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }, [(coluna_val.unidade) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(coluna_val.unidade))]) : _vm._e()], 2) : (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        coluna_val.tipo_campo.id == 215
      ) ? _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text"
        },
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }, [(coluna_val.unidade) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(coluna_val.unidade))]) : _vm._e()], 2) : (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        coluna_val.tipo_campo.id == 209
      ) ? _c('el-input-number', {
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }) : _vm._e(), _vm._v(" "), _vm._l((coluna_val.linhas), function(coluna_val_lin, k) {
        return _c('div', {
          key: i + j + k,
          class: 'col-12 text-left p-0 mt-2'
        }, [(j == 0 && k > 0) ? _c('span', [_c('el-link', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.onDeleteLinha(coluna, k)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v("\n                        Remover Linha\n                      ")])], 1) : (k > 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (
          coluna_val_lin.tipo_campo &&
          (coluna_val_lin.tipo_campo.id == 208 ||
            coluna_val_lin.tipo_campo.id == 216)
        ) ? _c('el-input', {
          attrs: {
            "type": coluna_val_lin.tipo_campo ?
              coluna_val_lin.tipo_campo.valor :
              'text'
          },
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }, [(coluna_val_lin.unidade) ? _c('template', {
          slot: "append"
        }, [_vm._v(_vm._s(coluna_val_lin.unidade))]) : _vm._e()], 2) : (
          coluna_val_lin.tipo_campo &&
          coluna_val_lin.tipo_campo.id == 215
        ) ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }, [(coluna_val_lin.unidade) ? _c('template', {
          slot: "append"
        }, [_vm._v(_vm._s(coluna_val_lin.unidade))]) : _vm._e()], 2) : (
          coluna_val_lin.tipo_campo &&
          coluna_val_lin.tipo_campo.id == 209
        ) ? _c('el-input-number', {
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }) : _vm._e()], 1)
      })], 2)
    }), 0) : _vm._e(), _vm._v(" "), (
      _vm.response.status == 400 &&
      _vm.response.options.data[0] &&
      _vm.response.options.data[0][coluna.id]
    ) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "color": "#e66666",
        "font-size": "9pt"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.response.options.data[0][coluna.id]) + "\n              ")]) : _vm._e()])
  }), 0) : _vm._e()])], 1), _vm._v(" "), (
    !_vm.config.loading.content &&
    !_vm.config.loading.lancamentos &&
    (!_vm.formData.id_age || !_vm.formData.id_tab)
  ) ? _c('ed-alert', {
    attrs: {
      "type": "warning",
      "title": "Selecione todos os campos obrigatórios"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Medição",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatRisco,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [(_vm.isRadio) ? [_c('div', {
    staticClass: "el-input"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "form-check col-12 text-left pl-0"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '_' + item.id,
        "disabled": _vm.disabled || _vm.disabledItem(item)
      },
      domProps: {
        "checked": _vm.value == item.id ? 'checked' : '',
        "value": _vm.value
      },
      on: {
        "change": function($event) {
          return _vm.setEvent('input', this.isObject ? item : item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": _vm.name + '_' + item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.descricao) + "\n        ")]), _vm._v(" "), (!!_vm.$slots[_vm.name + '_' + item.id]) ? _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "background": "#ffdbdb"
      }
    }, [_vm._t(_vm.name + '_' + item.id)], 2) : _vm._e()])
  }), 0)] : [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "value-key": _vm.valueKey,
      "collapse-tags": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.setEvent('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.descricao,
        "value": this.isObject ? item : item[_vm.valueKey]
      }
    })
  }), 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    attrs: {
      "title": _vm.title,
      "type": _vm.type,
      "description": _vm.description,
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consulta) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-aso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir ASO")]), _vm._v(" "), _c('Aso', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": " Imprimir Ficha Clínica",
      "name": "tab-femo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir Ficha Clínica")]), _vm._v(" "), _c('Femo', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": " Liberar ASO",
      "name": "tab-liberar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Liberar ASO")]), _vm._v(" "), _c('Liberar', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), (!_vm.consulta || (_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id != 66 && _vm.consulta.tipo_status.id != 57 && _vm.consulta.tipo_status.id != 58)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Cancelar Consulta",
      "name": "tab-cancelar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-window-close"
  }), _vm._v(" Cancelar Consulta")]), _vm._v(" "), _c('Cancelar', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.id == 0 ? 'Inserir 	Novo Email' : 'Editar Email'),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.emailItems
    }
  }), _vm._v(" "), (_vm.formData.usuario) ? _c('EdAlert', {
    attrs: {
      "title": "Última Atualização"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('b', [_vm._v("Usuário:")]), _vm._v(" " + _vm._s(_vm.formData.usuario.usuario)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Data:")]), _vm._v(" " + _vm._s(_vm.toDate(_vm.formData.updated_at)) + "\n          ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('EdAlert', {
    attrs: {
      "title": "Atenção",
      "description": "Aqui você pode cadastrar múltiplos emails para essa empresa especificando cada email por setores",
      "type": "warning"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Novo Email",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onSearch": _vm.getEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('h1', [_vm._v("eSocial - Download de Arquivo")]), _vm._v(" "), _c('div', {
    staticClass: "widget-container fluid-height clearfix widget-content padded"
  }, [(_vm.error) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "description": _vm.error,
      "show-icon": "",
      "closable": false
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.error && _vm.formData.id) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Arquivo Carregado com Sucesso",
      "type": "success",
      "description": "Confira abaixo as informações do lote",
      "show-icon": "",
      "closable": false
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.lote))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.empresa_nome_fantasia) + " - " + _vm._s(_vm.formData.empresa_cnpj))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.layout))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onDownloadArquivo
    }
  }, [_vm._v(_vm._s(_vm.formData.filename))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.toDate(_vm.formData.updated_at, false)))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 text-center",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingDownload
    },
    on: {
      "click": _vm.onDownloadArquivo
    }
  }, [(!_vm.loadingDownload) ? _c('i', {
    staticClass: "fa fa-download"
  }) : _vm._e(), _vm._v("\n                    Baixar Arquivo\n                ")]), _vm._v(" "), _vm._m(6)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Lote:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Empresa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Layout:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Nome do Arquivo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Última Atualização:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12 text-center",
    staticStyle: {
      "margin-top": "30px",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                    O arquivo foi baixado automaticamente. Clique no botão acima para baixar novamente.\n                ")])
}]}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "isModal": false,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "pagination": _vm.paginationExame,
      "response": _vm.response,
      "loadingTable": _vm.loadingTableExame,
      "onSearch": _vm.getExame,
      "disableCheckAll": "",
      "disableInputSearch": "",
      "disabledConfigCell": ""
    }
  })], 1)]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 10 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Certificado',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['empresa'] ? 'is-error' : '',
    attrs: {
      "label": "Empresa",
      "prop": "empresa",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                                  " + _vm._s(item.cnpj) + "\n                            ")])])
  }), 1), _vm._v(" "), (_vm.error['empresa']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['empresa'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['tipo_certificado_id'] ? 'is-error' : '',
    attrs: {
      "label": "Tipo de Certificado",
      "prop": "tipo_certificado_id",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Selecione"
    },
    model: {
      value: (_vm.formData.tipo_certificado_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo_certificado_id", $$v)
      },
      expression: "formData.tipo_certificado_id"
    }
  }, _vm._l((_vm.lstTipoCertificado), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1), _vm._v(" "), (_vm.error['tipo_certificado_id']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['tipo_certificado_id'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['arquivo'] ? 'is-error' : '',
    attrs: {
      "label": "Certificado",
      "prop": "arquivo",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('Upload', {
    attrs: {
      "onChangeFile": _vm.onChangeArquivo,
      "currentFile": _vm.arquivo,
      "ordem": "1"
    }
  }), _vm._v(" "), (_vm.error['arquivo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['arquivo'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('el-form-item', {
    class: _vm.error['senha'] ? 'is-error' : '',
    attrs: {
      "label": "Senha do Certificado",
      "prop": "senha",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formData.senha),
      callback: function($$v) {
        _vm.$set(_vm.formData, "senha", $$v)
      },
      expression: "formData.senha"
    }
  }), _vm._v(" "), (_vm.error['senha']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['senha'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('el-form-item', {
    class: _vm.error['confirmar_senha'] ? 'is-error' : '',
    attrs: {
      "label": "Confirmar Senha do Certificado",
      "prop": "confirmar_senha",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formData.confirmar_senha),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmar_senha", $$v)
      },
      expression: "formData.confirmar_senha"
    }
  }), _vm._v(" "), (_vm.error['confirmar_senha']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['confirmar_senha'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    class: _vm.error['vincular'] ? 'is-error' : '',
    attrs: {
      "label": "Vincular Automaticamente",
      "prop": "vincular",
      "rules": []
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                        Vincular Automaticamente\n                        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Ao habilitar essa opção o sistema vai vincular esse certificado para todos seus clientes automaticamente.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.vincular),
      callback: function($$v) {
        _vm.$set(_vm.formData, "vincular", $$v)
      },
      expression: "formData.vincular"
    }
  }), _vm._v(" "), (_vm.error['vincular']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['vincular'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formData.id > 0 && _vm.formData.vincular == 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    class: _vm.error['deletar_vinculo'] ? 'is-error' : '',
    attrs: {
      "label": "Deletar Vínculo",
      "prop": "deletar_vinculo",
      "rules": []
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                        Deletar Vínculo Existente\n                        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Ao habilitar essa opção o sistema vai deletar esse certificado da base de seus clientes.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.deletar_vinculo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "deletar_vinculo", $$v)
      },
      expression: "formData.deletar_vinculo"
    }
  }), _vm._v(" "), (_vm.error['deletar_vinculo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['deletar_vinculo'][0]))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    class: _vm.error['inserir_vinculo'] ? 'is-error' : '',
    attrs: {
      "label": "Inserir Vínculo Não Existente",
      "prop": "inserir_vinculo",
      "rules": []
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                        Inserir Vínculo Não Existente\n                        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Ao habilitar essa opção o sistema vai inserir esse certificado da base de seus clientes que já estão cadastrados no sistema.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.inserir_vinculo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inserir_vinculo", $$v)
      },
      expression: "formData.inserir_vinculo"
    }
  }), _vm._v(" "), (_vm.error['inserir_vinculo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['inserir_vinculo'][0]))]) : _vm._e()], 1)], 1) : _vm._e()])])], 1)]), _vm._v(" "), _c('Vincular', {
    attrs: {
      "showForm": _vm.showFormVincular,
      "certificado": _vm.formData
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Certificado",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getEsocialCertificado,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99:99'),
      expression: "'99:99'"
    }],
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "rules": _vm.rules,
      "placeholder": "hh:mm"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    staticClass: "mt-2"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, _vm._l((_vm.tableData), function(modelo, i) {
    return _c('el-tab-pane', {
      key: i,
      attrs: {
        "label": i.toString(),
        "name": modelo.id.toString()
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      staticClass: "fa fa-list-ol"
    }), _vm._v(" " + _vm._s(modelo.id) + " (" + _vm._s(modelo.nome) + ")\n\t\t\t")]), _vm._v(" "), _c('Conteudo', {
      attrs: {
        "modelo": modelo
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Aguarde enquanto o upload é processado...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('UploadPagina', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "UPLOAD DE ASO",
      "modal": _vm.parent.showUploadASO,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "98%",
      "saveName": "Salvar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Fazer Novo Upload")]), _vm._v(" "), (_vm.formData.tipo == 86) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Na Identificação Automática o sistema reconhece automaticamente a quem pertence o ASO. Para isso funcionar verifique se o ASO está em PDF e possui no rodapé o código de identificação.",
      "show-icon": ""
    }
  }) : (_vm.formData.tipo == 87) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Na Identificação Manual o sistema exige que você informe a quem pertence o ASO: empresa, funcionário e a consulta.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Escolha o Tipo do Upload",
      "prop": "tipo",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.formData.tipo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo", $$v)
      },
      expression: "formData.tipo"
    }
  }, _vm._l((_vm.lstTipoUpload), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['arquivo'] ? 'is-error' : '',
    attrs: {
      "label": "Selecione o ASO (no formato PDF e no máximo 25MB de tamanho)",
      "prop": "arquivo",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('Upload', {
    attrs: {
      "onChangeFile": _vm.handleArquivo,
      "currentFile": _vm.formData.arquivo,
      "ordem": "1"
    }
  }), _vm._v(" "), (_vm.error['arquivo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['arquivo'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Escolha o Tipo do Documento",
      "prop": "documento",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tEscolha o Tipo do Documento\n\t\t\t\t\t\t\t\t\t\t"), (_vm.formData.documento == 83) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Certifique-se que a primeira página do Prontuário Médico esteja anexado a FEMO da consulta ( Ficha de Exame Médico Ocupacional)",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.formData.tipo == 86
    },
    model: {
      value: (_vm.formData.documento),
      callback: function($$v) {
        _vm.$set(_vm.formData, "documento", $$v)
      },
      expression: "formData.documento"
    }
  }, _vm._l((_vm.lstTipoDocumento), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Empresa",
      "prop": "id_emp",
      "rules": [{
        required: (_vm.formData.tipo == 87),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "disabled": _vm.formData.tipo == 86
    },
    on: {
      "change": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cnpj) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Funcionario",
      "prop": "id_fun",
      "rules": [{
        required: (_vm.formData.tipo == '87'),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome do funcionário",
      "remote-method": _vm.getFuncionario,
      "loading": _vm.loadingFuncionario,
      "disabled": !_vm.formData.id_emp
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.formData.id_fun),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fun", $$v)
      },
      expression: "formData.id_fun"
    }
  }, _vm._l((_vm.lstFuncionario), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cnpj) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Consulta",
      "prop": "id_con",
      "rules": [{
        required: (_vm.formData.tipo == '87'),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Selecione a consulta",
      "loading": _vm.loadingConsulta,
      "disabled": !_vm.formData.id_fun
    },
    model: {
      value: (_vm.formData.id_con),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_con", $$v)
      },
      expression: "formData.id_con"
    }
  }, _vm._l((_vm.lstConsulta), function(item) {
    return _c('el-option', {
      key: item.id_con,
      attrs: {
        "value": item.id_con,
        "label": item.id_con + ((item.dt_cad ? ' | ' + _vm.toDate(item.dt_cad, true) : '') + (item.tipo_aso ? ' | ' + item.tipo_aso.descricao : ''))
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.id_con) + " | " + _vm._s((item.dt_cad ? _vm.toDate(item.dt_cad, true) : '')) + " | " + _vm._s((item.tipo_aso ? item.tipo_aso.descricao : '')) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.formData.documento == 83) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Juntar Arquivo",
      "prop": "juntar",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tJuntar Arquivo\n\t\t\t\t\t\t\t\t\t\t"), (_vm.formData.documento == 83) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Se essa opção estiver marcado, o sistema vai adicionar esse upload nos os arquivos enviados anteriormente.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.juntar),
      callback: function($$v) {
        _vm.$set(_vm.formData, "juntar", $$v)
      },
      expression: "formData.juntar"
    }
  })], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v(" \n\t\t\t\t\t\tHistórico de Uploads\n\t\t\t\t\t")]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaUpload,
      "onDelete": _vm.onDelete,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Parâmetros Gerais\n            ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: _vm.ref,
    attrs: {
      "model": _vm.formData,
      "disabled": _vm.block || _vm.loading
    }
  }, [_c('div', {
    staticClass: "col-md-12 pa-2 justify-center text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.block && _vm.blockMessage) ? _c('ed-alert', {
    attrs: {
      "type": "warning",
      "message": _vm.blockMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'col-md-12 pa-0 pt-3 justify-center ' + _vm.classFooter
  }, [(_vm.handlerSave) ? _c('ed-button', {
    attrs: {
      "color": _vm.colorButton,
      "label": _vm.labelButton,
      "disabled": _vm.block,
      "icon": "salvar",
      "size": "100%"
    },
    on: {
      "click": _vm.validar
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("form-footer")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "registerName": "Liberação",
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disableCheckAll": true,
      "filterBadge": _vm.filterBadge,
      "loadingTable": _vm.config.loading.table
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-session', {
    ref: "session"
  }), _vm._v(" "), _c('ed-socket', {
    ref: "socket"
  }), _vm._v(" "), _c('ed-notify', {
    ref: "notify"
  }), _vm._v(" "), _c('ed-dialog', {
    ref: "dialog"
  }), _vm._v(" "), _c('ed-loading', {
    ref: "loading"
  }), _vm._v(" "), _c('ed-request', {
    ref: "request"
  }), _vm._v(" "), (!_vm.loadingContent) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n        ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.loadingSave,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.formData && _vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-emails"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Emails\n        ")]), _vm._v(" "), _c('Emails', {
    attrs: {
      "empresa": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.consulta.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir ASO"
    },
    on: {
      "click": _vm.imprimirASO
    }
  })], 1)], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('b-table-simple', {
    staticClass: "table-v2",
    attrs: {
      "hover": "",
      "small": "",
      "responsive": "",
      "stacked": (this.device == 'xs')
    }
  }, [_c('b-thead', {
    attrs: {
      "head-variant": ""
    }
  }, [_c('b-tr', [_c('b-th', [_vm._v("EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("DATA")])], 1)], 1), _vm._v(" "), (_vm.formData) ? _c('b-tbody', _vm._l((_vm.formData.exames), function(consulta_exame, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', [_vm._v("\r\n            " + _vm._s(consulta_exame.exame.nome) + "\r\n            "), (consulta_exame.id_con_dem != '0') ? _c('span', {
      staticClass: "tp-exame-dem",
      staticStyle: {
        "font-size": "9pt"
      },
      attrs: {
        "title": "Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
      }
    }, [_c('br'), _vm._v("Exame "), _c('b', [_vm._v("demonstrativo")]), _vm._v(" na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(consulta_exame.id_con_dem))])]) : (consulta_exame.id_con_rea != '0') ? _c('span', {
      staticClass: "tp-exame-dem",
      staticStyle: {
        "font-size": "9pt"
      },
      attrs: {
        "title": "Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
      }
    }, [_c('br'), _vm._v("Exame "), _c('b', [_vm._v("reaproveitado")]), _vm._v(" na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(consulta_exame.id_con_rea))])]) : _vm._e()]), _vm._v(" "), _c('b-td', [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "placeholder": "dd/mm/aaaa",
        "value-format": "yyyy-MM-dd",
        "format": "dd/MM/yyyy",
        "disabled": _vm.formOption.empty == 1 || consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0,
        "title": (consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0 ? 'A data deste exame não pode ser alterado' : '')
      },
      model: {
        value: (consulta_exame.data),
        callback: function($$v) {
          _vm.$set(consulta_exame, "data", $$v)
        },
        expression: "consulta_exame.data"
      }
    })], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center mt-3 mb-2"
  }, [_c('el-checkbox', {
    attrs: {
      "checked": _vm.formOption.empty == 1
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.formOption.empty),
      callback: function($$v) {
        _vm.$set(_vm.formOption, "empty", $$v)
      },
      expression: "formOption.empty"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Imprimir ASO com a data dos exames em branco")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Salvar Alterações e Imprimir ASO"
    },
    on: {
      "click": _vm.imprimirASO
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Saindo do sistema..."
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Logs', {
    attrs: {
      "showForm": _vm.showLogs,
      "formData": _vm.formData
    }
  }), _vm._v(" "), _c('div', [(!_vm.layout && !_vm.avulso) ? _c('p', [_c('ed-alert', {
    attrs: {
      "title": "Atenção"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n          Para visualizar a documentação do eSocial favor acessar o link\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/e/2PACX-1vSBgbysNalUj6JJ9QpfYQGAU1w34wBgbXkN888R4b5jI1KbwgjQGRWEiMOVlbdpX4HKHAuPWE77ivY9/pub"
    }
  }, [_vm._v("\n            visualizar documentação\n          ")])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.avulso) ? _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.layoutItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tabConfig),
      callback: function($$v) {
        _vm.tabConfig = $$v
      },
      expression: "tabConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-geral"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Consultar Arquivos Disponíveis\n        ")]), _vm._v(" "), (!this.layout && _vm.formData.esocial_tabela && _vm.formData.esocial_tabela.descricao) ? _c('ed-alert', {
    staticClass: "mb-2 mt-2",
    attrs: {
      "title": "Atenção",
      "type": "warning"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n              " + _vm._s(_vm.formData.esocial_tabela.descricao) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getEsocial,
      "onRegister": _vm.avulso ? _vm.onRegister : null,
      "onEdit": _vm.avulso ? _vm.onEditXml : null,
      "onClear": _vm.onClear,
      "onFilter": _vm.getEsocial,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "registerName": "Inserir novo XML"
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('Filters', {
    attrs: {
      "parent": this
    }
  })], 1)]), _vm._v(" "), (_vm.avulso) ? _c('s0000', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2210'
  ) ? _c('s2210', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2220'
  ) ? _c('s2220', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2240'
  ) ? _c('s2240', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-3000'
  ) ? _c('s3000', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Novo Email' : 'Editar Email',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": "textarea",
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules,
      "rows": 4
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'DETALHAMENTO DA CONSULTA EXTERNA ' +
        (this.formData.consulta ?
          ' - ' + this.formData.consulta.funcionario.nome :
          ''),
      "modal": _vm.showConsultaDetail,
      "loading": _vm.loadingConsultaDetail,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ConsultaDetalhe', {
    attrs: {
      "consulta": _vm.formData.consulta
    }
  })], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'ALTERAR PCMSO DA CONSULTA EXTERNA ' +
        (this.formData.consulta ?
          ' - ' + this.formData.consulta.funcionario.nome :
          ''),
      "modal": _vm.showAlterarRevisao,
      "onSave": _vm.onAlterarPcmso,
      "disabledSave": _vm.checkAlterarPcmso,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ConsultaAlterarRevisao', {
    attrs: {
      "consulta": _vm.formData.consulta,
      "consultaNova": _vm.formData.consultaNova,
      "ultimaRevisao": _vm.formData.ultima_revisao
    }
  })], 1)]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsulta,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "onFilter": _vm.getConsulta,
      "filterBadge": _vm.filterBadge,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems,
      "onClear": _vm.onClear
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-table-simple', {
    staticClass: "table-v2",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    staticStyle: {
      "font-size": "7pt !important"
    }
  }, [_vm._v(_vm._s(_vm.formData.point_type == "ghe" ? "GHE (SETOR)" : "FUNÇÃO"))]), _vm._v(" "), _c('b-th', [_c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "7pt !important",
      "border": "none",
      "background": "transparent",
      "color": "#fff"
    },
    attrs: {
      "width": "80%"
    }
  }, [_vm._v("\n                AGENTE AVALIADO\n              ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "7pt !important",
      "border": "none",
      "background": "transparent",
      "color": "#fff"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("\n                METODOLOGIA\n              ")])])])])], 1)], 1), _vm._v(" "), _c('b-tbody', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }]
  }, _vm._l((_vm.tableData), function(data, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, _vm._l((data.points), function(point, j) {
      return _c('p', {
        key: i + j
      }, [_c('el-checkbox', {
        attrs: {
          "label": point.id,
          "disabled": _vm.tableMedicaoChecked.length > 0 || data.points.length > 1,
          "title": data.points.length > 1 ?
            'Não é possível agrupar um GHE que já foi agrupado anteriormente' :
            ''
        },
        model: {
          value: (_vm.tablePointChecked),
          callback: function($$v) {
            _vm.tablePointChecked = $$v
          },
          expression: "tablePointChecked"
        }
      }), _vm._v(" "), (_vm.formData.point_type == 'ghe') ? _c('span', [_vm._v("\n              " + _vm._s(point.ghe) + " (" + _vm._s(point.descricao) + ")\n            ")]) : (_vm.formData.point_type == 'funcao') ? _c('span', [_vm._v("\n              " + _vm._s(point.nome) + "\n            ")]) : _vm._e()], 1)
    }), 0), _vm._v(" "), _c('b-td', {
      style: ('background:' + (i % 2 == 0 ? '#E6E6E6' : ''))
    }, _vm._l((data.orcamento_medicoes), function(orcamento_medicao, j) {
      return _c('table', {
        key: j,
        attrs: {
          "width": "100%"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "background": "#f9f6db"
        },
        attrs: {
          "width": "80%"
        }
      }, [(false) ? _c('el-checkbox', {
        attrs: {
          "label": orcamento_medicao.id,
          "disabled": _vm.tablePointChecked.length > 0
        },
        model: {
          value: (_vm.tableMedicaoChecked),
          callback: function($$v) {
            _vm.tableMedicaoChecked = $$v
          },
          expression: "tableMedicaoChecked"
        }
      }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("\n                  " + _vm._s(orcamento_medicao.fator_risco.nome) + "\n                ")])], 1), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "background": "#f9f6db"
        },
        attrs: {
          "width": "20%"
        }
      }, [_c('b', [_vm._v(_vm._s(orcamento_medicao.fator_risco.cod_metodologia))])])]), _vm._v(" "), _c('tr', [_c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "border": "none"
        },
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    Nº DE AMOSTRAGENS\n                    "), _c('el-input', {
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            return _vm.formataDados()
          }
        },
        model: {
          value: (orcamento_medicao.amostragem),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "amostragem", $$v)
          },
          expression: "orcamento_medicao.amostragem"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    VALOR UNITÁRIO\n                    "), _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text"
        },
        on: {
          "change": function($event) {
            return _vm.formataDados()
          }
        },
        model: {
          value: (orcamento_medicao.valor_venda),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "valor_venda", $$v)
          },
          expression: "orcamento_medicao.valor_venda"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    VALOR TOTAL\n                    "), _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text",
          "readonly": ""
        },
        model: {
          value: (orcamento_medicao.valor_total),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "valor_total", $$v)
          },
          expression: "orcamento_medicao.valor_total"
        }
      })], 1)])])])])
    }), 0)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-save",
      "type": "success",
      "value": "Salvar Medições"
    },
    on: {
      "click": _vm.salvar
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-history",
      "type": "primary",
      "title": "Clique aqui para restaurar e inicializar o orçamento",
      "value": "Restaurar Medições"
    },
    on: {
      "click": _vm.restaurar
    }
  }), _vm._v(" "), (_vm.tablePointChecked.length > 1) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-object-group",
      "type": "warning",
      "title": "Clique aqui para agrupar as medições selecionadas",
      "value": 'Agrupar ' + this.formData.point_type.toUpperCase()
    },
    on: {
      "click": _vm.agrupar
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": (_vm.tabela_preco ? _vm.tabela_preco.credenciada_nome + ' - VALOR TOTAL DOS EXAMES: R$ ' + _vm.tabela_preco.valor_total : ''),
      "width": "90%"
    }
  }, [(_vm.tabela_preco) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.parent.loadingExame),
      expression: "parent.loadingExame"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Disponibilizamos abaixo a lista dos exames obrigatórios no PCMSO. Você pode escolher em qual Parceiro o exame deve ser feito.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "tableFooter": _vm.tableFooter,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Trabalhador",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.id_fun),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fun", $$v)
      },
      expression: "formData.id_fun"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de Início do Periodo"
    },
    model: {
      value: (_vm.formData.data_inicio),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_inicio", $$v)
      },
      expression: "formData.data_inicio"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de Final do Periodo"
    },
    model: {
      value: (_vm.formData.data_fim),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_fim", $$v)
      },
      expression: "formData.data_fim"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "\n        col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\n        text-center\n        mt-5\n      "
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "disabled": !_vm.formData.id_emp ||
        !_vm.formData.id_fun ||
        !_vm.formData.data_inicio ||
        !_vm.formData.data_fim ?
        true :
        false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loadingContent) ? _c('div', [_c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.froalaConfig
    },
    model: {
      value: (_vm.mensagem),
      callback: function($$v) {
        _vm.mensagem = $$v
      },
      expression: "mensagem"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('Editar', {
    attrs: {
      "conclusao_tecnica": _vm.formData,
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Conclusão Técnica",
      "onRegister": (this.validarPermissao(573) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getConclusaoTecnica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "As tabelas listadas abaixo fazem referência as tabelas de riscos químicos, físicos e biológicos nos documentos do LTCAT. Aqui você pode cadastrar os modelos customizados dessas tabelas."
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "modal": _vm.showHtml,
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.html)
    }
  })])]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Tabela Dinâmica",
      "onRegister": this.$root.$session.validarPermissao(571) ? _vm.onRegister : null,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [(_vm.tableData.length) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "label": "Exportar Tabelas",
      "title": "Clique aqui para exportar as tabelas e visualizar a extrutura das colunas"
    },
    on: {
      "click": _vm.onExportar
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaExame,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {}, [_c('b-form-file', {
    ref: 'file-input-' + this.input,
    attrs: {
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "placeholder": "Escolher arquivo...",
      "drop-placeholder": "Apagar arquivo...",
      "browse-text": "Procurar..."
    },
    on: {
      "change": _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function(ref) {
        var names = ref.names;

        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))]), _vm._v(" "), (names.length > 1) ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("\n              + " + _vm._s(names.length - 1) + " More files\n            ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), _vm._v(" "), (_vm.currentFile != null) ? _c('div', {
    staticClass: "arquivo-info"
  }, [_c('Download', {
    attrs: {
      "arquivo": _vm.currentFile
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cadastrar', {
    attrs: {
      "showForm": _vm.showFormCadastro,
      "parent": this
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card",
      "editable": _vm.orcamentos.length > 0
    },
    on: {
      "tab-remove": _vm.handleTabsDelete
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-listar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Orçamentos Cadastrados\n\t\t\t")]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Gerar Novo Orçamento",
      "onRegister": (this.validarPermissao(577) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatOrcamento,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _vm._l((_vm.orcamentos), function(orcamento, i) {
    return _c('el-tab-pane', {
      key: i,
      attrs: {
        "label": "Config",
        "name": 'tab-editar-' + i
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v(" Editar Orçamento " + _vm._s(orcamento.codigo) + "\n\t\t\t")]), _vm._v(" "), _c('Editar', {
      attrs: {
        "showForm": _vm.showFormEdit,
        "parent": this,
        "orcamento": orcamento
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "title": "Atenção",
      "description": "Aqui você visualizar o histórico de atendimento dessa consulta"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaAcompanhamento,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ConsultaLote', {
    attrs: {
      "showLote": _vm.showConsultaLote,
      "funcionario": _vm.formDataConsulta.funcionario,
      "tipoAso": 52
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": 'EXAMES' + (_vm.funcionario ? ' :: ' + _vm.funcionario.nome : '') + ' :: ' + _vm.formData.periodo[0] + ' a ' + _vm.formData.periodo[1],
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabExame),
      callback: function($$v) {
        _vm.tabExame = $$v
      },
      expression: "tabExame"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#4ac467",
      "float": "left"
    }
  }, [_vm._v("   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Dentro do Período Selecionado "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#dd4040",
      "float": "left"
    }
  }, [_vm._v("   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Fora do Período Selecionado "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#d8a027",
      "float": "left"
    }
  }, [_vm._v("   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Exame não Realizado - Fora dos requisitos do PCMSO"), _c('br')])])]), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1), _vm._v(" "), (_vm.funcionario) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('ConsultaHistorico', {
    attrs: {
      "funcionario": _vm.funcionario
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.funcionario) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.funcionario.id_ghe
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-search",
      "type": "success",
      "loading": _vm.config.loading.save || _vm.loadingTable,
      "disabled": _vm.config.loading.save || _vm.loadingTable,
      "value": "Pesquisar"
    },
    on: {
      "click": _vm.getPeriodico
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "col-12"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabPeriodico),
      callback: function($$v) {
        _vm.tabPeriodico = $$v
      },
      expression: "tabPeriodico"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-ok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Dentro do Período Selecionado (" + _vm._s(_vm.tableData.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "success",
      "description": "Os trabalhadores mostrados abaixo estão com a data dos exames DENTRO PERÍODO SELECIONADO.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "onEditAll": _vm.onConsultaLote,
      "editAllIcon": "fa fa-address-card",
      "editAllName": "Gerar Consulta",
      "editAllTitle": "Gerar Consulta para os trabalhadores selecionados",
      "disableInputSearch": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar Resultado para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1)])], 1), _vm._v(" "), (_vm.tableDataTabelaPreco.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Orçamento Aproximado",
      "name": "tab-preco"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamento Aproximado")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Orçamento aproximado para os periódidocos dentro do período selecionado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataTabelaPreco,
      "tableHead": _vm.tableHeadTabelaPreco,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableDataForaPeriodo.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-nok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Fora do Período Selecionado (" + _vm._s(_vm.tableDataForaPeriodo.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Os trabalhadores mostrados abaixo estão com o periódico atrasado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataForaPeriodo,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableDataError.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-error"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Erro de Cadastro(" + _vm._s(_vm.tableDataError.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "error",
      "description": "Os trabalhadores mostrados abaixo estão com erros no cadastro.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataError,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Editar Conteúdo',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "tab-editar",
      "name": "tab-editar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Editar\n\t\t\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.conteudoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "tab-editar",
      "name": "tab-conteudo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v(" Visualizar Conteúdo\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.titulo)
    }
  })])], 1)], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onEdit": _vm.onEdit,
      "onSearch": _vm.getModeloConteudo,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.content,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Editar', {
    attrs: {
      "anexo": _vm.formData,
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Anexo",
      "onRegister": (this.validarPermissao(576) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatAnexo,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.env && _vm.env.mode && _vm.env.mode != 'production') ? _c('div', {
    staticClass: "aviso2"
  }, [_vm._v("\r\n    Ambiente de Teste\r\n  ")]) : _vm._e(), _vm._v(" "), _c('b-navbar', {
    staticClass: "header1",
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "light",
      "align": "center",
      "fixed": "top"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#",
      "title": ':: ' + _vm.usuario.logged.point.nome + '\n:: ' + _vm.usuario.logged.nome
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo,
      "alt": "Kitten",
      "width": "120"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "align-content-center flex-wrap",
    staticStyle: {
      "font-size": "7pt"
    }
  }, [(_vm.sub_domain == 'empresa') ? _c('span', [_vm._v("Area da Empresa")]) : _vm._e(), _vm._v(" "), (_vm.sub_domain == 'credenciada') ? _c('span', [_vm._v("Area da Credenciada")]) : _vm._e(), _vm._v(" "), (_vm.sub_domain == 'parceiro') ? _c('span', [_vm._v("Area do Parceiro")]) : _vm._e()])]), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav-collapse",
      "type": "dark"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "nav-collapse",
      "is-nav": ""
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "transparent",
      "text-color": "#fff",
      "unique-opened": "",
      "active-text-color": "#fff"
    }
  }, [_vm._l((_vm.usuario.menu), function(menu, i) {
    return [(menu.sub_menu.length == 0) ? _c('el-menu-item', {
      key: i,
      class: menu.class + (menu.rota == _vm.$route.path ? ' is-active' : ''),
      attrs: {
        "index": i.toString(),
        "default-active": +(menu.rota == _vm.$route.path ? menu.rota : ''),
        "exact": ""
      },
      on: {
        "click": function($event) {
          return _vm.toRoute({
            path: menu.rota
          })
        }
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v("\r\n            " + _vm._s(menu.descricao) + " \r\n            "), (menu.badge && menu.badge > 0) ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "danger"
      }
    }, [_vm._v(_vm._s(menu.badge))]) : _vm._e()], 1) : _c('el-submenu', {
      key: i,
      class: menu.class,
      attrs: {
        "index": i.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: menu.icon
    }), _vm._v("\r\n               " + _vm._s(menu.descricao) + "\r\n            ")]), _vm._v(" "), _vm._l((menu.sub_menu), function(sub_menu, j) {
      return _c('el-menu-item', {
        key: i + j,
        staticClass: "sub_menu",
        attrs: {
          "index": i.toString() + '-' + j.toString()
        },
        on: {
          "click": function($event) {
            return _vm.toRoute({
              path: sub_menu.rota
            })
          }
        }
      }, [_c('i', {
        class: sub_menu.icon
      }), _vm._v("\r\n              " + _vm._s(sub_menu.descricao) + "\r\n            ")])
    })], 2)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Novo Anexo' : 'Editar Anexo',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), (_vm.formData.id == 0) ? _c('ed-alert', {
    attrs: {
      "title": "Instruções",
      "type": "warning"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('ul', [_c('li', [_vm._v("O arquivo não deve exceder 50MB de tamanho")]), _vm._v(" "), _c('li', [_vm._v("Os formatos dos arquivos devem estar em PDF, ZIP, JPG, PNG ou JPEG")]), _vm._v(" "), _c('li', [_vm._v("Todos o arquivos enviados que não corresponderem a uma IMAGEM, serão convertidos em IMAGEM automaticamente.")]), _vm._v(" "), _c('li', [_vm._v("Só é possível enviar 1 arquivo por vez. Se precisar enviar vários arquivos, você deve compactar os mesmo no formato ZIP e envia-los. Assim o sistema consegue desconpactar e salvar corretamente no servidor.")])])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.consulta && _vm.ultimaRevisao) ? _c('div', [_c('ed-form', [_c('div', {
    staticClass: "row text-left"
  }, [_c('ed-alert', {
    staticClass: "col-12 mb-3",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n\t\t\t\t\tEssa consulta está com o PCMSO desatualizado. Para continuar você deve selecionar o último PCMSO válido dessa Frente de Trabalho.\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#c1d19c"
    }
  }, [_c('b', [_vm._v("Último PCMSO válido: ")]), _vm._v(" "), (_vm.ultimaRevisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultimaRevisao.parent.rev) + " (" + _vm._s(_vm.ultimaRevisao.parent.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.ultimaRevisao.parent.data_hora, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultimaRevisao.rev) + " (" + _vm._s(_vm.ultimaRevisao.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.ultimaRevisao.data_hora, true)) + ")\n\t\t\t\t\t")])]), _vm._v(" "), (_vm.consulta.fdt) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Frente de Trabalho: ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.fdt.pcmso) + " (" + _vm._s(_vm.consulta.fdt.descricao) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.revisao) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Revisão: ")]), _vm._v(" "), (_vm.consulta.revisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.revisao.parent.rev) + " (" + _vm._s(_vm.consulta.revisao.parent.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.consulta.revisao.parent.data_hora, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.revisao.rev) + " (" + _vm._s(_vm.consulta.revisao.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.consulta.revisao.data_hora, true)) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.ghe) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("GHE (Setor): ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.ghe.ghe) + " (" + _vm._s(_vm.consulta.ghe.descricao) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.funcao) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Função: ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.funcao.nome) + "\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('h4', [_vm._v("Selecione o novo PCMSO")])]), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getGhe
    },
    model: {
      value: (_vm.consultaNova.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_fdt", $$v)
      },
      expression: "consultaNova.id_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
    attrs: {
      "label": "GHE (Setor)",
      "items": _vm.list.ghe,
      "loading": _vm.loadingGhe,
      "itemText": "ghe",
      "item-group": "",
      "required": "",
      "disabled": !_vm.consultaNova.id_fdt
    },
    on: {
      "input": _vm.getFuncao
    },
    model: {
      value: (_vm.consultaNova.id_ghe),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_ghe", $$v)
      },
      expression: "consultaNova.id_ghe"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Função",
      "items": _vm.list.funcao,
      "loading": _vm.loadingFuncao,
      "itemText": "nome",
      "required": "",
      "disabled": !_vm.consultaNova.id_ghe
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.consultaNova.id_funcao),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_funcao", $$v)
      },
      expression: "consultaNova.id_funcao"
    }
  }), _vm._v(" "), (_vm.tabela_preco !== null) ? _c('ed-alert', {
    staticClass: "col-12 mt-3",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.tabela_preco) + "\n\t\t\t\t")]) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.consulta.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Imprimir",
      "value": "Imprimir Ficha Clínica"
    },
    on: {
      "click": _vm.imprimir
    }
  })], 1)], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center mt-3 mb-2"
  }, [_c('el-checkbox', {
    attrs: {
      "checked": _vm.formData.empty == 1
    },
    model: {
      value: (_vm.formData.empty),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empty", $$v)
      },
      expression: "formData.empty"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Gostaria de preencher tudo a mão")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Salvar Alterações e Imprimir Ficha Clínica"
    },
    on: {
      "click": _vm.imprimir
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Informações do Orçamento\n      ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Informações das Medições\n      ")]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfigResumo),
      callback: function($$v) {
        _vm.tagConfigResumo = $$v
      },
      expression: "tagConfigResumo"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-res-med"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" Medições\n          ")]), _vm._v(" "), _c('Medicao', {
    attrs: {
      "orcamento": _vm.orcamento
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-res-cus"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Custos\n          ")]), _vm._v(" "), _c('Servico', {
    attrs: {
      "orcamento": _vm.orcamento
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-email"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Propostas Enviadas")]), _vm._v(" "), _c('LogEmail', {
    attrs: {
      "point_type": "ltcat_orcamento",
      "point_id": _vm.orcamento.id
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaRisco,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66) || (_vm.formData.tipo_status && _vm.formData.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.formData.updated_at,
      "title": "Atenção"
    }
  })], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para salvar as alterações efetuadas",
      "value": "Salvar Alterações"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-times",
      "type": "danger",
      "value": "Prosseguir com o Calcelamento"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Função' : 'Editar Função',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Função",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatFuncao,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.format,
      "value-format": _vm.format,
      "format": _vm.format,
      "picker-options": _vm.handleDateOptions,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "rules": _vm.rules
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-categoria"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Gerenciar Categoria\n\t\t\t")]), _vm._v(" "), (_vm.formData.id > 0) ? _c('TabelaDinamicaCategoria', {
    attrs: {
      "tabela": _vm.formData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.boolExibir) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-colunas"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-columns"
  }), _vm._v(" Gerenciar Colunas\n\t\t\t")]), _vm._v(" "), (_vm.formData.id > 0) ? _c('TabelaDinamicaColuna', {
    attrs: {
      "tabela": _vm.formData
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Enviar Orçamento por Email",
      "modal": _vm.showFormEmail,
      "loadingSave": _vm.loadingTable,
      "onSave": _vm.proposta,
      "width": "95%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('b-table-simple', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticClass: "table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("DESCRIÇÃO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("QUANTIDADE")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("VALOR (R$)")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("ATUALIZAÇÃO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [_c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold",
      "height": "40px"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-usd",
      "type": "text"
    }
  }), _vm._v("\n          CUSTO DAS MEDIÇÕES\n        ")], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.servicosMedicao), function(data, i) {
    return _c('b-tr', {
      key: i + 1000
    }, [_c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.nome) + "\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.total) + "\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.valor_venda) + "\n          "), (
      _vm.response.options &&
      _vm.response.options.data &&
      _vm.response.options.data[data.id]
    ) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('br'), _vm._v(_vm._s(_vm.response.options.data[data.id][0]) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          ---\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          ---\n        ")])], 1)
  }), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold",
      "height": "40px"
    }
  }, [_vm._v("\n          TOTAL MEDIÇÕES\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.qtde_medicao) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.valor_medicao) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  })], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold",
      "height": "40px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-usd",
      "type": "text"
    }
  }), _vm._v("\n          CUSTOS DOS SERVIÇOS\n        ")], 1), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "title": "Inserir Novo Serviço",
      "value": "Inserir Novo Serviço"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister()
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.servicos), function(data, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (data.descricao),
        callback: function($$v) {
          _vm.$set(data, "descricao", $$v)
        },
        expression: "data.descricao"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      on: {
        "change": _vm.formataCustoServicos
      },
      model: {
        value: (data.qtde),
        callback: function($$v) {
          _vm.$set(data, "qtde", $$v)
        },
        expression: "data.qtde"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "change": _vm.formataCustoServicos
      },
      model: {
        value: (data.valor),
        callback: function($$v) {
          _vm.$set(data, "valor", $$v)
        },
        expression: "data.valor"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [(data.usuario) ? _c('div', [_vm._v("\n            " + _vm._s(data.usuario.usuario)), _c('br'), _vm._v("\n            " + _vm._s(_vm.toDate(data.updated_at)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [(data.padrao == 0) ? _c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "size": "mini",
        "title": "Deletar Registro"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(i)
        }
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold",
      "height": "40px"
    }
  }, [_vm._v("\n          TOTAL SERVIÇOS\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.qtde_servico) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.valor_servico) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  })], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-right d-flex flex-row-reverse bd-highlight",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-center col-sm-12 col-md-6 col-lg-5 col-xl-4",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('b-table-simple', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticClass: "table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CUSTO TOTAL")])], 1)], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "color": "#dd5a5a",
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n            DESCONTOS\n          ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "color": "#dd5a5a",
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "change": _vm.formataCustoTotal
    },
    model: {
      value: (_vm.formData.valor_desconto),
      callback: function($$v) {
        _vm.$set(_vm.formData, "valor_desconto", $$v)
      },
      expression: "formData.valor_desconto"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "right",
      "font-size": "18px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            Custo Total\n            "), _c('span', {
    staticStyle: {
      "color": "#699e62"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.formData.valor_total))])])], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "right",
      "font-size": "18px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            Lucro Líquido\n            "), _c('span', {
    staticStyle: {
      "color": "#699e62"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.formData.valor_lucro))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#699e62",
      "font-size": "15px !important"
    }
  }, [_vm._v("(" + _vm._s(_vm.formData.percent_lucro) + "%)")])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "primary",
      "value": "Salvar Orçamento"
    },
    on: {
      "click": _vm.salvar
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-search-plus",
      "type": "warning",
      "value": "Prévia do Orçamento"
    },
    on: {
      "click": _vm.previa
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-paper-plane",
      "type": "success",
      "value": "Enviar Orçamento"
    },
    on: {
      "click": function($event) {
        _vm.showFormEmail = !_vm.showFormEmail
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (this.config.loading.content),
      expression: "this.config.loading.content"
    }],
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-end"
    },
    slot: "form-end"
  }, [_c('ed-button', {
    attrs: {
      "type": "warning",
      "value": "Gerar Documento",
      "icon": "fa fa-file-word-o",
      "title": "Clique aqui para gerar o LTCAT no formato .DOC"
    },
    on: {
      "click": _vm.gerarDocumento
    }
  }), _vm._v(" "), (_vm.formData.id > 0) ? _c('div', {
    staticClass: "col-12 text-left mt-3"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-ghe"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Setores\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatGhe', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1), _vm._v(" "), (this.validarPermissao(576)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-docs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Documentos e Anexos\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatAnexo', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.validarPermissao(577)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-orcamento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamentos\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatOrcamento', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.parceiroItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Fator de Risco desse Laboratório",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Fator de Risco desse Laboratório")]), _vm._v(" "), _c('FatorRisco', {
    attrs: {
      "laboratorio": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": "Formulário de Cadasto de Consulta em Lote",
      "width": "99%",
      "onSave": _vm.salvar,
      "onClose": _vm.fechar
    }
  }, [(_vm.formData.data_age) ? _c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Selecione o(s) Trabalhador(es)\n        ")]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Trabalhadores",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.list.funcionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": function($event) {
        return _vm.formatarFuncionario(_vm.formData.funcionario)
      }
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Data do Agendamento da Consulta",
      "info": "A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.",
      "disabled": !_vm.formData.funcionarios.length,
      "yesterdayDisabled": "",
      "tomorrowDisabled": ""
    },
    model: {
      value: (_vm.formData.data_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_age", $$v)
      },
      expression: "formData.data_age"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Observações",
      "type": "textarea",
      "disabled": !_vm.formData.funcionarios.length
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  }), _vm._v(" "), (_vm.formData.funcionarios.length) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Informações da Consulta\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formData.funcionarios.length) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('b-table-simple', {
    attrs: {
      "hover": "",
      "small": "",
      "caption-top": "",
      "responsive": ""
    }
  }, [_c('b-thead', {
    staticClass: "table-v2",
    attrs: {
      "head-variant": "light"
    }
  }, [_c('b-tr', [_c('b-th', [_vm._v("Trabalhador")]), _vm._v(" "), _c('b-th', [_vm._v("Função")]), _vm._v(" "), _c('b-th', [_vm._v("Frente de Trabalho")]), _vm._v(" "), _c('b-th', [_vm._v("GHE (Setor)")]), _vm._v(" "), _c('b-th', [_vm._v("Tipo de Consulta")]), _vm._v(" "), _c('b-th', [_vm._v("Remover")])], 1)], 1), _vm._v(" "), _c('b-tbody', _vm._l((_vm.formData.funcionarios), function(funcionario, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.nome) + "\n                "), (_vm.getError(funcionario)) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "7pt"
      }
    }, [_c('br'), _vm._v("\n                  " + _vm._s(_vm.getError(funcionario)) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.funcao ? funcionario.funcao.nome : "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.fdt && funcionario.fdt.pcmso ?
      funcionario.fdt.pcmso +
      " (" +
      funcionario.fdt.descricao +
      ")" :
      "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.ghe && funcionario.ghe.ghe ?
      funcionario.ghe.ghe +
      " (" +
      funcionario.ghe.descricao +
      ")" :
      "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_c('el-collapse', {
      attrs: {
        "title": "Clique para mostrar mais informações"
      },
      model: {
        value: (funcionario.collapse),
        callback: function($$v) {
          _vm.$set(funcionario, "collapse", $$v)
        },
        expression: "funcionario.collapse"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": index.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [(
      funcionario.collapse && funcionario.collapse[0]
    ) ? _c('i', {
      staticClass: "fa fa-minus-circle fa-1x mr-1",
      staticStyle: {
        "color": "#28a745"
      }
    }) : _c('i', {
      staticClass: "fa fa-plus-circle fa-1x mr-1",
      staticStyle: {
        "color": "#28a745"
      }
    }), _vm._v("\n                        " + _vm._s(_vm.formatarTipoConsulta(funcionario)) + "\n                      ")]), _vm._v(" "), _c('ed-input-select-tipo', {
      key: index,
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "name": 'id_tipo_aso_' + index,
        "tipo": "46",
        "isRadio": "",
        "required": ""
      },
      model: {
        value: (funcionario.id_tipo_aso),
        callback: function($$v) {
          _vm.$set(funcionario, "id_tipo_aso", $$v)
        },
        expression: "funcionario.id_tipo_aso"
      }
    }, [(funcionario.id_tipo_aso == 50) ? _c('div', {
      staticClass: "pb-1",
      attrs: {
        "slot": 'id_tipo_aso_' + index + '_50'
      },
      slot: 'id_tipo_aso_' + index + '_50'
    }, [_c('div', {
      staticClass: "row ml-0 mr-0 mb-0"
    }, [_c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Nova Frente de Trabalho",
        "items": _vm.list.fdt,
        "loading": _vm.loadingFdt,
        "itemText": "fdt",
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.getGhe(funcionario)
        }
      },
      model: {
        value: (funcionario.id_mf_fdt),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_fdt", $$v)
        },
        expression: "funcionario.id_mf_fdt"
      }
    }), _vm._v(" "), _c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Novo GHE (Setor)",
        "items": _vm.list.ghe,
        "loading": _vm.loadingGhe,
        "disabled": !funcionario.id_mf_fdt,
        "itemGroup": "",
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.getFuncao(funcionario)
        }
      },
      model: {
        value: (funcionario.id_mf_ghe),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_ghe", $$v)
        },
        expression: "funcionario.id_mf_ghe"
      }
    }), _vm._v(" "), _c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Nova Função",
        "items": _vm.list.funcao,
        "loading": _vm.loadingFuncao,
        "disabled": !funcionario.id_mf_fdt ||
          !funcionario.id_mf_ghe,
        "required": ""
      },
      model: {
        value: (funcionario.id_mf_funcao),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_funcao", $$v)
        },
        expression: "funcionario.id_mf_funcao"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (
      funcionario.id_tipo_aso == 52 ||
      funcionario.id_tipo_aso == 48
    ) ? _c('div', {
      staticClass: "pb-1",
      attrs: {
        "slot": 'id_tipo_aso_' +
          index +
          '_' +
          funcionario.id_tipo_aso
      },
      slot: 'id_tipo_aso_' +
        index +
        '_' +
        funcionario.id_tipo_aso
    }, [_c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Periodicidade",
        "items": _vm.listaPeriodicidade(funcionario),
        "required": ""
      },
      model: {
        value: (funcionario.periodicidade),
        callback: function($$v) {
          _vm.$set(funcionario, "periodicidade", $$v)
        },
        expression: "funcionario.periodicidade"
      }
    })], 1) : _vm._e()])], 2)], 1)], 1), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(funcionario)
        }
      }
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Mensagem Email :: ' + _vm.formData.id,
      "modal": _vm.showFormMsg,
      "width": "95%",
      "isModal": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.mensagem)
    }
  })])]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getLog,
      "onFilter": _vm.getLog,
      "onRegister": _vm.onRegister ? _vm.onRegister : null,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disabledConfigCell": _vm.disabledConfigCell,
      "filterBadge": _vm.filterBadge,
      "disableCheckAll": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cadastrar', {
    attrs: {
      "showForm": _vm.showFormCadastro,
      "parent": this
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Desativar Nova Empresa",
      "onRegister": (this.validarPermissao(310) ? _vm.onRegister : null),
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getDesativado,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.titleLogsReq + ' Lote ' + this.formData.lote,
      "width": "60%",
      "modal": _vm.showLogsReq,
      "isModal": false
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('XmlViewer', {
    attrs: {
      "xml": _vm.messageLogsReq
    }
  })], 1)], 1), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'STATUS PROCESSAMENTO -  ' +
        (_vm.formDataLogs.protocolo ? _vm.formDataLogs.protocolo : ''),
      "width": "60%",
      "modal": _vm.showLogs,
      "isModal": false
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")])])]), _vm._v(" "), _vm._l((_vm.formDataLogs.log_retorno), function(retorno, i) {
    return _c('tbody', {
      key: i
    }, [_c('tr', [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(retorno.cdResposta))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(retorno.descResposta))])]), _vm._v(" "), (retorno.uid) ? _c('tr', [_c('td', {
      staticStyle: {
        "background": "#fce6d9"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('b', [_vm._v("Arquivo")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background": "#fce6d9"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(retorno.uid))]), _vm._v(" "), (retorno.recibo) ? _c('label', {
      staticStyle: {
        "color": "green"
      }
    }, [_c('b', [_vm._v("Recibo: ")]), _vm._v(" " + _vm._s(retorno.recibo) + "\n              ")]) : _vm._e(), _vm._v(" "), (retorno.funcionario) ? _c('label', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v("\n                " + _vm._s(retorno.funcionario) + "\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (retorno.ocorrencias) ? _vm._l((retorno.ocorrencias), function(ocorrencia, j) {
      return _c('tr', {
        key: i + j
      }, [_c('td', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "align": "left"
        }
      }, [_vm._v("\n                " + _vm._s(ocorrencia.codigo) + "\n              ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "align": "left"
        }
      }, [_vm._v("\n                " + _vm._s(ocorrencia.descricao) + " "), (ocorrencia.localizacao) ? _c('span', [_vm._v("em " + _vm._s(ocorrencia.localizacao))]) : _vm._e()])])
    }) : _vm._e()], 2)
  })], 2)])], 1), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "SELECIONE O MODO DE TRANSMISSÃO DO ARQUIVO",
      "modal": _vm.showModo,
      "isModal": false,
      "width": "70%"
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "show-icon": "",
      "closable": false
    }
  }, [_c('b', [_vm._v("ORIENTAÇÕES")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Inclusão:")]), _vm._v("\n        Selecione esta opção na primeira vez que enviar o lote ou quando a\n        tentativa de inclusão foi rejeitada.\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Alteração:")]), _vm._v("\n        Selecione esta opção para alterar o evento. Nesse ponto deve existir\n        um lote de inclusão enviado.\n        "), _c('br'), _vm._v(" "), (_vm.tableData && _vm.tableData.length > 0) ? _c('span', {
    staticStyle: {
      "color": "#21bc4d"
    }
  }, [_c('b', [_vm._v("Último Lote Enviado:")]), _vm._v("\n          " + _vm._s(_vm.parseModo(_vm.tableData[0]._data.modo)) + " em\n          " + _vm._s(_vm.toDate(_vm.tableData[0]._data.created_at, false)) + "\n\n          "), (_vm.tableData[0]._data.status != '201') ? _c('span', {
    staticStyle: {
      "font-size": "9pt",
      "color": "red"
    }
  }, [_c('br'), _vm._v("Lote não processado. Verifique o detalhamento do\n            processamento.")]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'inc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Inclusão\n        ")]), _vm._v(" "), (_vm.formData && _vm.formData.layout != 'S-3000') ? _c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'alt')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Alteração\n        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Processar Lote",
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getEsocialLotesProcessar,
      "onEdit": null,
      "onDelete": null,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingContent,
      "pagination": _vm.pagination
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled ? true : false,
      "multiple": _vm.multiple,
      "value-key": _vm.itemValue,
      "remote-method": _vm.remoteMethod,
      "collapse-tags": "",
      "remote": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      },
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm.getLabel(item),
        "value": _vm.getValue(item)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(item))
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.id == 0 ? 'Nova Coluna' : 'Editar Coluna') + ' :: ' + _vm.tabela.nome,
      "modal": _vm.showForm,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "99%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [(_vm.formData.id_tipo_campo == 210 || _vm.formData.id_tipo_campo == 211 || _vm.formData.id_tipo_campo == 212 || _vm.formData.id_tipo_campo == 217) ? _c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Valores', {
    attrs: {
      "parent": this
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Coluna",
      "onRegister": (this.validarPermissao(571) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamicaColuna,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.content,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Laboratorios', {
    attrs: {
      "parent": this
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Guia', {
    attrs: {
      "showGuia": _vm.showGuia,
      "consulta": _vm.consulta
    }
  }), _vm._v(" "), _c('Lote', {
    attrs: {
      "showLote": _vm.showLote,
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Nova Consulta",
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "loadingTable": _vm.config.loading.table
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-copy",
      "type": "success",
      "value": "Gerar Consulta em Lote",
      "title": "Clique aqui para gerar várias consultas ao mesmo tempo."
    },
    on: {
      "click": _vm.onLote
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde enquanto a liberação é concluída..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'LIBERAR ASO' + _vm.title,
      "modal": _vm.parent.showLiberacao,
      "loadingSave": _vm.config.loading.save,
      "loading": _vm.config.loading.content,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Liberar ASO")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n            Histórico de Liberação\n          ")]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaLiberacao,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Desativar nova Empresa',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.disparoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": _vm.icon,
      "type": _vm.type,
      "loading": _vm.loading,
      "title": (_vm.title ? _vm.title : _vm.value),
      "size": _vm.size,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO XML",
      "modal": _vm.parent.showNovoXml,
      "onSave": _vm.salvar,
      "isModal": false,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Selecione um Layout",
      "items": _vm.getTabelas(),
      "required": ""
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Empresa",
      "name": "id_emp",
      "items": _vm.bind.empresas,
      "loading": _vm.bind.loadingEmpresa,
      "disabled": !_vm.formData.layout,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getEmpresa,
      "input": _vm.setEmpresa
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Trabalhador (a)",
      "name": "id_fun",
      "items": _vm.bind.funcionarios,
      "loading": _vm.bind.loadingFuncionario,
      "disabled": !_vm.formData.id_emp,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.setFuncionario
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), (_vm.formData.layout == 'S-2240') ? _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "name": "valor.id_fdt",
      "items": _vm.bind.fdt,
      "loading": _vm.bind.loadingFdt,
      "disabled": !_vm.formData.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.valor.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "id_fdt", $$v)
      },
      expression: "formData.valor.id_fdt"
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Categoria do Trabalhador",
      "info": "Somente se informado no evento de admissão do layout S-2200",
      "items": _vm.bind.categorias,
      "loading": _vm.bind.loadingCategoria,
      "clearable": ""
    },
    on: {
      "search": _vm.getCategoria
    },
    model: {
      value: (_vm.formData.valor.id_esocial_categoria),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "id_esocial_categoria", $$v)
      },
      expression: "formData.valor.id_esocial_categoria"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Mátricula do Trabalhador",
      "info": "Somente se informado no evento de admissão do layout S-2200"
    },
    model: {
      value: (_vm.formData.valor.matricula),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "matricula", $$v)
      },
      expression: "formData.valor.matricula"
    }
  }), _vm._v(" "), (_vm.formData.layout == 'S-2220') ? _c('s2220', {
    attrs: {
      "formData": _vm.formData.valor,
      "parent": this,
      "avulso": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.layout == 'S-2240' && _vm.formData.id_emp && _vm.formData.id_fun && _vm.formData.valor.id_fdt) ? _c('s2240', {
    attrs: {
      "formData": _vm.formData.valor,
      "parent": this,
      "avulso": 1
    }
  }) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo LTCAT",
      "onRegister": (!_vm.validarPacote(27) ? null : _vm.onRegister),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcat,
      "onFilter": _vm.getLtcat,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [(_vm.ultima_revisao) ? _c('ed-alert', {
    staticClass: "text-left",
    attrs: {
      "title": "Última Revisão desse LTCAT",
      "type": "warning"
    }
  }, [_c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [(_vm.ultima_revisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultima_revisao.parent.rev) + " (" + _vm._s(_vm.ultima_revisao.parent.descricao) + " em " + _vm._s(_vm.toDate(_vm.ultima_revisao.parent.data, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultima_revisao.rev) + " (" + _vm._s(_vm.ultima_revisao.descricao) + " em " + _vm._s(_vm.toDate(_vm.ultima_revisao.data, true)) + ")\n\t\t\t\t\t")])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getFuncionario,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHedad,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Os Fatores de Riscos listados abaixo devem ser vinculados aos riscos mostrados em Configurações > Riscos"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Fator de Risco",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getFatorRisco,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onFilter": _vm.getFatorRisco,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', [_c('ed-input-select-tipo', {
    staticClass: "col-12",
    attrs: {
      "label": "Filtrar por Categopria",
      "name": "cat_esocial",
      "tipo": "269",
      "valueKey": "descricao",
      "multiple": ""
    },
    model: {
      value: (_vm.formFilter.cat_esocial),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "cat_esocial", $$v)
      },
      expression: "formFilter.cat_esocial"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (this.$store.state.ltcat.title + ' Novo GHE'),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onClose": _vm.onClose,
      "onSave": (_vm.tagConfig == 'tab-cadastro' ? this.salvar : null),
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações do GHE\n          ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Nova Linha"
    },
    on: {
      "click": _vm.onRegister
    }
  }), _vm._v(" "), _c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum item encontrado",
      "busy": _vm.config.loading.content || _vm.config.loading.copiar,
      "items": _vm.tableData,
      "fields": _vm.tableHead,
      "stacked": (this.device == 'xs')
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_text) ? _c('el-input', {
          attrs: {
            "maxlength": 150,
            "disabled": data.item._data.ativo == 0,
            "type": "text"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_numeric) ? _c('el-input-number', {
          attrs: {
            "disabled": data.item._data.ativo == 0,
            "min": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)])])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo d-none d-sm-inline d-xl-inline",
    attrs: {
      "src": __webpack_require__(210),
      "width": "192"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Oops! Endereço incompleto...")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.url) ? _c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n    Por exemplo: "), _c('i', [_c('b', [_vm._v(_vm._s(_vm.url) + "/"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("url-da-clinica")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Para acessar essa página você deve fornecer a "), _c('i', [_vm._v("URL")]), _vm._v(" da sua clínica de medicina do Trabalho.\n  ")])
}]}

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('p', {
    staticClass: "mt-5"
  }, [_c('ckeditor', {
    attrs: {
      "id": _vm.id,
      "value": _vm.value,
      "config": _vm.editorConfig,
      "disabled": _vm.disabled,
      "read-only": _vm.readonly,
      "tag-name": "textarea",
      "editor-url": _vm.editorUrl
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "click": _vm.salvar,
      "loading": _vm.loadingSave,
      "value": "Salvar"
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(210),
      "width": "192"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Oops! Algo deu errado...")]), _vm._v(" "), (_vm.erro) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.erro) + "\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])])
}]}

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n      Informações do Trabalhador(a)\n    ")]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 pa-0",
    attrs: {
      "label": "Trabalhador (a)",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.list.funcionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.formatarFuncionario
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "disabled": !_vm.formData.funcionario,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getFuncao
    },
    model: {
      value: (_vm.formData.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fdt", $$v)
      },
      expression: "formData.id_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5",
    attrs: {
      "label": "Função",
      "items": _vm.list.funcao,
      "loading": _vm.loadingFuncao,
      "disabled": !_vm.formData.funcionario || !_vm.formData.id_fdt,
      "required": ""
    },
    on: {
      "input": _vm.getGHE
    },
    model: {
      value: (_vm.formData.id_funcao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_funcao", $$v)
      },
      expression: "formData.id_funcao"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "GHE (Setor)",
      "items": _vm.list.ghe,
      "loading": _vm.loadingGhe,
      "disabled": !_vm.formData.funcionario || !_vm.formData.id_fdt || !_vm.formData.id_funcao,
      "itemGroup": "",
      "required": ""
    },
    model: {
      value: (_vm.formData.id_ghe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_ghe", $$v)
      },
      expression: "formData.id_ghe"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3",
    attrs: {
      "label": "Data do Agendamento da Consulta",
      "info": "A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.",
      "disabled": !_vm.formData.funcionario ||
        !_vm.formData.id_fdt ||
        !_vm.formData.id_funcao ||
        !_vm.formData.id_ghe,
      "maxDaysTomorrow": 15
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.formData.data_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_age", $$v)
      },
      expression: "formData.data_age"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Observações",
      "type": "textarea",
      "disabled": !_vm.formData.funcionario ||
        !_vm.formData.id_fdt ||
        !_vm.formData.id_funcao ||
        !_vm.formData.id_ghe
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n      Informações da Consulta\n    ")]), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Tipo de Consulta",
      "name": "id_tipo_aso",
      "tipo": "46",
      "disabled": !_vm.formData.funcionario ||
        !_vm.formData.id_fdt ||
        !_vm.formData.id_funcao ||
        !_vm.formData.id_ghe ||
        !_vm.formData.data_age,
      "disabledItem": _vm.disabilitarConsulta,
      "isRadio": "",
      "required": ""
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.formData.id_tipo_aso),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_tipo_aso", $$v)
      },
      expression: "formData.id_tipo_aso"
    }
  }, [(_vm.formData.id_tipo_aso == 50) ? _c('div', {
    staticClass: "pb-1",
    attrs: {
      "slot": "id_tipo_aso_50"
    },
    slot: "id_tipo_aso_50"
  }, [_c('div', {
    staticClass: "row ml-0 mr-0 mb-0"
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Nova Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "disabled": !_vm.formData.funcionario,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getGheMudancaFuncao
    },
    model: {
      value: (_vm.formData.id_mf_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_mf_fdt", $$v)
      },
      expression: "formData.id_mf_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-4",
    attrs: {
      "label": "Novo GHE (Setor)",
      "items": _vm.list.mf_ghe,
      "loading": _vm.loadingGhe,
      "disabled": !_vm.formData.id_mf_fdt,
      "itemGroup": "",
      "required": ""
    },
    on: {
      "input": _vm.getFuncaoMudancaFuncao
    },
    model: {
      value: (_vm.formData.id_mf_ghe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_mf_ghe", $$v)
      },
      expression: "formData.id_mf_ghe"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5",
    attrs: {
      "label": "Nova Função",
      "items": _vm.list.mf_funcao,
      "loading": _vm.loadingFuncao,
      "disabled": !_vm.formData.id_mf_fdt || !_vm.formData.id_mf_ghe,
      "required": ""
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.formData.id_mf_funcao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_mf_funcao", $$v)
      },
      expression: "formData.id_mf_funcao"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.formData.id_tipo_aso == 52 || _vm.formData.id_tipo_aso == 48) ? _c('div', {
    staticClass: "pb-1",
    attrs: {
      "slot": 'id_tipo_aso_' + _vm.formData.id_tipo_aso
    },
    slot: 'id_tipo_aso_' + _vm.formData.id_tipo_aso
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3",
    attrs: {
      "label": "Periodicidade",
      "items": _vm.listaPeriodicidade,
      "loading": !_vm.$root.$session.pcmso,
      "required": ""
    },
    model: {
      value: (_vm.formData.periodicidade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "periodicidade", $$v)
      },
      expression: "formData.periodicidade"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [(
    _vm.formData.id_tipo_aso != 50 ||
    (_vm.formData.id_tipo_aso == 50 &&
      _vm.formData.id_mf_fdt &&
      _vm.formData.id_mf_ghe &&
      _vm.formData.id_mf_funcao)
  ) ? _c('div', {
    staticClass: "col-md-12 pa-0"
  }, [_c('ed-credenciada', {
    attrs: {
      "parent": this
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center mt-5",
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "size": "big",
      "icon": "fa fa-floppy-o",
      "label": "Gerar Consulta",
      "disabled": !_vm.formData.id_tipo_aso || !Array.isArray(_vm.tabela_preco),
      "title": !_vm.formData.id_tipo_aso ?
        'Para continuar selecione o tipo da consulta' :
        'Clique aqui para gerar a consulta'
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Aqui você pode inserir uma nova categoria para classificar uma coluna se houver necessidade."
    }
  }), _vm._v(" "), _c('CategoriaEdit', {
    attrs: {
      "tabela": _vm.tabela,
      "parent": this
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Categoria",
      "onRegister": (this.validarPermissao(571) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamicaCategoria,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('LiberarASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('DownloadASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('UploadASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Upload de ASO",
      "registerIcon": "fa fa-upload",
      "registerTitle": "Clique aqui para fazer o upload dos ASO e liberar posteriormente",
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "onRegister": _vm.validarPermissao(553) ? _vm.onRegister : null,
      "filterBadge": _vm.filterBadge,
      "response": _vm.response,
      "disableCheckAll": ""
    }
  }, [(_vm.validarPermissao(561)) ? _c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-paper-plane",
      "type": "warning",
      "value": "Enviar ASO por Email"
    },
    on: {
      "click": function($event) {
        return _vm.onDownloadASO(null)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "search-detail"
    },
    slot: "search-detail"
  }, [_vm._v("Busca por consulta: Digite somente o código da consulta")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'ENVIAR ARQUIVOS POR EMAIL',
      "modal": _vm.showEnviarEmail,
      "onSave": _vm.enviar,
      "saveName": "Enviar Agora",
      "saveIcon": "fa fa-paper-plane",
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingEmailSave),
      expression: "loadingEmailSave"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "warning",
      "description": "Você pode conferir abaixo os ASO`s que serão enviados por email. Nesse etapa você pode alterar o destinatário e customizar uma mensagem para cada empresa. Clique no nome da empresa para visualizar os arquivos e customizar os dados para envio do email.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, _vm._l((_vm.tableDataEmail), function(item, i) {
    return _c('el-collapse-item', {
      key: i,
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [(item[0] && item[0].empresa) ? _c('span', {
      staticStyle: {
        "color": "#3777a2"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-arrow-circle-right"
    }), _vm._v("\n                  " + _vm._s(item[0].empresa.nome) + "\n                  "), _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#666"
      }
    }, [_vm._v(" " + _vm._s(_vm.formData[item[0].empresa.id].consultas.length) + " aso selecionado(s) ")]), _vm._v(" "), (_vm.formData[item[0].empresa.id].error) ? _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#d16868",
        "text-align": "right"
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle faa-flash animated"
    }), _vm._v("\n                    " + _vm._s(_vm.formData[item[0].empresa.id].error) + "\n                  ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Destinatário",
        "prop": "destinatario",
        "rules": [{
          required: false,
          message: 'Campo Obrigatorio'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Digite o destinatário (separado por `;` ponto e vírgula)"
      },
      model: {
        value: (_vm.formData[item[0].empresa.id].destinatario),
        callback: function($$v) {
          _vm.$set(_vm.formData[item[0].empresa.id], "destinatario", $$v)
        },
        expression: "formData[item[0].empresa.id].destinatario"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Observações",
        "prop": "obs",
        "rules": [{
          required: false,
          message: 'Campo Obrigatorio'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "O conteúdo deste campo será anexado junto com o email enviado para o destinatário..."
      },
      model: {
        value: (_vm.formData[item[0].empresa.id].obs),
        callback: function($$v) {
          _vm.$set(_vm.formData[item[0].empresa.id], "obs", $$v)
        },
        expression: "formData[item[0].empresa.id].obs"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Consultas (ASO)",
        "prop": "consultas",
        "rules": [{
          required: false,
          message: 'Campo Obrigatorio'
        }]
      }
    }, [_c('table', {
      staticClass: "table table-hover has-gutter",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "width": "120"
      }
    }, [_vm._v("Consulta")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("Funcionário")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "width": "200"
      }
    }, [_vm._v("Arquivo")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "width": "200"
      }
    }, [_vm._v("Enviar por Email")])])]), _vm._v(" "), _c('tbody', _vm._l((item), function(consulta, j) {
      return _c('tr', {
        key: i + j
      }, [_c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(consulta.id_con))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(consulta.funcionario.nome))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('Download', {
        attrs: {
          "arquivo": consulta.arquivo
        }
      })], 1), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('el-checkbox', {
        attrs: {
          "label": consulta.id_con,
          "disabled": consulta.tipo_documento && consulta.tipo_documento.id == '82' ? false : true
        },
        model: {
          value: (_vm.formData[item[0].empresa.id].consultas),
          callback: function($$v) {
            _vm.$set(_vm.formData[item[0].empresa.id], "consultas", $$v)
          },
          expression: "formData[item[0].empresa.id].consultas"
        }
      }, [(_vm.formData[item[0].empresa.id].consultas.indexOf(consulta.id_con) != -1) ? _c('span', [_vm._v(" Sim ")]) : _c('span', [_vm._v("Não")])])], 1)])
    }), 0)])])], 1)])], 2)
  }), 1)], 1)], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'EDITAR PÁGINA' + (_vm.formDataEdit.id ? ' ' + _vm.formDataEdit.page : ''),
      "modal": _vm.showFormEdit,
      "onSave": _vm.salvar,
      "saveName": "Salvar",
      "saveIcon": "fa fa-paper-plane",
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "warning",
      "description": "Aqui você pode vincular a página, do PDF, em alguma consulta. Faça isso caso a página em questão não for identificado pelo sistema ou foi identificado incorretamente.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formDataEdit,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItemsEdit
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), (_vm.formDataEdit.usuario) ? _c('ed-alert', {
    attrs: {
      "type": "success",
      "description": _vm.formDataEdit.usuario.usuario + ' em ' + _vm.formDataEdit.updated_at,
      "title": "Última Atualização"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'DETALHAMENTO DO ARQUIVO ' + (this.parent.upload_pagina && this.parent.upload_pagina.arquivo ? this.parent.upload_pagina.arquivo.name : ''),
      "modal": _vm.parent.showUploadPagina,
      "width": "90%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-detalhe"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v(" Detalhamento do Arquivo")]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getConsultaUploadPagina,
      "onEdit": _vm.onEdit,
      "onEditAll": _vm.onArquivoEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "editAllName": "Enviar Arquivo(s) por Email",
      "editAllIcon": "fa fa-paper-plane",
      "editAllTitle": "Clique aqui para enviar emails para os registros selecionados"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history'
  }), _vm._v("\n            Histórico de Envio de Emails\n          ")]), _vm._v(" "), _c('DownloadAsoEmail', {
    attrs: {
      "parent": this
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination) ? _c('div', [_c('span', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("Página " + _vm._s(_vm.pagination.current_page) + " de " + _vm._s(_vm.pagination.last_page))]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-count": _vm.pagination.last_page,
      "current-page": _vm.pagination.current_page
    },
    on: {
      "current-change": _vm.navigation,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "current_page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "current_page", $event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v(_vm._s(_vm.pagination.total) + " registro(s)")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conclusão Técnica' : 'Editar Conclusão Técnica',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "85%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "value-key": _vm.itemValue,
      "remote": _vm.remote,
      "remote-method": _vm.remoteMethod,
      "collapse-tags": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.setEvent('input', $event)
      },
      "input": function($event) {
        return _vm.setEvent('input', $event)
      }
    }
  }, [(_vm.itemGroup) ? _vm._l((_vm.items), function(item, indexItem) {
    return _c('el-option-group', {
      key: indexItem,
      attrs: {
        "label": _vm.getLabel(item),
        "disabled": _vm.disabled
      }
    }, _vm._l((item.options), function(subItem, indexSubItem) {
      return _c('el-option', {
        key: indexItem + indexSubItem,
        attrs: {
          "label": _vm.getLabel(subItem),
          "value": _vm.getValue(subItem),
          "disabled": _vm.disabled
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.getHtml(subItem))
        }
      })])
    }), 1)
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm.getLabel(item),
        "value": _vm.getValue(item)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(item))
      }
    })])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    attrs: {
      "title": _vm.title,
      "type": _vm.type,
      "description": _vm.description,
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._t("description")], 2)
},staticRenderFns: []}

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": _vm.icon,
      "type": _vm.type,
      "size": _vm.size,
      "loading": _vm.loading,
      "title": _vm.title ? _vm.title : _vm.label,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click', $event)
      }
    }
  }, [_c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [(_vm.icon) ? _c('i', {
    class: _vm.$utilidade.getIcone(_vm.icon)
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('TableView', {
    attrs: {
      "registerName": "Inserir Laboratório",
      "onRegister": (this.validarPermissao(570) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLaboratorio,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Número do Recibo",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.busca),
      callback: function($$v) {
        _vm.$set(_vm.formData, "busca", $$v)
      },
      expression: "formData.busca"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "\n        col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\n        text-center\n        mt-5\n      "
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "disabled": !_vm.formData.id_emp || !_vm.formData.busca ? true : false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row text-left"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.parent.loadingTabelaPreco),
      expression: "parent.loadingTabelaPreco"
    }],
    staticClass: "col-12"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.parent.tabHistorico),
      callback: function($$v) {
        _vm.$set(_vm.parent, "tabHistorico", $$v)
      },
      expression: "parent.tabHistorico"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-credenciada"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Credenciadas")]), _vm._v(" "), (!_vm.parent.formData.id_tipo_aso) ? _c('label', [_vm._v("Selecione o Tipo de Consulta")]) : (!_vm.parent.tabela_preco) ? _c('label', [_vm._v("Aguarde...")]) : (_vm.parent.tabela_preco && _vm.parent.tabela_preco.total == 0) ? _c('span', [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Por favor entre em contato conosco no telefone ' +
        _vm.cliente.logged.tel_com +
        ' para maiores informações',
      "title": "Nenhuma credenciada encontrado"
    }
  })], 1) : (_vm.parent.tabela_preco && !Array.isArray(_vm.parent.tabela_preco)) ? _c('span', {
    staticClass: "col-12"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": _vm.parent.tabela_preco,
      "title": "Falha ao Carregar as Credenciadas"
    }
  })], 1) : _c('span', [_c('div', {
    staticClass: "row"
  }, [(_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Para continuar com o cadastro do ASO você deve selecionar a Credenciada. Você tambem pode utilizar os filtros ao lado para buscar alguma credenciada próximo do seu local.",
      "title": "Atenção"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 q-pa-xs"
  }, [_c('div', {
    staticClass: "col-12 q-mb-md",
    staticStyle: {
      "color": "#21ba45"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.parent.tabela_preco.total) + "\n                  "), (_vm.parent.tabela_preco.total == 1) ? _c('label', [_vm._v("credenciada encontrado")]) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco.total > 1) ? _c('label', [_vm._v("credenciadas encontrado")]) : _vm._e()]), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('span', {
    staticClass: "credenciada-title"
  }, [_vm._v("Organizar Credenciadas")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Selecione"
    },
    model: {
      value: (_vm.parent.formFilter.order),
      callback: function($$v) {
        _vm.$set(_vm.parent.formFilter, "order", $$v)
      },
      expression: "parent.formFilter.order"
    }
  }, _vm._l((_vm.lstOrganizar), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('span', {
    staticClass: "credenciada-title"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Selecione"
    },
    on: {
      "change": _vm.getCidade
    },
    model: {
      value: (_vm.parent.formFilter.id_estado),
      callback: function($$v) {
        _vm.$set(_vm.parent.formFilter, "id_estado", $$v)
      },
      expression: "parent.formFilter.id_estado"
    }
  }, _vm._l((_vm.estados), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('span', {
    staticClass: "credenciada-title"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Selecione",
      "disabled": !_vm.parent.formFilter.id_estado
    },
    model: {
      value: (_vm.parent.formFilter.id_cidade),
      callback: function($$v) {
        _vm.$set(_vm.parent.formFilter, "id_cidade", $$v)
      },
      expression: "parent.formFilter.id_cidade"
    }
  }, _vm._l((_vm.cidades), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.parent.tabela_preco), function(tabela_preco, i) {
    return _c('div', {
      key: i,
      staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 card-item"
    }, [_c('el-card', {
      class: 'box-card col-md-12 mb-3' +
        (_vm.parent.formData.id_tabela_preco == tabela_preco.id ?
          ' box-card-selected' :
          ''),
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [_c('el-radio', {
      attrs: {
        "val": tabela_preco.id,
        "label": tabela_preco.id,
        "title": tabela_preco.credenciada_nome
      },
      model: {
        value: (_vm.parent.formData.id_tabela_preco),
        callback: function($$v) {
          _vm.$set(_vm.parent.formData, "id_tabela_preco", $$v)
        },
        expression: "parent.formData.id_tabela_preco"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.textLimit(tabela_preco.credenciada_nome, 50)))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('i', {
      staticClass: "fas fa-map-marker-alt"
    }), _vm._v("\n                            " + _vm._s(tabela_preco.credenciada_end.toUpperCase()) + ",\n                            " + _vm._s(tabela_preco.credenciada_num) + "\n                            "), (tabela_preco.credenciada_cidade) ? _c('span', [_vm._v("\n                              -\n                              " + _vm._s(tabela_preco.credenciada_cidade.toUpperCase() +
      "/" +
      tabela_preco.credenciada_uf.toUpperCase()) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "text-center item",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "35px"
      }
    }, [_vm._v("\n                              " + _vm._s("R$" +
      _vm.getPreco(tabela_preco.valor_total, "unit")) + "\n                            ")]), _vm._v(" "), _c('label', {
      staticStyle: {
        "font-size": "25px"
      }
    }, [_c('sup', [_vm._v("\n                                " + _vm._s(_vm.getPreco(tabela_preco.valor_total, "cents")) + "\n                              ")])]), _vm._v(" "), _c('label', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('br'), _vm._v("Valor por cada ASO"), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Esses valores podem sofrer alteração, devido a validade dos exames complementares.")])])])], 1)]), _vm._v(" "), (tabela_preco.exames.mascaramento < 0) ? _c('div', {
      staticClass: "text item q-mb-sm pa-1",
      staticStyle: {
        "font-size": "9pt",
        "background": "#d7eaf4"
      }
    }, [_c('b', [_vm._v("Mascaramento")])]) : _vm._e(), _vm._v(" "), (tabela_preco.exames.mascaramento < 0) ? _c('div', {
      staticClass: "text item",
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('i', {
      staticClass: "far fa-hand-point-right"
    }), _vm._v("\n                        O mascaramento está habilitado: Os exames serão carregados " + _vm._s(Math.abs(tabela_preco.exames.mascaramento)) + " dia(s) antes do vencimento configurado no PCMSO.\n                        \n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text item q-mb-sm mt-1 pa-1",
      staticStyle: {
        "font-size": "9pt",
        "background": "#d7eaf4"
      }
    }, [_c('b', [_vm._v("Exames")])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('i', {
      staticClass: "far fa-hand-point-right"
    }), _vm._v("\n                        Total: " + _vm._s(tabela_preco.total_exames)), _c('br'), _vm._v("\n                        Total Pendente: " + _vm._s(tabela_preco.total_exames_realizar)), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text item text-center q-mt-lg mt-2"
    }, [_c('ed-button', {
      attrs: {
        "size": "mini",
        "value": " Ver Exames",
        "type": "default",
        "icon": "fa fa-search"
      },
      on: {
        "click": function($event) {
          return _vm.onShowExame(tabela_preco)
        }
      }
    })], 1)])], 1)
  }), 0)])]), _vm._v(" "), _c('Exame', {
    attrs: {
      "parent": this,
      "tabela_preco": _vm.tabela_preco,
      "showExame": _vm.showExame
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Exames no PCMSO",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Na tabela abaixo você pode conferir os exames cadastrados no PCMSO. Esses exames estão vinculados diretamente com o GHE (Setor) seleciona acima.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.parent.formData.id_ghe
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Histórico de Consultas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('span', [_c('Historico', {
    attrs: {
      "funcionario": _vm.parent.formData.funcionario,
      "id_funcao": _vm.parent.formData.id_funcao
    }
  })], 1)])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.credenciadaItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.device != 'xs') ? _c('div', [_vm._v("\r\n  ©" + _vm._s(_vm.toDate(null, true, 'YYYY')) + " Todos os Direitos Reservados a "), _c('b', [_vm._v(_vm._s(_vm.cliente.logged.nome))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    class: _vm.getError ? 'is-error' : '',
    attrs: {
      "title": _vm.info,
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.label) ? _c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.label) + "\n\n      "), (_vm.info) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.getError && _vm.getError.length) ? _c('div', {
    staticClass: "text-left mt-1",
    staticStyle: {
      "color": "#e66666",
      "font-size": "9pt"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.getError.join(', ')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.fatorRiscoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Laboratorios', {
    attrs: {
      "parent": this
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('Config', {
    attrs: {
      "consulta": _vm.formData.result
    }
  }), _vm._v(" "), (false) ? _c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "button": "",
      "title": "Clique aqui para imprimir o ASO desta consulta"
    },
    on: {
      "click": _vm.onASO
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir ASO\n            ")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "button": "",
      "title": "Clique aqui para imprimir a Ficha Clínica desta consulta"
    },
    on: {
      "click": _vm.onFemo
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir Ficha Clínica\n            ")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "disabled": "",
      "button": "",
      "title": "Clique aqui para Liberar o ASO desta consulta"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Liberar ASO\n              ")])], 1) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.config && _vm.config.loading) ? _c('span', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Processando..."
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: _vm.id,
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.data
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.itens), function(item, i) {
    return (!_vm.config || !_vm.config.hidden || !_vm.config.hidden[item.field]) ? _c('div', {
      key: i,
      class: item.class,
      style: (item.style)
    }, [(item.type == 'group') ? _c('div', {
      staticClass: "col-12 item-group"
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n          " + _vm._s(item.label) + "\n        ")]) : (item.type != 'group') ? _c('el-form-item', {
      class: _vm.error && _vm.error[item.field] ? 'is-error' : '',
      attrs: {
        "label": item.label,
        "title": item.placeholder,
        "rules": _vm.handleRules(item.rules)
      }
    }, [(item.label) ? _c('span', {
      staticStyle: {
        "color": "#636363"
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('span', [(_vm.config.label && _vm.config.label[item.field]) ? _c('label', [_vm._v(_vm._s(_vm.config.label[item.field]))]) : _c('label', [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.info) ? _c('a', {
      attrs: {
        "href": "#",
        "title": item.info
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (item.title && item.title.model) ? _c('el-switch', {
      attrs: {
        "title": _vm.config.description ? _vm.config.description[item.title.model] : '',
        "active-value": 1,
        "inactive-value": 0,
        "active-text": _vm.config.title[item.title.model],
        "inactive-text": ""
      },
      model: {
        value: (_vm.data[item.title.model]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.title.model, $$v)
        },
        expression: "data[item.title.model]"
      }
    }) : _vm._e(), _vm._v(" "), (item.title && item.title.link && _vm.config.click[item.title.link]) ? _c('ed-button', {
      attrs: {
        "type": "text",
        "icon": item.title.icon,
        "value": _vm.config.title[item.title.link]
      },
      on: {
        "click": function($event) {
          _vm.config.click[item.title.link]()
        }
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (item.type == 'text' || item.type == 'password' || item.type == 'textarea' || item.type == 'email' || item.type == 'number') ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (item.mask ? _vm.mask[item.mask] : ''),
        expression: "item.mask ? mask[item.mask] : ''"
      }],
      attrs: {
        "type": item.type,
        "rows": item.rows ? item.rows : 2,
        "maxlength": item.maxlength ? item.maxlength : 5000,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder,
        "show-word-limit": item.maxlength ? true : false,
        "autocomplete": "false"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'number') ? _c('el-input-number', {
      attrs: {
        "min": item.min ? item.min : 0,
        "max": item.max ? item.max : 99999999999,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-text' && _vm.config.list[item.select_field]) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (item.mask ? _vm.mask[item.mask] : ''),
        expression: "item.mask ? mask[item.mask] : ''"
      }],
      attrs: {
        "type": item.type,
        "rows": item.rows ? item.rows : 2,
        "maxlength": item.maxlength ? item.maxlength : 5000,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder,
        "show-word-limit": item.maxlength ? true : false,
        "autocomplete": "false"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "slot": "prepend",
        "placeholder": "---",
        "value-key": "id"
      },
      slot: "prepend",
      model: {
        value: (_vm.data[item.select_field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.select_field, $$v)
        },
        expression: "data[item.select_field]"
      }
    }, _vm._l((_vm.config.list[item.select_field]), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "data": item,
          "label": item.nome,
          "value": item.id
        }
      })
    }), 1)], 1) : (item.type == 'checkbox') ? _c('el-checkbox', {
      staticClass: "disable-checkbox-label",
      attrs: {
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "label": "1",
        "true-label": "1",
        "false-label": "0"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'color') ? _c('el-color-picker', {
      attrs: {
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "predefine": _vm.predefineColors,
        "color-format": "hex"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'boolean') ? _c('el-switch', {
      attrs: {
        "active-value": 1,
        "inactive-value": 0,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'date') ? _c('el-date-picker', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (_vm.mask.date),
        expression: "mask.date"
      }],
      attrs: {
        "type": "date",
        "placeholder": "dd/mm/aaaa",
        "value-format": "dd/MM/yyyy",
        "format": "dd/MM/yyyy",
        "picker-options": _vm.handleDateOptions(item),
        "clearable": item.clearable ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'time') ? _c('el-time-select', {
      attrs: {
        "picker-options": _vm.handleTimeOptions(item),
        "clearable": item.clearable ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'date-range') ? _c('el-date-picker', {
      attrs: {
        "type": "daterange",
        "placeholder": "dd/mm/aaaa",
        "value-format": "dd/MM/yyyy",
        "format": "dd/MM/yyyy",
        "clearable": item.clearable ? true : false,
        "start-placeholder": "Data Inicial",
        "end-placeholder": "Data Final",
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'time-range') ? _c('el-time-picker', {
      attrs: {
        "is-range": "",
        "value-format": "HH:mm",
        "format": "HH:mm",
        "start-placeholder": "Início",
        "end-placeholder": "Fim"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'upload') ? _c('ed-upload', {
      attrs: {
        "input": item.field,
        "currentFile": _vm.data[item.field],
        "accept": item.accept ? item.accept : '',
        "multiple": item.multiple ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      }
    }) : (item.type == 'cep') ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (_vm.mask.cep),
        expression: "mask.cep"
      }],
      attrs: {
        "maxlength": item.maxlength ? item.maxlength : 10,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      on: {
        "blur": _vm.handleEndereco
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-cnae') ? _c('el-select', {
      attrs: {
        "placeholder": "Selecione",
        "loading": _vm.loadingCnae,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "clearable": "",
        "remote": "",
        "remote-method": _vm.handleCnaeDebounce,
        "value-key": "cnae"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.cnaes), function(cnae) {
      return _c('el-option', {
        key: cnae.id,
        attrs: {
          "label": cnae.cnae + ' | ' + cnae.nome,
          "value": cnae
        }
      })
    }), 1) : (item.type == 'select-uf') ? _c('el-select', {
      attrs: {
        "placeholder": "Selecione",
        "loading": _vm.loadingEstado,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "clearable": ""
      },
      on: {
        "change": _vm.handleCidadeDebounce
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.estados), function(estado) {
      return _c('el-option', {
        key: estado.uf,
        attrs: {
          "label": estado.estado.toUpperCase(),
          "value": item.value_uf ? estado.uf : estado.uf
        }
      })
    }), 1) : (item.type == 'select-cidade') ? _c('el-select', {
      attrs: {
        "placeholder": "Pesquisa...",
        "loading": _vm.loadingCidade,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "remote": "",
        "clearable": "",
        "remote-method": _vm.handleCidadeDebounce
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.cidades), function(cidade) {
      return _c('el-option', {
        key: cidade.id_cidade,
        attrs: {
          "label": cidade.cidade.toUpperCase(),
          "value": cidade.id_cidade
        }
      })
    }), 1) : (item.type == 'editor') ? _c('ed-editor', {
      attrs: {
        "conteudo": _vm.data[item.field],
        "model": item.field
      }
    }) : (item.type == 'select-tipo') ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "multiple": item.multiple ? true : false,
        "collapse-tags": true,
        "placeholder": item.placeholder ? item.placeholder : 'Selecione',
        "filterable": "",
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "value-key": "id"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-option', {
        key: tipo.id,
        attrs: {
          "label": tipo.descricao,
          "value": item.valor ? _vm.toString(tipo[item.valor]) : parseInt(tipo.id),
          "title": item.obs
        }
      }, [_c('div', [_vm._v(_vm._s(tipo.descricao))]), _vm._v(" "), (tipo.obs) ? _c('div', {
        staticStyle: {
          "color": "#8492a6",
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(tipo.obs))]) : _vm._e()])
    }), 1) : (item.type == 'select-tipo-radio') ? _c('el-radio-group', {
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-radio', {
        key: tipo.id,
        staticStyle: {
          "padding": "5px"
        },
        attrs: {
          "label": item.valor ? _vm.toString(tipo[item.valor]) : parseInt(tipo.id),
          "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field] ? true : false)
        }
      }, [_vm._v("\n              " + _vm._s(tipo.descricao) + "\n            ")])
    }), 1) : (item.type == 'select-tipo-checkbox') ? _c('div', _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-checkbox', {
        key: tipo.id,
        staticStyle: {
          "padding": "5px",
          "width": "100% !important"
        },
        attrs: {
          "label": item.valor ? tipo[item.valor] : tipo.id,
          "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field] ? true : false)
        },
        model: {
          value: (_vm.data[item.field]),
          callback: function($$v) {
            _vm.$set(_vm.data, item.field, $$v)
          },
          expression: "data[item.field]"
        }
      }, [_vm._v("\n              " + _vm._s(tipo.descricao) + "\n            ")])
    }), 1) : (item.type == 'select-custom' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "placeholder": item.placeholder ? item.placeholder : 'Pesquisar...',
        "filterable": "",
        "disabled": _vm.config.disabled && _vm.config.disabled[item.field] ? true : false,
        "multiple": item.multiple ? true : false,
        "collapse-tags": "",
        "remote": "",
        "remote-method": item.disable_remote ? null : _vm.config.click[item.field],
        "value-key": "id"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(val, j) {
      return _c('el-option', {
        key: j,
        attrs: {
          "label": _vm.handleLabelSelect(item, val),
          "value": _vm.handleValueSelect(item, val),
          "title": _vm.handleTitleSelect(item, val)
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.handleLabelSelectHtml(item, val))
        }
      })])
    }), 1) : (item.type == 'select-ghe' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": "Selecione",
        "filterable": ""
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(revisao) {
      return _c('el-option-group', {
        key: revisao.id,
        attrs: {
          "label": (revisao.parent ? revisao.parent.rev + ' (' + revisao.parent.descricao.toUpperCase() + ' em ' + _vm.toDate(revisao.parent.data_hora, true) + ') / ' : '') + revisao.rev + ' (' + revisao.descricao.toUpperCase() + ' em ' + _vm.toDate(revisao.data_hora, true) + ')'
        }
      }, _vm._l((revisao.options), function(ghe) {
        return _c('el-option', {
          key: revisao.id + ghe.id,
          attrs: {
            "label": ghe.id == '0' ? ghe.descricao : ghe.ghe + ' (' + ghe.descricao + ')',
            "value": ghe.id,
            "disabled": ghe.id == '0' || revisao.disabled || (revisao.parent && revisao.parent.disabled) || (_vm.config.disabled && _vm.config.disabled[item.field]) ? true : false,
            "title": revisao.disabled || (revisao.parent && revisao.parent.disabled) ? 'O PCMSO desde GHE está vencido. Entre em contato conosco para melhores esclarecimentos.' : ''
          }
        })
      }), 1)
    }), 1) : (item.type == 'select-revisao' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": "Selecione",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          _vm.config.change[item.field](_vm.data[item.field])
        }
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(revisao, j) {
      return _c('el-option-group', {
        key: j,
        attrs: {
          "label": revisao.label,
          "value-key": "id"
        }
      }, _vm._l((revisao.options), function(val, k) {
        return _c('el-option', {
          key: k,
          attrs: {
            "label": _vm.handleLabelSelect(item, val),
            "value": _vm.handleValueSelect(item, val),
            "title": _vm.handleTitleSelect(item, val)
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.handleLabelSelectHtml(item, val))
          }
        })])
      }), 1)
    }), 1) : (item.type == 'limite-credito') ? _c('div', [_c('el-radio', {
      attrs: {
        "label": 1
      },
      model: {
        value: (_vm.data.ilimitada),
        callback: function($$v) {
          _vm.$set(_vm.data, "ilimitada", $$v)
        },
        expression: "data.ilimitada"
      }
    }, [_vm._v("Ilimitada")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 0
      },
      model: {
        value: (_vm.data.ilimitada),
        callback: function($$v) {
          _vm.$set(_vm.data, "ilimitada", $$v)
        },
        expression: "data.ilimitada"
      }
    }, [_vm._v("\n              Com limite de\n              "), _c('input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.data.limite),
        expression: "data.limite"
      }],
      staticClass: "el-input__inner",
      style: ('width:200px !important;' + (_vm.data.ilimitada == 1 ? 'background:#ececec' : '')),
      attrs: {
        "placeholder": "Informe o valor",
        "prefix-icon": "fa fa-usd",
        "disabled": _vm.data.ilimitada == 1
      },
      domProps: {
        "value": (_vm.data.limite)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "limite", $event.target.value)
        }
      }
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.error && _vm.error[item.field]) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "color": "#e66666",
        "font-size": "9pt"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.error[item.field][0]) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.config.obs && _vm.config.obs[item.field]) ? _c('div', {
      staticStyle: {
        "font-size": "9pt"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.config.obs[item.field])
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_vm._t("form-itens")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._t("form-footer")], 2), _vm._v(" "), (_vm.config && _vm.config.click && _vm.config.click.save) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('ed-button', {
    attrs: {
      "loading": _vm.config.loading.save,
      "icon": "fa fa-save",
      "type": "success",
      "value": " Salvar"
    },
    on: {
      "click": _vm.handlerSave
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.usuario && _vm.data.updated_at) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('b', [_vm._v("Última Atualização:")]), _vm._v(" " + _vm._s(_vm.data.usuario.usuario) + " em " + _vm._s(_vm.toDate(_vm.data.updated_at)))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2"
  }, [_c('ed-error', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
  }, [_vm._t("form-end")], 2)], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.avulso) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
  }, [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO RISCO",
      "modal": _vm.showProcedimento,
      "onSave": _vm.inserirProcedimento,
      "isModal": false,
      "width": "50%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Pesquisar risco",
      "items": _vm.bind.procedimentos,
      "loading": _vm.bind.loadingProcedimento,
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getRisco
    },
    model: {
      value: (_vm.bind.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.bind, "procedimento", $$v)
      },
      expression: "bind.procedimento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações sobre as atividades\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Início das Atividades",
      "name": "valor.ambiente.dtIniCondicao",
      "required": ""
    },
    model: {
      value: (_vm.formData.ambiente.dtIniCondicao),
      callback: function($$v) {
        _vm.$set(_vm.formData.ambiente, "dtIniCondicao", $$v)
      },
      expression: "formData.ambiente.dtIniCondicao"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9",
    attrs: {
      "label": "Descrição das Atividades",
      "name": "valor.Atividades",
      "required": ""
    },
    model: {
      value: (_vm.formData.ambiente.dscAtivDes),
      callback: function($$v) {
        _vm.$set(_vm.formData.ambiente, "dscAtivDes", $$v)
      },
      expression: "formData.ambiente.dscAtivDes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações relativas ao responsável pelos registros ambientais.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Nome do Responsavel",
      "name": "valor.responsavel.nome",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "nome", $$v)
      },
      expression: "formData.responsavel.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "CPF do Responsavel",
      "name": "valor.responsavel.cpfResp",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.cpfResp),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "cpfResp", $$v)
      },
      expression: "formData.responsavel.cpfResp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Órgão de Classe",
      "items": [{
          id: 1,
          nome: 'Conselho Regional de Medicina - CRM'
        },
        {
          id: 4,
          nome: 'Conselho Regional de Engenharia e Agronomia - CREA'
        },
        {
          id: 9,
          nome: 'Outros'
        } ],
      "name": "valor.responsavel.ideOC"
    },
    model: {
      value: (_vm.formData.responsavel.ideOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "ideOC", $$v)
      },
      expression: "formData.responsavel.ideOC"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Número de Incrição de Classe",
      "name": "valor.responsavel.nrOC",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.nrOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "nrOC", $$v)
      },
      expression: "formData.responsavel.nrOC"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Unidade Federativa",
      "name": "valor.responsavel.ufOC",
      "items": _vm.parent.bind.estados,
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.ufOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "ufOC", $$v)
      },
      expression: "formData.responsavel.ufOC"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Agente(s) nocivo(s) ao(s) qual(is) o trabalhador está exposto. - Tabela 24\n    do eSocial\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "success",
      "label": "Inserir Novo Risco",
      "title": "Inserir Novo Risco"
    },
    on: {
      "click": function($event) {
        _vm.showProcedimento = !_vm.showProcedimento
      }
    }
  }), _vm._v(" "), _c('b-table-simple', {
    staticClass: "col-12 table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('b-th', [_vm._v("RISCO")]), _vm._v(" "), _c('b-th', [_vm._v("DESCRIÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("TIPO DE AVALIAÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("INTENSIDADE OU CONCENTRAÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("LIMITE DE TOLERÂNCIA")]), _vm._v(" "), _c('b-th', [_vm._v("UNIDADE DE MEDIDA")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [(!_vm.formData.riscos.length) ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(" Nenhum risco cadastrado ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.riscos), function(risco, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_vm._v("\n              " + _vm._s(risco.codigo) + "\n            ")]), _vm._v(" "), _c('b-td', [_vm._v("\n              " + _vm._s(risco.nome) + "\n            ")]), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      key: 'dscAgNoc-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.dscAgNoc),
        callback: function($$v) {
          _vm.$set(risco, "dscAgNoc", $$v)
        },
        expression: "risco.dscAgNoc"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      key: 'tpAval-' + index,
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'Critério quantitativo'
          },
          {
            id: 2,
            nome: 'Critério qualitativo'
          } ]
      },
      model: {
        value: (risco.tpAval),
        callback: function($$v) {
          _vm.$set(risco, "tpAval", $$v)
        },
        expression: "risco.tpAval"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      key: 'intConc-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.intConc),
        callback: function($$v) {
          _vm.$set(risco, "intConc", $$v)
        },
        expression: "risco.intConc"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      key: 'limTol-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.limTol),
        callback: function($$v) {
          _vm.$set(risco, "limTol", $$v)
        },
        expression: "risco.limTol"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      key: 'unMed-' + index,
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'dose diária de ruído'
          },
          {
            id: 2,
            nome: 'decibel linear (dB (linear))'
          },
          {
            id: 3,
            nome: 'decibel (C) (dB(C))'
          },
          {
            id: 4,
            nome: 'decibel (A) (dB(A))'
          },
          {
            id: 5,
            nome: 'metro por segundo ao quadrado (m/s2)'
          },
          {
            id: 6,
            nome: 'metro por segundo elevado a 1,75 (m/s1,75)'
          },
          {
            id: 7,
            nome: 'parte de vapor ou gás por milhão de partes de ar contaminado (ppm)'
          },
          {
            id: 8,
            nome: 'miligrama por metro cúbico de ar (mg/m3)'
          },
          {
            id: 9,
            nome: 'fibra por centímetro cúbico (f/cm3)'
          },
          {
            id: 10,
            nome: 'grau Celsius (ºC)'
          },
          {
            id: 11,
            nome: 'metro por segundo (m/s)'
          },
          {
            id: 12,
            nome: 'porcentual'
          },
          {
            id: 13,
            nome: 'lux (lx)'
          },
          {
            id: 14,
            nome: 'unidade formadora de colônias por metro cúbico (ufc/m3)'
          },
          {
            id: 15,
            nome: 'dose diária'
          },
          {
            id: 16,
            nome: 'dose mensal'
          },
          {
            id: 17,
            nome: 'dose trimestral'
          },
          {
            id: 18,
            nome: 'dose anual'
          },
          {
            id: 19,
            nome: 'watt por metro quadrado (W/m2)'
          },
          {
            id: 20,
            nome: 'ampère por metro (A/m)'
          },
          {
            id: 21,
            nome: 'militesla (mT)'
          },
          {
            id: 22,
            nome: 'microtesla (μT)'
          },
          {
            id: 23,
            nome: 'miliampère (mA)'
          },
          {
            id: 24,
            nome: 'quilovolt por metro (kV/m)'
          },
          {
            id: 25,
            nome: 'volt por metro (V/m)'
          },
          {
            id: 26,
            nome: 'joule por metro quadrado (J/m2)'
          },
          {
            id: 27,
            nome: 'milijoule por centímetro quadrado (mJ/cm2)'
          },
          {
            id: 28,
            nome: ' milisievert (mSv)'
          },
          {
            id: 29,
            nome: 'milhão de partículas por decímetro cúbico (mppdc)'
          },
          {
            id: 30,
            nome: 'umidade relativa do ar (UR (%))'
          } ],
        "required": risco.tpAval == 1
      },
      model: {
        value: (risco.unMed),
        callback: function($$v) {
          _vm.$set(risco, "unMed", $$v)
        },
        expression: "risco.unMed"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "title": "Remover Novo risco"
      },
      on: {
        "click": function($event) {
          return _vm.removerProcedimento(index)
        }
      }
    })], 1)], 1)
  })], 2)], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent && _vm.cliente.logged),
      expression: "loadingContent && cliente.logged",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "page",
      "element-loading-text": "Carregando..."
    }
  }, [(_vm.noTenant) ? _c('Erro500', {
    attrs: {
      "erro": _vm.noTenant
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.$route.meta.disablePageHeader && !_vm.loadingContent && _vm.usuario.logged && _vm.usuario.logged.point) ? _c('div', [_c('EmpresaHeader')], 1) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent) ? _c('div', {
    staticClass: "pl-3 pr-3 pb-3",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [(!_vm.$route.meta.disablePageHeader) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": this.navigation
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent && _vm.cliente.logged) ? _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('EmpresaFooter')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('Guia', {
    attrs: {
      "showGuia": _vm.showGuia,
      "consulta": _vm.formData
    }
  }), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.formData.result && _vm.formData.result.tipo_status.bloqueado == 0) ? _c('div', {
    staticClass: "col-md-12 text-center mt-5"
  }, [(_vm.formData.id_tipo_status == 54) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "size": "big",
      "loading": _vm.loadingSave,
      "value": "Salvar Consulta"
    },
    on: {
      "click": _vm.salvar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center mt-2"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-file-pdf-o",
      "type": "warning",
      "size": "big",
      "value": "Gerar Guia de Encaminhamento"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1)], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.formData.result.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir ASO"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1)], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 194)) ? _c('div', {
    staticClass: "col-12 mt-5 text-left"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Essa consulta está aguardando processamento. Espere alguns minutos e atualize essa página para verificar o andamento do registro da consulta.",
      "title": "Atenção"
    }
  })], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 195)) ? _c('div', {
    staticClass: "col-12 mt-5 text-left"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Erro ao registrar a consulta: ' + _vm.formData.result.info,
      "title": "Atenção"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id != 194 && _vm.formData.result.tipo_status.id != 195) ? _c('el-tab-pane', {
    attrs: {
      "label": "Exames Complementares",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v(" Exames Complementares")]), _vm._v(" "), _c('Exames')], 1) : _vm._e(), _vm._v(" "), (_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id != 194 && _vm.formData.result.tipo_status.id != 195) ? _c('el-tab-pane', {
    attrs: {
      "label": "Riscos Ocupacionais",
      "name": "tab-riscos"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Riscos Ocupacionais")]), _vm._v(" "), _c('Riscos')], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Acompanhamento",
      "name": "tab-acompanhamento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" Acompanhamento")]), _vm._v(" "), _c('Acompanhamento')], 1), _vm._v(" "), (_vm.formData.result) ? _c('el-tab-pane', {
    attrs: {
      "label": "Exames no PCMSO",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.formData.result.ghe.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.result) ? _c('el-tab-pane', {
    attrs: {
      "label": "Histórico de Consultas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('Historico', {
    attrs: {
      "funcionario": _vm.formData.result.funcionario,
      "id_funcao": _vm.formData.result.funcao.id
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.avulso) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
  }, [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO PROCEDIMENTO",
      "modal": _vm.showProcedimento,
      "onSave": _vm.inserirProcedimento,
      "isModal": false,
      "width": "50%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Pesquisar procedimento",
      "items": _vm.bind.procedimentos,
      "loading": _vm.bind.loadingProcedimento,
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getProcedimento
    },
    model: {
      value: (_vm.bind.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.bind, "procedimento", $$v)
      },
      expression: "bind.procedimento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-group"
  }, [_vm._v("Informações da Consulta")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Data da Consulta",
      "maxDaysTomorrow": 1,
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.aso_dt),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "aso_dt", $$v)
      },
      expression: "formData.consulta.aso_dt"
    }
  }), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Tipo de Consulta",
      "name": "id_tipo_aso",
      "tipo": "46",
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.id_tipo_aso),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "id_tipo_aso", $$v)
      },
      expression: "formData.consulta.id_tipo_aso"
    }
  }), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Aptidão",
      "name": "id_tipo_aptidao",
      "tipo": "185",
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.aptidao),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "aptidao", $$v)
      },
      expression: "formData.consulta.aptidao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("Informações do Médico Examinador")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Nome do Médico",
      "name": "valor.medico.nome",
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "nome", $$v)
      },
      expression: "formData.medico.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "CRM do Médico",
      "name": "valor.medico.crm",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.crm),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "crm", $$v)
      },
      expression: "formData.medico.crm"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Unidade Federativa do CRM",
      "name": "valor.medico.crm_uf",
      "items": _vm.parent.bind.estados,
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.crm_uf),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "crm_uf", $$v)
      },
      expression: "formData.medico.crm_uf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações do Médico Coordenador do PCMSO\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Nome do Médico",
      "name": "valor.responsavel_pcmso.nome"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "nome", $$v)
      },
      expression: "formData.responsavel_pcmso.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "CRM do Médico",
      "name": "valor.responsavel_pcmso.crm",
      "type": "number"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.crm),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "crm", $$v)
      },
      expression: "formData.responsavel_pcmso.crm"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Unidade Federativa do CRM",
      "items": _vm.parent.bind.estados,
      "name": "valor.responsavel_pcmso.crm_uf"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.crm_uf),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "crm_uf", $$v)
      },
      expression: "formData.responsavel_pcmso.crm_uf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("Procedimentos - Tabela 27 do eSocial")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "success",
      "label": "Inserir Novo Exame",
      "title": "Inserir Novo Exame"
    },
    on: {
      "click": function($event) {
        _vm.showProcedimento = !_vm.showProcedimento
      }
    }
  }), _vm._v(" "), _c('b-table-simple', {
    staticClass: "col-12 table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('b-th', [_vm._v("EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("DATA DO EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("RESULTADO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [(!_vm.formData.exames.length) ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(" Nenhum exame cadastrado ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.exames), function(exame, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_vm._v("\n              " + _vm._s(exame.codigo) + "\n            ")]), _vm._v(" "), _c('b-td', [_vm._v("\n              " + _vm._s(exame.nome) + "\n            ")]), _vm._v(" "), _c('b-td', [_c('ed-input-date', {
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "maxDaysTomorrow": 1,
        "required": ""
      },
      model: {
        value: (exame.data),
        callback: function($$v) {
          _vm.$set(exame, "data", $$v)
        },
        expression: "exame.data"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'Normal'
          },
          {
            id: 2,
            nome: 'Alterado'
          },
          {
            id: 3,
            nome: 'Estável'
          },
          {
            id: 4,
            nome: 'Agravamento'
          } ],
        "required": ""
      },
      model: {
        value: (exame.resultado),
        callback: function($$v) {
          _vm.$set(exame, "resultado", $$v)
        },
        expression: "exame.resultado"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "title": "Remover Novo Exame"
      },
      on: {
        "click": function($event) {
          return _vm.removerProcedimento(index)
        }
      }
    })], 1)], 1)
  })], 2)], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.certificado ? _vm.certificado.tipo_certificado_nome + ' - ' + _vm.certificado.representante : ''),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['empresa'] ? 'is-error' : '',
    attrs: {
      "label": "INSERIR NOVO VÍNCULO",
      "prop": "empresa",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "value-key": "id"
    },
    on: {
      "change": function($event) {
        return _vm.salvar('ruleForm')
      }
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.nome
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                                  " + _vm._s(item.cnpj) + "\n                            ")])])
  }), 1), _vm._v(" "), (_vm.error['empresa']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['empresa'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('TableView', {
    attrs: {
      "pagination": _vm.pagination,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "loadingTable": _vm.loadingTable,
      "onRegister": null,
      "onEdit": null,
      "response": _vm.response,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getEsocialCertificado
    }
  })], 1)])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.arquivo) ? _c('div', {
    staticClass: "download",
    style: ('max-width:' + (_vm.fullWidth ? '100%' : this.window.width * 0.5 + ' px') + ' !important')
  }, [_c('el-popover', {
    attrs: {
      "placement": "top",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Arquivo:")]), _vm._v(" (" + _vm._s(_vm.arquivo.id) + ") " + _vm._s(_vm.arquivo.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Tamanho:")]), _vm._v(" " + _vm._s(_vm.toMb(_vm.arquivo.size)) + " \n        "), (_vm.arquivo.width && _vm.arquivo.height) ? _c('span', [_vm._v("\n          (" + _vm._s(_vm.arquivo.width) + "x" + _vm._s(_vm.arquivo.height) + ")\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.arquivo.id && _vm.arquivo.type && _vm.arquivo.type.indexOf('image') != -1) ? _c('div', {
    staticClass: "col-md-12 text-center pt-2 pb-2"
  }, [_c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "title": "Clique para visualizar a imagem",
      "src": _vm.displayFile(_vm.arquivo),
      "fit": "scale-down",
      "preview-src-list": [_vm.displayFile(_vm.arquivo)]
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline fa-2x"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.arquivo.id) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "value": "Baixar Arquivo",
      "icon": "fa fa-download"
    },
    on: {
      "click": function($event) {
        return _vm.downloadFile(_vm.arquivo)
      }
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "value": "Deletar Arquivo",
      "icon": "fa fa-times",
      "loading": _vm.loadingDelete
    },
    on: {
      "click": function($event) {
        return _vm.deleteFile(_vm.arquivo)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.arquivo.name) + " (" + _vm._s(_vm.toMb(_vm.arquivo.size)) + ")")])])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-conclusao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wpforms"
  }), _vm._v(" Conclusão Técnica\n\t\t\t")]), _vm._v(" "), _c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Aqui você pode cadastrar todas as conclusões técnicas. Essas conclusões podem ser vinculados no cadastro do LTCAT."
    }
  }), _vm._v(" "), _c('Conclusao')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-modelo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Ocultar Items no Documento\n\t\t\t")]), _vm._v(" "), _c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Aqui você pode ocultar ou exibir os items no modelo do LTCAT criado."
    }
  }), _vm._v(" "), _c('Modelo')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.item ? _vm.formData.item._nome + ' :: LOGS' : ''),
      "modal": _vm.showLogs,
      "isModal": false,
      "width": "97%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData.item && _vm.formData.item && _vm.formData.item.log_erro.length) ? _c('el-tab-pane', {
    attrs: {
      "label": "Erro",
      "name": "error"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Erro\n                  "), (_vm.formData.item && _vm.formData.item.log_erro) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formData.item.log_erro.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', [(!_vm.formData.item || !_vm.formData.item.log_erro || _vm.formData.item.log_erro.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        Nenhum erro encontrado\n                      ")])]) : _vm._l((_vm.formData.item.log_erro), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "align": "left"
      }
    }, [(item['risco_vinculo']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("RISCO SEM VÍNCULO COM ESOCIAL")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Riscos para atualizar corretamente os riscos abaixo.")])]), _vm._v(" "), _vm._l((item['risco_vinculo']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['exame_vinculo']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Exames para atualizar corretamente os exames abaixo.")])]), _vm._v(" "), _vm._l((item['exame_vinculo']), function(exame, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(exame) + "\n                              ")])
    })], 2) : (item['cadastro_medico']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Médicos Examinadores para atualizar corretamente o médico da consulta.")])]), _vm._v(" "), _vm._l((item['cadastro_medico']), function(exame, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                " + _vm._s(exame) + "\n                              ")])
    })], 2) : (item['cadastro_funcionario']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO TRABALHADOR INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Empresa > Funcionários para atualizar corretamente os dados do trabalhador.")])]), _vm._v(" "), _vm._l((item['cadastro_funcionario']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_reg_amb']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente os dados do responsável pelo PGR.")])]), _vm._v(" "), _vm._l((item['cadastro_reg_amb']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [(posicoes.posicao) ? _c('b', [_vm._v(_vm._s(posicoes.posicao) + ":")]) : _vm._e(), _vm._v(" "), (posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (item['cadastro_ppp_fdt']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.")])]), _vm._v(" "), _vm._l((item['cadastro_ppp_fdt']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [(posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (item['erro_cadastro_fdt']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DA FRENTE DE TRABALHO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Empresa > Editar > Frente de Trabalho > Editar para atualizar corretamente a frente de trabalho.")])]), _vm._v(" "), _vm._l((item['erro_cadastro_fdt']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_sem_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("NENHUM RISCO FOI ENCONTRADO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PCMSO > Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.")])]), _vm._v(" "), _vm._l((item['cadastro_sem_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['error_cadastro_epi']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EPI CADASTRADO INCORRETAMENTE")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições no documento.")])]), _vm._v(" "), _vm._l((item['error_cadastro_epi']), function(epis, i) {
      return [_c('p', {
        key: i,
        staticStyle: {
          "color": "#000000"
        }
      }, [_c('b', [_vm._v(_vm._s(i))])]), _vm._v(" "), _vm._l((epis), function(epi) {
        return _c('p', {
          key: epi
        }, [_vm._v("\n                                    " + _vm._s(epi) + "\n                                  ")])
      })]
    })], 2) : (item['cadastro']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO INVÁLIDO")])]), _vm._v(" "), _vm._l((item['cadastro']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_abs']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO ABSENTEÍSMO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Absenteísmo > Gerenciar para atualizar corretamente o registro que está com erro")])]), _vm._v(" "), _vm._l((item['cadastro_abs']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_setor']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO GHE (SETOR) INCORRETO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente o GHE (Setor) em questão")])]), _vm._v(" "), _vm._l((item['erro_cadastro_setor']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_reg_amb']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("NENHUMA MEDICAÇÃO FOI CADASTRADO PARA ESSE LTCAT")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Ltcat > Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.")])])]) : _c('span', [_c('p', [_vm._v(_vm._s(item))])])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.formData.item && _vm.formData.item && _vm.formData.item.log_warning.length) ? _c('el-tab-pane', {
    attrs: {
      "label": "Pontos de Atenção",
      "name": "warning"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Pontos de Atenção\n                  "), (_vm.formData.item && _vm.formData.item.log_warning) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formData.item.log_warning.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', [(!_vm.formData.item || !_vm.formData.item.log_warning || _vm.formData.item.log_warning.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        Nenhum ponto de atenção encontrado\n                      ")])]) : _vm._l((_vm.formData.item.log_warning), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "color": "#ff8300"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('span', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])])])
  })], 2)])]) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loadingContent) ? _c('div', {
    staticClass: "row d-flex justify-content-center",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-md-offset-4"
  }, [_c('b-card', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tAcesso Restrito\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ed-modal', {
    attrs: {
      "title": "Recuperar Senha",
      "modal": _vm.showModal,
      "width": "50%",
      "onSave": _vm.recuperarSenha,
      "loadingSave": _vm.loadingRecuperarSenha,
      "saveName": "Recuperar Senha"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.resetitens
    }
  })], 1)]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.loginItens
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-sign-in",
      "type": "primary",
      "loading": _vm.loadingSave,
      "value": "Entrar"
    },
    on: {
      "click": _vm.login
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }, [_vm._v("Esqueci Minha Senha")])])], 1)])])], 1)])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showConfig,
      "title": (_vm.consulta ? 'CONFIGURAÇÕES DA CONSULTA Nº ' + _vm.consulta.id_con + ' - ' + _vm.consulta.funcionario.nome : ''),
      "width": "90%"
    }
  }, [(_vm.consulta) ? _c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('Config', {
    attrs: {
      "show": _vm.showConfig,
      "consulta": _vm.consulta
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.config.loading.table,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde enquanto o email é processado..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'ENVIAR ASO POR EMAIL' +
        (_vm.parent.consulta ? ' - CONSULTA ' + _vm.parent.consulta.id_con : ''),
      "modal": _vm.parent.showDownloadASO,
      "loadingSave": _vm.loadingSave,
      "loading": _vm.parent.loadingDownloadASO,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Enviar novo Email\n            ")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Informe abaixo o destinatário. Você pode adicionar vários emails separado por ; (ponto e vírgula).",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Empresa",
      "prop": "id_emp",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "disabled": _vm.parent.consulta ? true : false,
      "value-key": "id"
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.empresa),
      callback: function($$v) {
        _vm.empresa = $$v
      },
      expression: "empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                        " + _vm._s(item.cnpj) + "\n                      ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Destinatário",
      "prop": "destinatario",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Digite o destinatário (separado por `;` ponto e vírgula)",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.destinatario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "destinatario", $$v)
      },
      expression: "formData.destinatario"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Observações",
      "prop": "obs",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "O conteúdo deste campo será anexado junto com o email enviado para o destinatário...",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Consulta",
      "prop": "id_con",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    Consulta\n                    "), _c('el-checkbox', {
    attrs: {
      "disabled": !_vm.formData.id_emp || (_vm.parent.consulta ? true : false)
    },
    model: {
      value: (_vm.formData.todos),
      callback: function($$v) {
        _vm.$set(_vm.formData, "todos", $$v)
      },
      expression: "formData.todos"
    }
  }, [_vm._v("Selecionar Todas as Consultas")])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Selecione a consulta",
      "loading": _vm.loadingConsulta,
      "disabled": _vm.formData.todos == 1 ||
        !_vm.formData.id_emp ||
        (_vm.parent.consulta ? true : false),
      "value-key": "id_con"
    },
    model: {
      value: (_vm.formData.consultas),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consultas", $$v)
      },
      expression: "formData.consultas"
    }
  }, _vm._l((_vm.lstConsulta), function(item) {
    return _c('el-option', {
      key: item.id_con,
      attrs: {
        "value": item,
        "label": 'CÓD ' +
          item.id_con +
          ((item.dt_cad ?
              ' | ' + _vm.toDate(item.dt_cad, true) :
              '') +
            (item.tipo_aso ?
              ' | ' + item.tipo_aso.descricao.toUpperCase() :
              '') +
            (item.tipo_status ?
              ' | ' + item.tipo_status.descricao.toUpperCase() :
              ''))
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                        CÓD " + _vm._s(item.id_con) + " |\n                        " + _vm._s(item.dt_cad ? _vm.toDate(item.dt_cad, true) : "") + " |\n                        " + _vm._s(item.tipo_aso ?
      item.tipo_aso.descricao.toUpperCase() :
      "") + "\n                        " + _vm._s(item.tipo_status ?
      " | " + item.tipo_status.descricao.toUpperCase() :
      "") + "\n                      ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Anexar os Seguintes Documentos",
      "prop": "id_con",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.formData.tipo_documento),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo_documento", $$v)
      },
      expression: "formData.tipo_documento"
    }
  }, _vm._l((_vm.lstTipoDocumento), function(tipo) {
    return _c('el-checkbox', {
      key: tipo.id,
      staticStyle: {
        "width": "100% !important"
      },
      attrs: {
        "label": tipo.id,
        "disabled": !_vm.formData.id_emp
      }
    }, [_vm._v(_vm._s(tipo.descricao))])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.formData.consultas.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-hover has-gutter",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "400"
    }
  }, [_vm._v("CONSULTA")]), _vm._v(" "), _c('th', [_vm._v("DOCUMENTOS")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.formData.consultas), function(consulta, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_vm._v("CÓD:")]), _vm._v("\n                          " + _vm._s(consulta.id_con) + "\n                          "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_vm._v(_vm._s(consulta.funcionario.nome))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_vm._v(_vm._s(consulta.empresa.nome))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-hand-o-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                              Atestado de Saúde Ocupacional\n                              "), _c('br')]), _vm._v(" "), (consulta.arquivo_aso) ? _c('p', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(consulta.arquivo_aso)
        }
      }
    }, [_c('Download', {
      attrs: {
        "arquivo": consulta.arquivo_aso
      }
    })], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_c('b', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Aqui você pode escolher quais páginas do documento serão enviadas por email.",
        "placement": "top"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                      Páginas\n                                    ")])])], 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "210px !important"
      },
      attrs: {
        "collapse-tags": "",
        "multiple": "",
        "placeholder": "Selecione as páginas"
      },
      model: {
        value: (consulta.arquivo_aso.select_pages),
        callback: function($$v) {
          _vm.$set(consulta.arquivo_aso, "select_pages", $$v)
        },
        expression: "consulta.arquivo_aso.select_pages"
      }
    }, _vm._l((consulta.arquivo_aso.pages), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1)]) : _c('p', [_vm._v("Nenhum arquivo")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-hand-o-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                              Exames Complementares\n                              "), _c('br')]), _vm._v(" "), (consulta.arquivo_prontuario) ? _c('p', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(consulta.arquivo_prontuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('Download', {
      attrs: {
        "arquivo": consulta.arquivo_prontuario
      }
    })], 1), _vm._v(" "), _c('b', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Aqui você pode escolher quais páginas do documento serão enviadas por email.",
        "placement": "top"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                    Páginas\n                                  ")])])], 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "210px !important"
      },
      attrs: {
        "collapse-tags": "",
        "multiple": "",
        "placeholder": "Selecione as páginas"
      },
      model: {
        value: (
          consulta.arquivo_prontuario.select_pages
        ),
        callback: function($$v) {
          _vm.$set(consulta.arquivo_prontuario, "select_pages", $$v)
        },
        expression: "\n                                  consulta.arquivo_prontuario.select_pages\n                                "
      }
    }, _vm._l((consulta.arquivo_prontuario
      .pages), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1) : _c('p', [_vm._v("Nenhum arquivo")])])])])])
  }), 0)])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n              Histórico de Envio de Emails\n            ")]), _vm._v(" "), _c('DownloadAsoEmail', {
    attrs: {
      "parent": _vm.parent
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Novo Funcionário",
      "modal": _vm.showFormEdit,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [(_vm.formData.id == 0) ? _c('ed-input-auto-complete', {
    staticClass: "text-left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Funcionário",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "itemText": "funcionario"
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.setFuncionario
    },
    model: {
      value: (_vm.formData.id_funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_funcionario", $$v)
      },
      expression: "formData.id_funcionario"
    }
  }) : (_vm.formData.funcionario && _vm.formData.id > 0) ? _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Trabalhador(a)",
      "type": "text",
      "required": "",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.funcionario.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.funcionario, "nome", $$v)
      },
      expression: "formData.funcionario.nome"
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-input-text-area', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Descrição das Atividades do funcionário",
      "type": "text",
      "maxlength": "999",
      "required": ""
    },
    model: {
      value: (_vm.formData.descricao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "descricao", $$v)
      },
      expression: "formData.descricao"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo Funcionário",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatFuncionario,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('EmailEditar', {
    attrs: {
      "exame": _vm.formData,
      "showForm": _vm.showFormEdit,
      "parent": this
    }
  }), _vm._v(" "), _c('EmailTeste', {
    attrs: {
      "exame": _vm.formData,
      "showForm": _vm.showFormTeste,
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Email",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getContaEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": (_vm.device == 'xs' ? '97%' : _vm.width),
      "close-on-press-escape": _vm.closeESC,
      "close-on-click-modal": _vm.closeCLICK,
      "modal": _vm.isModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": _vm.handlerClose
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title.toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._t("modal-content")], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.onSave) ? _c('ed-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave,
      "icon": _vm.saveIcon,
      "value": _vm.saveName
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "icon": "fa fa-window-close",
      "value": "Fechar"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "title": "Exames Vinculados no PCMSO"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.parent.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Novo Valor"
    },
    on: {
      "click": _vm.onRegister
    }
  }), _vm._v(" "), _c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum item encontrado",
      "busy": _vm.parent.config.loading.content,
      "items": _vm.tableData,
      "fields": _vm.tableHead,
      "stacked": (this.device == 'xs')
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_text) ? _c('el-input', {
          attrs: {
            "maxlength": 150,
            "disabled": data.item._data.ativo == 0,
            "type": "text"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_numeric) ? _c('el-input-number', {
          attrs: {
            "disabled": data.item._data.ativo == 0,
            "min": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_select) ? _c('el-select', {
          attrs: {
            "clearable": true,
            "placeholder": "Selecione",
            "disabled": data.item._data.ativo == 0 || (_vm.parent.formData.id_tipo_campo != 212 && _vm.parent.formData.id_tipo_campo != 217)
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }, _vm._l((_vm.tipo_campos), function(tipo) {
          return _c('el-option', {
            key: tipo.id,
            attrs: {
              "label": tipo.descricao,
              "value": tipo.id,
              "title": tipo.obs
            }
          }, [_c('div', [_vm._v(_vm._s(tipo.descricao))]), _vm._v(" "), (tipo.obs) ? _c('div', {
            staticStyle: {
              "color": "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(tipo.obs))]) : _vm._e()])
        }), 1) : (data.field && data.field.show_boolean) ? _c('el-switch', {
          attrs: {
            "active-value": 1,
            "inactive-value": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-left item-group"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  }), _vm._v("\n\t\tVALORES DESSE CAMPO\n\t")])
}]}

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
    attrs: {
      "label": "Layout",
      "items": _vm.lstLayout,
      "itemValue": "codigo",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
    attrs: {
      "label": "Periodo de Apuramento",
      "format": "MM/yyyy",
      "type": "month"
    },
    model: {
      value: (_vm.formData.periodo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "periodo", $$v)
      },
      expression: "formData.periodo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "\n        col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\n        text-center\n        mt-5\n      "
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout || !_vm.formData.periodo ?
        true :
        false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(210),
      "width": "192"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Oops! Página não encontrada...")]), _vm._v(" "), _c('p', [_vm._v("\n    Verifique se você digitou o endereço corretamente.\n  ")])])
}]}

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Inserir Laboratório",
      "modal": _vm.showForm,
      "onSave": _vm.onRegister,
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Novo Laboratório"
    },
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum laboratório encontrado",
      "busy": _vm.config.loading.content,
      "items": _vm.tableData,
      "fields": _vm.tableHedad,
      "stacked": this.device == 'xs'
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_money) ? _c('div', [_c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "prefix-icon": "fa fa-usd"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        })], 1) : (
          data.field && data.field.show_radio && data.item._data.laboratorio
        ) ? _c('div', [_c('el-radio', {
          attrs: {
            "label": data.item._data.laboratorio.id
          },
          model: {
            value: (_vm.parent.formData.id_lab),
            callback: function($$v) {
              _vm.$set(_vm.parent.formData, "id_lab", $$v)
            },
            expression: "parent.formData.id_lab"
          }
        }, [_vm._v("\n            Padrão\n          ")])], 1) : _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n        ")])]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.response && _vm.response.status && _vm.response.status != 200 && _vm.response.status != 400) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "description": _vm.response.msg,
      "show-icon": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conclusão Técnica' : 'Editar Conclusão Técnica',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Conclusão Técnica",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatConclusaoTecnica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'Enviar Email de Teste :: Conta ' + (this.parent ? this.parent.formData.email : ''),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": 'EXAMES' +
        (_vm.funcionario ? ' :: ' + _vm.funcionario.nome : '') +
        ' :: ' +
        _vm.formData.periodo[0] +
        ' a ' +
        _vm.formData.periodo[1],
      "width": "97%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabExame),
      callback: function($$v) {
        _vm.tabExame = $$v
      },
      expression: "tabExame"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#4ac467",
      "float": "left"
    }
  }, [_vm._v("\n                     \n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Dentro do Período Selecionado\n                "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#dd4040",
      "float": "left"
    }
  }, [_vm._v("\n                     \n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Fora do Período Selecionado\n                "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#d8a027",
      "float": "left"
    }
  }, [_vm._v("\n                     \n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Exame não Realizado - Fora dos requisitos do PCMSO"), _c('br')])])]), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "tableFooter": _vm.tableFooterExame,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1), _vm._v(" "), (_vm.funcionario && _vm.formData.id_empresa) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('ConsultaHistorico', {
    attrs: {
      "funcionario": _vm.funcionario,
      "empresa": {
        id: _vm.formData.id_empresa
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.funcionario && _vm.formData.id_empresa) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.funcionario.id_ghe
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-left"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-search",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Pesquisar"
    },
    on: {
      "click": _vm.getPeriodico
    }
  })], 1), _vm._v(" "), (!_vm.formData.id_empresa) ? _c('ed-alert', {
    staticClass: "mt-2 text-left",
    attrs: {
      "type": "warning",
      "title": "Atenção",
      "description": "Selecione todos os campos obrigatórios."
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.formData.id_empresa) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabPeriodico),
      callback: function($$v) {
        _vm.tabPeriodico = $$v
      },
      expression: "tabPeriodico"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-ok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Dentro do Período Selecionado (" + _vm._s(_vm.tableData.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "success",
      "description": "Os trabalhadores mostrados abaixo estão com a data dos exames DENTRO PERÍODO SELECIONADO.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "onEditAll": _vm.onConsultaLote,
      "editAllIcon": "fa fa-address-card",
      "editAllName": "Gerar Consulta",
      "editAllTitle": "Gerar Consulta para os trabalhadores selecionados",
      "disableInputSearch": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar Resultado para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1)])], 1), _vm._v(" "), (_vm.formData.id_empresa && _vm.tableDataTabelaPreco.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Orçamento Aproximado",
      "name": "tab-preco"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamento Aproximado")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Orçamento aproximado para os periódidocos dentro do período selecionado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataTabelaPreco,
      "tableHead": _vm.tableHeadTabelaPreco,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id_empresa && _vm.tableDataForaPeriodo.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-nok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Fora\n          do Período Selecionado (" + _vm._s(_vm.tableDataForaPeriodo.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Os trabalhadores mostrados abaixo estão com o periódico atrasado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataForaPeriodo,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id_empresa && _vm.tableDataError.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-error"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Erro\n          de Cadastro(" + _vm._s(_vm.tableDataError.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "error",
      "description": "Os trabalhadores mostrados abaixo estão com erros no cadastro.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataError,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo GHE",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcat,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  }), _vm._v(" "), _c('Editar', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('Cadastrar', {
    attrs: {
      "parent": this
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": (_vm.formData ? 'IMPRIMIR GUIA DE ENCAMINHAMENTO OU ASO - CONSULTA Nº ' + _vm.formData.id_con : ''),
      "width": "80%"
    }
  }, [(_vm.formData) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "color": "warning",
      "icon": "info",
      "title": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n              Disponibilizamos abaixo algumas opções para você visualizar as Guias de Encaminhamento ou o ASO dessa consulta.\r\n              "), _c('br'), _vm._v("\r\n              Certifique-se que seu navegador esteja liberado para abrir os POP-UP desse sistema. Para mais informações acesse "), _c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95472?hl=pt-BR",
      "target": "_blank"
    }
  }, [_vm._v("clique aqui")])])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData && _vm.formData.tipo_status.id == 54) ? _c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-guia"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir Guia de Encaminhamento")]), _vm._v(" "), (_vm.formData) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "message": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n                  Esse Guia de Encaminhamento não garante atendimento na clínica. Por favor imprimir esse Guia e entregar ao funcionário para apresentar na hora do atendimento.\r\n                ")])])]), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-aso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir ASO")]), _vm._v(" "), (_vm.formData) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formData && _vm.formData.id_con && (_vm.formData.tipo_status.id == 66 || _vm.formData.tipo_status.id == 67)) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "title": "Clique Aqui para Imprimir",
      "disabled": _vm.formData.tipo_status.id != 66 && _vm.formData.tipo_status.id != 67,
      "value": "Imprimir"
    },
    on: {
      "click": _vm.onAso
    }
  }) : _c('ed-alert', {
    attrs: {
      "type": "error",
      "class_name": "q-mb-lg",
      "message": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n                  Esse ASO ainda não foi liberado. Você será notificado por email quando o ASO estiver liberado.\r\n                  "), (_vm.formData.credenciada.tel_com) ? _c('span', [_vm._v("\r\n                    Para maiores informações entre com " + _vm._s(_vm.formData.credenciada.nome.toUpperCase()) + " pelo telefone \r\n                    " + _vm._s(_vm.formData.credenciada.tel_com) + "\r\n                  ")]) : _c('span', [_vm._v("\r\n                    Para maiores informações entre com " + _vm._s(_vm.formData.credenciada.nome.toUpperCase()) + "\r\n                  ")])])])])], 1) : _vm._e()])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[845]);


// WEBPACK FOOTER //
// static/js/app.b5745968d69a865a34bc.js